[
  {
    "product_url": "https://www.amazon.com/HP-256GB-x900w-Flash-P-FD256HP900-GE/dp/B077BL7THJ/ref=sr_1_115?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.WK-FB3NtEv26JGR9QbAlz5tU2lej2XF6Xi_dUmVqnWXGjHj071QN20LucGBJIEps.2H5a_fxDAEhAai6ZfVv4UctY2un4LaI43R9pRtG_Xqc&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-115&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B077BL7THJ",
    "blank": null,
    "affiliate_link": "https://amzn.to/452PVsz",
    "source_file": "drives-08.html",
    "position": 1,
    "asin": "B077BL7THJ",
    "title": "HP 256GB x900w USB 3.0 Flash Drive,BLACK",
    "brand": "HP",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.6,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "7 sizes7 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/51XWA+gGvvL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/GARMESE-Waterproof-Portable-Keychain-Computer/dp/B0D5H7XH7L/ref=sr_1_116?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.WK-FB3NtEv26JGR9QbAlz5tU2lej2XF6Xi_dUmVqnWXGjHj071QN20LucGBJIEps.2H5a_fxDAEhAai6ZfVv4UctY2un4LaI43R9pRtG_Xqc&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-116&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D5H7XH7L",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 2,
    "asin": "B0D5H7XH7L",
    "title": "64GB USB 3.0 Flash Drive, Waterproof Metal USB Memory Stick, Slim Thumb Drive Portable Pen Drive with Keychain Hole Stylish Jump Drive for PC Computer Car - Gray",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$7.59",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Waterproof, Metal, Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/51LdJJjyyOL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 7.59,
    "currency": "USD",
    "price_original": "$7.59"
  },
  {
    "product_url": "https://www.amazon.com/64GB-Memorex-Flash-Drive-Type/dp/B0F255N8YD/ref=sr_1_117?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.WK-FB3NtEv26JGR9QbAlz5tU2lej2XF6Xi_dUmVqnWXGjHj071QN20LucGBJIEps.2H5a_fxDAEhAai6ZfVv4UctY2un4LaI43R9pRtG_Xqc&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-117&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0F255N8YD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 3,
    "asin": "B0F255N8YD",
    "title": "64GB Memorex USB 3.1 Flash Drive ‚Äì Transfer Speeds Up to 10x Faster Than USB 2.0, Latest USB 3.1 Gen 1 Technology, Lightweight Design, for Daily File Management, Type-A Connector, 6-Pack",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$25.69",
    "rating": 4.6,
    "review_count": 100,
    "special_features": "Lightweight",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/510m0yYraaL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 25.69,
    "currency": "USD",
    "price_original": "$25.69"
  },
  {
    "product_url": "https://www.amazon.com/256GB-PNY-Elite-Flash-Drive/dp/B0DNNHVJY6/ref=sr_1_113?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YkvA33etjb1KUKlFRnyCpLjmvlbIF0lII2RUbHny-p6DLlHqkFjeUu79uK0PBmgdQrNuczxGiCfNXF25YclOlgvl6Sp9Nh8ssK9o415BzzlWEGU-AnJHb0kf0nhZXq8pE9E53HXZjxTQd5pUuzyqZe8F3aVXzgl2urCpaX8aIE5GGfBPE3_kEBDqTQ-GNc-X.aDW-vtVv2Ax6qlWgPMGoI_hcFMQ5HWh_6L7sybK0ArQ&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-113&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DNNHVJY6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 4,
    "asin": "B0DNNHVJY6",
    "title": "256GB PNY PRO Elite V3 USB 3.2 Gen 2 Flash Drive ‚Äì Up to 1000MB/s Read, Up to 800MB/s Write, Extreme Performance for Professional Data Storage and Transfers, Premium Metal Design, Type-A Connector",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 2",
    "memory_type": "USB",
    "price": "$30.99",
    "rating": 4.6,
    "review_count": 500,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/51-0LOmjuXL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 30.99,
    "currency": "USD",
    "price_original": "$30.99"
  },
  {
    "product_url": "https://www.amazon.com/Capture-Cassette-Computer-External-Indicative/dp/B08DLJWDRK/ref=sr_1_114?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YkvA33etjb1KUKlFRnyCpLjmvlbIF0lII2RUbHny-p6DLlHqkFjeUu79uK0PBmgdQrNuczxGiCfNXF25YclOlgvl6Sp9Nh8ssK9o415BzzlWEGU-AnJHb0kf0nhZXq8pE9E53HXZjxTQd5pUuzyqZe8F3aVXzgl2urCpaX8aIE5GGfBPE3_kEBDqTQ-GNc-X.aDW-vtVv2Ax6qlWgPMGoI_hcFMQ5HWh_6L7sybK0ArQ&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-114&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08DLJWDRK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 5,
    "asin": "B08DLJWDRK",
    "title": "32GB FAT32 Format USB 2.0 Flash Drives, USB Memory Stick for Game Capture Card/Cassette Player/Computer/Laptop/External Data Storage with Indicative Light",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": "Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/61L54K4wnBL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Ultra-Flash-Drive-Performance/dp/B01EG72D1Q/ref=sr_1_115?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YkvA33etjb1KUKlFRnyCpLjmvlbIF0lII2RUbHny-p6DLlHqkFjeUu79uK0PBmgdQrNuczxGiCfNXF25YclOlgvl6Sp9Nh8ssK9o415BzzlWEGU-AnJHb0kf0nhZXq8pE9E53HXZjxTQd5pUuzyqZe8F3aVXzgl2urCpaX8aIE5GGfBPE3_kEBDqTQ-GNc-X.aDW-vtVv2Ax6qlWgPMGoI_hcFMQ5HWh_6L7sybK0ArQ&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-115&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B01EG72D1Q",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 6,
    "asin": "B01EG72D1Q",
    "title": "SanDisk Ultra USB (10 Pack) 3.0 32GB CZ48 Flash Drive High Performance Jump Drive/Thumb Drive/Pen Drive up to 100MB/s - Bundle with (5) Everything But Stromboli Lanyard",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$66.82",
    "rating": 4.7,
    "review_count": 100,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -180,
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/71KRJGVPlgL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 66.82,
    "currency": "USD",
    "price_original": "$66.82"
  },
  {
    "product_url": "https://www.amazon.com/ZZ-Flash-Memory-Drives-Colors/dp/B07H26NHWW/ref=sr_1_116?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YkvA33etjb1KUKlFRnyCpLjmvlbIF0lII2RUbHny-p6DLlHqkFjeUu79uK0PBmgdQrNuczxGiCfNXF25YclOlgvl6Sp9Nh8ssK9o415BzzlWEGU-AnJHb0kf0nhZXq8pE9E53HXZjxTQd5pUuzyqZe8F3aVXzgl2urCpaX8aIE5GGfBPE3_kEBDqTQ-GNc-X.aDW-vtVv2Ax6qlWgPMGoI_hcFMQ5HWh_6L7sybK0ArQ&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-116&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07H26NHWW",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 7,
    "asin": "B07H26NHWW",
    "title": "K&ZZ 5 Pack 64GB Flash Drive 64 GB USB Flash Drives USB 2.0 Thumb Drive Gig Zip Drive Stick 64G Flash Memory Stick Jump Drives for PC Laptop, Multicolored",
    "brand": "K&ZZ",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.98",
    "rating": 4.5,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/71TmU8mY+MS._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.98,
    "currency": "USD",
    "price_original": "$19.98"
  },
  {
    "product_url": "https://www.amazon.com/SSK-External-Portable-Android-Windows/dp/B0DCJMK9SN/ref=sr_1_117?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YkvA33etjb1KUKlFRnyCpLjmvlbIF0lII2RUbHny-p6DLlHqkFjeUu79uK0PBmgdQrNuczxGiCfNXF25YclOlgvl6Sp9Nh8ssK9o415BzzlWEGU-AnJHb0kf0nhZXq8pE9E53HXZjxTQd5pUuzyqZe8F3aVXzgl2urCpaX8aIE5GGfBPE3_kEBDqTQ-GNc-X.aDW-vtVv2Ax6qlWgPMGoI_hcFMQ5HWh_6L7sybK0ArQ&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-117&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DCJMK9SN",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 8,
    "asin": "B0DCJMK9SN",
    "title": "SSK 1TB USB C Thumb Drive up to 1000MB/s,Fast Flash Dual Drive,External Portable SSD Drive Type C+USB A 3.2 Gen 2 Flash Drive,USB C Memory Stick for iPhone 15/PS4/Android Phone/Tablet/Windows/Mac",
    "brand": "SSK",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$84.99",
    "rating": 4.4,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/611MBsHRN7L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "tb",
    "price_numeric": 84.99,
    "currency": "USD",
    "price_original": "$84.99"
  },
  {
    "product_url": "https://www.amazon.com/SunData-Flash-Drives-Memory-Colors/dp/B078MHMHKG/ref=sr_1_120?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YkvA33etjb1KUKlFRnyCpLjmvlbIF0lII2RUbHny-p6DLlHqkFjeUu79uK0PBmgdQrNuczxGiCfNXF25YclOlgvl6Sp9Nh8ssK9o415BzzlWEGU-AnJHb0kf0nhZXq8pE9E53HXZjxTQd5pUuzyqZe8F3aVXzgl2urCpaX8aIE5GGfBPE3_kEBDqTQ-GNc-X.aDW-vtVv2Ax6qlWgPMGoI_hcFMQ5HWh_6L7sybK0ArQ&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-120&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B078MHMHKG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 9,
    "asin": "B078MHMHKG",
    "title": "3 Pack 16GB USB 2.0 Flash Drive Thumb Drives Memory Stick, 3 Colors: Black Blue Green",
    "brand": 3,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$9.99",
    "rating": 4.4,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/71p21hR8nuL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 9.99,
    "currency": "USD",
    "price_original": "$9.99"
  },
  {
    "product_url": "https://www.amazon.com/KEXIN-Memory-Storage-Colorful-5-Pack/dp/B0C2D95SZZ/ref=sr_1_121?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YkvA33etjb1KUKlFRnyCpLjmvlbIF0lII2RUbHny-p6DLlHqkFjeUu79uK0PBmgdQrNuczxGiCfNXF25YclOlgvl6Sp9Nh8ssK9o415BzzlWEGU-AnJHb0kf0nhZXq8pE9E53HXZjxTQd5pUuzyqZe8F3aVXzgl2urCpaX8aIE5GGfBPE3_kEBDqTQ-GNc-X.aDW-vtVv2Ax6qlWgPMGoI_hcFMQ5HWh_6L7sybK0ArQ&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-121&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0C2D95SZZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 10,
    "asin": "B0C2D95SZZ",
    "title": "KEXIN Flash Drive 64GB USB 3.0 Flash Drive 64 GB Thumb Drive 5 Pack Memory Stick USB Drive Data Storage Jump Drive Colorful(64G 5-Pack)",
    "brand": "KEXIN",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$22.59",
    "rating": 4.5,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/61Syr0wuRjL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 22.59,
    "currency": "USD",
    "price_original": "$22.59"
  },
  {
    "product_url": "https://www.amazon.com/PNY-Elite-Type-C-Flash-Drive/dp/B0DVD8GBYL/ref=sr_1_122?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YkvA33etjb1KUKlFRnyCpLjmvlbIF0lII2RUbHny-p6DLlHqkFjeUu79uK0PBmgdQrNuczxGiCfNXF25YclOlgvl6Sp9Nh8ssK9o415BzzlWEGU-AnJHb0kf0nhZXq8pE9E53HXZjxTQd5pUuzyqZe8F3aVXzgl2urCpaX8aIE5GGfBPE3_kEBDqTQ-GNc-X.aDW-vtVv2Ax6qlWgPMGoI_hcFMQ5HWh_6L7sybK0ArQ&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-122&ufe=app_do%3Aamzn1.fos.9fe8cbfa-bf43-43d1-a707-3f4e65a4b666&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DVD8GBYL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 11,
    "asin": "B0DVD8GBYL",
    "title": "1TB PNY PRO Elite V3‚Ñ¢ Type-C USB 3.2 Gen 2 Flash Drive ‚Äì Up to 1000MB/s Read, Up to 800MB/s Write, Extreme Performance for Professional Data Storage and Transfers, Premium Metal Design, USB-C",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 2",
    "memory_type": "USB",
    "price": "$82.99",
    "rating": 4.3,
    "review_count": 50,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/41bD4m8TFYL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "tb",
    "price_numeric": 82.99,
    "currency": "USD",
    "price_original": "$82.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Performance-SDCZ48-128G-U46-Everything-Stromboli/dp/B07R2DCB1D/ref=sr_1_123?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YkvA33etjb1KUKlFRnyCpLjmvlbIF0lII2RUbHny-p6DLlHqkFjeUu79uK0PBmgdQrNuczxGiCfNXF25YclOlgvl6Sp9Nh8ssK9o415BzzlWEGU-AnJHb0kf0nhZXq8pE9E53HXZjxTQd5pUuzyqZe8F3aVXzgl2urCpaX8aIE5GGfBPE3_kEBDqTQ-GNc-X.aDW-vtVv2Ax6qlWgPMGoI_hcFMQ5HWh_6L7sybK0ArQ&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-123&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07R2DCB1D",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 12,
    "asin": "B07R2DCB1D",
    "title": "SanDisk 128GB Flash Ultra (10 Pack Bundle) 3.0 USB Flash Drive High Performance Thumb Drive (SDCZ48-128G-U46) Plus (5) Everything But Stromboli (TM) Lanyard",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "SD",
    "price": "$91.84",
    "rating": 3.8,
    "review_count": 22,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -22,
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/81v7xm7QwNL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 91.84,
    "currency": "USD",
    "price_original": "$91.84"
  },
  {
    "product_url": "https://www.amazon.com/Verbatim-32GB-Pinstripe-Flash-Drive/dp/B07PVJTF4C/ref=sr_1_124?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YkvA33etjb1KUKlFRnyCpLjmvlbIF0lII2RUbHny-p6DLlHqkFjeUu79uK0PBmgdQrNuczxGiCfNXF25YclOlgvl6Sp9Nh8ssK9o415BzzlWEGU-AnJHb0kf0nhZXq8pE9E53HXZjxTQd5pUuzyqZe8F3aVXzgl2urCpaX8aIE5GGfBPE3_kEBDqTQ-GNc-X.aDW-vtVv2Ax6qlWgPMGoI_hcFMQ5HWh_6L7sybK0ArQ&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-124&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07PVJTF4C",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 13,
    "asin": "B07PVJTF4C",
    "title": "Verbatim 32GB Pinstripe USB 2.0 Flash Drive Retractable Thumb Drive - 5 Pack - Multicolor (Green, Blue, Red, Purple, Cyan)",
    "brand": "Verbatim",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$20.60",
    "rating": 4.6,
    "review_count": 100,
    "special_features": "Retractable",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.1K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/71jOh2vNLyL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.6,
    "currency": "USD",
    "price_original": "$20.60"
  },
  {
    "product_url": "https://www.amazon.com/Aoriher-Drives-Portable-Lanyards-Storage/dp/B0BPSGQ5D3/ref=sr_1_125?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YkvA33etjb1KUKlFRnyCpLjmvlbIF0lII2RUbHny-p6DLlHqkFjeUu79uK0PBmgdQrNuczxGiCfNXF25YclOlgvl6Sp9Nh8ssK9o415BzzlWEGU-AnJHb0kf0nhZXq8pE9E53HXZjxTQd5pUuzyqZe8F3aVXzgl2urCpaX8aIE5GGfBPE3_kEBDqTQ-GNc-X.aDW-vtVv2Ax6qlWgPMGoI_hcFMQ5HWh_6L7sybK0ArQ&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-125&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BPSGQ5D3",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 14,
    "asin": "B0BPSGQ5D3",
    "title": "Aoriher 50 Pack USB 2.0 Flash Drives Bulk, Portable USB Thumb Drives with Lanyards, Swivel Flash Drives Thumb Drives for Office School Data Storage (128MB)",
    "brand": "Aoriher",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$49.99",
    "rating": 3.7,
    "review_count": 50,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -163,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/81bomFKNEGL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "mb",
    "price_numeric": 49.99,
    "currency": "USD",
    "price_original": "$49.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-256GB-Phone-Drive-Android/dp/B0DFJ5KBH2/ref=sr_1_126?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YkvA33etjb1KUKlFRnyCpLjmvlbIF0lII2RUbHny-p6DLlHqkFjeUu79uK0PBmgdQrNuczxGiCfNXF25YclOlgvl6Sp9Nh8ssK9o415BzzlWEGU-AnJHb0kf0nhZXq8pE9E53HXZjxTQd5pUuzyqZe8F3aVXzgl2urCpaX8aIE5GGfBPE3_kEBDqTQ-GNc-X.aDW-vtVv2Ax6qlWgPMGoI_hcFMQ5HWh_6L7sybK0ArQ&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-126&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DFJ5KBH2",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 15,
    "asin": "B0DFJ5KBH2",
    "title": "SanDisk 256GB Phone Drive for Android - The 2-in-1 USB for Smartphones, Tablets, and Computers - Thumb Drive with USB Type-C and Type-A Connectors - SDDDC6-256G-G46",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$24.99",
    "rating": 4.3,
    "review_count": 300,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/61ETpT6K8YL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/MOSDART-Bright-Multipack-Computers-Storage/dp/B0D3FB3KFV/ref=sr_1_127?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YkvA33etjb1KUKlFRnyCpLjmvlbIF0lII2RUbHny-p6DLlHqkFjeUu79uK0PBmgdQrNuczxGiCfNXF25YclOlgvl6Sp9Nh8ssK9o415BzzlWEGU-AnJHb0kf0nhZXq8pE9E53HXZjxTQd5pUuzyqZe8F3aVXzgl2urCpaX8aIE5GGfBPE3_kEBDqTQ-GNc-X.aDW-vtVv2Ax6qlWgPMGoI_hcFMQ5HWh_6L7sybK0ArQ&dib_tag=se&keywords=flash+drives&qid=1753561795&sprefix=flash+drive%2Caps%2C146&sr=8-127&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D3FB3KFV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 16,
    "asin": "B0D3FB3KFV",
    "title": "MOSDART 64GB USB 2.0 Flash Drive, with Keychain Loop, Swivel Design with LED Light, exFAT Memory Stick for Computers, System Backup, Data Storage Thumb Drive, Green and Blue (Pack of 2)",
    "brand": "MOSDART",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "SD",
    "price": "$9.99",
    "rating": 4.6,
    "review_count": 200,
    "special_features": "Keychain, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/61fBzba0MDL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 9.99,
    "currency": "USD",
    "price_original": "$9.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=8&crid=BALSGJKBQE1X&qid=1753561770&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_8#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 17,
    "asin": null,
    "title": "AGECASH A 8GB USB Flash Drive 20 Pack USB 2.0 Flash Drives Bulk 8GB Thumb Drive 20 Packs Memory Stick Jump Drives Multipack Zip Drive for Data Storage and Backup (Multicolor, 8 GB 20Pack)",
    "brand": "AGECASH",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$37.68",
    "rating": 4.5,
    "review_count": 98,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -98,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/71AXNECWmTL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.68,
    "currency": "USD",
    "price_original": "$37.68"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4ODY2MTcwMjUwMzA3MTUyOjE3NTM1NjE4MjE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1NTQwNDUzNjAwMjo6MDo6&url=%2FAGECASH-8GB-Flash-Pack-Drives%2Fdp%2FB0DZBPJT9H%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DZBPJT9H%26pd_rd_r%3D13eca64c-61b4-4329-bf74-94113ac27506%26pd_rd_w%3Dr1sMF%26pd_rd_wg%3DcBw7c%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D87NGQ4WT51YNRHS1TENS%26qid%3D1753561795%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-113-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DZBPJT9H",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 18,
    "asin": "B0DZBPJT9H",
    "title": "AGECASH A 8GB USB Flash Drive 20 Pack USB 2.0 Flash Drives Bulk 8GB Thumb Drive 20 Packs Memory Stick Jump Drives Multipack Zip Drive for Data Storage and Backup (Multicolor, 8 GB 20Pack)",
    "brand": "AGECASH",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$37.68",
    "rating": 4.5,
    "review_count": 98,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -98,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/71AXNECWmTL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.68,
    "currency": "USD",
    "price_original": "$37.68"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4ODY2MTcwMjUwMzA3MTUyOjE3NTM1NjE4MjE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1ODA0MTgyNjAwMjo6MTo6&url=%2FAGECASH-Flashdrive-Pendrive-Transfer-Multicolored%2Fdp%2FB0CBK2FG8T%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CBK2FG8T%26pd_rd_r%3D13eca64c-61b4-4329-bf74-94113ac27506%26pd_rd_w%3Dr1sMF%26pd_rd_wg%3DcBw7c%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D87NGQ4WT51YNRHS1TENS%26qid%3D1753561795%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-114-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CBK2FG8T",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 19,
    "asin": "B0CBK2FG8T",
    "title": "USB Flash Drives 10 Pack 2GB Flash Drive AGECASH A USB 2.0 Thumb Drive Jump Zip Drive Flashdrive, USB Memory Stick Pendrive for Data Storage & Transfer with 10PCS Lanyard Multicolored",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$18.53",
    "rating": 4.5,
    "review_count": 50,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -388,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/81IEDqEE-3L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.53,
    "currency": "USD",
    "price_original": "$18.53"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4ODY2MTcwMjUwMzA3MTUyOjE3NTM1NjE4MjE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1OTYyOTMxNDgwMjo6Mjo6&url=%2FAGECASH-Flashdrive-Pendrive-Transfer-Multi-Colored%2Fdp%2FB0CBK225CB%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CBK225CB%26pd_rd_r%3D13eca64c-61b4-4329-bf74-94113ac27506%26pd_rd_w%3Dr1sMF%26pd_rd_wg%3DcBw7c%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D87NGQ4WT51YNRHS1TENS%26qid%3D1753561795%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-115-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CBK225CB",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 20,
    "asin": "B0CBK225CB",
    "title": "USB Flash Drives 20 Pack 16GB Flash Drive AGECASH A USB 2.0 Thumb Drive Jump Zip Drive Flashdrive Memory Stick Pendrive for Data Storage & Transfer with 20PCS Lanyard (Multi-Colored, 16GB)",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$44.38",
    "rating": 4.6,
    "review_count": 50,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -143,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/81xaaPBewUL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 44.38,
    "currency": "USD",
    "price_original": "$44.38"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4ODY2MTcwMjUwMzA3MTUyOjE3NTM1NjE4MjE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDE5OTU5MjMyMzEwMjo6Mzo6&url=%2FWooolken-Drives-Memory-Lanyards-Storage%2Fdp%2FB0C5CYWMMC%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0C5CYWMMC%26pd_rd_r%3D13eca64c-61b4-4329-bf74-94113ac27506%26pd_rd_w%3Dr1sMF%26pd_rd_wg%3DcBw7c%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D87NGQ4WT51YNRHS1TENS%26qid%3D1753561795%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-116-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0C5CYWMMC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 21,
    "asin": "B0C5CYWMMC",
    "title": "1GB Flash Drive 20 Pack, Wooolken USB 2.0 Thumb Drives Memory Stick with LED Light and Lanyards for Storage and Backup (Mixed Colors: Black Red Blue Orange Green)",
    "brand": "1GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$32.39",
    "rating": 4.6,
    "review_count": 50,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/71-kUjhphpL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 32.39,
    "currency": "USD",
    "price_original": "$32.39"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4ODY2MTcwMjUwMzA3MTUyOjE3NTM1NjE4MjE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODQxOTAyOTYwMjo6NDo6&url=%2FNicepicten-Pendrive-Stroage-Memoria-Lanyard%2Fdp%2FB0D45TWBQJ%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0D45TWBQJ%26pd_rd_r%3D13eca64c-61b4-4329-bf74-94113ac27506%26pd_rd_w%3Dr1sMF%26pd_rd_wg%3DcBw7c%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D87NGQ4WT51YNRHS1TENS%26qid%3D1753561795%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-117-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0D45TWBQJ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 22,
    "asin": "B0D45TWBQJ",
    "title": "2GB USB Flash Drive 20 Pack Nicepicten Bulk USB 2.0 Thumb Drives 20Pack Metal Jump Zip Drive Memory Stick Pendrive Memoria USB 2 GB with 20PCS Lanyard Label - Mixcolor 20 X 2GB Flash Drives Bulk",
    "brand": "2GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$35.16",
    "rating": 4.6,
    "review_count": 116,
    "special_features": "Metal, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -116,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/71d6XJRMzzL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 35.16,
    "currency": "USD",
    "price_original": "$35.16"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=8&crid=BALSGJKBQE1X&qid=1753561770&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_8#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 23,
    "asin": null,
    "title": "64GB USB Flash Drive USB 3.1 Gen1 Dual USB-A & Type-C, Portable Thumb Drive for Smartphones, Laptops & Tablets",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$18.99",
    "rating": 4.4,
    "review_count": 60,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -7,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/51QQPxf1X2L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.99,
    "currency": "USD",
    "price_original": "$18.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1MDc5OTYzMDAzOTYwOTk5OjE3NTM1NjE4MjE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MDY1Njc2NjMwMjo6MTo6&url=%2FOSCOO-Portable-Smartphones-Laptops-Tablets%2Fdp%2FB0F6MZXV2V%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0F6MZXV2V%26pd_rd_r%3D13eca64c-61b4-4329-bf74-94113ac27506%26pd_rd_w%3D1e17h%26pd_rd_wg%3DcBw7c%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D87NGQ4WT51YNRHS1TENS%26qid%3D1753561795%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-113-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0F6MZXV2V",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 24,
    "asin": "B0F6MZXV2V",
    "title": "64GB USB Flash Drive USB 3.1 Gen1 Dual USB-A & Type-C, Portable Thumb Drive for Smartphones, Laptops & Tablets",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$18.99",
    "rating": 4.4,
    "review_count": 7,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -7,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/51QQPxf1X2L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.99,
    "currency": "USD",
    "price_original": "$18.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1MDc5OTYzMDAzOTYwOTk5OjE3NTM1NjE4MjE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5ODUwMjo6Mjo6&url=%2FCustom-Drives-Personalized-Business-Promotions%2Fdp%2FB0FGQ6PZFF%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQ6PZFF%26pd_rd_r%3D13eca64c-61b4-4329-bf74-94113ac27506%26pd_rd_w%3D1e17h%26pd_rd_wg%3DcBw7c%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D87NGQ4WT51YNRHS1TENS%26qid%3D1753561795%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-114-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ6PZFF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 25,
    "asin": "B0FGQ6PZFF",
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (50,4GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$159.99",
    "rating": null,
    "review_count": 159,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-08_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 159.99,
    "currency": "USD",
    "price_original": "$159.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1MDc5OTYzMDAzOTYwOTk5OjE3NTM1NjE4MjE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1MDgwNDE5MzAwMjo6Mzo6&url=%2F128GB-USB-Flash-Drive-Compatible%2Fdp%2FB0FF4SWQRB%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FF4SWQRB%26pd_rd_r%3D13eca64c-61b4-4329-bf74-94113ac27506%26pd_rd_w%3D1e17h%26pd_rd_wg%3DcBw7c%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D87NGQ4WT51YNRHS1TENS%26qid%3D1753561795%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-115-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FF4SWQRB",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 26,
    "asin": "B0FF4SWQRB",
    "title": "128GB USB Flash Drive ‚Äì 2 in 1 Flash Drive with USB 3.0 and Type C Connector ‚Äì High Speed Thumb Drive, Plug and Play Photo Stick, Memory Stick Compatible with Laptop, Android, PC",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$16.99",
    "rating": null,
    "review_count": 16,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/51Ri+2TBGwL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.99,
    "currency": "USD",
    "price_original": "$16.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1MDc5OTYzMDAzOTYwOTk5OjE3NTM1NjE4MjE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5MzEwMjo6NDo6&url=%2FFlash-Drive-Customizable-Thumb-4GB-128GB%2Fdp%2FB0FGQJ6YV5%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQJ6YV5%26pd_rd_r%3D13eca64c-61b4-4329-bf74-94113ac27506%26pd_rd_w%3D1e17h%26pd_rd_wg%3DcBw7c%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D87NGQ4WT51YNRHS1TENS%26qid%3D1753561795%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-116-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQJ6YV5",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 27,
    "asin": "B0FGQJ6YV5",
    "title": "Mini USB Flash Drive Customizable Tiny Thumb Drive with Your Logo 4GB-128GB - Perfect for Corporate Events, Branded Promotions, Student Projects Plug and Play, PC Mac (100,32GB)",
    "brand": "Mini",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$410.99",
    "rating": null,
    "review_count": 410,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-08_files/41Y5IinJkAL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 410.99,
    "currency": "USD",
    "price_original": "$410.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1MDc5OTYzMDAzOTYwOTk5OjE3NTM1NjE4MjE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5NjcwMjo6NTo6&url=%2FCustom-Personalized-Packaging-Business-Outreach%2Fdp%2FB0FGX4W55C%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGX4W55C%26pd_rd_r%3D13eca64c-61b4-4329-bf74-94113ac27506%26pd_rd_w%3D1e17h%26pd_rd_wg%3DcBw7c%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D87NGQ4WT51YNRHS1TENS%26qid%3D1753561795%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-117-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGX4W55C",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 28,
    "asin": "B0FGX4W55C",
    "title": "Custom Logo USB Drive 50 100 Count Personalized Packaging for School Business Outreach (50,64GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$206.99",
    "rating": null,
    "review_count": 206,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-08_files/41ckOfpOT5L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 206.99,
    "currency": "USD",
    "price_original": "$206.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=8&crid=BALSGJKBQE1X&qid=1753561770&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_8#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 29,
    "asin": null,
    "title": "JUANWE 8GB USB Flash Drive 10 Packs, Bulk USB Sticks 2.0 Mutipack Metal Thumb Drive 360¬∞ Swivel Design, FAT32 Jump Drives Pen Drive Zip Drives for Data Storage - Black",
    "brand": "JUANWE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$25.59",
    "rating": 4.4,
    "review_count": 4,
    "special_features": "Metal, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/61FdaQfcUNL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 25.59,
    "currency": "USD",
    "price_original": "$25.59"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NTg3NjU3MDQzODE1MDgzOjE3NTM1NjE4MjE6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4NDc4NDM0ODc0MDI6OjA6Og&url=%2FJUANWE-Flash-Drive-Swivel-Memory%2Fdp%2FB00VLAE3TW%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB00VLAE3TW%26pd_rd_r%3D4b680cca-24a3-42df-9eb2-f70bbcb9b052%26pd_rd_w%3DEIxcf%26pd_rd_wg%3DBctp8%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D87NGQ4WT51YNRHS1TENS%26qid%3D1753561795%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-113-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B00VLAE3TW",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 30,
    "asin": "B00VLAE3TW",
    "title": "JUANWE 8GB USB Flash Drive 10 Packs, Bulk USB Sticks 2.0 Mutipack Metal Thumb Drive 360¬∞ Swivel Design, FAT32 Jump Drives Pen Drive Zip Drives for Data Storage - Black",
    "brand": "JUANWE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$25.59",
    "rating": 4.4,
    "review_count": 4,
    "special_features": "Metal, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/61FdaQfcUNL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 25.59,
    "currency": "USD",
    "price_original": "$25.59"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NTg3NjU3MDQzODE1MDgzOjE3NTM1NjE4MjE6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyMTI3OTUwMzg4MDI6OjI6Og&url=%2F4GB-Multi-Coloured-Pendrive-Assorted-FEBNISCTE%2Fdp%2FB07MNRYJGX%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07MNRYJGX%26pd_rd_r%3D4b680cca-24a3-42df-9eb2-f70bbcb9b052%26pd_rd_w%3DEIxcf%26pd_rd_wg%3DBctp8%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D87NGQ4WT51YNRHS1TENS%26qid%3D1753561795%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-115-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07MNRYJGX",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 31,
    "asin": "B07MNRYJGX",
    "title": "FEBNISCTE Thumb Drive 4GB 10 Pack USB Flash Drives Bulk, Swivel Jump Drive 4 GB Multi-Coloured Pen Drive USB 2.0 Memory Stick with Cords, Data Storage Pendrive 10 Color Assorted Zip Drives",
    "brand": "FEBNISCTE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$21.59",
    "rating": 4.5,
    "review_count": 5,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-08_files/71lxOtSOxNL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 21.59,
    "currency": "USD",
    "price_original": "$21.59"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NTg3NjU3MDQzODE1MDgzOjE3NTM1NjE4MjE6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyNjM4NTg0OTQ3MDI6OjM6Og&url=%2FWooolken-Memory-Lanyards-Swivel-Pendrive%2Fdp%2FB0C4NWQ3LL%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0C4NWQ3LL%26pd_rd_r%3D4b680cca-24a3-42df-9eb2-f70bbcb9b052%26pd_rd_w%3DEIxcf%26pd_rd_wg%3DBctp8%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D87NGQ4WT51YNRHS1TENS%26qid%3D1753561795%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-116-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0C4NWQ3LL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 32,
    "asin": "B0C4NWQ3LL",
    "title": "4GB USB Flash Drive 10 Pack, Wooolken USB 2.0 Thumb Drives with Lanyards Swivel Memory Stick for Data Storage and Backup (Mixed Colors)",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.31",
    "rating": 4.6,
    "review_count": 700,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/71xGy6SiMEL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.31,
    "currency": "USD",
    "price_original": "$19.31"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NTg3NjU3MDQzODE1MDgzOjE3NTM1NjE4MjE6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA1NjcwMTIyNTEwMDI6OjQ6Og&url=%2FCertified-iPhone-Memory-Compatible-Android%2Fdp%2FB0DCZLG48X%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DCZLG48X%26pd_rd_r%3D4b680cca-24a3-42df-9eb2-f70bbcb9b052%26pd_rd_w%3DEIxcf%26pd_rd_wg%3DBctp8%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D87NGQ4WT51YNRHS1TENS%26qid%3D1753561795%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-117-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DCZLG48X",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-08.html",
    "position": 33,
    "asin": "B0DCZLG48X",
    "title": "Apple MFi Certified 128GB Flash Drive for iPhone Thumb Drive Photo Stick, USB Memory Stick iPhone Flash Drive for Photos Videos, High Speed Jump Drive Compatible for iPhone/iPad/Android/PC (Pink)",
    "brand": "Apple",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$19.98",
    "rating": 4.2,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-08_files/61ZEyzOhrpL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.98,
    "currency": "USD",
    "price_original": "$19.98"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Performance-SDCZ48-128G-U46-Everything-Stromboli/dp/B07R2DCB1D/ref=sr_1_131?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.awDO7u2Wl1VT7zgBj3IsyMOEMJS7bi95X-9Y19XDMo7GjHj071QN20LucGBJIEps.8_T4vtsJZTjnN6-cLc4sLid83OIeXphMlBkn8HQAykc&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-131&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07R2DCB1D",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 1,
    "asin": "B07R2DCB1D",
    "title": "128GB Flash Ultra (10 Pack Bundle) 3.0 USB Flash Drive High Performance Thumb Drive (SDCZ48-128G-U46) Plus (5) Everything But Stromboli (TM) Lanyard",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "SD",
    "price": "$91.84",
    "rating": 3.8,
    "review_count": 22,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -22,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/81v7xm7QwNL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 91.84,
    "currency": "USD",
    "price_original": "$91.84"
  },
  {
    "product_url": "https://www.amazon.com/MOSDART-Bright-Multipack-Computers-Storage/dp/B0D3FB3KFV/ref=sr_1_132?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.awDO7u2Wl1VT7zgBj3IsyMOEMJS7bi95X-9Y19XDMo7GjHj071QN20LucGBJIEps.8_T4vtsJZTjnN6-cLc4sLid83OIeXphMlBkn8HQAykc&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-132&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D3FB3KFV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 2,
    "asin": "B0D3FB3KFV",
    "title": "64GB USB 2.0 Flash Drive, with Keychain Loop, Swivel Design with LED Light, exFAT Memory Stick for Computers, System Backup, Data Storage Thumb Drive, Green and Blue (Pack of 2)",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$9.99",
    "rating": 4.6,
    "review_count": 200,
    "special_features": "Keychain, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/61fBzba0MDL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 9.99,
    "currency": "USD",
    "price_original": "$9.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Ultra-Type-C-Flash-Drive/dp/B081DFPN3T/ref=sr_1_133?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.awDO7u2Wl1VT7zgBj3IsyMOEMJS7bi95X-9Y19XDMo7GjHj071QN20LucGBJIEps.8_T4vtsJZTjnN6-cLc4sLid83OIeXphMlBkn8HQAykc&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-133&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B081DFPN3T",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 3,
    "asin": "B081DFPN3T",
    "title": "32GB Ultra USB Type-C Flash Drive - SDCZ460-032G-G46, Black",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$8.79",
    "rating": 4.4,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/51U1ek10aEL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 8.79,
    "currency": "USD",
    "price_original": "$8.79"
  },
  {
    "product_url": "https://www.amazon.com/PNY-32GB-Attach%C3%A9-Flash-Drive/dp/B07YZSXG21/ref=sr_1_129?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ciRcPo0yCRDQNowFVgIAkRfeaGLIVswNRydFBewFe2R-yxCnl4X9sZbv1TrLuUvp7JolbrjqOFl6wvznRYzI7WhEZUnxNavnP6sk0BTBQISTy__DzbR86z2i4J0jR813ZB5eJ9iwkspZr9NhWOQLt99zMHf1VnS4NwraQSRs3FqoQ4xX0SJN2lxxzlZA7Kbz.V36Ut83ajgT5A33WBW5lMQbPIwXA0Iq1i-J1M134eb0&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-129&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07YZSXG21",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 4,
    "asin": "B07YZSXG21",
    "title": "32GB Attach√© 4 USB 2.0 Flash Drive, Black, (Pack of 5)",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$14.98",
    "rating": 4.5,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.8K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/71w7QwXuItL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.98,
    "currency": "USD",
    "price_original": "$14.98"
  },
  {
    "product_url": "https://www.amazon.com/Waterproof-Memory-Storage-Keychain-Computer/dp/B0D4QRSW5J/ref=sr_1_130?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ciRcPo0yCRDQNowFVgIAkRfeaGLIVswNRydFBewFe2R-yxCnl4X9sZbv1TrLuUvp7JolbrjqOFl6wvznRYzI7WhEZUnxNavnP6sk0BTBQISTy__DzbR86z2i4J0jR813ZB5eJ9iwkspZr9NhWOQLt99zMHf1VnS4NwraQSRs3FqoQ4xX0SJN2lxxzlZA7Kbz.V36Ut83ajgT5A33WBW5lMQbPIwXA0Iq1i-J1M134eb0&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-130&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D4QRSW5J",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 5,
    "asin": "B0D4QRSW5J",
    "title": "USB Flash Drive 230GB Waterproof USB Stick High Speed Memory Stick 230GB Ultra Large Storage Metal Thumb Drive with Keychain Design for Laptop Computer Tablet",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 230000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$13.99",
    "rating": 4.2,
    "review_count": 500,
    "special_features": "Waterproof, Metal, Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -267,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/51JIByl41sL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 13.99,
    "currency": "USD",
    "price_original": "$13.99"
  },
  {
    "product_url": "https://www.amazon.com/SSK-Memory-Type-C-Smartphones-Tablets/dp/B0DFGMSQ8C/ref=sr_1_131?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ciRcPo0yCRDQNowFVgIAkRfeaGLIVswNRydFBewFe2R-yxCnl4X9sZbv1TrLuUvp7JolbrjqOFl6wvznRYzI7WhEZUnxNavnP6sk0BTBQISTy__DzbR86z2i4J0jR813ZB5eJ9iwkspZr9NhWOQLt99zMHf1VnS4NwraQSRs3FqoQ4xX0SJN2lxxzlZA7Kbz.V36Ut83ajgT5A33WBW5lMQbPIwXA0Iq1i-J1M134eb0&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-131&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DFGMSQ8C",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 6,
    "asin": "B0DFGMSQ8C",
    "title": "USB 3.2 Flash Drive 64GB,Up to 200 MB/S Read Speed USB C Memory Stick,Dual USB C Thumb Drive with USB Type-C and USB A,Robust Black Metal Pen Drive for Smartphones,Tablets,Mac,Laptop,Car,TV",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$9.99",
    "rating": 4.5,
    "review_count": 400,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/61NTqP0MI2L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 9.99,
    "currency": "USD",
    "price_original": "$9.99"
  },
  {
    "product_url": "https://www.amazon.com/PNY-Attach%C3%A9-Flash-Drive-2-Pack/dp/B0CKLT8GG2/ref=sr_1_132?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ciRcPo0yCRDQNowFVgIAkRfeaGLIVswNRydFBewFe2R-yxCnl4X9sZbv1TrLuUvp7JolbrjqOFl6wvznRYzI7WhEZUnxNavnP6sk0BTBQISTy__DzbR86z2i4J0jR813ZB5eJ9iwkspZr9NhWOQLt99zMHf1VnS4NwraQSRs3FqoQ4xX0SJN2lxxzlZA7Kbz.V36Ut83ajgT5A33WBW5lMQbPIwXA0Iq1i-J1M134eb0&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-132&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CKLT8GG2",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 7,
    "asin": "B0CKLT8GG2",
    "title": "16GB Attach√© USB 2.0 Flash Drive 2-Pack",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$10.69",
    "rating": 4.5,
    "review_count": 299,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/51K7bihlReL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 10.69,
    "currency": "USD",
    "price_original": "$10.69"
  },
  {
    "product_url": "https://www.amazon.com/Transfer-External-Picture-Storage-Expansion/dp/B0CFDZ46TN/ref=sr_1_133?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ciRcPo0yCRDQNowFVgIAkRfeaGLIVswNRydFBewFe2R-yxCnl4X9sZbv1TrLuUvp7JolbrjqOFl6wvznRYzI7WhEZUnxNavnP6sk0BTBQISTy__DzbR86z2i4J0jR813ZB5eJ9iwkspZr9NhWOQLt99zMHf1VnS4NwraQSRs3FqoQ4xX0SJN2lxxzlZA7Kbz.V36Ut83ajgT5A33WBW5lMQbPIwXA0Iq1i-J1M134eb0&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-133&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CFDZ46TN",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 8,
    "asin": "B0CFDZ46TN",
    "title": "256GB Flash Drive for iPhone Photo Stick,Thumb Drive USB Stick High Speed Transfer USB Drives External Picture Video Storage Memory Expansion for iPhone/iPad/PC (Blue)",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 3.8,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/61l4p6mjA3L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/Vansuny-Waterproof-Memory-Portable-Tablets/dp/B0998WHY69/ref=sr_1_136?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ciRcPo0yCRDQNowFVgIAkRfeaGLIVswNRydFBewFe2R-yxCnl4X9sZbv1TrLuUvp7JolbrjqOFl6wvznRYzI7WhEZUnxNavnP6sk0BTBQISTy__DzbR86z2i4J0jR813ZB5eJ9iwkspZr9NhWOQLt99zMHf1VnS4NwraQSRs3FqoQ4xX0SJN2lxxzlZA7Kbz.V36Ut83ajgT5A33WBW5lMQbPIwXA0Iq1i-J1M134eb0&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-136&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0998WHY69",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 9,
    "asin": "B0998WHY69",
    "title": "64GB Flash Drive Metal Waterproof USB Drive USB 3.0 Ultra High Speed Memory Stick, Portable Thumb Drive for PC/Tablets/Mac/Laptop",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$7.99",
    "rating": 4.5,
    "review_count": 300,
    "special_features": "Waterproof, Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/41gl+3RV10L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 7.99,
    "currency": "USD",
    "price_original": "$7.99"
  },
  {
    "product_url": "https://www.amazon.com/TOPESEL-128GB-Memory-Swivel-Indicator/dp/B09MT7VLY4/ref=sr_1_137?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ciRcPo0yCRDQNowFVgIAkRfeaGLIVswNRydFBewFe2R-yxCnl4X9sZbv1TrLuUvp7JolbrjqOFl6wvznRYzI7WhEZUnxNavnP6sk0BTBQISTy__DzbR86z2i4J0jR813ZB5eJ9iwkspZr9NhWOQLt99zMHf1VnS4NwraQSRs3FqoQ4xX0SJN2lxxzlZA7Kbz.V36Ut83ajgT5A33WBW5lMQbPIwXA0Iq1i-J1M134eb0&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-137&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09MT7VLY4",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 10,
    "asin": "B09MT7VLY4",
    "title": "128GB USB 2.0 Flash Drive Memory Stick Thumb Drive Swivel USB Jump Drive with LED Indicator (Black)",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$8.99",
    "rating": 4.5,
    "review_count": 50,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/61SIuyM72DL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 8.99,
    "currency": "USD",
    "price_original": "$8.99"
  },
  {
    "product_url": "https://www.amazon.com/Verbatim-Metal-Executive-Flash-Drive/dp/B017JJSJZM/ref=sr_1_138?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ciRcPo0yCRDQNowFVgIAkRfeaGLIVswNRydFBewFe2R-yxCnl4X9sZbv1TrLuUvp7JolbrjqOFl6wvznRYzI7WhEZUnxNavnP6sk0BTBQISTy__DzbR86z2i4J0jR813ZB5eJ9iwkspZr9NhWOQLt99zMHf1VnS4NwraQSRs3FqoQ4xX0SJN2lxxzlZA7Kbz.V36Ut83ajgT5A33WBW5lMQbPIwXA0Iq1i-J1M134eb0&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-138&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B017JJSJZM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 11,
    "asin": "B017JJSJZM",
    "title": "32GB Metal Executive USB Flash Drive - Silver - 98749",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$6.03",
    "rating": 4.5,
    "review_count": 100,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/61DMAbSsa0L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 6.03,
    "currency": "USD",
    "price_original": "$6.03"
  },
  {
    "product_url": "https://www.amazon.com/Silicon-Power-128GB-Flash-Drive/dp/B0CCV9S84T/ref=sr_1_139?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ciRcPo0yCRDQNowFVgIAkRfeaGLIVswNRydFBewFe2R-yxCnl4X9sZbv1TrLuUvp7JolbrjqOFl6wvznRYzI7WhEZUnxNavnP6sk0BTBQISTy__DzbR86z2i4J0jR813ZB5eJ9iwkspZr9NhWOQLt99zMHf1VnS4NwraQSRs3FqoQ4xX0SJN2lxxzlZA7Kbz.V36Ut83ajgT5A33WBW5lMQbPIwXA0Iq1i-J1M134eb0&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-139&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CCV9S84T",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 12,
    "asin": "B0CCV9S84T",
    "title": "Silicon Power 3 Pack 128GB USB 3.0/3.1 Gen1 USB Flash Drive Blaze B02",
    "brand": "Silicon",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$21.99",
    "rating": 4.5,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "7 sizes7 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/71RX00ySs3L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 21.99,
    "currency": "USD",
    "price_original": "$21.99"
  },
  {
    "product_url": "https://www.amazon.com/Certified-iPhone-Memory-Compatible-Android/dp/B0DCZLGJGM/ref=sr_1_140?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ciRcPo0yCRDQNowFVgIAkRfeaGLIVswNRydFBewFe2R-yxCnl4X9sZbv1TrLuUvp7JolbrjqOFl6wvznRYzI7WhEZUnxNavnP6sk0BTBQISTy__DzbR86z2i4J0jR813ZB5eJ9iwkspZr9NhWOQLt99zMHf1VnS4NwraQSRs3FqoQ4xX0SJN2lxxzlZA7Kbz.V36Ut83ajgT5A33WBW5lMQbPIwXA0Iq1i-J1M134eb0&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-140&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DCZLGJGM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 13,
    "asin": "B0DCZLGJGM",
    "title": "Apple MFi Certified 128GB Flash Drive for iPhone Thumb Drive Photo Stick, USB Memory Stick iPhone Flash Drive for Photos Videos, High Speed Jump Drive Compatible for iPhone/iPad/Android/PC (Blue)",
    "brand": "Apple",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$18.98",
    "rating": 4.2,
    "review_count": 3,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/61mO23ePr1L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.98,
    "currency": "USD",
    "price_original": "$18.98"
  },
  {
    "product_url": "https://www.amazon.com/TOPESEL-Indicator-Sharing-Between-Smartphones/dp/B0CW63G4QT/ref=sr_1_141?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ciRcPo0yCRDQNowFVgIAkRfeaGLIVswNRydFBewFe2R-yxCnl4X9sZbv1TrLuUvp7JolbrjqOFl6wvznRYzI7WhEZUnxNavnP6sk0BTBQISTy__DzbR86z2i4J0jR813ZB5eJ9iwkspZr9NhWOQLt99zMHf1VnS4NwraQSRs3FqoQ4xX0SJN2lxxzlZA7Kbz.V36Ut83ajgT5A33WBW5lMQbPIwXA0Iq1i-J1M134eb0&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-141&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CW63G4QT",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 14,
    "asin": "B0CW63G4QT",
    "title": "Type C 256GB USB C Flash Drive Dual 2-in-1 Thumb Drive USB 3.0/3.2 Gen1 Drive 256 GB USB-C Memory Stick with LED Indicator for Easy Data Sharing Between PC and Android Smartphones",
    "brand": "Type",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$19.54",
    "rating": 4.3,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/51cfAHrKdoL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.54,
    "currency": "USD",
    "price_original": "$19.54"
  },
  {
    "product_url": "https://www.amazon.com/Verbatim-Snag-free-Microban-Antimicrobial-Protection/dp/B00RORBNSK/ref=sr_1_142?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ciRcPo0yCRDQNowFVgIAkRfeaGLIVswNRydFBewFe2R-yxCnl4X9sZbv1TrLuUvp7JolbrjqOFl6wvznRYzI7WhEZUnxNavnP6sk0BTBQISTy__DzbR86z2i4J0jR813ZB5eJ9iwkspZr9NhWOQLt99zMHf1VnS4NwraQSRs3FqoQ4xX0SJN2lxxzlZA7Kbz.V36Ut83ajgT5A33WBW5lMQbPIwXA0Iq1i-J1M134eb0&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-142&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B00RORBNSK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 15,
    "asin": "B00RORBNSK",
    "title": "16GB Store 'n' Stay Nano USB 3.2 Gen 1 Flash Drive Snag-free Low Profile Thumb Drive - Blue",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$7.06",
    "rating": 4.3,
    "review_count": 300,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/61pYZ-CzMSL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 7.06,
    "currency": "USD",
    "price_original": "$7.06"
  },
  {
    "product_url": "https://www.amazon.com/XINWAY-Drives-Memory-Swivel-Design/dp/B09YQZLYV8/ref=sr_1_143?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ciRcPo0yCRDQNowFVgIAkRfeaGLIVswNRydFBewFe2R-yxCnl4X9sZbv1TrLuUvp7JolbrjqOFl6wvznRYzI7WhEZUnxNavnP6sk0BTBQISTy__DzbR86z2i4J0jR813ZB5eJ9iwkspZr9NhWOQLt99zMHf1VnS4NwraQSRs3FqoQ4xX0SJN2lxxzlZA7Kbz.V36Ut83ajgT5A33WBW5lMQbPIwXA0Iq1i-J1M134eb0&dib_tag=se&keywords=flash+drives&qid=1753561844&sprefix=flash+drive%2Caps%2C146&sr=8-143&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09YQZLYV8",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 16,
    "asin": "B09YQZLYV8",
    "title": "64GB USB 2.0 Flash Drives Thumb Drive Memory Stick Jump Drive Swivel Design, (2 Pack Tow Colors: Black Blue)",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$7.99",
    "rating": 4.2,
    "review_count": 50,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -216,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/51tDIxilKNL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 7.99,
    "currency": "USD",
    "price_original": "$7.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=9&crid=BALSGJKBQE1X&qid=1753561795&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_9#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 17,
    "asin": null,
    "title": "AGECASH 2GB USB Flash Drive 20 Pack Bulk USB 2.0 Fat Flash Drives 2GB Thumb Drive 20 Packs Memory Stick Jump Drives Multipack Zip Drive for Data Storage and Backup (Multicolor, 2 GB 20Pack)",
    "brand": "AGECASH",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$35.71",
    "rating": 4.5,
    "review_count": 98,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -98,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/71AXNECWmTL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 35.71,
    "currency": "USD",
    "price_original": "$35.71"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1NjcyNTI0ODk4NjA2NTM1OjE3NTM1NjE4NDc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1ODA2Mjc5NTMwMjo6MDo6&url=%2FAGECASH-2GB-Flash-Pack-Drives%2Fdp%2FB0DZBT3QF3%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DZBT3QF3%26pd_rd_r%3D9f8827e9-d3f2-4070-aaf7-8e287646b03e%26pd_rd_w%3DJ89pX%26pd_rd_wg%3Dwx8Qb%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DN3JGZ88Q036ZY7HZM3DB%26qid%3D1753561844%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-129-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DZBT3QF3",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 18,
    "asin": "B0DZBT3QF3",
    "title": "AGECASH 2GB USB Flash Drive 20 Pack Bulk USB 2.0 Fat Flash Drives 2GB Thumb Drive 20 Packs Memory Stick Jump Drives Multipack Zip Drive for Data Storage and Backup (Multicolor, 2 GB 20Pack)",
    "brand": "AGECASH",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$35.71",
    "rating": 4.5,
    "review_count": 98,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -98,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/71AXNECWmTL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 35.71,
    "currency": "USD",
    "price_original": "$35.71"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1NjcyNTI0ODk4NjA2NTM1OjE3NTM1NjE4NDc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MDkzNTgzMjMwMjo6MTo6&url=%2F20PACK-AGECASH-Pendrive-Lanyards-Storage%2Fdp%2FB0CXM34VB4%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CXM34VB4%26pd_rd_r%3D9f8827e9-d3f2-4070-aaf7-8e287646b03e%26pd_rd_w%3DJ89pX%26pd_rd_wg%3Dwx8Qb%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DN3JGZ88Q036ZY7HZM3DB%26qid%3D1753561844%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-130-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CXM34VB4",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 19,
    "asin": "B0CXM34VB4",
    "title": "256MB USB Flash Drive 20 Pack AGECASH USB 2.0 Thumb Flash Drives Bulk Green Swivel 256MB USB Memory Stick Zip Jump Drive Multipack Pendrive with Labels & Lanyards",
    "brand": "256MB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$25.26",
    "rating": 4.5,
    "review_count": 388,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -388,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-09_files/71GfnlOheQL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "mb",
    "price_numeric": 25.26,
    "currency": "USD",
    "price_original": "$25.26"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1NjcyNTI0ODk4NjA2NTM1OjE3NTM1NjE4NDc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MTQzMjM1NzgwMjo6Mjo6&url=%2FNicepicten-Storage-Pendrive-Lanyard-Mixcolor%2Fdp%2FB0CSBKPTYF%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CSBKPTYF%26pd_rd_r%3D9f8827e9-d3f2-4070-aaf7-8e287646b03e%26pd_rd_w%3DJ89pX%26pd_rd_wg%3Dwx8Qb%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DN3JGZ88Q036ZY7HZM3DB%26qid%3D1753561844%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-131-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CSBKPTYF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 20,
    "asin": "B0CSBKPTYF",
    "title": "2GB USB Flash Drive 10 Pack Nicepicten USB 2.0 Thumb Drives Metal Jump Zip Drive Memory Stick Pendrive Memoria USB 2 GB with 10PCS Lanyard Label - Mixcolor 10 X 2GB Flash Drives",
    "brand": "2GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.6,
    "review_count": 116,
    "special_features": "Metal, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -116,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/71n29rpKrBL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1NjcyNTI0ODk4NjA2NTM1OjE3NTM1NjE4NDc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDY3NzIwODU2MTQwMjo6Mzo6&url=%2FFlash-Drive-USB2-0-Drives-lcwamy%2Fdp%2FB0D4JY28MF%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0D4JY28MF%26pd_rd_r%3D9f8827e9-d3f2-4070-aaf7-8e287646b03e%26pd_rd_w%3DJ89pX%26pd_rd_wg%3Dwx8Qb%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DN3JGZ88Q036ZY7HZM3DB%26qid%3D1753561844%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-132-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0D4JY28MF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 21,
    "asin": "B0D4JY28MF",
    "title": "8GB Flash Drives 10 Pack USB Drive 8GB USB Stick USB Flash Drive Bulk Thumb Drive",
    "brand": "8GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$26.99",
    "rating": 4.7,
    "review_count": 99,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -99,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/61lS3HoEy0L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 26.99,
    "currency": "USD",
    "price_original": "$26.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1NjcyNTI0ODk4NjA2NTM1OjE3NTM1NjE4NDc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDEzODc5NzYzODAwMjo6NDo6&url=%2FKepmem-Portable-Keychain-Colorful-Multipack%2Fdp%2FB09D3R4C2Z%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB09D3R4C2Z%26pd_rd_r%3D9f8827e9-d3f2-4070-aaf7-8e287646b03e%26pd_rd_w%3DJ89pX%26pd_rd_wg%3Dwx8Qb%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DN3JGZ88Q036ZY7HZM3DB%26qid%3D1753561844%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-133-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B09D3R4C2Z",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 22,
    "asin": "B09D3R4C2Z",
    "title": "Swivel Pen Drive 8GB USB 3.0 Memory Stick Pack of 10, Colorful Multipack Zip Drives for Data Storage",
    "brand": "Swivel",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 4.2,
    "review_count": 50,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -150,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/71lFJZly-9L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=9&crid=BALSGJKBQE1X&qid=1753561795&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_9#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 23,
    "asin": null,
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (50,128GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$329.99",
    "rating": null,
    "review_count": 60,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 329.99,
    "currency": "USD",
    "price_original": "$329.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0MDk5NzE3NjE2NDY2NTcyOjE3NTM1NjE4NDc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU4OTkwMjo6MTo6&url=%2FCustom-Drives-Personalized-Business-Promotions%2Fdp%2FB0FGQ46QL2%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQ46QL2%26pd_rd_r%3D9f8827e9-d3f2-4070-aaf7-8e287646b03e%26pd_rd_w%3DzdL0d%26pd_rd_wg%3Dwx8Qb%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DN3JGZ88Q036ZY7HZM3DB%26qid%3D1753561844%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-129-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ46QL2",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 24,
    "asin": "B0FGQ46QL2",
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (50,128GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$329.99",
    "rating": null,
    "review_count": 329,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-09_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 329.99,
    "currency": "USD",
    "price_original": "$329.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0MDk5NzE3NjE2NDY2NTcyOjE3NTM1NjE4NDc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5MjcwMjo6Mjo6&url=%2FFlash-Drive-Customizable-Thumb-4GB-128GB%2Fdp%2FB0FGQ2X739%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQ2X739%26pd_rd_r%3D9f8827e9-d3f2-4070-aaf7-8e287646b03e%26pd_rd_w%3DzdL0d%26pd_rd_wg%3Dwx8Qb%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DN3JGZ88Q036ZY7HZM3DB%26qid%3D1753561844%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-130-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ2X739",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 25,
    "asin": "B0FGQ2X739",
    "title": "Mini USB Flash Drive Customizable Tiny Thumb Drive with Your Logo 4GB-128GB - Perfect for Corporate Events, Branded Promotions, Student Projects Plug and Play, PC Mac (50,16GB)",
    "brand": "Mini",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$189.99",
    "rating": null,
    "review_count": 189,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-09_files/41Y5IinJkAL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 189.99,
    "currency": "USD",
    "price_original": "$189.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0MDk5NzE3NjE2NDY2NTcyOjE3NTM1NjE4NDc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5NjkwMjo6Mzo6&url=%2FCustom-Personalized-Packaging-Business-Outreach%2Fdp%2FB0FGQHX9FP%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQHX9FP%26pd_rd_r%3D9f8827e9-d3f2-4070-aaf7-8e287646b03e%26pd_rd_w%3DzdL0d%26pd_rd_wg%3Dwx8Qb%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DN3JGZ88Q036ZY7HZM3DB%26qid%3D1753561844%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-131-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQHX9FP",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 26,
    "asin": "B0FGQHX9FP",
    "title": "Custom Logo USB Drive 50 100 Count Personalized Packaging for School Business Outreach (100,128GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$654.99",
    "rating": null,
    "review_count": 654,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-09_files/41ckOfpOT5L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 654.99,
    "currency": "USD",
    "price_original": "$654.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0MDk5NzE3NjE2NDY2NTcyOjE3NTM1NjE4NDc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5MzYwMjo6NDo6&url=%2FPersonalized-Corporate-University-Outreach-Branding%2Fdp%2FB0FGQ438DN%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQ438DN%26pd_rd_r%3D9f8827e9-d3f2-4070-aaf7-8e287646b03e%26pd_rd_w%3DzdL0d%26pd_rd_wg%3Dwx8Qb%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DN3JGZ88Q036ZY7HZM3DB%26qid%3D1753561844%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-132-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ438DN",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 27,
    "asin": "B0FGQ438DN",
    "title": "Personalized USB Memory Sticks 50 100 Pack Branded Boxes for Corporate Gifts University Fairs Company Outreach Client Branding (100,128GB)",
    "brand": "Personalized",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$654.99",
    "rating": null,
    "review_count": 654,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-09_files/31bGX-EfFeL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 654.99,
    "currency": "USD",
    "price_original": "$654.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0MDk5NzE3NjE2NDY2NTcyOjE3NTM1NjE4NDc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1NTU4ODgyODgwMjo6NTo6&url=%2F32GB-USB-Flash-Drive-Compatible%2Fdp%2FB0FF4QQD7K%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FF4QQD7K%26pd_rd_r%3D9f8827e9-d3f2-4070-aaf7-8e287646b03e%26pd_rd_w%3DzdL0d%26pd_rd_wg%3Dwx8Qb%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DN3JGZ88Q036ZY7HZM3DB%26qid%3D1753561844%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-133-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FF4QQD7K",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 28,
    "asin": "B0FF4QQD7K",
    "title": "32GB USB Flash Drive ‚Äì 4 in 1 USB C Flash Drive with USB 3.0, Type C, Micro USB & iOS Connector ‚Äì High Speed Thumb Drive, Memory Stick Compatible with Laptop, Android, PC - Black",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$15.29",
    "rating": null,
    "review_count": 15,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/61dIzLLe+-L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 15.29,
    "currency": "USD",
    "price_original": "$15.29"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=9&crid=BALSGJKBQE1X&qid=1753561795&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_9#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 29,
    "asin": null,
    "title": "1GB Flash Drive 10 Pack, Wooolken USB 2.0 Memory Stick Thumb Drive with Lanyards Swivel USB Stick for Data Storage and Backup (Mixed Colors)",
    "brand": "1GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.31",
    "rating": 4.6,
    "review_count": 700,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/71xGy6SiMEL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.31,
    "currency": "USD",
    "price_original": "$19.31"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyNTU0OTIzMTE3NzkzODE1OjE3NTM1NjE4NDc6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyNjM4NTg0OTQ0MDI6OjA6Og&url=%2FWooolken-Memory-Storage-Backup-Colors%2Fdp%2FB0C4NWR46H%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0C4NWR46H%26pd_rd_r%3D3a5c4996-09db-41f5-baa9-d82496e434e2%26pd_rd_w%3DdAa9g%26pd_rd_wg%3D7IjrK%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DN3JGZ88Q036ZY7HZM3DB%26qid%3D1753561844%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-129-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0C4NWR46H",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 30,
    "asin": "B0C4NWR46H",
    "title": "1GB Flash Drive 10 Pack, Wooolken USB 2.0 Memory Stick Thumb Drive with Lanyards Swivel USB Stick for Data Storage and Backup (Mixed Colors)",
    "brand": "1GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.31",
    "rating": 4.6,
    "review_count": 700,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/71xGy6SiMEL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.31,
    "currency": "USD",
    "price_original": "$19.31"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyNTU0OTIzMTE3NzkzODE1OjE3NTM1NjE4NDc6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyNjM4NTg1MDA0MDI6OjE6Og&url=%2FWooolken-10Pack-Keychains-Computer-Mixcolors%2Fdp%2FB0CXM15S33%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CXM15S33%26pd_rd_r%3D3a5c4996-09db-41f5-baa9-d82496e434e2%26pd_rd_w%3DdAa9g%26pd_rd_wg%3D7IjrK%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DN3JGZ88Q036ZY7HZM3DB%26qid%3D1753561844%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-130-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CXM15S33",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 31,
    "asin": "B0CXM15S33",
    "title": "Flash Drives 8GB 10 Pack, Wooolken USB 2.0 Thumb Drives with Keychains Memory Stick USB Drive Pendrive for PC Laptop Computer (Mixcolors)",
    "brand": "Flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$21.24",
    "rating": 4.5,
    "review_count": 569,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -569,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/71LZG0ddZrL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 21.24,
    "currency": "USD",
    "price_original": "$21.24"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyNTU0OTIzMTE3NzkzODE1OjE3NTM1NjE4NDc6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4NDc2ODA2NjU3MDI6OjI6Og&url=%2FJUANWE-Drives-Storage-Memory-Swivel%2Fdp%2FB00W16DVA2%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB00W16DVA2%26pd_rd_r%3D3a5c4996-09db-41f5-baa9-d82496e434e2%26pd_rd_w%3DdAa9g%26pd_rd_wg%3D7IjrK%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DN3JGZ88Q036ZY7HZM3DB%26qid%3D1753561844%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-131-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B00W16DVA2",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 32,
    "asin": "B00W16DVA2",
    "title": "2GB USB Flash Drive 10 Packs, 2.0 Thumb Drives 360¬∞ Swivel Shell, USB Sticks Jump Drives for Storage, Mutipack Zip Drive Pen Drive for Computer/CarÔºåBulk Memory Sticks - Black",
    "brand": "2GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$23.99",
    "rating": 4.4,
    "review_count": 4,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/61p4ip0Pn+L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 23.99,
    "currency": "USD",
    "price_original": "$23.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyNTU0OTIzMTE3NzkzODE1OjE3NTM1NjE4NDc6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyNjM4NTg0OTc1MDI6OjM6Og&url=%2FWooolken-Keychains-Drives-Memory-Computer%2Fdp%2FB0CWRT373M%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CWRT373M%26pd_rd_r%3D3a5c4996-09db-41f5-baa9-d82496e434e2%26pd_rd_w%3DdAa9g%26pd_rd_wg%3D7IjrK%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DN3JGZ88Q036ZY7HZM3DB%26qid%3D1753561844%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-132-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CWRT373M",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 33,
    "asin": "B0CWRT373M",
    "title": "20 Pack 4GB USB Flash Drive with Keychains, Wooolken Sleek Metal USB 2.0 Thumb Drives Memory Stick for PC Laptop Computer(Gold)",
    "brand": 20,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$40.49",
    "rating": 4.4,
    "review_count": 681,
    "special_features": "Metal, Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -681,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/71hADI4NdsL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 40.49,
    "currency": "USD",
    "price_original": "$40.49"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyNTU0OTIzMTE3NzkzODE1OjE3NTM1NjE4NDc6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjoyMDAxMDAxMDU3MDgxMTE6OjQ6Og&url=%2FFlash-Drive-Crystal-Memory-Pendrive%2Fdp%2FB07SM7VKQJ%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07SM7VKQJ%26pd_rd_r%3D3a5c4996-09db-41f5-baa9-d82496e434e2%26pd_rd_w%3DdAa9g%26pd_rd_wg%3D7IjrK%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DN3JGZ88Q036ZY7HZM3DB%26qid%3D1753561844%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-133-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07SM7VKQJ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-09.html",
    "position": 34,
    "asin": "B07SM7VKQJ",
    "title": "16GB USB 2.0 Flash Drive,Crystal Wood Clear Glass LED Light Thumb Jump Pendrive Pen Drive Fast Speed Memory Stick Gift for Girl Boy Women Men Kids Wedding Unique Novelty Cool Fun Photography Gift",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$11.87",
    "rating": 4,
    "review_count": 828,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -828,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-09_files/41boIFKf2EL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.87,
    "currency": "USD",
    "price_original": "$11.87"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMjMzNTE2MjkxOTkxMDEzOjE3NTM1NTkyODQ6c3BfYXRmOjIwMDA5NjA1MTY0MDY5ODo6MDo6&url=%2FAmazon-Basics-128GB-Ultra-Flash%2Fdp%2FB0B6148YKN%2Fref%3Dsr_1_1_ffob_sspa%3Fcrid%3DBALSGJKBQE1X%26dib%3DeyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48%26dib_tag%3Dse%26keywords%3Dflash%2Bdrives%26qid%3D1753559284%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D8-1-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9hdGY%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0B6148YKN",
    "blank": "",
    "affiliate_link": "https://amzn.to/40DDDFX",
    "source_file": "drives-1.html",
    "position": 1,
    "asin": "B0B6148YKN",
    "title": "Amazon Basics 128 GB Ultra Fast USB 3.1 Flash Drive, Black",
    "brand": "Amazon Basics",
    "manufacturer": "Amazon",
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.1",
    "memory_type": "USB",
    "price": "$14.99",
    "rating": 4.6,
    "review_count": 25740,
    "special_features": "Lightweight",
    "weight": 0.02,
    "height": 0.53,
    "warranty": 12,
    "unit_count": 1,
    "read_speed": 130,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/71RhxfozxvL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.99,
    "currency": "USD",
    "price_original": "$14.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMjMzNTE2MjkxOTkxMDEzOjE3NTM1NTkyODQ6c3BfYXRmOjIwMDA5NjA1MTY0MDY5ODo6MDo6&url=%2FAmazon-Basics-128GB-Ultra-Flash%2Fdp%2FB0B6148YKN%2Fref%3Dsr_1_1_ffob_sspa%3Fcrid%3DBALSGJKBQE1X%26dib%3DeyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48%26dib_tag%3Dse%26keywords%3Dflash%2Bdrives%26qid%3D1753559284%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D8-1-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9hdGY%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0B61DGG18",
    "blank": "",
    "affiliate_link": "https://amzn.to/4o61sA2",
    "source_file": "drives-1.html",
    "position": 1,
    "asin": "B0B61DGG18",
    "title": "Amazon Basics 256 GB Ultra Fast USB 3.1 High Capacity Flash Drive for Data Transfer and Storage, Black",
    "brand": "Amazon Basics",
    "manufacturer": "Amazon",
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "256 GB",
    "memory_capacity_category": "256 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.6,
    "review_count": 25501,
    "special_features": "Lightweight",
    "weight": 0.02,
    "height": 0.53,
    "warranty": 12,
    "unit_count": 1,
    "read_speed": 130,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/71RhxfozxvL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Ultra-Flair-128GB-Flash/dp/B015CH1PJU/ref=sr_1_3?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-3&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B015CH1PJU",
    "blank": "",
    "affiliate_link": "https://amzn.to/458nOIy",
    "source_file": "drives-1.html",
    "position": 2,
    "asin": "B015CH1PJU",
    "title": "SanDisk 128GB Ultra Flair USB 3.0 Flash Drive - SDCZ73-128G-G46, black",
    "brand": "SanDisk",
    "manufacturer": "Western Digital Technologies Inc",
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.6,
    "review_count": 195003,
    "special_features": "Lightweight, Durable, Metal Casing",
    "weight": "4.5 grams",
    "height": 0.52,
    "warranty": 12,
    "unit_count": 1,
    "read_speed": 150,
    "write_speed": 4,
    "seller": "8 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/51q1BJpgGkL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/PNY-128GB-Turbo-Attach%C3%A9-5-Pack/dp/B0DDYCT5YS/ref=sr_1_4?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-4&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DDYCT5YS",
    "blank": "",
    "affiliate_link": "https://amzn.to/4f6h2aS",
    "source_file": "drives-1.html",
    "position": 3,
    "asin": "B0DDYCT5YS",
    "title": "PNY 128GB Turbo Attach√© 3 USB 3.0 Flash Drive 5-Pack ‚Äì Grey, P-FD128X5TBOP-MP, 100MB/s, Light-Weight Durable - Data Storage and Transfer",
    "brand": "PNY",
    "manufacturer": "PNY",
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$29.99",
    "rating": 4.6,
    "review_count": 40553,
    "special_features": "Lightweight",
    "weight": null,
    "height": null,
    "warranty": 12,
    "unit_count": 5,
    "read_speed": 100,
    "write_speed": null,
    "seller": "7 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/6155RbbYkAL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 29.99,
    "currency": "USD",
    "price_original": "$29.99"
  },
  {
    "product_url": "https://www.amazon.com/Amazon-Basics-128GB-Ultra-Flash/dp/B0B6148YKN/ref=sr_1_5?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-5&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0B6148YKN",
    "blank": "",
    "affiliate_link": "https://amzn.to/3IGSdq3",
    "source_file": "drives-1.html",
    "position": 4,
    "asin": "B0B6148YKN",
    "title": "Amazon Basics 128 GB Ultra Fast USB 3.1 Flash Drive, Black",
    "brand": "Amazon Basics",
    "manufacturer": "Amazon",
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$14.99",
    "rating": 4.6,
    "review_count": 10,
    "special_features": null,
    "weight": 0.02,
    "height": 0.53,
    "warranty": 12,
    "unit_count": 1,
    "read_speed": 130,
    "write_speed": null,
    "seller": "2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/71RhxfozxvL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.99,
    "currency": "USD",
    "price_original": "$14.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&crid=BALSGJKBQE1X&qid=1753559235&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_1#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": "",
    "affiliate_link": null,
    "source_file": "drives-1.html",
    "position": 5,
    "asin": null,
    "title": "128GB USB C Flash Drive Dual USB 3.0 Flash Drive Type C + USB A Portable Type-C Flash Drive 2-in-1 USB-C Thumb Drive for Smartphone Tablet Computer Mac iPhone 15 Black",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.4,
    "review_count": 4,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -946,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/51K6hZcFQ4L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyNjQ2NTY3MTc2Mzg5NzMwOjE3NTM1NTkyODQ6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDE1MDIyODMzMDkwMjo6MDo6&url=%2FJOIOT-Portable-Keychain-Smartphone-Computer%2Fdp%2FB0CSW6375K%2Fref%3Dsxin_15_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.70fcaece-2dd2-4653-bf00-fb6af1af1b93%253Aamzn1.sym.70fcaece-2dd2-4653-bf00-fb6af1af1b93%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CSW6375K%26pd_rd_r%3D9709b73e-6a1e-4ddb-a392-4aa1ee8f4cb7%26pd_rd_w%3DTsFwA%26pd_rd_wg%3DaLByD%26pf_rd_p%3D70fcaece-2dd2-4653-bf00-fb6af1af1b93%26pf_rd_r%3DRR3PD02GESNKAAF9140F%26qid%3D1753559284%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-1-e169343e-09af-4d41-85b1-8335fe8f32d0-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CSW6375K",
    "blank": "",
    "affiliate_link": "https://amzn.to/4kXozde",
    "source_file": "drives-1.html",
    "position": 6,
    "asin": "B0CSW6375K",
    "title": "JOIOT",
    "brand": "JOIOT",
    "manufacturer": "JOIOT",
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.4,
    "review_count": 1016,
    "special_features": "Shockproof",
    "weight": "8 grams",
    "height": null,
    "warranty": 12,
    "unit_count": 1,
    "read_speed": 70,
    "write_speed": 20,
    "seller": -946,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/51K6hZcFQ4L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyNjQ2NTY3MTc2Mzg5NzMwOjE3NTM1NTkyODQ6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDEzODc4ODU5MDkwMjo6MTo6&url=%2FGIGASTONE-Keychain-Push-Pull-Storage-Compatible%2Fdp%2FB0BY317K3Z%2Fref%3Dsxin_15_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.70fcaece-2dd2-4653-bf00-fb6af1af1b93%253Aamzn1.sym.70fcaece-2dd2-4653-bf00-fb6af1af1b93%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0BY317K3Z%26pd_rd_r%3D9709b73e-6a1e-4ddb-a392-4aa1ee8f4cb7%26pd_rd_w%3DTsFwA%26pd_rd_wg%3DaLByD%26pf_rd_p%3D70fcaece-2dd2-4653-bf00-fb6af1af1b93%26pf_rd_r%3DRR3PD02GESNKAAF9140F%26qid%3D1753559284%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-2-e169343e-09af-4d41-85b1-8335fe8f32d0-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0BY317K3Z",
    "blank": "",
    "affiliate_link": "https://amzn.to/4l2z2nU",
    "source_file": "drives-1.html",
    "position": 7,
    "asin": "B0BY317K3Z",
    "title": "GIGASTONE 128GB Flash Drive (5 Pack) Z30 USB 3.2 Gen 1, 100MB/s Ultra Fast, Keychain Loop, Carbon Fiber Style, Push-Pull Design, Data Storage, Backup for PC/Mac/TV/Car, USB 2.0/3.0/3.1 Compatible",
    "brand": "Gigastone",
    "manufacturer": "Gigastone",
    "model": "GS-U332GSLBL-R",
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$36.99",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Keychain,Wear Resistant, Magnetic Proof, Shockproof, Dust Proof, Water Resistant",
    "weight": null,
    "height": "0.7 cm",
    "warranty": 60,
    "unit_count": 5,
    "read_speed": 150,
    "write_speed": 60,
    "seller": -932,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/51O8YA-wWCL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 36.99,
    "currency": "USD",
    "price_original": "$36.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyNjQ2NTY3MTc2Mzg5NzMwOjE3NTM1NTkyODQ6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDA0OTAzNjExNTIwMjo6Mjo6&url=%2FSamData-Drives-Memory-Storage-Backup%2Fdp%2FB0CHB1RNFR%2Fref%3Dsxin_15_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.70fcaece-2dd2-4653-bf00-fb6af1af1b93%253Aamzn1.sym.70fcaece-2dd2-4653-bf00-fb6af1af1b93%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CHB1RNFR%26pd_rd_r%3D9709b73e-6a1e-4ddb-a392-4aa1ee8f4cb7%26pd_rd_w%3DTsFwA%26pd_rd_wg%3DaLByD%26pf_rd_p%3D70fcaece-2dd2-4653-bf00-fb6af1af1b93%26pf_rd_r%3DRR3PD02GESNKAAF9140F%26qid%3D1753559284%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-3-e169343e-09af-4d41-85b1-8335fe8f32d0-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CHB1RNFR",
    "blank": "",
    "affiliate_link": "https://amzn.to/46ve4uq",
    "source_file": "drives-1.html",
    "position": 8,
    "asin": "B0CHB1RNFR",
    "title": "128GB USB Flash Drives 2 Pack 128GB Thumb Drives Memory Stick Jump Drive with LED Light for Storage and Backup (2 Pack Black)",
    "brand": "SamData",
    "manufacturer": "Sosun Tech",
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$16.99",
    "rating": 4.5,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": "1cm",
    "warranty": 12,
    "unit_count": 2,
    "read_speed": 20,
    "write_speed": 8,
    "seller": "(37.6K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/6131tPOZLoL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.99,
    "currency": "USD",
    "price_original": "$16.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyNjQ2NTY3MTc2Mzg5NzMwOjE3NTM1NTkyODQ6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDAwNDQ2MTMyMDYwMjo6Mzo6&url=%2FPNY-Turbo-Attach%25C3%25A9-10-Pack-Silver%2Fdp%2FB0BPJVH88Y%2Fref%3Dsxin_15_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.70fcaece-2dd2-4653-bf00-fb6af1af1b93%253Aamzn1.sym.70fcaece-2dd2-4653-bf00-fb6af1af1b93%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0BPJVH88Y%26pd_rd_r%3D9709b73e-6a1e-4ddb-a392-4aa1ee8f4cb7%26pd_rd_w%3DTsFwA%26pd_rd_wg%3DaLByD%26pf_rd_p%3D70fcaece-2dd2-4653-bf00-fb6af1af1b93%26pf_rd_r%3DRR3PD02GESNKAAF9140F%26qid%3D1753559284%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-4-e169343e-09af-4d41-85b1-8335fe8f32d0-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0BPJVH88Y",
    "blank": "",
    "affiliate_link": "https://amzn.to/458nWb0",
    "source_file": "drives-1.html",
    "position": 9,
    "asin": "B0BPJVH88Y",
    "title": "PNY 32GB Turbo Attach√© 3 USB 3.0 Flash Drive, Silver (Pack of 10)",
    "brand": "PNY",
    "manufacturer": "PNY",
    "model": "Turbo Attaché 3",
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 4.6,
    "review_count": 3,
    "special_features": null,
    "weight": "0.1kg",
    "height": null,
    "warranty": null,
    "unit_count": 10,
    "read_speed": null,
    "write_speed": null,
    "seller": -464,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/616cOXMmVZL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyNjQ2NTY3MTc2Mzg5NzMwOjE3NTM1NTkyODQ6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDUyODMzOTM1MDQwMjo6NDo6&url=%2FPNY-128GB-Attach%25C3%25A9-Flash-5-Pack%2Fdp%2FB0BDT8FTMP%2Fref%3Dsxin_15_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.70fcaece-2dd2-4653-bf00-fb6af1af1b93%253Aamzn1.sym.70fcaece-2dd2-4653-bf00-fb6af1af1b93%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0BDT8FTMP%26pd_rd_r%3D9709b73e-6a1e-4ddb-a392-4aa1ee8f4cb7%26pd_rd_w%3DTsFwA%26pd_rd_wg%3DaLByD%26pf_rd_p%3D70fcaece-2dd2-4653-bf00-fb6af1af1b93%26pf_rd_r%3DRR3PD02GESNKAAF9140F%26qid%3D1753559284%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-5-e169343e-09af-4d41-85b1-8335fe8f32d0-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0BDT8FTMP",
    "blank": "",
    "affiliate_link": "https://amzn.to/4o8iYDX",
    "source_file": "drives-1.html",
    "position": 10,
    "asin": "B0BDT8FTMP",
    "title": "PNY 128GB Attach√© 3 USB 2.0 Flash Drive, Black (Pack of 5)",
    "brand": "PNY",
    "manufacturer": "PNY",
    "model": "Attaché 3",
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$24.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": 5,
    "read_speed": null,
    "write_speed": 300,
    "seller": "(5.6K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/51L3dUD+jkL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/Drives-USB2-0-Storage-Backup-Indicator/dp/B0DHVQBQLQ/ref=sr_1_6?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-6&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DHVQBQLQ",
    "blank": "",
    "affiliate_link": "https://amzn.to/44XoyQA",
    "source_file": "drives-1.html",
    "position": 11,
    "asin": "B0DHVQBQLQ",
    "title": "8GB Flash Drive 10 Pack Bulk USB Flash Drives, USB2.0 Thumb Drive USB Stick for Data Storage Backup, Jump Drive Pen Drive Zip Drive Memory Stick with Indicator, USB Storage Flash Drive Swivel Design",
    "brand": "8GB",
    "manufacturer": "MECHEER",
    "model": "MECHEER",
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$16.88",
    "rating": 4.6,
    "review_count": 4,
    "special_features": "Swivel,Lightweight, LED Indicator",
    "weight": "",
    "height": null,
    "warranty": null,
    "unit_count": 10,
    "read_speed": null,
    "write_speed": 20,
    "seller": "9 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/71blLwEjZ9L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.88,
    "currency": "USD",
    "price_original": "$16.88"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-2-Pack-Ultra-Flash-2x64GB/dp/B08HSQP37L/ref=sr_1_8?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-8&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08HSQP37L",
    "blank": "",
    "affiliate_link": "https://amzn.to/3U02zDH",
    "source_file": "drives-1.html",
    "position": 12,
    "asin": "B08HSQP37L",
    "title": "SanDisk 64GB 2-Pack Ultra USB 3.0 Flash Drive (2x64GB) - SDCZ48-064G-GAM462, Black",
    "brand": "SanDisk",
    "manufacturer": "Western Digital Technologies, Inc.",
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$14.19",
    "rating": 4.7,
    "review_count": 4,
    "special_features": null,
    "weight": "9.07g",
    "height": 0.31,
    "warranty": 60,
    "unit_count": 2,
    "read_speed": 130,
    "write_speed": "10x",
    "seller": "13 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/71jzP3WDwbL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.19,
    "currency": "USD",
    "price_original": "$14.19"
  },
  {
    "product_url": "https://www.amazon.com/PNY-Advanced-Performance-Everyday-Computers/dp/B0DT7JSGTC/ref=sr_1_9?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-9&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DT7JSGTC",
    "blank": "",
    "affiliate_link": "https://amzn.to/41oGGSr",
    "source_file": "drives-1.html",
    "position": 13,
    "asin": "B0DT7JSGTC",
    "title": "PNY 64GB Attaché X USB 3.2 Gen 1 Flash Drive, Advanced Performance Up to 130MB/s Read, Everyday Data Store & Transfer, Reliable Portable Storage, Durable, Type-A, Computers, Laptops, Desktops, 5-Pack",
    "brand": "PNY",
    "manufacturer": "PNY",
    "model": "Attaché X",
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$21.99",
    "rating": 4.5,
    "review_count": 2,
    "special_features": "Advanced Speed, Convenience, Portable, Lightweight",
    "weight": "",
    "height": null,
    "warranty": 12,
    "unit_count": 5,
    "read_speed": 130,
    "write_speed": "10x",
    "seller": "6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/51mrTmNIksL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 21.99,
    "currency": "USD",
    "price_original": "$21.99"
  },
  {
    "product_url": "https://www.amazon.com/PNY-Turbo-Attach%C3%A9-Flash-5-Pack/dp/B09RG1TNM7/ref=sr_1_10?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-10&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09RG1TNM7",
    "blank": "",
    "affiliate_link": "https://amzn.to/4m5xsmp",
    "source_file": "drives-1.html",
    "position": 14,
    "asin": "B09RG1TNM7",
    "title": "PNY 64GB Turbo Attaché 3 USB 3.0 Flash Drive, Silver (Pack of 5)",
    "brand": "PNY",
    "manufacturer": "PNY",
    "model": "Turbo Attaché 3",
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$21.99",
    "rating": 4.6,
    "review_count": 6,
    "special_features": "Shockproof",
    "weight": null,
    "height": null,
    "warranty": 12,
    "unit_count": 5,
    "read_speed": null,
    "write_speed": "10x",
    "seller": "(1.5K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/51qNgGQLpIL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 21.99,
    "currency": "USD",
    "price_original": "$21.99"
  },
  {
    "product_url": "https://aax-us-iad.amazon.com/x/c/JJUqNy8ky2CKTMTRXBmob7EAAAGYSEc8yQEAAAH2AQBvbm9fdHhuX2JpZDIgICBvbm9fdHhuX2ltcDEgICDnZFlS/clv1c_ek-Y2oHTEtbCDZFFLw1uOGh9ujorHk87-DKqA9TrvAaT5oVXGlDhRHtEfccYV5IN6on4JajOwksF1vMFKsncNDj5T2icJkGx68vmAdf2XApq2Pn8NvyhTSn8i19eq7Usi0gxlh-WdzLbGsu4jMRq5aDTlJX8B9SIkEL0wrf_ZOaOSMoOv8AkqkGKpATjyHDFULw5BRL5JG2zYVI2NxFRp_T4cSKMrojuPoCleRzOyFb8BbtmDPf-N3sFTVyiG6LJaom1Xj7sxsWwRFKwUMp8xwh2HjpG_Hy2EZxGuY9o5lB23GtVYQAiOzB6-CzN-ZjhpO4omPxY_Rrsfz1GjK-QtvQ3T5JTct3Q2tlfF48U5XYi5uI9Q2fHNWONVfyi4-IDHo4hzk5EvMIh1YmAPtZeKfM6wMAWXBQIRSXq6B4dvFf5ZZzjV1JboSnRmMCuSLFIf_NOXrm_CEgA2ycBQoZjosyz7GRY0AUZAppK1qLb04EJo3Y9skzC_IxAc27s6yPdITQxMprEogwiRnp_19iRNztKchfccmEU1oYL17OstXKBKbx5IWUs5qniPdlVDhItfZZR66pSZiQx3Pz1RgIDYHNmSf83f035H0RTEewPmQsXr2OhgtBtv0-AoI1FzJZnWnKF2lq2LeMK_z6Ku4w3feO7CO9JTfK55ZVMsuKcVBSsAoUenEjccbnpkCCt7IOgreUv-0cthmiDv2sSGzCcspj1krGmBWuuNXQaMmWaIqeB7Z77YCtYl7NkuFe7Yo0Kc0sDbT9gArFLxkcbuUl8njO-kLUV1pXd0KYM3xMADC7fA6BaWKE0PG3YfID7WZaQw_NE-fnuwIC9nWNK8DW6OKdWSE5my7i-D7DwxDK5N-3V4Ji3x3q-1PUJfh0aTQq8xv6L9hkxIaSUndv8Kvra5ynjMRQPlL4rF5d7ob1CYeoWOz6remJ6VJz4JV0tpzlJbElEwp2pSDqL-psmnk9r/https://www.amazon.com/dp/B0C2D95SZZ?pd_rd_i=B0C2D95SZZ&pf_rd_p=c8b39f81-ded8-4d75-80c2-6dfa03cbb699&pf_rd_r=RR3PD02GESNKAAF9140F&pd_rd_wg=aLByD&pd_rd_w=UymL5&pd_rd_r=9709b73e-6a1e-4ddb-a392-4aa1ee8f4cb7",
    "product_link": "https://www.amazon.com/dp/",
    "blank": "",
    "affiliate_link": null,
    "source_file": "drives-1.html",
    "position": 15,
    "asin": null,
    "title": "KEXIN Flash Drive 64GB USB 3.0 Flash Drive 64 GB Thumb Drive 5 Pack Memory Stick USB Drive Data Storage Jump Drive Colorful(64G 5-Pack)",
    "brand": "KEXIN",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$22.59",
    "rating": 4.5,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/61Syr0wuRjL._AC_UL640_QL65_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 22.59,
    "currency": "USD",
    "price_original": "$22.59"
  },
  {
    "product_url": "https://www.amazon.com/PNY-128GB-Turbo-Attach%C3%A9-2-Pack/dp/B09DBTWWSF/ref=sr_1_11?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-11&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09DBTWWSF",
    "blank": "",
    "affiliate_link": "https://amzn.to/4lg6K9x",
    "source_file": "drives-1.html",
    "position": 16,
    "asin": "B09DBTWWSF",
    "title": "PNY 128GB Turbo Attaché 3 USB 3.0 Flash Drive, Silver (Pack of 2)",
    "brand": "PNY",
    "manufacturer": "PNY",
    "model": "Turbo Attaché 3",
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$14.99",
    "rating": 4.6,
    "review_count": 5,
    "special_features": "Portable",
    "weight": "0.02kg",
    "height": null,
    "warranty": 12,
    "unit_count": 2,
    "read_speed": null,
    "write_speed": "10x",
    "seller": "(3.6K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/61s1hIk7tXL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.99,
    "currency": "USD",
    "price_original": "$14.99"
  },
  {
    "product_url": "https://www.amazon.com/JOIOT-Portable-Keychain-Smartphone-Computer/dp/B0CSW6375K/ref=sr_1_13?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-13&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CSW6375K",
    "blank": "",
    "affiliate_link": "https://amzn.to/3Hur4Gi",
    "source_file": "drives-1.html",
    "position": 17,
    "asin": "B0CSW6375K",
    "title": "128GB USB C Flash Drive Dual USB 3.0 Flash Drive Type C + USB A Portable Type-C Flash Drive 2-in-1 USB-C Thumb Drive for Smartphone Tablet Computer Mac iPhone 15 Black",
    "brand": "JOIOT",
    "manufacturer": "JOIOT",
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.4,
    "review_count": 9,
    "special_features": "Shockproof",
    "weight": "8g",
    "height": "0.34\"D x 0.7\"W x 0.34\"H",
    "warranty": 12,
    "unit_count": 1,
    "read_speed": 70,
    "write_speed": 20,
    "seller": "6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/51K6hZcFQ4L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/SAMSUNG-Type-CTM-Transfers-Compatible-Waterproof/dp/B09WB2NL8W/ref=sr_1_14?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-14&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09WB2NL8W",
    "blank": "",
    "affiliate_link": "https://amzn.to/45t8ZRe",
    "source_file": "drives-1.html",
    "position": 18,
    "asin": "B09WB2NL8W",
    "title": "Samsung Type-C USB Flash Drive, 256GB, Transfers 4GB Files in 11 Secs w/Up to 400MB/s 3.13 Read Speeds, Compatible w/USB 3.0/2.0, Waterproof, 2022, Blue, MUF-256DA/AM",
    "brand": "Samsung Electronics",
    "manufacturer": "Samsung Electronics",
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "256 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB-C OTG",
    "price": "$24.99",
    "rating": 4.6,
    "review_count": 14357,
    "special_features": "Waterproof, Shockproof, magnet-proof, temperature-proof, x-ray proof",
    "weight": "3.4g",
    "height": "8.2mm",
    "warranty": 60,
    "unit_count": 1,
    "read_speed": 400,
    "write_speed": 300,
    "seller": "5 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/817xK9Cd6JL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/Drives-Storage-Memory-Swivel-Design/dp/B07XSGNQ2X/ref=sr_1_15?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-15&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07XSGNQ2X",
    "blank": "",
    "affiliate_link": "https://amzn.to/3UhjiTc",
    "source_file": "drives-1.html",
    "position": 19,
    "asin": "B07XSGNQ2X",
    "title": "2 Pack 64GB USB Flash Drive USB 2.0 Thumb Drives Jump Drive Fold Storage Memory Stick Swivel Design - Black",
    "brand": "Maspen",
    "manufacturer": "ALMEMO",
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$8.99",
    "rating": 4.4,
    "review_count": 9,
    "special_features": "Swivel",
    "weight": "0.02lbs",
    "height": "0.45in",
    "warranty": null,
    "unit_count": 2,
    "read_speed": null,
    "write_speed": 8,
    "seller": "4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/5175s67dwwL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 8.99,
    "currency": "USD",
    "price_original": "$8.99"
  },
  {
    "product_url": "https://www.amazon.com/PNY-Turbo-Attach%C3%A9-10-Pack-Silver/dp/B0BPJVH88Y/ref=sr_1_16?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-16&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BPJVH88Y",
    "blank": "",
    "affiliate_link": "https://amzn.to/3HhKyOw",
    "source_file": "drives-1.html",
    "position": 20,
    "asin": "B0BPJVH88Y",
    "title": "PNY 32GB Turbo Attaché 3 USB 3.0 Flash Drive, Silver (Pack of 10)",
    "brand": "PNY",
    "manufacturer": "PNY",
    "model": "Turbo Attaché 3",
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 4.6,
    "review_count": 3,
    "special_features": "Portable",
    "weight": "0.1kg",
    "height": null,
    "warranty": 12,
    "unit_count": 10,
    "read_speed": null,
    "write_speed": "10x",
    "seller": -464,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/616cOXMmVZL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": "https://www.amazon.com/Enfain-Memory-Swivel-Indicator-Removable/dp/B00JES3MO0/ref=sr_1_18?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-18&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B00JES3MO0",
    "blank": "",
    "affiliate_link": "https://amzn.to/3J6tV94",
    "source_file": "drives-1.html",
    "position": 21,
    "asin": "B00JES3MO0",
    "title": "10-Pack Enfain 16GB USB 2.0 Swivel Flash Drives: Shareable Data Storage for Home & Office Use (Black)",
    "brand": "10-Pack",
    "manufacturer": "Enfain",
    "model": "Enfain",
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$24.99",
    "rating": 4.6,
    "review_count": 2,
    "special_features": "Swivel",
    "weight": null,
    "height": "1in",
    "warranty": 12,
    "unit_count": 10,
    "read_speed": 18,
    "write_speed": 6,
    "seller": "13 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/61SXsXKraVL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/SamData-Drives-Memory-Storage-Backup/dp/B092879BVB/ref=sr_1_19?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-19&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B092879BVB",
    "blank": "",
    "affiliate_link": "https://amzn.to/45tm0Ku",
    "source_file": "drives-1.html",
    "position": 22,
    "asin": "B092879BVB",
    "title": "8GB USB Flash Drives 5 Pack 8GB Thumb Drives Memory Stick Jump Drive with LED Light for Storage and Backup (5 Colors: Black Blue Green Red Silver)",
    "brand": "SamData",
    "manufacturer": "Sosun Tech",
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.5,
    "review_count": 1,
    "special_features": "LED Indicator",
    "weight": null,
    "height": "1cm",
    "warranty": null,
    "unit_count": 5,
    "read_speed": 8,
    "write_speed": 10,
    "seller": "5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/71uDG7jFAKL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/PNY-256GB-Turbo-Attach%C3%A9-2-Pack/dp/B0BDTKK1XZ/ref=sr_1_20?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-20&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BDTKK1XZ",
    "blank": "",
    "affiliate_link": "https://amzn.to/3UG6dTL",
    "source_file": "drives-1.html",
    "position": 23,
    "asin": "B0BDTKK1XZ",
    "title": "PNY P-FD256X2TBOP-MP 256GB Turbo Attaché 3 USB 3.0 Flash Drive,Silver (Pack of 2)",
    "brand": "PNY",
    "manufacturer": "PNY",
    "model": "Turbo Attaché 3",
    "capacity_raw": 2000000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$27.99",
    "rating": 4.6,
    "review_count": 2,
    "special_features": "Portable",
    "weight": null,
    "height": null,
    "warranty": 12,
    "unit_count": 2,
    "read_speed": null,
    "write_speed": "10x",
    "seller": -662,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/61JFWzaPKfL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "tb",
    "price_numeric": 27.99,
    "currency": "USD",
    "price_original": "$27.99"
  },
  {
    "product_url": "https://www.amazon.com/RAOYI-Memory-Drives-Laptop-Computer/dp/B09DSMYXWL/ref=sr_1_21?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.i6iHyQ_4zFr4y4I2AIicYAbCNdyP-kP9tPWrQTSHIlKD-Bx8POT3_m1Y2lfOyt9ODfRk9f-mkYVuvv9ct4eTEbmtjGY-Y2wGkfOiYEpeZhWkGjcHOCVdg7RWQrA3R3wZG7bOjOYaLMcrczFdAccTHrCH3yyC42Uan5FCzqKCgieuDqKBj204OtHVRscwfX0CKi9pNvsfA-IiwpgFODRq_sbugCaYNIYb--pZpw0dFaQ.CC_e78wom3hlGpJI-QK_CcDPOZBjx12luquCYpCxh48&dib_tag=se&keywords=flash+drives&qid=1753559284&sprefix=flash+drive%2Caps%2C146&sr=8-21&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09DSMYXWL",
    "blank": "",
    "affiliate_link": "https://amzn.to/45xY1d9",
    "source_file": "drives-1.html",
    "position": 24,
    "asin": "B09DSMYXWL",
    "title": "RAOYI 5 Pack 64GB USB Flash Drive, USB 2.0 Memory Stick Thumb Drives Jump Drive Pen Drive for PC Laptop Computer - 64G Multipack",
    "brand": "RAOYI",
    "manufacturer": "RAOYI",
    "model": "U200-BGPRU5-64G",
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.54",
    "rating": 4.4,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "11 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/61-blT+CTjL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.54,
    "currency": "USD",
    "price_original": "$19.54"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&crid=BALSGJKBQE1X&qid=1753559235&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_1#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": "",
    "affiliate_link": null,
    "source_file": "drives-1.html",
    "position": 25,
    "asin": null,
    "title": "GIGASTONE 128GB Flash Drive (5 Pack) Z30 USB 3.2 Gen 1, 100MB/s Ultra Fast, Keychain Loop, Carbon Fiber Style, Push-Pull Design, Data Storage, Backup for PC/Mac/TV/Car, USB 2.0/3.0/3.1 Compatible",
    "brand": "Gigastone",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$36.99",
    "rating": 4.4,
    "review_count": 932,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -932,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/51O8YA-wWCL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 36.99,
    "currency": "USD",
    "price_original": "$36.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2OTI2MDUzNDY2MTg2MzM6MTc1MzU1OTI4NDpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDEzODc4ODU5MDkwMjo6MDo6&url=%2FGIGASTONE-Keychain-Push-Pull-Storage-Compatible%2Fdp%2FB0BY317K3Z%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.dc2957f5-59a0-4027-bc7c-a7d7726dcfc0%253Aamzn1.sym.dc2957f5-59a0-4027-bc7c-a7d7726dcfc0%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0BY317K3Z%26pd_rd_r%3D3ff6bc33-1976-4910-ac29-47fa4b928e22%26pd_rd_w%3D45N2h%26pd_rd_wg%3DVRDlH%26pf_rd_p%3Ddc2957f5-59a0-4027-bc7c-a7d7726dcfc0%26pf_rd_r%3DRR3PD02GESNKAAF9140F%26qid%3D1753559284%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-1-fb395260-7243-4e30-82ce-3176e35831b6-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0BY317K3Z",
    "blank": "",
    "affiliate_link": null,
    "source_file": "drives-1.html",
    "position": 26,
    "asin": "B0BY317K3Z",
    "title": "GIGASTONE 128GB Flash Drive (5 Pack) Z30 USB 3.2 Gen 1, 100MB/s Ultra Fast, Keychain Loop, Carbon Fiber Style, Push-Pull Design, Data Storage, Backup for PC/Mac/TV/Car, USB 2.0/3.0/3.1 Compatible",
    "brand": "Gigastone",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$36.99",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -932,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/51O8YA-wWCL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 36.99,
    "currency": "USD",
    "price_original": "$36.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2OTI2MDUzNDY2MTg2MzM6MTc1MzU1OTI4NDpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDQ3MTQzNzAxMTQwMjo6MTo6&url=%2FPNY-128GB-Turbo-Attach%25C3%25A9-5-Pack%2Fdp%2FB0DDYCT5YS%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.dc2957f5-59a0-4027-bc7c-a7d7726dcfc0%253Aamzn1.sym.dc2957f5-59a0-4027-bc7c-a7d7726dcfc0%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DDYCT5YS%26pd_rd_r%3D3ff6bc33-1976-4910-ac29-47fa4b928e22%26pd_rd_w%3D45N2h%26pd_rd_wg%3DVRDlH%26pf_rd_p%3Ddc2957f5-59a0-4027-bc7c-a7d7726dcfc0%26pf_rd_r%3DRR3PD02GESNKAAF9140F%26qid%3D1753559284%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-2-fb395260-7243-4e30-82ce-3176e35831b6-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DDYCT5YS",
    "blank": "",
    "affiliate_link": null,
    "source_file": "drives-1.html",
    "position": 27,
    "asin": "B0DDYCT5YS",
    "title": "PNY 128GB Turbo Attach√© 3 USB 3.0 Flash Drive 5-Pack ‚Äì Grey, P-FD128X5TBOP-MP, 100MB/s, Light-Weight Durable - Data Storage and Transfer",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$29.99",
    "rating": 4.6,
    "review_count": 10,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(40.4K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/6155RbbYkAL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 29.99,
    "currency": "USD",
    "price_original": "$29.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2OTI2MDUzNDY2MTg2MzM6MTc1MzU1OTI4NDpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDE1MDIyODMzMDkwMjo6Mjo6&url=%2FJOIOT-Portable-Keychain-Smartphone-Computer%2Fdp%2FB0CSW6375K%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.dc2957f5-59a0-4027-bc7c-a7d7726dcfc0%253Aamzn1.sym.dc2957f5-59a0-4027-bc7c-a7d7726dcfc0%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CSW6375K%26pd_rd_r%3D3ff6bc33-1976-4910-ac29-47fa4b928e22%26pd_rd_w%3D45N2h%26pd_rd_wg%3DVRDlH%26pf_rd_p%3Ddc2957f5-59a0-4027-bc7c-a7d7726dcfc0%26pf_rd_r%3DRR3PD02GESNKAAF9140F%26qid%3D1753559284%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-3-fb395260-7243-4e30-82ce-3176e35831b6-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CSW6375K",
    "blank": "",
    "affiliate_link": null,
    "source_file": "drives-1.html",
    "position": 28,
    "asin": "B0CSW6375K",
    "title": "128GB USB C Flash Drive Dual USB 3.0 Flash Drive Type C + USB A Portable Type-C Flash Drive 2-in-1 USB-C Thumb Drive for Smartphone Tablet Computer Mac iPhone 15 Black",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.4,
    "review_count": 9,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -946,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/51K6hZcFQ4L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2OTI2MDUzNDY2MTg2MzM6MTc1MzU1OTI4NDpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDAwNDQ2MTMyMDYwMjo6NDo6&url=%2FPNY-Turbo-Attach%25C3%25A9-10-Pack-Silver%2Fdp%2FB0BPJVH88Y%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.dc2957f5-59a0-4027-bc7c-a7d7726dcfc0%253Aamzn1.sym.dc2957f5-59a0-4027-bc7c-a7d7726dcfc0%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0BPJVH88Y%26pd_rd_r%3D3ff6bc33-1976-4910-ac29-47fa4b928e22%26pd_rd_w%3D45N2h%26pd_rd_wg%3DVRDlH%26pf_rd_p%3Ddc2957f5-59a0-4027-bc7c-a7d7726dcfc0%26pf_rd_r%3DRR3PD02GESNKAAF9140F%26qid%3D1753559284%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-4-fb395260-7243-4e30-82ce-3176e35831b6-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0BPJVH88Y",
    "blank": "",
    "affiliate_link": null,
    "source_file": "drives-1.html",
    "position": 29,
    "asin": "B0BPJVH88Y",
    "title": "PNY 32GB Turbo Attach√© 3 USB 3.0 Flash Drive, Silver (Pack of 10)",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 4.6,
    "review_count": 3,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -464,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-1_files/616cOXMmVZL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": null,
    "product_link": "https://www.amazon.com/dp/",
    "blank": "",
    "affiliate_link": null,
    "source_file": "drives-1.html",
    "position": 30,
    "asin": null,
    "title": "flash drives",
    "brand": "flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 0,
    "capacity_category": null,
    "memory_capacity_category": null,
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": null,
    "rating": null,
    "review_count": null,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": null,
    "extracted_date": "7/27/25",
    "capacity_units": "unknown",
    "price_numeric": 0,
    "currency": null,
    "price_original": null
  },
  {
    "product_url": "https://www.amazon.com/TOPESEL-Flash-Memory-Drives-Colors/dp/B01LW2NKPZ/ref=sr_1_147?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YmzFy6vGL8YxkoMVtJwTO1GaVuKwqmOmFgyEV5KkoUrGjHj071QN20LucGBJIEps.D6TQpfJxNhcTCyvWc_mJNV8qXv9WYn1DuE2Cr_-A96U&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-147&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B01LW2NKPZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 1,
    "asin": "B01LW2NKPZ",
    "title": "5 Pack 32GB USB 2.0 Flash Drive Memory Stick Thumb Drives (5 Mixed Colors: Black Blue Green Red Silver)",
    "brand": 5,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$18.91",
    "rating": 4.6,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "13 sizes13 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/719NSvPwJYL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.91,
    "currency": "USD",
    "price_original": "$18.91"
  },
  {
    "product_url": "https://www.amazon.com/KEXIN-Drives-Swivel-Stylish-Colorful/dp/B0D69JK89C/ref=sr_1_148?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YmzFy6vGL8YxkoMVtJwTO1GaVuKwqmOmFgyEV5KkoUrGjHj071QN20LucGBJIEps.D6TQpfJxNhcTCyvWc_mJNV8qXv9WYn1DuE2Cr_-A96U&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-148&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D69JK89C",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 2,
    "asin": "B0D69JK89C",
    "title": "16GB Flash Drive 10 Pack USB 2.0 Thumb Drives Swivel Memory Stick Bulk USB Drive with LED Light - Green, Red, Black, Blue, Yellow",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$25.99",
    "rating": 4.6,
    "review_count": 200,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "7 sizes7 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/61wwwprte1L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 25.99,
    "currency": "USD",
    "price_original": "$25.99"
  },
  {
    "product_url": "https://www.amazon.com/TOPESEL-Flash-Drives-Memory-USB3-0/dp/B07Q6KKQX3/ref=sr_1_149?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.YmzFy6vGL8YxkoMVtJwTO1GaVuKwqmOmFgyEV5KkoUrGjHj071QN20LucGBJIEps.D6TQpfJxNhcTCyvWc_mJNV8qXv9WYn1DuE2Cr_-A96U&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-149&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07Q6KKQX3",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 3,
    "asin": "B07Q6KKQX3",
    "title": "USB Flash Drive 5 Pack 16GB USB 3.0 Flash Drive Memory Stick USB Drive Thumb Drives USB Stick USB3.0 Thumb Drives (16GB 5PCS, Black)",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.6,
    "review_count": 6,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "12 sizes12 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/610Kz4DjcNL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/SIMMAX-Drives-Memory-Indicator-Purple/dp/B07F9WLQG9/ref=sr_1_145?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.QUh1BD6pup41awoqVUe6jykhMhgIncDUDKJfFFPwez9k9Ktqi-36zwNWdy_knkbOfnOjK1YuOhRLhAwEgL0i6so7Ges0_xmtiJZVHCHcoPLmTRWMRz0bGi9YsvD3-qpcVa3yERGfIY9aPWH0J3fHvfLnQe3xJVUxWi_Chy-OInFKwcPEWAK22Xm6twRcJPt-.gxQDalj2mndAxFK2Yb0xjk9ZoxzbaISTlx7ZK3lhOcs&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-145&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07F9WLQG9",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 4,
    "asin": "B07F9WLQG9",
    "title": "Flash Drive 2 Pack 32GB USB 2.0 Flash Drives Thumb Drive Memory Stick Pen Drive with Led Indicator (Red Purple)",
    "brand": "Flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$7.99",
    "rating": 4.4,
    "review_count": 525,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/710KflfgQlL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 7.99,
    "currency": "USD",
    "price_original": "$7.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-SDCZ50-008G-10PK-Everything-Stromboli-Lanyard/dp/B00FVWVDSK/ref=sr_1_146?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.QUh1BD6pup41awoqVUe6jykhMhgIncDUDKJfFFPwez9k9Ktqi-36zwNWdy_knkbOfnOjK1YuOhRLhAwEgL0i6so7Ges0_xmtiJZVHCHcoPLmTRWMRz0bGi9YsvD3-qpcVa3yERGfIY9aPWH0J3fHvfLnQe3xJVUxWi_Chy-OInFKwcPEWAK22Xm6twRcJPt-.gxQDalj2mndAxFK2Yb0xjk9ZoxzbaISTlx7ZK3lhOcs&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-146&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B00FVWVDSK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 5,
    "asin": "B00FVWVDSK",
    "title": "Cruzer Blade 8GB (10 pack) USB 2.0 Flash Drive Jump Drive Thumb Drive SDCZ50-008G-10PK w/ (5) Everything But Stromboli (TM) Lanyard",
    "brand": "Cruzer",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "SD",
    "price": "$38.96",
    "rating": 4.5,
    "review_count": 50,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -291,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/81mja2gEl1L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 38.96,
    "currency": "USD",
    "price_original": "$38.96"
  },
  {
    "product_url": "https://www.amazon.com/Certified-iPhone-External-Storage-Android/dp/B0CMDBN1ZL/ref=sr_1_147?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.QUh1BD6pup41awoqVUe6jykhMhgIncDUDKJfFFPwez9k9Ktqi-36zwNWdy_knkbOfnOjK1YuOhRLhAwEgL0i6so7Ges0_xmtiJZVHCHcoPLmTRWMRz0bGi9YsvD3-qpcVa3yERGfIY9aPWH0J3fHvfLnQe3xJVUxWi_Chy-OInFKwcPEWAK22Xm6twRcJPt-.gxQDalj2mndAxFK2Yb0xjk9ZoxzbaISTlx7ZK3lhOcs&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-147&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CMDBN1ZL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 6,
    "asin": "B0CMDBN1ZL",
    "title": "MFi Certified 128GB Flash Drive for iPhone Photo Stick USB Memory Stick Thumb Drives, High Speed USB Stick External Storage for iPhone/iPad/Android/PC",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.2,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/61qCRySEdRL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/AreTop-Drives-Retractable-Storage-Multipack/dp/B0DZNZ7S4F/ref=sr_1_148?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.QUh1BD6pup41awoqVUe6jykhMhgIncDUDKJfFFPwez9k9Ktqi-36zwNWdy_knkbOfnOjK1YuOhRLhAwEgL0i6so7Ges0_xmtiJZVHCHcoPLmTRWMRz0bGi9YsvD3-qpcVa3yERGfIY9aPWH0J3fHvfLnQe3xJVUxWi_Chy-OInFKwcPEWAK22Xm6twRcJPt-.gxQDalj2mndAxFK2Yb0xjk9ZoxzbaISTlx7ZK3lhOcs&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-148&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DZNZ7S4F",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 7,
    "asin": "B0DZNZ7S4F",
    "title": "8GB Flash Drive 5 Pack Thumb Drives Slide Retractable USB Flash Drives 5 Pack 8GB Memory Sticks for Data Storage Jump Drives Multipack (Mixed Color:Yellow,Red,Blue,Green,Purple)",
    "brand": "8GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$9.87",
    "rating": 4.5,
    "review_count": 200,
    "special_features": "Retractable",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/61hWZ3jj+2L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 9.87,
    "currency": "USD",
    "price_original": "$9.87"
  },
  {
    "product_url": "https://www.amazon.com/KEXIN-Swivel-Type-C-Smartphone-Console/dp/B0FBVZPDQD/ref=sr_1_149?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.QUh1BD6pup41awoqVUe6jykhMhgIncDUDKJfFFPwez9k9Ktqi-36zwNWdy_knkbOfnOjK1YuOhRLhAwEgL0i6so7Ges0_xmtiJZVHCHcoPLmTRWMRz0bGi9YsvD3-qpcVa3yERGfIY9aPWH0J3fHvfLnQe3xJVUxWi_Chy-OInFKwcPEWAK22Xm6twRcJPt-.gxQDalj2mndAxFK2Yb0xjk9ZoxzbaISTlx7ZK3lhOcs&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-149&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0FBVZPDQD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 8,
    "asin": "B0FBVZPDQD",
    "title": "128GB USB C Flash Drive 100MB/s Swivel Dual USB 3.0 USB-A & Type-C Memory Stick for Smartphone Tablet iPhone 15/16 Car Game Console, 128GB Black",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$13.59",
    "rating": 4.4,
    "review_count": 500,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/61bT6VXqtjL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 13.59,
    "currency": "USD",
    "price_original": "$13.59"
  },
  {
    "product_url": "https://www.amazon.com/PNY-Elite-X-128GB-Flash-Drive/dp/B01LFV52T6/ref=sr_1_152?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.QUh1BD6pup41awoqVUe6jykhMhgIncDUDKJfFFPwez9k9Ktqi-36zwNWdy_knkbOfnOjK1YuOhRLhAwEgL0i6so7Ges0_xmtiJZVHCHcoPLmTRWMRz0bGi9YsvD3-qpcVa3yERGfIY9aPWH0J3fHvfLnQe3xJVUxWi_Chy-OInFKwcPEWAK22Xm6twRcJPt-.gxQDalj2mndAxFK2Yb0xjk9ZoxzbaISTlx7ZK3lhOcs&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-152&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B01LFV52T6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 9,
    "asin": "B01LFV52T6",
    "title": "128GB Elite-X Fit USB 3.1 Flash Drive - 200MB/s",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$14.99",
    "rating": 4.6,
    "review_count": 400,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.8K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/719JW-h3PJL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.99,
    "currency": "USD",
    "price_original": "$14.99"
  },
  {
    "product_url": "https://www.amazon.com/PNY-512GB-Elite-Flash-Drive/dp/B0BLJBQN25/ref=sr_1_153?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.QUh1BD6pup41awoqVUe6jykhMhgIncDUDKJfFFPwez9k9Ktqi-36zwNWdy_knkbOfnOjK1YuOhRLhAwEgL0i6so7Ges0_xmtiJZVHCHcoPLmTRWMRz0bGi9YsvD3-qpcVa3yERGfIY9aPWH0J3fHvfLnQe3xJVUxWi_Chy-OInFKwcPEWAK22Xm6twRcJPt-.gxQDalj2mndAxFK2Yb0xjk9ZoxzbaISTlx7ZK3lhOcs&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-153&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BLJBQN25",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 10,
    "asin": "B0BLJBQN25",
    "title": "512GB PRO Elite V2 USB 3.2 Gen 2 Flash Drive ‚Äì 600MB/s",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 2",
    "memory_type": "USB",
    "price": "$44.99",
    "rating": 4.8,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/51135hzHdeL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 44.99,
    "currency": "USD",
    "price_original": "$44.99"
  },
  {
    "product_url": "https://www.amazon.com/Kingston-DataTraveler-Exodia-DTX-128GBCR/dp/B09GKZHXQY/ref=sr_1_154?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.QUh1BD6pup41awoqVUe6jykhMhgIncDUDKJfFFPwez9k9Ktqi-36zwNWdy_knkbOfnOjK1YuOhRLhAwEgL0i6so7Ges0_xmtiJZVHCHcoPLmTRWMRz0bGi9YsvD3-qpcVa3yERGfIY9aPWH0J3fHvfLnQe3xJVUxWi_Chy-OInFKwcPEWAK22Xm6twRcJPt-.gxQDalj2mndAxFK2Yb0xjk9ZoxzbaISTlx7ZK3lhOcs&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-154&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09GKZHXQY",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 11,
    "asin": "B09GKZHXQY",
    "title": "DataTraveler Exodia 128GB USB 3.2 Flash Drive (DTX/128GBCR)",
    "brand": "DataTraveler",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$11.56",
    "rating": 4.5,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -154,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "No",
    "image_url": "./drives-10_files/61bHwSp6Y0L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.56,
    "currency": "USD",
    "price_original": "$11.56"
  },
  {
    "product_url": "https://www.amazon.com/EASTBULL-Adapter-Keychain-Fast-Speed-Storage/dp/B0D2GPPVHF/ref=sr_1_155?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.QUh1BD6pup41awoqVUe6jykhMhgIncDUDKJfFFPwez9k9Ktqi-36zwNWdy_knkbOfnOjK1YuOhRLhAwEgL0i6so7Ges0_xmtiJZVHCHcoPLmTRWMRz0bGi9YsvD3-qpcVa3yERGfIY9aPWH0J3fHvfLnQe3xJVUxWi_Chy-OInFKwcPEWAK22Xm6twRcJPt-.gxQDalj2mndAxFK2Yb0xjk9ZoxzbaISTlx7ZK3lhOcs&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-155&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D2GPPVHF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 12,
    "asin": "B0D2GPPVHF",
    "title": "32GB FAT32 USB 3.0 Flash Drive with a USB C Adapter and Keychain, Fast-Speed Thumb Drive Metal Pen Drive 32 G Memory Stick for Storage and Backup (Grey, with USB C 3.0 Adapter, Keychain)",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$8.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": "Metal, Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/61i4aZNaMNL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 8.99,
    "currency": "USD",
    "price_original": "$8.99"
  },
  {
    "product_url": "https://www.amazon.com/External-Drives-Storage-Memory-Photos/dp/B0CMXNBGQK/ref=sr_1_156?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.QUh1BD6pup41awoqVUe6jykhMhgIncDUDKJfFFPwez9k9Ktqi-36zwNWdy_knkbOfnOjK1YuOhRLhAwEgL0i6so7Ges0_xmtiJZVHCHcoPLmTRWMRz0bGi9YsvD3-qpcVa3yERGfIY9aPWH0J3fHvfLnQe3xJVUxWi_Chy-OInFKwcPEWAK22Xm6twRcJPt-.gxQDalj2mndAxFK2Yb0xjk9ZoxzbaISTlx7ZK3lhOcs&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-156&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CMXNBGQK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 13,
    "asin": "B0CMXNBGQK",
    "title": "256GB USB Flash Drive for Phone and Pad, Photo Stick High Speed External USB Thumb Drives Photo Storage Memory Stick for Save More Photos and Videos (Blue, 256GB)",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 3.9,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/614ARE4PwrL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/Corsair-Flash-Survivor-Stealth-Drive/dp/B00YHL1LN8/ref=sr_1_157?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.QUh1BD6pup41awoqVUe6jykhMhgIncDUDKJfFFPwez9k9Ktqi-36zwNWdy_knkbOfnOjK1YuOhRLhAwEgL0i6so7Ges0_xmtiJZVHCHcoPLmTRWMRz0bGi9YsvD3-qpcVa3yERGfIY9aPWH0J3fHvfLnQe3xJVUxWi_Chy-OInFKwcPEWAK22Xm6twRcJPt-.gxQDalj2mndAxFK2Yb0xjk9ZoxzbaISTlx7ZK3lhOcs&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-157&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B00YHL1LN8",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 14,
    "asin": "B00YHL1LN8",
    "title": "Flash Survivor Stealth 64GB USB 3.0 Flash Drive, Black (CMFSS3B-64GB)",
    "brand": "Flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$24.99",
    "rating": 4.7,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/51a2Db8XKNL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/RAOYI-Smartphones-MacBook-Tablets-Samsung/dp/B07FFTHGS1/ref=sr_1_158?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.QUh1BD6pup41awoqVUe6jykhMhgIncDUDKJfFFPwez9k9Ktqi-36zwNWdy_knkbOfnOjK1YuOhRLhAwEgL0i6so7Ges0_xmtiJZVHCHcoPLmTRWMRz0bGi9YsvD3-qpcVa3yERGfIY9aPWH0J3fHvfLnQe3xJVUxWi_Chy-OInFKwcPEWAK22Xm6twRcJPt-.gxQDalj2mndAxFK2Yb0xjk9ZoxzbaISTlx7ZK3lhOcs&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-158&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07FFTHGS1",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 15,
    "asin": "B07FFTHGS1",
    "title": "128GB USB C Flash Drive, 2 in 1 USB 3.0 Type C Dual OTG Metal Thumb Drive Jump Drive Memory Stick with Keychain Suitable for USB-C Smartphones, MacBook, Computers and Tablets (Silver)",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$11.39",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Metal, Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/51p-HxiAi3L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.39,
    "currency": "USD",
    "price_original": "$11.39"
  },
  {
    "product_url": "https://www.amazon.com/Certified-High-Speed-External-Storage-Transfer/dp/B0DLH28LF5/ref=sr_1_159?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.QUh1BD6pup41awoqVUe6jykhMhgIncDUDKJfFFPwez9k9Ktqi-36zwNWdy_knkbOfnOjK1YuOhRLhAwEgL0i6so7Ges0_xmtiJZVHCHcoPLmTRWMRz0bGi9YsvD3-qpcVa3yERGfIY9aPWH0J3fHvfLnQe3xJVUxWi_Chy-OInFKwcPEWAK22Xm6twRcJPt-.gxQDalj2mndAxFK2Yb0xjk9ZoxzbaISTlx7ZK3lhOcs&dib_tag=se&keywords=flash+drives&qid=1753561866&sprefix=flash+drive%2Caps%2C146&sr=8-159&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DLH28LF5",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 16,
    "asin": "B0DLH28LF5",
    "title": "MFi Certified 512GB Flash Drive for iPhone & iPad, High-Speed Photo Stick for External Memory Storage, Backup & Transfer Files, Thumb Drive Memory Stick for iPhone/iPad/iOS/Android/PC (Silver)",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$45.59",
    "rating": 4.8,
    "review_count": 400,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/61CkM1WOSxL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 45.59,
    "currency": "USD",
    "price_original": "$45.59"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=10&crid=BALSGJKBQE1X&qid=1753561844&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_10#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 17,
    "asin": null,
    "title": "10-Pack Enfain 16GB USB 2.0 Swivel Flash Drives: Shareable Data Storage for Home & Office Use (Black)",
    "brand": "10-Pack",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$24.99",
    "rating": 4.6,
    "review_count": 13,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(13.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/61SXsXKraVL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTQzODAxMjM0ODE1MzA1OjE3NTM1NjE4Njg6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDA0NTUyOTY2OTI5ODo6MDo6&url=%2FEnfain-Memory-Swivel-Indicator-Removable%2Fdp%2FB00JES3MO0%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB00JES3MO0%26pd_rd_r%3D44d80445-2d5f-426f-bbfd-6a96951f0ebf%26pd_rd_w%3DnIlJO%26pd_rd_wg%3DQcY0H%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D7X10VEZ3MPGYKNJJNJM3%26qid%3D1753561866%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-145-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B00JES3MO0",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 18,
    "asin": "B00JES3MO0",
    "title": "10-Pack Enfain 16GB USB 2.0 Swivel Flash Drives: Shareable Data Storage for Home & Office Use (Black)",
    "brand": "10-Pack",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$24.99",
    "rating": 4.6,
    "review_count": 2,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(13.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/61SXsXKraVL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTQzODAxMjM0ODE1MzA1OjE3NTM1NjE4Njg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MTQzMjM1NzcwMjo6MTo6&url=%2FNicepicten-Pendrive-Memory-Storage-Lanyards%2Fdp%2FB0CSBLH7MM%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CSBLH7MM%26pd_rd_r%3D44d80445-2d5f-426f-bbfd-6a96951f0ebf%26pd_rd_w%3DnIlJO%26pd_rd_wg%3DQcY0H%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D7X10VEZ3MPGYKNJJNJM3%26qid%3D1753561866%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-146-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CSBLH7MM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 19,
    "asin": "B0CSBLH7MM",
    "title": "4GB USB Flash Drive 10 Pack Nicepicten USB 2.0 Thumb Drives Metal Jump Zip Drive Memory Stick Pendrive Memoria USB 4 GB with 10PCS Lanyard Label - Mixcolor 10 X 4GB Flash Drives",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$20.99",
    "rating": 4.6,
    "review_count": 116,
    "special_features": "Metal, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -116,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/7183LGZQqiL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.99,
    "currency": "USD",
    "price_original": "$20.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTQzODAxMjM0ODE1MzA1OjE3NTM1NjE4Njg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDEyMjg1MjMwOTYwMjo6Mjo6&url=%2FWooolken-Swivel-Memory-Multipack-Lanyard%2Fdp%2FB0CHNRYQ1W%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CHNRYQ1W%26pd_rd_r%3D44d80445-2d5f-426f-bbfd-6a96951f0ebf%26pd_rd_w%3DnIlJO%26pd_rd_wg%3DQcY0H%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D7X10VEZ3MPGYKNJJNJM3%26qid%3D1753561866%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-147-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CHNRYQ1W",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 20,
    "asin": "B0CHNRYQ1W",
    "title": "64GB Flash Drive 10 Pack, Wooolken USB 2.0 Thumb Drive Bulk Pen Drive Metal Swivel Memory Stick 64GB 10 Colors Multipack Value Zip USB Drives with Lanyard",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$35.99",
    "rating": 4.6,
    "review_count": 400,
    "special_features": "Metal, Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/71JY3OqwsHL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 35.99,
    "currency": "USD",
    "price_original": "$35.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTQzODAxMjM0ODE1MzA1OjE3NTM1NjE4Njg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDY3NzIwODU1NTkwMjo6Mzo6&url=%2Flcwamy-Flash-Drives-Stick-Pendrive%2Fdp%2FB0DSPRQVJC%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DSPRQVJC%26pd_rd_r%3D44d80445-2d5f-426f-bbfd-6a96951f0ebf%26pd_rd_w%3DnIlJO%26pd_rd_wg%3DQcY0H%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D7X10VEZ3MPGYKNJJNJM3%26qid%3D1753561866%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-148-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DSPRQVJC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 21,
    "asin": "B0DSPRQVJC",
    "title": "8GB Flash Drives 2 Pack USB Drives Pack USB Flash Drives 2 Pack USB Stick Thumb Drive Pack Pendrive USB Flash Drive(8GB 2PCS)",
    "brand": "8GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$5.99",
    "rating": 4.6,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -210,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/61O8JvkToUL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 5.99,
    "currency": "USD",
    "price_original": "$5.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTQzODAxMjM0ODE1MzA1OjE3NTM1NjE4Njg6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDAyOTE2NzM4Mzg5ODo6NDo6&url=%2FDrives-Kepmem-Portable-Swivel-Pieces%2Fdp%2FB075GQ17GL%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB075GQ17GL%26pd_rd_r%3D44d80445-2d5f-426f-bbfd-6a96951f0ebf%26pd_rd_w%3DnIlJO%26pd_rd_wg%3DQcY0H%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D7X10VEZ3MPGYKNJJNJM3%26qid%3D1753561866%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-149-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B075GQ17GL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 22,
    "asin": "B075GQ17GL",
    "title": "USB Flash Drive 4GB 10 Pack USB 2.0 Thumb Drives 4 GB Memory Sticks Portable Jump Drive Bulk Swivel 10 Pieces Zip Drives Mixed Colors Pendrive Data Storage and Backup",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$23.99",
    "rating": 4.6,
    "review_count": 8,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(8.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-10_files/71lFJZly-9L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 23.99,
    "currency": "USD",
    "price_original": "$23.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=10&crid=BALSGJKBQE1X&qid=1753561844&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_10#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 23,
    "asin": null,
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (50,8GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$169.99",
    "rating": null,
    "review_count": 60,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-10_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 169.99,
    "currency": "USD",
    "price_original": "$169.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2MDQ4NzI5MzcxNTQ0Mjk4OjE3NTM1NjE4Njg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5ODEwMjo6MTo6&url=%2FCustom-Drives-Personalized-Business-Promotions%2Fdp%2FB0FGX9Q7X9%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGX9Q7X9%26pd_rd_r%3D44d80445-2d5f-426f-bbfd-6a96951f0ebf%26pd_rd_w%3Dv4zes%26pd_rd_wg%3DQcY0H%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D7X10VEZ3MPGYKNJJNJM3%26qid%3D1753561866%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-145-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGX9Q7X9",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 24,
    "asin": "B0FGX9Q7X9",
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (50,8GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$169.99",
    "rating": null,
    "review_count": 169,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-10_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 169.99,
    "currency": "USD",
    "price_original": "$169.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2MDQ4NzI5MzcxNTQ0Mjk4OjE3NTM1NjE4Njg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5MTcwMjo6Mjo6&url=%2FFlash-Drive-Customizable-Thumb-4GB-128GB%2Fdp%2FB0FGQ3VPN7%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQ3VPN7%26pd_rd_r%3D44d80445-2d5f-426f-bbfd-6a96951f0ebf%26pd_rd_w%3Dv4zes%26pd_rd_wg%3DQcY0H%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D7X10VEZ3MPGYKNJJNJM3%26qid%3D1753561866%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-146-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ3VPN7",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 25,
    "asin": "B0FGQ3VPN7",
    "title": "Mini USB Flash Drive Customizable Tiny Thumb Drive with Your Logo 4GB-128GB - Perfect for Corporate Events, Branded Promotions, Student Projects Plug and Play, PC Mac (50,4GB)",
    "brand": "Mini",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$159.99",
    "rating": null,
    "review_count": 159,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-10_files/41Y5IinJkAL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 159.99,
    "currency": "USD",
    "price_original": "$159.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2MDQ4NzI5MzcxNTQ0Mjk4OjE3NTM1NjE4Njg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5MTAwMjo6Mzo6&url=%2F4GB-128GB-Personalized-Promotions-Corporate-Compatible%2Fdp%2FB0FGQ83SLX%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQ83SLX%26pd_rd_r%3D44d80445-2d5f-426f-bbfd-6a96951f0ebf%26pd_rd_w%3Dv4zes%26pd_rd_wg%3DQcY0H%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D7X10VEZ3MPGYKNJJNJM3%26qid%3D1753561866%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-147-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ83SLX",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 26,
    "asin": "B0FGQ83SLX",
    "title": "Mini Custom USB Flash Drive 4GB-128GB Tiny Personalized Thumb Drive with Logo for Business Promotions, Corporate Gifts, Trade Shows Bulk Mini USB Memory Stick, PC Mac Compatible (50,32GB)",
    "brand": "Mini",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$205.99",
    "rating": null,
    "review_count": 205,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-10_files/31Dd1PlYHIL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 205.99,
    "currency": "USD",
    "price_original": "$205.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2MDQ4NzI5MzcxNTQ0Mjk4OjE3NTM1NjE4Njg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5NzgwMjo6NDo6&url=%2FCustom-Personalized-Packaging-Business-Outreach%2Fdp%2FB0FGPZ5NTM%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGPZ5NTM%26pd_rd_r%3D44d80445-2d5f-426f-bbfd-6a96951f0ebf%26pd_rd_w%3Dv4zes%26pd_rd_wg%3DQcY0H%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D7X10VEZ3MPGYKNJJNJM3%26qid%3D1753561866%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-148-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGPZ5NTM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 27,
    "asin": "B0FGPZ5NTM",
    "title": "Custom Logo USB Drive 50 100 Count Personalized Packaging for School Business Outreach (50,32GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$205.99",
    "rating": null,
    "review_count": 205,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-10_files/41ckOfpOT5L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 205.99,
    "currency": "USD",
    "price_original": "$205.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2MDQ4NzI5MzcxNTQ0Mjk4OjE3NTM1NjE4Njg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDgxNTI2MTg0MTgwMjo6NTo6&url=%2FUPALDHOU-Modeling-Violin-Storage-Lovers%2Fdp%2FB0FCYQVR9W%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FCYQVR9W%26pd_rd_r%3D44d80445-2d5f-426f-bbfd-6a96951f0ebf%26pd_rd_w%3Dv4zes%26pd_rd_wg%3DQcY0H%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D7X10VEZ3MPGYKNJJNJM3%26qid%3D1753561866%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-149-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FCYQVR9W",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 28,
    "asin": "B0FCYQVR9W",
    "title": "Nice Modeling of the Violin Flash Sh USB for Data Storage, Plug and USB Stick Games for Music Lovers (64GB)",
    "brand": "Nice",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$12.27",
    "rating": null,
    "review_count": 12,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-10_files/51OjxmuL5GS._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.27,
    "currency": "USD",
    "price_original": "$12.27"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=10&crid=BALSGJKBQE1X&qid=1753561844&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_10#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 29,
    "asin": null,
    "title": "4GB USB Flash Drive 10 PacksÔºåBulk Thumb Drives Jump Drive with 360¬∞Swivel Shell, Fold Storage USB Stick with Lanyard Hole Portable Pen Drive Mutipack Zip Drive, Black",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$22.49",
    "rating": 4.4,
    "review_count": 4,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/61p4ip0Pn+L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 22.49,
    "currency": "USD",
    "price_original": "$22.49"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0MjQ0NzY3MzA4OTcxMjM3OjE3NTM1NjE4Njg6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4NDc3MzI2MDQ0MDI6OjA6Og&url=%2FJUANWE-Drives-Storage-Memory-Swivel%2Fdp%2FB00VWZ32DO%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB00VWZ32DO%26pd_rd_r%3D708465b8-4a64-4551-9a33-6ceaf8fbd2d0%26pd_rd_w%3DfH3j6%26pd_rd_wg%3DQLROX%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D7X10VEZ3MPGYKNJJNJM3%26qid%3D1753561866%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-145-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B00VWZ32DO",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 30,
    "asin": "B00VWZ32DO",
    "title": "4GB USB Flash Drive 10 PacksÔºåBulk Thumb Drives Jump Drive with 360¬∞Swivel Shell, Fold Storage USB Stick with Lanyard Hole Portable Pen Drive Mutipack Zip Drive, Black",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$22.49",
    "rating": 4.4,
    "review_count": 4,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/61p4ip0Pn+L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 22.49,
    "currency": "USD",
    "price_original": "$22.49"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0MjQ0NzY3MzA4OTcxMjM3OjE3NTM1NjE4Njg6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4MjQ1NDYyNjg4MDI6OjE6Og&url=%2FAUAMOZ-Intended-Compatible-Application-Required%2Fdp%2FB0F8KDP8MH%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0F8KDP8MH%26pd_rd_r%3D708465b8-4a64-4551-9a33-6ceaf8fbd2d0%26pd_rd_w%3DfH3j6%26pd_rd_wg%3DQLROX%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D7X10VEZ3MPGYKNJJNJM3%26qid%3D1753561866%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-146-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0F8KDP8MH",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 31,
    "asin": "B0F8KDP8MH",
    "title": "512GB Flash Drive Intended for iPhone, Memory Stick Storage Files Photos Videos Backup, Compatible with iPhone iPad Android PC, Plug and Play, No Application Required (Rose Gold)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$52.49",
    "rating": 4.5,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -35,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/61B1TxeW2tL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 52.49,
    "currency": "USD",
    "price_original": "$52.49"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0MjQ0NzY3MzA4OTcxMjM3OjE3NTM1NjE4Njg6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4NTAwNzQ5MTM0MDI6OjI6Og&url=%2FPhoto-Stick-USB-Flash-Drives-iPhone-Thumb-Drive-Memory-Mobile-Android-Phones%2Fdp%2FB0956QXSSZ%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0956QXSSZ%26pd_rd_r%3D708465b8-4a64-4551-9a33-6ceaf8fbd2d0%26pd_rd_w%3DfH3j6%26pd_rd_wg%3DQLROX%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D7X10VEZ3MPGYKNJJNJM3%26qid%3D1753561866%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-147-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0956QXSSZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 32,
    "asin": "B0956QXSSZ",
    "title": "MFi Certified 256GB 3-in-1 Photo-Stick-for-iPhone-USB-Flash-Drive Photo-Storage-Stick-iPhone-Thumb-Drive External-Storage-Mobile-for-Android iPad Type-C Flash Drive Photo-Stick for iPhone 16/15/14",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$51.29",
    "rating": 4.3,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/61mTv27LKKL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 51.29,
    "currency": "USD",
    "price_original": "$51.29"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0MjQ0NzY3MzA4OTcxMjM3OjE3NTM1NjE4Njg6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4NTk4OTY1OTE3MDI6OjQ6Og&url=%2FType-C-Android-iPhone-Console-Laptop%2Fdp%2FB0F7QLT8RT%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0F7QLT8RT%26pd_rd_r%3D708465b8-4a64-4551-9a33-6ceaf8fbd2d0%26pd_rd_w%3DfH3j6%26pd_rd_wg%3DQLROX%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D7X10VEZ3MPGYKNJJNJM3%26qid%3D1753561866%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-149-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0F7QLT8RT",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-10.html",
    "position": 33,
    "asin": "B0F7QLT8RT",
    "title": "256GB USB C Flash Drive USB 3.2 Up to 450MB/s Type-C Thumb Drive for Android, iPhone 15/16, Game Console, Laptop, Black",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$24.99",
    "rating": 5,
    "review_count": 4,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -4,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-10_files/519Z9LYahTL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/RAOYI-Smartphones-MacBook-Tablets-Samsung/dp/B07FFTHGS1/ref=sr_1_163?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.jtCEJwXzsMqa21Q7sv_OQnIxsXU29WtedHChct4zgefGjHj071QN20LucGBJIEps._cZHuJQ0oCDt2S05i-0_WO1IxZX6WvpJEaemqc-2Bh4&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-163&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07FFTHGS1",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 1,
    "asin": "B07FFTHGS1",
    "title": "128GB USB C Flash Drive, 2 in 1 USB 3.0 Type C Dual OTG Metal Thumb Drive Jump Drive Memory Stick with Keychain Suitable for USB-C Smartphones, MacBook, Computers and Tablets (Silver)",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$11.39",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Metal, Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/51p-HxiAi3L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.39,
    "currency": "USD",
    "price_original": "$11.39"
  },
  {
    "product_url": "https://www.amazon.com/Nicepicten-Storage-Pendrive-Lanyard-Mixcolor/dp/B0CSBKPTYF/ref=sr_1_164?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.jtCEJwXzsMqa21Q7sv_OQnIxsXU29WtedHChct4zgefGjHj071QN20LucGBJIEps._cZHuJQ0oCDt2S05i-0_WO1IxZX6WvpJEaemqc-2Bh4&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-164&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CSBKPTYF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 2,
    "asin": "B0CSBKPTYF",
    "title": "2GB USB Flash Drive 10 Pack Nicepicten USB 2.0 Thumb Drives Metal Jump Zip Drive Memory Stick Pendrive Memoria USB 2 GB with 10PCS Lanyard Label - Mixcolor 10 X 2GB Flash Drives",
    "brand": "2GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.6,
    "review_count": 116,
    "special_features": "Metal, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/71n29rpKrBL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/EASTFUN-Flash-Memory-Storage-Colors/dp/B01HKUIBZS/ref=sr_1_165?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.jtCEJwXzsMqa21Q7sv_OQnIxsXU29WtedHChct4zgefGjHj071QN20LucGBJIEps._cZHuJQ0oCDt2S05i-0_WO1IxZX6WvpJEaemqc-2Bh4&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-165&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B01HKUIBZS",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 3,
    "asin": "B01HKUIBZS",
    "title": "5 Pack 8GB USB Flash Drive USB 2.0 Flash Memory Stick Fold Storage Thumb Stick Pen (Five Mixed Colors: Black Rose Blue Purple Green)",
    "brand": 5,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$11.99",
    "rating": 4.5,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/61oBM5jYd2L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.99,
    "currency": "USD",
    "price_original": "$11.99"
  },
  {
    "product_url": "https://www.amazon.com/Gigastone-Capless-Retractable-Interface-Compatible/dp/B0C49KR4MB/ref=sr_1_161?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.hialHGFNH6jUS4BCAetBeKC-1_K541Mgj8gM_bzxAsb0y-vVRto1znDzOyXnd6RE0AhXs51CRjfW4mieryUVIy8oRNvJ0dVmEEcgn4uIzyqmaTcTy3whPmCYDVx2T_V4sOj598o8f0pdhIGughoq5TttfDip2R0vQGt7WdmSt87SsQ0AKFM5-qoH0cvkzrKB.qui-VCS-QHA9orwcDmIeeV5GAw5BNkkaTK20d2cmu8o&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-161&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0C49KR4MB",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 4,
    "asin": "B0C49KR4MB",
    "title": "512GB Flash Drive, Z60 USB 3.2 Gen 1, 120MB/s Ultra Fast, Retractable Capless Slider Design, Data Storage, Backup for PC/Mac/TV/Car Audio, USB 2.0/3.0/3.1 Compatible",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 4.3,
    "review_count": 200,
    "special_features": "Retractable, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/31D9GInVR1L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": "https://www.amazon.com/SSK-Transfer-Externel-Adapter-Smartphone/dp/B0DCNP8XHP/ref=sr_1_162?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.hialHGFNH6jUS4BCAetBeKC-1_K541Mgj8gM_bzxAsb0y-vVRto1znDzOyXnd6RE0AhXs51CRjfW4mieryUVIy8oRNvJ0dVmEEcgn4uIzyqmaTcTy3whPmCYDVx2T_V4sOj598o8f0pdhIGughoq5TttfDip2R0vQGt7WdmSt87SsQ0AKFM5-qoH0cvkzrKB.qui-VCS-QHA9orwcDmIeeV5GAw5BNkkaTK20d2cmu8o&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-162&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DCNP8XHP",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 5,
    "asin": "B0DCNP8XHP",
    "title": "1TB USB Flash Drive 550MB/s USB3.2 Gen2 SSD Thumb Drive Fast Transfer Speed Externel Solid State Drive with USB C Adapter USB-C Memory Stick for Type-C Smartphone,MacBook/Pro/Air Laptop and More",
    "brand": "1TB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$72.99",
    "rating": 4.3,
    "review_count": 507,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/61XFR3rFaUL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "tb",
    "price_numeric": 72.99,
    "currency": "USD",
    "price_original": "$72.99"
  },
  {
    "product_url": "https://www.amazon.com/256GB-Flash-Drive-Mount-Module/dp/B0CN5QFYZD/ref=sr_1_163?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.hialHGFNH6jUS4BCAetBeKC-1_K541Mgj8gM_bzxAsb0y-vVRto1znDzOyXnd6RE0AhXs51CRjfW4mieryUVIy8oRNvJ0dVmEEcgn4uIzyqmaTcTy3whPmCYDVx2T_V4sOj598o8f0pdhIGughoq5TttfDip2R0vQGt7WdmSt87SsQ0AKFM5-qoH0cvkzrKB.qui-VCS-QHA9orwcDmIeeV5GAw5BNkkaTK20d2cmu8o&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-163&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CN5QFYZD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 6,
    "asin": "B0CN5QFYZD",
    "title": "256GB USB Flash Drive & Wall Mount for Blink Sync Module 2 with Short Cable ‚Äì Declutter, Save Space, and Effortlessly Enhance Security (1 Pack)",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$12.62",
    "rating": 4.5,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/61xbcUq7gdL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.62,
    "currency": "USD",
    "price_original": "$12.62"
  },
  {
    "product_url": "https://www.amazon.com/Drives-Lanyards-ABLAZE-Premium-Pendrive/dp/B09BFK6Z67/ref=sr_1_164?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.hialHGFNH6jUS4BCAetBeKC-1_K541Mgj8gM_bzxAsb0y-vVRto1znDzOyXnd6RE0AhXs51CRjfW4mieryUVIy8oRNvJ0dVmEEcgn4uIzyqmaTcTy3whPmCYDVx2T_V4sOj598o8f0pdhIGughoq5TttfDip2R0vQGt7WdmSt87SsQ0AKFM5-qoH0cvkzrKB.qui-VCS-QHA9orwcDmIeeV5GAw5BNkkaTK20d2cmu8o&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-164&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09BFK6Z67",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 7,
    "asin": "B09BFK6Z67",
    "title": "Flash Drives 1GB 20 Pack, USB 2.0 Thumb Drive Bulk with Lanyards Swivel Memory Stick U Disk 1GB Pendrive USB Pack (Black)",
    "brand": "Flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$33.99",
    "rating": 4.5,
    "review_count": 50,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "11 sizes11 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/71A7Un9+CSL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 33.99,
    "currency": "USD",
    "price_original": "$33.99"
  },
  {
    "product_url": "https://www.amazon.com/Sanfeya-Android-Smartphones-Tablets-MacBook/dp/B07TD47NPD/ref=sr_1_165?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.hialHGFNH6jUS4BCAetBeKC-1_K541Mgj8gM_bzxAsb0y-vVRto1znDzOyXnd6RE0AhXs51CRjfW4mieryUVIy8oRNvJ0dVmEEcgn4uIzyqmaTcTy3whPmCYDVx2T_V4sOj598o8f0pdhIGughoq5TttfDip2R0vQGt7WdmSt87SsQ0AKFM5-qoH0cvkzrKB.qui-VCS-QHA9orwcDmIeeV5GAw5BNkkaTK20d2cmu8o&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-165&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07TD47NPD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 8,
    "asin": "B07TD47NPD",
    "title": "64GB USB C Flash Drive, 2-in-1 OTG USB 3.0 Thumb Drive, Dual USB Memory Stick Pen Drive for Type-C Android Smartphones Tablets and New MacBook Laptop PC PDA Samsung, Black",
    "brand": "Samsung",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$9.99",
    "rating": 4.3,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/51WH7xYGTQL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 9.99,
    "currency": "USD",
    "price_original": "$9.99"
  },
  {
    "product_url": "https://www.amazon.com/Lexar-JumpDrive-128GB-Flash-LJDS080128G-BNBNU/dp/B08CYBCHTQ/ref=sr_1_168?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.hialHGFNH6jUS4BCAetBeKC-1_K541Mgj8gM_bzxAsb0y-vVRto1znDzOyXnd6RE0AhXs51CRjfW4mieryUVIy8oRNvJ0dVmEEcgn4uIzyqmaTcTy3whPmCYDVx2T_V4sOj598o8f0pdhIGughoq5TttfDip2R0vQGt7WdmSt87SsQ0AKFM5-qoH0cvkzrKB.qui-VCS-QHA9orwcDmIeeV5GAw5BNkkaTK20d2cmu8o&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-168&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08CYBCHTQ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 9,
    "asin": "B08CYBCHTQ",
    "title": "128GB JumpDrive S80 USB 3.2 Gen 1 Flash Drive for Storage Expansion and Backup, Up To 150MB/s Read, Black (LJDS080128G-BNBNU)",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$13.99",
    "rating": 4.5,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/61YePioUQ5L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 13.99,
    "currency": "USD",
    "price_original": "$13.99"
  },
  {
    "product_url": "https://www.amazon.com/Certified-iPhone-External-Storage-Android/dp/B0DMSMSVBQ/ref=sr_1_169?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.hialHGFNH6jUS4BCAetBeKC-1_K541Mgj8gM_bzxAsb0y-vVRto1znDzOyXnd6RE0AhXs51CRjfW4mieryUVIy8oRNvJ0dVmEEcgn4uIzyqmaTcTy3whPmCYDVx2T_V4sOj598o8f0pdhIGughoq5TttfDip2R0vQGt7WdmSt87SsQ0AKFM5-qoH0cvkzrKB.qui-VCS-QHA9orwcDmIeeV5GAw5BNkkaTK20d2cmu8o&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-169&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DMSMSVBQ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 10,
    "asin": "B0DMSMSVBQ",
    "title": "MFi Certified 256GB Flash Drive for iPhone iPad, Photo Stick for External Memory Storage, Easily Back Up and Save Photos, USB Memory Stick Thumb Drive for iPhone/iPad/Android/PC (Light Pink, 256GB)",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$24.98",
    "rating": 4.2,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/61aBdsrkmBL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.98,
    "currency": "USD",
    "price_original": "$24.98"
  },
  {
    "product_url": "https://www.amazon.com/PNY-16GB-Attach%C3%A9-Flash-Drive/dp/B07TJB41BY/ref=sr_1_170?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.hialHGFNH6jUS4BCAetBeKC-1_K541Mgj8gM_bzxAsb0y-vVRto1znDzOyXnd6RE0AhXs51CRjfW4mieryUVIy8oRNvJ0dVmEEcgn4uIzyqmaTcTy3whPmCYDVx2T_V4sOj598o8f0pdhIGughoq5TttfDip2R0vQGt7WdmSt87SsQ0AKFM5-qoH0cvkzrKB.qui-VCS-QHA9orwcDmIeeV5GAw5BNkkaTK20d2cmu8o&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-170&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07TJB41BY",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 11,
    "asin": "B07TJB41BY",
    "title": "16GB Attach√© 4 USB 2.0 Flash Drive 5-Pack",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$17.99",
    "rating": 4.6,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -716,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/71qyC7c27BL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 17.99,
    "currency": "USD",
    "price_original": "$17.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Cruzer-Blade-Flash-SDCZ50-032G/dp/B00IFU6DU8/ref=sr_1_171?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.hialHGFNH6jUS4BCAetBeKC-1_K541Mgj8gM_bzxAsb0y-vVRto1znDzOyXnd6RE0AhXs51CRjfW4mieryUVIy8oRNvJ0dVmEEcgn4uIzyqmaTcTy3whPmCYDVx2T_V4sOj598o8f0pdhIGughoq5TttfDip2R0vQGt7WdmSt87SsQ0AKFM5-qoH0cvkzrKB.qui-VCS-QHA9orwcDmIeeV5GAw5BNkkaTK20d2cmu8o&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-171&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B00IFU6DU8",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 12,
    "asin": "B00IFU6DU8",
    "title": "Cruzer Blade 32GB (5 pack) USB 2.0 Flash Drive Jump Drive Pen Drive SDCZ50-032G - Five Pack w/ (2) Everything But Stromboli (TM) Lanyard",
    "brand": "Cruzer",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "SD",
    "price": "$31.31",
    "rating": 4.6,
    "review_count": 50,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -176,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/51GjpR3BsnL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 31.31,
    "currency": "USD",
    "price_original": "$31.31"
  },
  {
    "product_url": "https://www.amazon.com/Drives-Adapters-Compatible-Laptops-Devices/dp/B0F66TYX1T/ref=sr_1_172?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.hialHGFNH6jUS4BCAetBeKC-1_K541Mgj8gM_bzxAsb0y-vVRto1znDzOyXnd6RE0AhXs51CRjfW4mieryUVIy8oRNvJ0dVmEEcgn4uIzyqmaTcTy3whPmCYDVx2T_V4sOj598o8f0pdhIGughoq5TttfDip2R0vQGt7WdmSt87SsQ0AKFM5-qoH0cvkzrKB.qui-VCS-QHA9orwcDmIeeV5GAw5BNkkaTK20d2cmu8o&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-172&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0F66TYX1T",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 13,
    "asin": "B0F66TYX1T",
    "title": "10 Pack 16GB Flash Drives with 2 USB C Adapters, Thumb Drive, Memory Stick Compatible with PC, Laptops, Mac and Adapters for USB C Devices (10 Mixed Color)",
    "brand": 10,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.3,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -9,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/71LpASH7SeL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/TosMemo-Flash-Swivel-Memory-Storage/dp/B099JHLW66/ref=sr_1_173?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.hialHGFNH6jUS4BCAetBeKC-1_K541Mgj8gM_bzxAsb0y-vVRto1znDzOyXnd6RE0AhXs51CRjfW4mieryUVIy8oRNvJ0dVmEEcgn4uIzyqmaTcTy3whPmCYDVx2T_V4sOj598o8f0pdhIGughoq5TttfDip2R0vQGt7WdmSt87SsQ0AKFM5-qoH0cvkzrKB.qui-VCS-QHA9orwcDmIeeV5GAw5BNkkaTK20d2cmu8o&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-173&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B099JHLW66",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 14,
    "asin": "B099JHLW66",
    "title": "USB Flash Drive 16GB Thumb Drive USB 2.0 Flash Drive Swivel Jump Drive Pen Drive Memory Stick for Data Storage(2 Pack,Black & Blue)",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$6.99",
    "rating": 4.3,
    "review_count": 100,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/510jFW4B5CL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 6.99,
    "currency": "USD",
    "price_original": "$6.99"
  },
  {
    "product_url": "https://www.amazon.com/Kingston-32GB-Protection-Multi-Password-IKLP50/dp/B0B5B2WL5R/ref=sr_1_174?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.hialHGFNH6jUS4BCAetBeKC-1_K541Mgj8gM_bzxAsb0y-vVRto1znDzOyXnd6RE0AhXs51CRjfW4mieryUVIy8oRNvJ0dVmEEcgn4uIzyqmaTcTy3whPmCYDVx2T_V4sOj598o8f0pdhIGughoq5TttfDip2R0vQGt7WdmSt87SsQ0AKFM5-qoH0cvkzrKB.qui-VCS-QHA9orwcDmIeeV5GAw5BNkkaTK20d2cmu8o&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-174&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0B5B2WL5R",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 15,
    "asin": "B0B5B2WL5R",
    "title": "Ironkey Locker+ 50 32GB Encrypted USB Flash Drive | USB 3.2 Gen 1 | XTS-AES Protection | Multi-Password Security Options | Automatic Cloud Backup | Metal Casing | IKLP50/32GB,Silver",
    "brand": "Ironkey",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$37.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": "Metal, Encrypted",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/51EKSPtXEbL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.99,
    "currency": "USD",
    "price_original": "$37.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-256GB-Ultra-Type-C-Flash/dp/B0CP43532G/ref=sr_1_175?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.hialHGFNH6jUS4BCAetBeKC-1_K541Mgj8gM_bzxAsb0y-vVRto1znDzOyXnd6RE0AhXs51CRjfW4mieryUVIy8oRNvJ0dVmEEcgn4uIzyqmaTcTy3whPmCYDVx2T_V4sOj598o8f0pdhIGughoq5TttfDip2R0vQGt7WdmSt87SsQ0AKFM5-qoH0cvkzrKB.qui-VCS-QHA9orwcDmIeeV5GAw5BNkkaTK20d2cmu8o&dib_tag=se&keywords=flash+drives&qid=1753561883&sprefix=flash+drive%2Caps%2C146&sr=8-175&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CP43532G",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 16,
    "asin": "B0CP43532G",
    "title": "256GB Ultra Luxe USB Type-C Flash Drive - Up to 400MB/s, USB 3.2 Gen 1, Premium Metal Design - SDCZ75-256G-G46",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$24.99",
    "rating": 4.6,
    "review_count": 300,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/61PrLVuIGPL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=11&crid=BALSGJKBQE1X&qid=1753561866&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_11#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 17,
    "asin": null,
    "title": "16GB Flash Drive, Jump Drive 10 Pack, Memoria USB 2.0 Multi-Coloured, USB Thumb Drive 16gb Swivel mit 10 Cords Jump Drive with LED Light for Data Storage/Transfer",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$26.37",
    "rating": 4.5,
    "review_count": 5,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/71lxOtSOxNL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 26.37,
    "currency": "USD",
    "price_original": "$26.37"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMDY4OTI3NzU4ODc1NjgxOjE3NTM1NjE4ODY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDcwNTgzNTMyNDYwMjo6MDo6&url=%2FFlash-Drive-Drives-Multi-Coloured-Memory%2Fdp%2FB01M3PWHA4%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB01M3PWHA4%26pd_rd_r%3D918302b4-187a-4c21-9c92-aa71a3d98294%26pd_rd_w%3DUAlhl%26pd_rd_wg%3DLSxyG%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D94KYKP5XYREQ310T5Y1X%26qid%3D1753561883%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-161-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B01M3PWHA4",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 18,
    "asin": "B01M3PWHA4",
    "title": "16GB Flash Drive, Jump Drive 10 Pack, Memoria USB 2.0 Multi-Coloured, USB Thumb Drive 16gb Swivel mit 10 Cords Jump Drive with LED Light for Data Storage/Transfer",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$26.37",
    "rating": 4.5,
    "review_count": 5,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/71lxOtSOxNL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 26.37,
    "currency": "USD",
    "price_original": "$26.37"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMDY4OTI3NzU4ODc1NjgxOjE3NTM1NjE4ODY6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDEwMTg3NTgyNDE5ODo6MTo6&url=%2FPNY-512GB-Turbo-Attach%25C3%25A9-Flash%2Fdp%2FB0BF5VHLBZ%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0BF5VHLBZ%26pd_rd_r%3D918302b4-187a-4c21-9c92-aa71a3d98294%26pd_rd_w%3DUAlhl%26pd_rd_wg%3DLSxyG%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D94KYKP5XYREQ310T5Y1X%26qid%3D1753561883%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-162-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0BF5VHLBZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 19,
    "asin": "B0BF5VHLBZ",
    "title": "512GB Turbo Attache 3 USB 3.2 Flash Drive 100MB/s, Silver (Pack of 1)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$31.99",
    "rating": 4.6,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(40.4K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/51qOUZkMTHL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 31.99,
    "currency": "USD",
    "price_original": "$31.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMDY4OTI3NzU4ODc1NjgxOjE3NTM1NjE4ODY6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDAxNzI0MjM0MzkyMTo6Mjo6&url=%2FALMEMO-Drives-Swivel-Memory-JumpDrive%2Fdp%2FB07SCR8G3M%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07SCR8G3M%26pd_rd_r%3D918302b4-187a-4c21-9c92-aa71a3d98294%26pd_rd_w%3DUAlhl%26pd_rd_wg%3DLSxyG%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D94KYKP5XYREQ310T5Y1X%26qid%3D1753561883%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-163-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07SCR8G3M",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 20,
    "asin": "B07SCR8G3M",
    "title": "USB Flash Drive 2GB 20 Pack, Bulk USB 2.0 Flash Drives Thumb Drive Swivel Memory Stick Jump Drive Pen Drive, Black, 2 GB, 20 Pieces",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$36.79",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.4K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/71mcQ2I+JOL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 36.79,
    "currency": "USD",
    "price_original": "$36.79"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMDY4OTI3NzU4ODc1NjgxOjE3NTM1NjE4ODY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDgzMzQxOTk4NTgwMjo6Mzo6&url=%2FMoment-128GB-Flash-Drive-4-Pack%2Fdp%2FB0FB8QXNHZ%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FB8QXNHZ%26pd_rd_r%3D918302b4-187a-4c21-9c92-aa71a3d98294%26pd_rd_w%3DUAlhl%26pd_rd_wg%3DLSxyG%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D94KYKP5XYREQ310T5Y1X%26qid%3D1753561883%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-164-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FB8QXNHZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 21,
    "asin": "B0FB8QXNHZ",
    "title": "Moment 128GB (4 Pack) MU G03 USB Flash Drive 4-Pack ‚Äì USB 3.2 Memory Stick with Protective Cap and Keychain Loop, Up to 100MB/s Read, 30MB/s Write ‚Äì Plug & Play USB Drive for PC, Mac, TV, Car",
    "brand": "Moment",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$32.99",
    "rating": 4.3,
    "review_count": 862,
    "special_features": "Keychain, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -862,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/61x1mrNLzWL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 32.99,
    "currency": "USD",
    "price_original": "$32.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMDY4OTI3NzU4ODc1NjgxOjE3NTM1NjE4ODY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDc2NjYwNjEzMDUwMjo6NDo6&url=%2FFlash-EASTBULL-Swivel-Memory-Storage%2Fdp%2FB07RTHSYMX%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07RTHSYMX%26pd_rd_r%3D918302b4-187a-4c21-9c92-aa71a3d98294%26pd_rd_w%3DUAlhl%26pd_rd_wg%3DLSxyG%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D94KYKP5XYREQ310T5Y1X%26qid%3D1753561883%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-165-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07RTHSYMX",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 22,
    "asin": "B07RTHSYMX",
    "title": "8GB Bulk USB Flash Drives 20 Pack, EASTBULL USB 2.0 Swivel USB Stick Bulk Gig Stick Metal Thumb Fold Storage (Blue)",
    "brand": "8GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$44.88",
    "rating": 4.5,
    "review_count": 992,
    "special_features": "Metal, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -992,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/71RV8v3lkKL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 44.88,
    "currency": "USD",
    "price_original": "$44.88"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=11&crid=BALSGJKBQE1X&qid=1753561866&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_11#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 23,
    "asin": null,
    "title": "256GB Flash Drive Intended for iPhone, Memory Stick Storage Files Photos Videos Backup, Compatible with iPhone iPad Android PC, Plug and Play, No Application Required (Metal Silver)",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$37.49",
    "rating": 4.6,
    "review_count": 60,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -32,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/61vpyoZTx9L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.49,
    "currency": "USD",
    "price_original": "$37.49"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxNTU3NzM4ODg0NjIwMjY1OjE3NTM1NjE4ODY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0MDU2Njc0NzYwMjo6MTo6&url=%2FAUAMOZ-Intended-Compatible-Application-Required%2Fdp%2FB0FCGZGW27%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FCGZGW27%26pd_rd_r%3D918302b4-187a-4c21-9c92-aa71a3d98294%26pd_rd_w%3DTTNlD%26pd_rd_wg%3DLSxyG%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D94KYKP5XYREQ310T5Y1X%26qid%3D1753561883%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-161-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FCGZGW27",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 24,
    "asin": "B0FCGZGW27",
    "title": "256GB Flash Drive Intended for iPhone, Memory Stick Storage Files Photos Videos Backup, Compatible with iPhone iPad Android PC, Plug and Play, No Application Required (Metal Silver)",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$37.49",
    "rating": 4.6,
    "review_count": 32,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -32,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/61vpyoZTx9L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.49,
    "currency": "USD",
    "price_original": "$37.49"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxNTU3NzM4ODg0NjIwMjY1OjE3NTM1NjE4ODY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5ODcwMjo6Mjo6&url=%2FCustom-Drives-Personalized-Business-Promotions%2Fdp%2FB0FGQ8HYQ5%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQ8HYQ5%26pd_rd_r%3D918302b4-187a-4c21-9c92-aa71a3d98294%26pd_rd_w%3DTTNlD%26pd_rd_wg%3DLSxyG%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D94KYKP5XYREQ310T5Y1X%26qid%3D1753561883%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-162-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ8HYQ5",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 25,
    "asin": "B0FGQ8HYQ5",
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (50,32GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$205.99",
    "rating": null,
    "review_count": 205,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-11_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 205.99,
    "currency": "USD",
    "price_original": "$205.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxNTU3NzM4ODg0NjIwMjY1OjE3NTM1NjE4ODY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5MTMwMjo6Mzo6&url=%2FFlash-Drive-Customizable-Thumb-4GB-128GB%2Fdp%2FB0FGQLLYQG%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQLLYQG%26pd_rd_r%3D918302b4-187a-4c21-9c92-aa71a3d98294%26pd_rd_w%3DTTNlD%26pd_rd_wg%3DLSxyG%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D94KYKP5XYREQ310T5Y1X%26qid%3D1753561883%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-163-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQLLYQG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 26,
    "asin": "B0FGQLLYQG",
    "title": "Mini USB Flash Drive Customizable Tiny Thumb Drive with Your Logo 4GB-128GB - Perfect for Corporate Events, Branded Promotions, Student Projects Plug and Play, PC Mac (100,16GB)",
    "brand": "Mini",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$380.99",
    "rating": null,
    "review_count": 380,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-11_files/41Y5IinJkAL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 380.99,
    "currency": "USD",
    "price_original": "$380.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxNTU3NzM4ODg0NjIwMjY1OjE3NTM1NjE4ODY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5ODAwMjo6NDo6&url=%2FCustom-Personalized-Packaging-Business-Outreach%2Fdp%2FB0FGPZJTYF%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGPZJTYF%26pd_rd_r%3D918302b4-187a-4c21-9c92-aa71a3d98294%26pd_rd_w%3DTTNlD%26pd_rd_wg%3DLSxyG%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D94KYKP5XYREQ310T5Y1X%26qid%3D1753561883%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-164-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGPZJTYF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 27,
    "asin": "B0FGPZJTYF",
    "title": "Custom Logo USB Drive 50 100 Count Personalized Packaging for School Business Outreach (50,128GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$329.99",
    "rating": null,
    "review_count": 329,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-11_files/41ckOfpOT5L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 329.99,
    "currency": "USD",
    "price_original": "$329.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxNTU3NzM4ODg0NjIwMjY1OjE3NTM1NjE4ODY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDgxNTQyOTA5OTkwMjo6NTo6&url=%2FPOENVFPO-Beautiful-Informed-Storage-PORTIL%2Fdp%2FB0FD8537HW%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FD8537HW%26pd_rd_r%3D918302b4-187a-4c21-9c92-aa71a3d98294%26pd_rd_w%3DTTNlD%26pd_rd_wg%3DLSxyG%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D94KYKP5XYREQ310T5Y1X%26qid%3D1753561883%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-165-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FD8537HW",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 28,
    "asin": "B0FD8537HW",
    "title": "Beautiful USB Flash Unit Informed for Music Data Storage 7 10 View Unix OS X, PORTIL PORTIL STICK (32GB)",
    "brand": "Beautiful",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$11.46",
    "rating": null,
    "review_count": 11,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-11_files/61C7tlrvtZS._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.46,
    "currency": "USD",
    "price_original": "$11.46"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=11&crid=BALSGJKBQE1X&qid=1753561866&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_11#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 29,
    "asin": null,
    "title": "128GB USB Flash Drive 5 Packs, Thumb Drives Foldable 360¬∞ Swivel Shell & Lanyard Hold for Memory Storage Expand, USB Sticks Pen Drive Zip Drive for PC/Tablet/Car Data Transfer - Black",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 4.4,
    "review_count": 4,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/61gJMo5hR6L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4ODY0NzM1MDIyMzYwOTk1OjE3NTM1NjE4ODY6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4NDc5ODUxNDc1MDI6OjA6Og&url=%2FJUANWE-Storage-Memory-Keychain-Drive-Black%2Fdp%2FB0B93NPSSC%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0B93NPSSC%26pd_rd_r%3Df160f7f0-ed45-4717-b761-5bf69d91577c%26pd_rd_w%3DxkB4f%26pd_rd_wg%3DaFomF%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D94KYKP5XYREQ310T5Y1X%26qid%3D1753561883%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-161-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0B93NPSSC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 30,
    "asin": "B0B93NPSSC",
    "title": "128GB USB Flash Drive 5 Packs, Thumb Drives Foldable 360¬∞ Swivel Shell & Lanyard Hold for Memory Storage Expand, USB Sticks Pen Drive Zip Drive for PC/Tablet/Car Data Transfer - Black",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 4.4,
    "review_count": 4,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/61gJMo5hR6L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4ODY0NzM1MDIyMzYwOTk1OjE3NTM1NjE4ODY6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4MjQ1NDYyNjkwMDI6OjI6Og&url=%2FAUAMOZ-Intended-Compatible-Application-Required%2Fdp%2FB0F8JZFGZL%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0F8JZFGZL%26pd_rd_r%3Df160f7f0-ed45-4717-b761-5bf69d91577c%26pd_rd_w%3DxkB4f%26pd_rd_wg%3DaFomF%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D94KYKP5XYREQ310T5Y1X%26qid%3D1753561883%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-163-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0F8JZFGZL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-11.html",
    "position": 31,
    "asin": "B0F8JZFGZL",
    "title": "512GB Flash Drive Intended for iPhone, Memory Stick Storage Files Photos Videos Backup, Compatible with iPhone iPad Android PC, Plug and Play, No Application Required (Metal Silver)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$52.49",
    "rating": 4.5,
    "review_count": 100,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -35,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-11_files/61uWct3lQQL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 52.49,
    "currency": "USD",
    "price_original": "$52.49"
  },
  {
    "product_url": "https://www.amazon.com/Drives-Adapter-Keychains-Wooolken-Swivel/dp/B0DZWNYTJ6/ref=sr_1_179?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.kFPMx7iiKkV4msu_RLw1T6WcrK790yfO5C--ghPMVaXGjHj071QN20LucGBJIEps.YtnjkjA8A2bVwOplWxC-3XCdazkgCAj4ERr2eq72hRE&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-179&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DZWNYTJ6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 1,
    "asin": "B0DZWNYTJ6",
    "title": "128GB USB 3.0 Flash Drives 2 Pack with USB C 3.0 Adapter and Keychains, Wooolken Swivel Thumb Drives USB Stick Drive Memory Stick",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$16.82",
    "rating": 4.6,
    "review_count": 100,
    "special_features": "Keychain, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/61OxytIEd7L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.82,
    "currency": "USD",
    "price_original": "$16.82"
  },
  {
    "product_url": "https://www.amazon.com/RAOYI-Retractable-Portable-Android-Smartphone/dp/B0DZB813KL/ref=sr_1_180?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.kFPMx7iiKkV4msu_RLw1T6WcrK790yfO5C--ghPMVaXGjHj071QN20LucGBJIEps.YtnjkjA8A2bVwOplWxC-3XCdazkgCAj4ERr2eq72hRE&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-180&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DZB813KL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 2,
    "asin": "B0DZB813KL",
    "title": "512GB USB C Flash Drive 2 in 1 Type C + USB 3.0 Flash Drive Dual OTG Retractable Type-C Thumb Drive Portable USB-C Memory Stick for iPhone 15 iPad Pro Android Smartphone Tablet PC (Black)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$36.99",
    "rating": 4.4,
    "review_count": 100,
    "special_features": "Retractable",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/51Lcg0V5+ZL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 36.99,
    "currency": "USD",
    "price_original": "$36.99"
  },
  {
    "product_url": "https://www.amazon.com/ZZ-Flash-Memory-iPhone-Photos/dp/B0D457CDSV/ref=sr_1_181?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.kFPMx7iiKkV4msu_RLw1T6WcrK790yfO5C--ghPMVaXGjHj071QN20LucGBJIEps.YtnjkjA8A2bVwOplWxC-3XCdazkgCAj4ERr2eq72hRE&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-181&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D457CDSV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 3,
    "asin": "B0D457CDSV",
    "title": "128GB USB C Flash Drive Dual USB-C Thumb Drive 3.0 Push-Pull USB A + Type C Memory Stick Photo Stick for Smartphone Tablet Laptop iPhone 15",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$11.68",
    "rating": 4.3,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -158,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/51a5x+7pRLL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.68,
    "currency": "USD",
    "price_original": "$11.68"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Ultra-Drive-Type-C-Flash/dp/B07YYK13LF/ref=sr_1_177?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.cmun5pU_g9WP_s05Cj8LguKWG5Gmo75vw8mpCNve_NRP_mJc7SPw-0TVjxHJRofh0v4GjXAIeF3tzSY8dQ0SlwkV2k2FHrFgxk8atVIKTdnRz0b8E7QZwoOlqp4JpJanyeGs-Rz78oAniRK6YxTh6c_LuMbqvxuXRpPDyOpjD74SqIQxnCju43Mbumy7i6oj.DSUS-4AwbsdGxazUkSd1QgV-qoeig3iXWgyP5fMaER8&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-177&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07YYK13LF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 4,
    "asin": "B07YYK13LF",
    "title": "64GB Ultra Dual Drive Go USB Type-C Flash Drive, Black - SDDDC3-064G-G46",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$13.36",
    "rating": 4.6,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/71qOWNxv4jL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 13.36,
    "currency": "USD",
    "price_original": "$13.36"
  },
  {
    "product_url": "https://www.amazon.com/PNY-Attach%C3%A9-Flash-Drive-5-Pack/dp/B0CBQH4J88/ref=sr_1_178?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.cmun5pU_g9WP_s05Cj8LguKWG5Gmo75vw8mpCNve_NRP_mJc7SPw-0TVjxHJRofh0v4GjXAIeF3tzSY8dQ0SlwkV2k2FHrFgxk8atVIKTdnRz0b8E7QZwoOlqp4JpJanyeGs-Rz78oAniRK6YxTh6c_LuMbqvxuXRpPDyOpjD74SqIQxnCju43Mbumy7i6oj.DSUS-4AwbsdGxazUkSd1QgV-qoeig3iXWgyP5fMaER8&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-178&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CBQH4J88",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 5,
    "asin": "B0CBQH4J88",
    "title": "16GB Attach√© 4 USB 2.0 Flash Drive 5-Pack",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.26",
    "rating": 4.3,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -46,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/51kYzbrdAXL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.26,
    "currency": "USD",
    "price_original": "$19.26"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-16GB-Ultra-Flash-Drive/dp/B077Y149DL/ref=sr_1_179?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.cmun5pU_g9WP_s05Cj8LguKWG5Gmo75vw8mpCNve_NRP_mJc7SPw-0TVjxHJRofh0v4GjXAIeF3tzSY8dQ0SlwkV2k2FHrFgxk8atVIKTdnRz0b8E7QZwoOlqp4JpJanyeGs-Rz78oAniRK6YxTh6c_LuMbqvxuXRpPDyOpjD74SqIQxnCju43Mbumy7i6oj.DSUS-4AwbsdGxazUkSd1QgV-qoeig3iXWgyP5fMaER8&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-179&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B077Y149DL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 6,
    "asin": "B077Y149DL",
    "title": "16GB Ultra Fit USB 3.2 Flash Drive - SDCZ430-016G-G46",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$8.95",
    "rating": 4.6,
    "review_count": 400,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(11.6K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/917k6WqTLSL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 8.95,
    "currency": "USD",
    "price_original": "$8.95"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-256GB-Creator-USB-C-Flash/dp/B0DP36TP4P/ref=sr_1_180?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.cmun5pU_g9WP_s05Cj8LguKWG5Gmo75vw8mpCNve_NRP_mJc7SPw-0TVjxHJRofh0v4GjXAIeF3tzSY8dQ0SlwkV2k2FHrFgxk8atVIKTdnRz0b8E7QZwoOlqp4JpJanyeGs-Rz78oAniRK6YxTh6c_LuMbqvxuXRpPDyOpjD74SqIQxnCju43Mbumy7i6oj.DSUS-4AwbsdGxazUkSd1QgV-qoeig3iXWgyP5fMaER8&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-180&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DP36TP4P",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 7,
    "asin": "B0DP36TP4P",
    "title": "256GB Creator USB-C Flash Drive - Up to 400MB/s, USB Type-C - Compatible with Laptops, Tablets and Smartphones -3 Months of Adobe Lightroom Included - SDCZ75C-256G-G46",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$26.99",
    "rating": 4.4,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -236,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/61KpbpLo4JL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 26.99,
    "currency": "USD",
    "price_original": "$26.99"
  },
  {
    "product_url": "https://www.amazon.com/AreTop-Swivel-Memory-Storage-Backup/dp/B0D6G916DK/ref=sr_1_181?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.cmun5pU_g9WP_s05Cj8LguKWG5Gmo75vw8mpCNve_NRP_mJc7SPw-0TVjxHJRofh0v4GjXAIeF3tzSY8dQ0SlwkV2k2FHrFgxk8atVIKTdnRz0b8E7QZwoOlqp4JpJanyeGs-Rz78oAniRK6YxTh6c_LuMbqvxuXRpPDyOpjD74SqIQxnCju43Mbumy7i6oj.DSUS-4AwbsdGxazUkSd1QgV-qoeig3iXWgyP5fMaER8&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-181&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D6G916DK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 8,
    "asin": "B0D6G916DK",
    "title": "16GB 20 Pack USB Flash Drive, Bulk USB 2.0 Thumb Drive Swivel Memory Stick Jump Drives Pen Drives for Storage and Backup (20 Pack 16GB, Black)",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$45.58",
    "rating": 4.4,
    "review_count": 50,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "7 sizes7 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/71AVUKgF4XL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 45.58,
    "currency": "USD",
    "price_original": "$45.58"
  },
  {
    "product_url": "https://www.amazon.com/Kingston-512GB-Independent-Protection-IKKP200C/dp/B0CJRMN1NK/ref=sr_1_184?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.cmun5pU_g9WP_s05Cj8LguKWG5Gmo75vw8mpCNve_NRP_mJc7SPw-0TVjxHJRofh0v4GjXAIeF3tzSY8dQ0SlwkV2k2FHrFgxk8atVIKTdnRz0b8E7QZwoOlqp4JpJanyeGs-Rz78oAniRK6YxTh6c_LuMbqvxuXRpPDyOpjD74SqIQxnCju43Mbumy7i6oj.DSUS-4AwbsdGxazUkSd1QgV-qoeig3iXWgyP5fMaER8&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-184&ufe=app_do%3Aamzn1.fos.5998aa40-ec6f-4947-a68f-cd087fee0848&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CJRMN1NK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 9,
    "asin": "B0CJRMN1NK",
    "title": "Ironkey Keypad 200 USB-C 512GB Encrypted Flash Drive | OS Independent | FIPS 140-3 Level 3 | XTS-AES 256-bit | BadUSB and Brute Force Protection | Multi-Pin Option | IKKP200C/512GB",
    "brand": "Ironkey",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$229.99",
    "rating": 4.4,
    "review_count": 50,
    "special_features": "Encrypted",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "7 sizes7 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "No",
    "image_url": "./drives-12_files/71OiDgVoKRL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 229.99,
    "currency": "USD",
    "price_original": "$229.99"
  },
  {
    "product_url": "https://www.amazon.com/Transcend-256GB-JF790-Flash-USB3-1/dp/B092W861B7/ref=sr_1_185?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.cmun5pU_g9WP_s05Cj8LguKWG5Gmo75vw8mpCNve_NRP_mJc7SPw-0TVjxHJRofh0v4GjXAIeF3tzSY8dQ0SlwkV2k2FHrFgxk8atVIKTdnRz0b8E7QZwoOlqp4JpJanyeGs-Rz78oAniRK6YxTh6c_LuMbqvxuXRpPDyOpjD74SqIQxnCju43Mbumy7i6oj.DSUS-4AwbsdGxazUkSd1QgV-qoeig3iXWgyP5fMaER8&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-185&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B092W861B7",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 10,
    "asin": "B092W861B7",
    "title": "256GB JF790 USB Flash Drive, USB3.1 Gen1, Retractable USB Connector, Thumb Drives, White - TS256GJF790W",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$18.61",
    "rating": 4.5,
    "review_count": 8,
    "special_features": "Retractable",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "9 sizes9 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "No",
    "image_url": "./drives-12_files/51x7jv9W5uL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.61,
    "currency": "USD",
    "price_original": "$18.61"
  },
  {
    "product_url": "https://www.amazon.com/Certified-External-Storage-Picture-Android/dp/B0FCLKJ6M6/ref=sr_1_186?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.cmun5pU_g9WP_s05Cj8LguKWG5Gmo75vw8mpCNve_NRP_mJc7SPw-0TVjxHJRofh0v4GjXAIeF3tzSY8dQ0SlwkV2k2FHrFgxk8atVIKTdnRz0b8E7QZwoOlqp4JpJanyeGs-Rz78oAniRK6YxTh6c_LuMbqvxuXRpPDyOpjD74SqIQxnCju43Mbumy7i6oj.DSUS-4AwbsdGxazUkSd1QgV-qoeig3iXWgyP5fMaER8&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-186&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0FCLKJ6M6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 11,
    "asin": "B0FCLKJ6M6",
    "title": "USB 3.0 Flash Drive for iPhone 256GB: MFi Certified 3in1 External Memory Photo Keeper Storage Stick for Picture/Video/Data Saver/Backup High Speed Thumb/Jump/Hard Drive for iPad/Android/PC -Rose Gold",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$28.49",
    "rating": 4.5,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -81,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/715qeoLf4iL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 28.49,
    "currency": "USD",
    "price_original": "$28.49"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=12&crid=BALSGJKBQE1X&qid=1753561883&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_12#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 12,
    "asin": null,
    "title": "64GB Flash Drive 10 Pack, Thumb Drive High Capacity Multicolour, Bulk USB Flash Drives 64 GB Metal Swivel, USB 2.0 Jump Drive Portable, Pen Drive Zip High Speed for Data Storage",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$32.39",
    "rating": 4.5,
    "review_count": 5,
    "special_features": "Metal, Swivel, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/71lxOtSOxNL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 32.39,
    "currency": "USD",
    "price_original": "$32.39"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1MTY5NzA1MjE5NTMxNjcwOjE3NTM1NjE5MDg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0MDg1NjAwMzcwMjo6MDo6&url=%2F64GB-Flash-Memory-Storage-Colors%2Fdp%2FB09C3JD1DZ%2Fref%3Dsxin_14_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB09C3JD1DZ%26pd_rd_r%3Dd73cb5f4-abf1-41a5-97d9-0ae0bcde6126%26pd_rd_w%3D9dO4B%26pd_rd_wg%3DRLJST%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DCEK13M7YKFB2VHBS45BS%26qid%3D1753561906%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-177-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B09C3JD1DZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 13,
    "asin": "B09C3JD1DZ",
    "title": "64GB Flash Drive 10 Pack, Thumb Drive High Capacity Multicolour, Bulk USB Flash Drives 64 GB Metal Swivel, USB 2.0 Jump Drive Portable, Pen Drive Zip High Speed for Data Storage",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$32.39",
    "rating": 4.5,
    "review_count": 300,
    "special_features": "Metal, Swivel, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/71lxOtSOxNL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 32.39,
    "currency": "USD",
    "price_original": "$32.39"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1MTY5NzA1MjE5NTMxNjcwOjE3NTM1NjE5MDg6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDAyOTE5NDY5MDc5ODo6MTo6&url=%2FDrives-Kepmem-Swivel-Portable-Multicoloured%2Fdp%2FB075GPSYH1%2Fref%3Dsxin_14_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB075GPSYH1%26pd_rd_r%3Dd73cb5f4-abf1-41a5-97d9-0ae0bcde6126%26pd_rd_w%3D9dO4B%26pd_rd_wg%3DRLJST%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DCEK13M7YKFB2VHBS45BS%26qid%3D1753561906%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-178-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B075GPSYH1",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 14,
    "asin": "B075GPSYH1",
    "title": "8GB Flash Drive 10 Pack Thumb Drives Bulk, Multipack Zip Drive 8 GB USB Memory Sticks Metal Swivel Pen Drive, Portable Jump Drive Value Multicoloured Pendrives with 10pcs Ropes",
    "brand": "8GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$25.99",
    "rating": 4.6,
    "review_count": 50,
    "special_features": "Metal, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(8.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/71lFJZly-9L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 25.99,
    "currency": "USD",
    "price_original": "$25.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1MTY5NzA1MjE5NTMxNjcwOjE3NTM1NjE5MDg6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDA1OTA3NzU5Mjc5ODo6Mjo6&url=%2FMemory-JBOS-Swivel-Digital-Storage%2Fdp%2FB07FLP3TKD%2Fref%3Dsxin_14_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07FLP3TKD%26pd_rd_r%3Dd73cb5f4-abf1-41a5-97d9-0ae0bcde6126%26pd_rd_w%3D9dO4B%26pd_rd_wg%3DRLJST%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DCEK13M7YKFB2VHBS45BS%26qid%3D1753561906%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-179-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07FLP3TKD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 15,
    "asin": "B07FLP3TKD",
    "title": "4GB USB Flash Drive, Flash Stick 4 GB 10 Pack Memory Stick JBOS Swivel Thumb Drives Gig Stick USB2.0 Pen Drive for Fold Digital Date Storage, Zip Drive, Jump Drive, Disk Key, USB Stick, Mixed Colors",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$18.99",
    "rating": 4.6,
    "review_count": 200,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.9K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/61lrRFxDPHL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.99,
    "currency": "USD",
    "price_original": "$18.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1MTY5NzA1MjE5NTMxNjcwOjE3NTM1NjE5MDg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDEzODQ1NDE5NzEwMjo6Mzo6&url=%2FJOIOT-Portable-Keychain-Smartphone-Computer%2Fdp%2FB0CSW5XY8Y%2Fref%3Dsxin_14_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CSW5XY8Y%26pd_rd_r%3Dd73cb5f4-abf1-41a5-97d9-0ae0bcde6126%26pd_rd_w%3D9dO4B%26pd_rd_wg%3DRLJST%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DCEK13M7YKFB2VHBS45BS%26qid%3D1753561906%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-180-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CSW5XY8Y",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 16,
    "asin": "B0CSW5XY8Y",
    "title": "32GB USB C Flash Drive Dual USB 3.0 Flash Drive Type C + USB A Portable Type-C Flash Drive 2-in-1 USB-C Thumb Drive for Smartphone Tablet Computer Mac iPhone 15 (5 Packs)",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$29.99",
    "rating": 4.4,
    "review_count": 300,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -946,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/61qG04u5+CL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 29.99,
    "currency": "USD",
    "price_original": "$29.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1MTY5NzA1MjE5NTMxNjcwOjE3NTM1NjE5MDg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDcyOTE3NzA0MTkwMjo6NDo6&url=%2FGIGASTONE-Drives-Reliable-Waterproof-Compatible%2Fdp%2FB0D6B8V68W%2Fref%3Dsxin_14_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0D6B8V68W%26pd_rd_r%3Dd73cb5f4-abf1-41a5-97d9-0ae0bcde6126%26pd_rd_w%3D9dO4B%26pd_rd_wg%3DRLJST%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DCEK13M7YKFB2VHBS45BS%26qid%3D1753561906%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-181-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0D6B8V68W",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 17,
    "asin": "B0D6B8V68W",
    "title": "„ÄêGIGASTONE„Äë Z70 128 GB 2 Pack USB 3.2 Gen1, USB Flash Drives, Reliable for PC and Mac, Waterproof Metal, Mini and Robust, USB 2.0/3.0/3.1 Interface Compatible",
    "brand": "Gigastone",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.3,
    "review_count": 50,
    "special_features": "Waterproof, Metal, Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -869,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/516HYmWZT2L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/WesData-Storage-Function-Laptops-MacBook/dp/B0CW2VJ7GV/ref=sr_1_187?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.cmun5pU_g9WP_s05Cj8LguKWG5Gmo75vw8mpCNve_NRP_mJc7SPw-0TVjxHJRofh0v4GjXAIeF3tzSY8dQ0SlwkV2k2FHrFgxk8atVIKTdnRz0b8E7QZwoOlqp4JpJanyeGs-Rz78oAniRK6YxTh6c_LuMbqvxuXRpPDyOpjD74SqIQxnCju43Mbumy7i6oj.DSUS-4AwbsdGxazUkSd1QgV-qoeig3iXWgyP5fMaER8&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-187&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CW2VJ7GV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 18,
    "asin": "B0CW2VJ7GV",
    "title": "32GB 3.0 USB C Flash Drive with Type C and Type A Port, USB C Thumb Drives Storage and Backup for Smart Phones with OTG Function and Type C Port, Laptops, MacBook, PC(Red)",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$6.99",
    "rating": 4.4,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/61YoLG4+-VL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 6.99,
    "currency": "USD",
    "price_original": "$6.99"
  },
  {
    "product_url": "https://www.amazon.com/MOVE-SPEED-Interface-3-Stage-Push-Pull/dp/B0D3F2SLPF/ref=sr_1_188?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.cmun5pU_g9WP_s05Cj8LguKWG5Gmo75vw8mpCNve_NRP_mJc7SPw-0TVjxHJRofh0v4GjXAIeF3tzSY8dQ0SlwkV2k2FHrFgxk8atVIKTdnRz0b8E7QZwoOlqp4JpJanyeGs-Rz78oAniRK6YxTh6c_LuMbqvxuXRpPDyOpjD74SqIQxnCju43Mbumy7i6oj.DSUS-4AwbsdGxazUkSd1QgV-qoeig3iXWgyP5fMaER8&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-188&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D3F2SLPF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 19,
    "asin": "B0D3F2SLPF",
    "title": "256GB External SSD 1000MB/s Read Write Speed,USB 3.2 Gen2+USB C Flash Drive with Dual Ports, Portable SSD 3-Stage Push-Pull Design, Thumb Drive for iPhone 15/16 Series/Mac/Android Phone etc",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$49.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/71+qfeB0rbL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 49.99,
    "currency": "USD",
    "price_original": "$49.99"
  },
  {
    "product_url": "https://www.amazon.com/Drives-EASTBULL-Swivel-Strings-16GB-Blue/dp/B0BKKPVN21/ref=sr_1_189?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.cmun5pU_g9WP_s05Cj8LguKWG5Gmo75vw8mpCNve_NRP_mJc7SPw-0TVjxHJRofh0v4GjXAIeF3tzSY8dQ0SlwkV2k2FHrFgxk8atVIKTdnRz0b8E7QZwoOlqp4JpJanyeGs-Rz78oAniRK6YxTh6c_LuMbqvxuXRpPDyOpjD74SqIQxnCju43Mbumy7i6oj.DSUS-4AwbsdGxazUkSd1QgV-qoeig3iXWgyP5fMaER8&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-189&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BKKPVN21",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 20,
    "asin": "B0BKKPVN21",
    "title": "16GB Bulk Flash Drives 50 Pack EASTBULL USB Flash Drives Pack USB 2.0 Thumb Drives Bulk Swivel USB Drives Bulk with Strings (16GB-Blue)",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$107.88",
    "rating": 4.5,
    "review_count": 992,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -992,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/71w+CV0LA4L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 107.88,
    "currency": "USD",
    "price_original": "$107.88"
  },
  {
    "product_url": "https://www.amazon.com/RAOYI-10Pack-Flash-Memory-Drives/dp/B00WU18M0C/ref=sr_1_190?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.cmun5pU_g9WP_s05Cj8LguKWG5Gmo75vw8mpCNve_NRP_mJc7SPw-0TVjxHJRofh0v4GjXAIeF3tzSY8dQ0SlwkV2k2FHrFgxk8atVIKTdnRz0b8E7QZwoOlqp4JpJanyeGs-Rz78oAniRK6YxTh6c_LuMbqvxuXRpPDyOpjD74SqIQxnCju43Mbumy7i6oj.DSUS-4AwbsdGxazUkSd1QgV-qoeig3iXWgyP5fMaER8&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-190&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B00WU18M0C",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 21,
    "asin": "B00WU18M0C",
    "title": "10 Pack 1GB 1G USB Flash Drive USB 2.0 Memory Stick Bulk Thumb Drive Pen Drive Blue",
    "brand": 10,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$18.71",
    "rating": 4.6,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/61q9i5m+5UL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.71,
    "currency": "USD",
    "price_original": "$18.71"
  },
  {
    "product_url": "https://www.amazon.com/Vansuny-Keychain-Android-Smartphone-Computers/dp/B0DHFSZ51Y/ref=sr_1_191?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.cmun5pU_g9WP_s05Cj8LguKWG5Gmo75vw8mpCNve_NRP_mJc7SPw-0TVjxHJRofh0v4GjXAIeF3tzSY8dQ0SlwkV2k2FHrFgxk8atVIKTdnRz0b8E7QZwoOlqp4JpJanyeGs-Rz78oAniRK6YxTh6c_LuMbqvxuXRpPDyOpjD74SqIQxnCju43Mbumy7i6oj.DSUS-4AwbsdGxazUkSd1QgV-qoeig3iXWgyP5fMaER8&dib_tag=se&keywords=flash+drives&qid=1753561906&sprefix=flash+drive%2Caps%2C146&sr=8-191&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DHFSZ51Y",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 22,
    "asin": "B0DHFSZ51Y",
    "title": "512GB Type C Flash Drive 2 in 1 OTG USB 3.0 + USB C Memory Stick with Keychain Dual Thumb Photo Stick Jump Drive for Android Smartphone, Computers",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$32.27",
    "rating": 4.3,
    "review_count": 500,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/41Mc1DlPcqL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 32.27,
    "currency": "USD",
    "price_original": "$32.27"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=12&crid=BALSGJKBQE1X&qid=1753561883&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_12#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 23,
    "asin": null,
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (100,16GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$380.99",
    "rating": null,
    "review_count": 60,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-12_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 380.99,
    "currency": "USD",
    "price_original": "$380.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyODIwNDE5MDQwNTA0ODU6MTc1MzU2MTkwODpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwODQ4MDU5NTg5MzAyOjoxOjo&url=%2FCustom-Drives-Personalized-Business-Promotions%2Fdp%2FB0FGQJFZCB%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQJFZCB%26pd_rd_r%3Dd73cb5f4-abf1-41a5-97d9-0ae0bcde6126%26pd_rd_w%3D3hf2W%26pd_rd_wg%3DRLJST%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DCEK13M7YKFB2VHBS45BS%26qid%3D1753561906%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-177-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQJFZCB",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 24,
    "asin": "B0FGQJFZCB",
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (100,16GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$380.99",
    "rating": null,
    "review_count": 380,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-12_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 380.99,
    "currency": "USD",
    "price_original": "$380.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyODIwNDE5MDQwNTA0ODU6MTc1MzU2MTkwODpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwODQ4MDU5NTkxNTAyOjoyOjo&url=%2FFlash-Drive-Customizable-Thumb-4GB-128GB%2Fdp%2FB0FGQ3XMC6%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQ3XMC6%26pd_rd_r%3Dd73cb5f4-abf1-41a5-97d9-0ae0bcde6126%26pd_rd_w%3D3hf2W%26pd_rd_wg%3DRLJST%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DCEK13M7YKFB2VHBS45BS%26qid%3D1753561906%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-178-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ3XMC6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 25,
    "asin": "B0FGQ3XMC6",
    "title": "Mini USB Flash Drive Customizable Tiny Thumb Drive with Your Logo 4GB-128GB - Perfect for Corporate Events, Branded Promotions, Student Projects Plug and Play, PC Mac (100,8GB)",
    "brand": "Mini",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$340.99",
    "rating": null,
    "review_count": 340,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-12_files/41Y5IinJkAL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 340.99,
    "currency": "USD",
    "price_original": "$340.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyODIwNDE5MDQwNTA0ODU6MTc1MzU2MTkwODpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwODQ4MDU5NTk4NDAyOjozOjo&url=%2FCustom-Personalized-Packaging-Business-Outreach%2Fdp%2FB0FGQ7XSW2%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQ7XSW2%26pd_rd_r%3Dd73cb5f4-abf1-41a5-97d9-0ae0bcde6126%26pd_rd_w%3D3hf2W%26pd_rd_wg%3DRLJST%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DCEK13M7YKFB2VHBS45BS%26qid%3D1753561906%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-179-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ7XSW2",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 26,
    "asin": "B0FGQ7XSW2",
    "title": "Custom Logo USB Drive 50 100 Count Personalized Packaging for School Business Outreach (50,16GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$189.99",
    "rating": null,
    "review_count": 189,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-12_files/41ckOfpOT5L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 189.99,
    "currency": "USD",
    "price_original": "$189.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyODIwNDE5MDQwNTA0ODU6MTc1MzU2MTkwODpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwODI1NTA5MjcyMDAyOjo1Ojo&url=%2FZDETGU-Modern-Versatile-Storage-Computers%2Fdp%2FB0FDH6C1XD%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FDH6C1XD%26pd_rd_r%3Dd73cb5f4-abf1-41a5-97d9-0ae0bcde6126%26pd_rd_w%3D3hf2W%26pd_rd_wg%3DRLJST%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DCEK13M7YKFB2VHBS45BS%26qid%3D1753561906%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-180-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FDH6C1XD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 27,
    "asin": "B0FDH6C1XD",
    "title": "Modern Key Design USB Drive for Versatile Data Storage in Computers and Cars (32GB)",
    "brand": "Modern",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$8.91",
    "rating": null,
    "review_count": 8,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-12_files/51NEXdwi5iS._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 8.91,
    "currency": "USD",
    "price_original": "$8.91"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=12&crid=BALSGJKBQE1X&qid=1753561883&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_12#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 28,
    "asin": null,
    "title": "4GB Flash Drive 20 Pack, Wooolken USB 2.0 Memory Stick with Lanyards Swivel USB Stick for Data Storage and Backup (Mixed Colors)",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$37.61",
    "rating": 4.6,
    "review_count": 700,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/71-kUjhphpL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.61,
    "currency": "USD",
    "price_original": "$37.61"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMjMwMjExNzkzMDg2ODk2OjE3NTM1NjE5MDg6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyNjM4NTg0OTY4MDI6OjA6Og&url=%2FWooolken-Memory-Storage-Backup-Colors%2Fdp%2FB0C5CYP3G9%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0C5CYP3G9%26pd_rd_r%3Dbb4a04e7-746f-4207-b761-21cc56ea25e4%26pd_rd_w%3DsetAh%26pd_rd_wg%3D4ZnYX%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DCEK13M7YKFB2VHBS45BS%26qid%3D1753561906%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-177-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0C5CYP3G9",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 29,
    "asin": "B0C5CYP3G9",
    "title": "4GB Flash Drive 20 Pack, Wooolken USB 2.0 Memory Stick with Lanyards Swivel USB Stick for Data Storage and Backup (Mixed Colors)",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$37.61",
    "rating": 4.6,
    "review_count": 700,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/71-kUjhphpL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.61,
    "currency": "USD",
    "price_original": "$37.61"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMjMwMjExNzkzMDg2ODk2OjE3NTM1NjE5MDg6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyNjM4NTg1MDMyMDI6OjE6Og&url=%2FWooolken-20Pack-Keychains-Swivel-Computer%2Fdp%2FB0CXM181QL%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CXM181QL%26pd_rd_r%3Dbb4a04e7-746f-4207-b761-21cc56ea25e4%26pd_rd_w%3DsetAh%26pd_rd_wg%3D4ZnYX%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DCEK13M7YKFB2VHBS45BS%26qid%3D1753561906%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-178-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CXM181QL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 30,
    "asin": "B0CXM181QL",
    "title": "USB Flash Drives 8GB 20 Pack, Wooolken USB 2.0 Thumb Drives with Keychains Memory Stick USB Drive Pendrive for PC Laptop Computer (Black)",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$41.39",
    "rating": 4.5,
    "review_count": 569,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -569,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/71Aw2AB2hQL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 41.39,
    "currency": "USD",
    "price_original": "$41.39"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMjMwMjExNzkzMDg2ODk2OjE3NTM1NjE5MDg6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyNjM4NTg0OTg5MDI6OjI6Og&url=%2FWooolken-Keychains-Drives-Memory-Computer%2Fdp%2FB0CWRT565T%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CWRT565T%26pd_rd_r%3Dbb4a04e7-746f-4207-b761-21cc56ea25e4%26pd_rd_w%3DsetAh%26pd_rd_wg%3D4ZnYX%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DCEK13M7YKFB2VHBS45BS%26qid%3D1753561906%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-179-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CWRT565T",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 31,
    "asin": "B0CWRT565T",
    "title": "20 Pack 4GB USB Flash Drive with Keychains, Wooolken Sleek Metal USB 2.0 Thumb Drives Memory Stick for PC Laptop Computer(Dark Grey)",
    "brand": 20,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$40.49",
    "rating": 4.4,
    "review_count": 681,
    "special_features": "Metal, Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -681,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/71x16G4xbNL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 40.49,
    "currency": "USD",
    "price_original": "$40.49"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMjMwMjExNzkzMDg2ODk2OjE3NTM1NjE5MDg6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4NDc3MTU2NDM3MDI6OjM6Og&url=%2FJUANWE-Flash-Drive-Memory-Laptop%2Fdp%2FB0CQQ3MTC6%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CQQ3MTC6%26pd_rd_r%3Dbb4a04e7-746f-4207-b761-21cc56ea25e4%26pd_rd_w%3DsetAh%26pd_rd_wg%3D4ZnYX%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DCEK13M7YKFB2VHBS45BS%26qid%3D1753561906%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-180-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CQQ3MTC6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 32,
    "asin": "B0CQQ3MTC6",
    "title": "64GB USB Flash Drives 5 Packs, FAT32 Thumb Drives Foldable 360¬∞Swivel Memory USB Stick with Lanyard Hole, Jump Drive Pen Drive Zip Drive Portable Flashdrive for PC/Tablet/Mac/Car,Mutipack Black",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$18.99",
    "rating": 4.4,
    "review_count": 4,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/51sZQVzNx0L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.99,
    "currency": "USD",
    "price_original": "$18.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMjMwMjExNzkzMDg2ODk2OjE3NTM1NjE5MDg6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjoyMDAxMDAxMDU3MDg0MTE6OjQ6Og&url=%2FCrystal-Transparent-Memory-Drives-Pendrive%2Fdp%2FB078GP28TP%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB078GP28TP%26pd_rd_r%3Dbb4a04e7-746f-4207-b761-21cc56ea25e4%26pd_rd_w%3DsetAh%26pd_rd_wg%3D4ZnYX%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DCEK13M7YKFB2VHBS45BS%26qid%3D1753561906%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-181-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B078GP28TP",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-12.html",
    "position": 33,
    "asin": "B078GP28TP",
    "title": "32GB USB 2.0 Flash Drive Crystal Blue LED Light Transparent Glass Clear Pen Thumb Drives Cute Mini Memory Stick Boy Girls Kids Women Men Pendrive Unique Cool Fun Novelty Sweet Wedding Photography Gift",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$11.73",
    "rating": 4,
    "review_count": 828,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -828,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-12_files/51RyOmnUWiL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.73,
    "currency": "USD",
    "price_original": "$11.73"
  },
  {
    "product_url": "https://www.amazon.com/Lexar-Swivel-Design-USB3-0-Smartphone/dp/B08XQFYK79/ref=sr_1_195?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ypghr1mc6JFJZHf4ajCDUcNX69K3fLLaK7iZCyXIsUDGjHj071QN20LucGBJIEps.m7Vm_F4z5y_JGGKzXetuHfb8374vV2vnRXKLHXLgams&dib_tag=se&keywords=flash+drives&qid=1753561921&sprefix=flash+drive%2Caps%2C146&sr=8-195&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08XQFYK79",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 1,
    "asin": "B08XQFYK79",
    "title": "E32C 128GB Type-C USB Flash Drive, USB-A&USB-C 3.2 Gen 1 Dual Drive OTG 100MB/s Read, Thumb Drive Swivel Design Jump Drive for USB 3.0/2.0, Memory Stick for Android Smartphone, Laptop, PC",
    "brand": "E32C",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.5,
    "review_count": 200,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/417KKxluFGL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/Wooolken-Keychains-Drives-Memory-Computer/dp/B0CWRT2VTS/ref=sr_1_197?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ypghr1mc6JFJZHf4ajCDUcNX69K3fLLaK7iZCyXIsUDGjHj071QN20LucGBJIEps.m7Vm_F4z5y_JGGKzXetuHfb8374vV2vnRXKLHXLgams&dib_tag=se&keywords=flash+drives&qid=1753561921&sprefix=flash+drive%2Caps%2C146&sr=8-197&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CWRT2VTS",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 2,
    "asin": "B0CWRT2VTS",
    "title": "5 Pack 16GB USB Flash Drive with Keychains, Wooolken Sleek Metal USB 2.0 Thumb Drives Memory Stick for PC Laptop Computer",
    "brand": 5,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$15.72",
    "rating": 4.4,
    "review_count": 100,
    "special_features": "Metal, Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "14 sizes14 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/61WxZRxUdWL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 15.72,
    "currency": "USD",
    "price_original": "$15.72"
  },
  {
    "product_url": "https://www.amazon.com/Drives-AreTop-Premium-USB2-0-Pendrive/dp/B08YJ5X9KV/ref=sr_1_193?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.VWUjFGLr-cWbLGiJCIdq_IkXdcTRKp9BQcdksQ8rP11WXiINHzRJIc5LjZ6UjoQfaTpP6N3pOac5EZ5GcjiVX58pCgYmqARFjeh-x9EEalCJ7uM4YlmN9nRjORpn5f8H3xjhTzpI4AjDY2r6KwlIx_Cbh8TQ06uJj97UaP30TTeTQL_sLIU7nU-j0uTz9a6o.r8rt7_N6gUglsALVXB7qbQgI_BlD5oF8M4E5tXPsp34&dib_tag=se&keywords=flash+drives&qid=1753561921&sprefix=flash+drive%2Caps%2C146&sr=8-193&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08YJ5X9KV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 3,
    "asin": "B08YJ5X9KV",
    "title": "512MB USB Flash Drives 100 Pack, Premium USB2.0 100 Pack Thumb Drives Bulk USB Pendrive Memory Stick Jump Drive Flash Drives Bulk (100 Pack 512MB, Black)",
    "brand": "512MB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$132.67",
    "rating": 4.5,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "7 sizes7 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/714e4G8Et-L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "mb",
    "price_numeric": 132.67,
    "currency": "USD",
    "price_original": "$132.67"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Computers-SDCZ600-G35-Everything-Stromboli/dp/B01EGAAT3W/ref=sr_1_194?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.VWUjFGLr-cWbLGiJCIdq_IkXdcTRKp9BQcdksQ8rP11WXiINHzRJIc5LjZ6UjoQfaTpP6N3pOac5EZ5GcjiVX58pCgYmqARFjeh-x9EEalCJ7uM4YlmN9nRjORpn5f8H3xjhTzpI4AjDY2r6KwlIx_Cbh8TQ06uJj97UaP30TTeTQL_sLIU7nU-j0uTz9a6o.r8rt7_N6gUglsALVXB7qbQgI_BlD5oF8M4E5tXPsp34&dib_tag=se&keywords=flash+drives&qid=1753561921&sprefix=flash+drive%2Caps%2C146&sr=8-194&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B01EGAAT3W",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 4,
    "asin": "B01EGAAT3W",
    "title": "Cruzer Glide 3.0 USB Flash Drive (10 Pack) Jump Drive Works with Laptop Computers with USB 2.0/3.0 Port (SDCZ600-G35) Bundle with (5) Everything But Stromboli Lanyard (32GB 10 Pack)",
    "brand": "Cruzer",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "SD",
    "price": "$61.97",
    "rating": 4.6,
    "review_count": 80,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -80,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "No",
    "image_url": "./drives-13_files/71CwkMlhM0L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 61.97,
    "currency": "USD",
    "price_original": "$61.97"
  },
  {
    "product_url": "https://www.amazon.com/Verbatim-128GB-Store-Flash-Devices/dp/B0CL7RBNR7/ref=sr_1_195?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.VWUjFGLr-cWbLGiJCIdq_IkXdcTRKp9BQcdksQ8rP11WXiINHzRJIc5LjZ6UjoQfaTpP6N3pOac5EZ5GcjiVX58pCgYmqARFjeh-x9EEalCJ7uM4YlmN9nRjORpn5f8H3xjhTzpI4AjDY2r6KwlIx_Cbh8TQ06uJj97UaP30TTeTQL_sLIU7nU-j0uTz9a6o.r8rt7_N6gUglsALVXB7qbQgI_BlD5oF8M4E5tXPsp34&dib_tag=se&keywords=flash+drives&qid=1753561921&sprefix=flash+drive%2Caps%2C146&sr=8-195&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CL7RBNR7",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 5,
    "asin": "B0CL7RBNR7",
    "title": "128GB Store ‚Äòn‚Äô Go Dual OTG USB 3.2 Gen 1 Flash Drive for USB-C Devices ‚Äì 2 in 1 Type C Thumb Drive",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$15.29",
    "rating": 4.4,
    "review_count": 400,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/71bwdJa3efL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 15.29,
    "currency": "USD",
    "price_original": "$15.29"
  },
  {
    "product_url": "https://www.amazon.com/SSK-JumpDrive-Pendrive-Android-Resistance/dp/B0DW8YBV8Y/ref=sr_1_196?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.VWUjFGLr-cWbLGiJCIdq_IkXdcTRKp9BQcdksQ8rP11WXiINHzRJIc5LjZ6UjoQfaTpP6N3pOac5EZ5GcjiVX58pCgYmqARFjeh-x9EEalCJ7uM4YlmN9nRjORpn5f8H3xjhTzpI4AjDY2r6KwlIx_Cbh8TQ06uJj97UaP30TTeTQL_sLIU7nU-j0uTz9a6o.r8rt7_N6gUglsALVXB7qbQgI_BlD5oF8M4E5tXPsp34&dib_tag=se&keywords=flash+drives&qid=1753561921&sprefix=flash+drive%2Caps%2C146&sr=8-196&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DW8YBV8Y",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 6,
    "asin": "B0DW8YBV8Y",
    "title": "64GB Dual USB Flash Drive USB C Thumb Drive, up to 240 MB/s Type-C and USB-A 3.2 JumpDrive Memory Stick, Zinc Pendrive for iPhone 15/16Pro/Win/Android OTG with Water, Dust, and Drop Resistance",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$9.99",
    "rating": 4.1,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/61cooDgswTL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 9.99,
    "currency": "USD",
    "price_original": "$9.99"
  },
  {
    "product_url": "https://www.amazon.com/Aiibe-128GB-Drives-Memory-Keychain/dp/B0DKDWDRQ9/ref=sr_1_197?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.VWUjFGLr-cWbLGiJCIdq_IkXdcTRKp9BQcdksQ8rP11WXiINHzRJIc5LjZ6UjoQfaTpP6N3pOac5EZ5GcjiVX58pCgYmqARFjeh-x9EEalCJ7uM4YlmN9nRjORpn5f8H3xjhTzpI4AjDY2r6KwlIx_Cbh8TQ06uJj97UaP30TTeTQL_sLIU7nU-j0uTz9a6o.r8rt7_N6gUglsALVXB7qbQgI_BlD5oF8M4E5tXPsp34&dib_tag=se&keywords=flash+drives&qid=1753561921&sprefix=flash+drive%2Caps%2C146&sr=8-197&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DKDWDRQ9",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 7,
    "asin": "B0DKDWDRQ9",
    "title": "128GB USB Flash Drive 2 Pack - 128GB USB Stick Thumb Drive USB 2.0 Memory Stick with Keychain (Black and Red)",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$17.99",
    "rating": 4.6,
    "review_count": 50,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/61xuvuLMUPL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 17.99,
    "currency": "USD",
    "price_original": "$17.99"
  },
  {
    "product_url": "https://www.amazon.com/Flash-Drive-Bulk-Thumb-Drives/dp/B011WV6B0I/ref=sr_1_200?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.VWUjFGLr-cWbLGiJCIdq_IkXdcTRKp9BQcdksQ8rP11WXiINHzRJIc5LjZ6UjoQfaTpP6N3pOac5EZ5GcjiVX58pCgYmqARFjeh-x9EEalCJ7uM4YlmN9nRjORpn5f8H3xjhTzpI4AjDY2r6KwlIx_Cbh8TQ06uJj97UaP30TTeTQL_sLIU7nU-j0uTz9a6o.r8rt7_N6gUglsALVXB7qbQgI_BlD5oF8M4E5tXPsp34&dib_tag=se&keywords=flash+drives&qid=1753561921&sprefix=flash+drive%2Caps%2C146&sr=8-200&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B011WV6B0I",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 8,
    "asin": "B011WV6B0I",
    "title": "8GB USB 3.0 Flash Drive Bulk 10 Pack Thumb Drives - Foldable 8 GB USB3.0 Memory Stick Data Storage Multipack Zip Drives - Portable Jump Drive Gift Multi-Coloured Pen Drive with 10pcs Rope",
    "brand": "8GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$32.99",
    "rating": 4,
    "review_count": 94,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -94,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "No",
    "image_url": "./drives-13_files/71QmLAbeJcL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 32.99,
    "currency": "USD",
    "price_original": "$32.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-128GB-iXpand-Flash-iPhone/dp/B07VNGVKGF/ref=sr_1_201?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.VWUjFGLr-cWbLGiJCIdq_IkXdcTRKp9BQcdksQ8rP11WXiINHzRJIc5LjZ6UjoQfaTpP6N3pOac5EZ5GcjiVX58pCgYmqARFjeh-x9EEalCJ7uM4YlmN9nRjORpn5f8H3xjhTzpI4AjDY2r6KwlIx_Cbh8TQ06uJj97UaP30TTeTQL_sLIU7nU-j0uTz9a6o.r8rt7_N6gUglsALVXB7qbQgI_BlD5oF8M4E5tXPsp34&dib_tag=se&keywords=flash+drives&qid=1753561921&sprefix=flash+drive%2Caps%2C146&sr=8-201&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07VNGVKGF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 9,
    "asin": "B07VNGVKGF",
    "title": "128GB iXpand Flash Drive Go - For your iPhone 14 or older - Create space on your iPhone - SDIX60N-128G-GN6NE",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "SD",
    "price": "$41.27",
    "rating": 4.4,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/81Fqh9hd73L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 41.27,
    "currency": "USD",
    "price_original": "$41.27"
  },
  {
    "product_url": "https://www.amazon.com/EASTBULL-Drives-Swivel-Memory-Storage/dp/B07RDHL3ZL/ref=sr_1_202?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.VWUjFGLr-cWbLGiJCIdq_IkXdcTRKp9BQcdksQ8rP11WXiINHzRJIc5LjZ6UjoQfaTpP6N3pOac5EZ5GcjiVX58pCgYmqARFjeh-x9EEalCJ7uM4YlmN9nRjORpn5f8H3xjhTzpI4AjDY2r6KwlIx_Cbh8TQ06uJj97UaP30TTeTQL_sLIU7nU-j0uTz9a6o.r8rt7_N6gUglsALVXB7qbQgI_BlD5oF8M4E5tXPsp34&dib_tag=se&keywords=flash+drives&qid=1753561921&sprefix=flash+drive%2Caps%2C146&sr=8-202&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07RDHL3ZL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 10,
    "asin": "B07RDHL3ZL",
    "title": "2GB Bulk Flash Drives 50 Pack EASTBULL USB 2.0 Metal Flash Drives Bulk Swivel USB Drives Bulk Thumb Drives Pack (2GB)",
    "brand": "2GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$73.98",
    "rating": 4.5,
    "review_count": 100,
    "special_features": "Metal, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -992,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/71nHqNgHofL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 73.98,
    "currency": "USD",
    "price_original": "$73.98"
  },
  {
    "product_url": "https://www.amazon.com/SIMMAX-Drives-Memory-Swivel-Design/dp/B07RPHQL7Z/ref=sr_1_203?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.VWUjFGLr-cWbLGiJCIdq_IkXdcTRKp9BQcdksQ8rP11WXiINHzRJIc5LjZ6UjoQfaTpP6N3pOac5EZ5GcjiVX58pCgYmqARFjeh-x9EEalCJ7uM4YlmN9nRjORpn5f8H3xjhTzpI4AjDY2r6KwlIx_Cbh8TQ06uJj97UaP30TTeTQL_sLIU7nU-j0uTz9a6o.r8rt7_N6gUglsALVXB7qbQgI_BlD5oF8M4E5tXPsp34&dib_tag=se&keywords=flash+drives&qid=1753561921&sprefix=flash+drive%2Caps%2C146&sr=8-203&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07RPHQL7Z",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 11,
    "asin": "B07RPHQL7Z",
    "title": "USB Flash Drives 2 Pack 64GB Memory Stick Swivel Design USB 2.0 Flash Drive Thumb Drive Zip Drives (64GB Red Purple)",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$8.99",
    "rating": 4.5,
    "review_count": 50,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/71ZCn9t4buL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 8.99,
    "currency": "USD",
    "price_original": "$8.99"
  },
  {
    "product_url": "https://www.amazon.com/Wooolken-Android-Smartphone-Tablets-Computers/dp/B0D5VCJY87/ref=sr_1_204?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.VWUjFGLr-cWbLGiJCIdq_IkXdcTRKp9BQcdksQ8rP11WXiINHzRJIc5LjZ6UjoQfaTpP6N3pOac5EZ5GcjiVX58pCgYmqARFjeh-x9EEalCJ7uM4YlmN9nRjORpn5f8H3xjhTzpI4AjDY2r6KwlIx_Cbh8TQ06uJj97UaP30TTeTQL_sLIU7nU-j0uTz9a6o.r8rt7_N6gUglsALVXB7qbQgI_BlD5oF8M4E5tXPsp34&dib_tag=se&keywords=flash+drives&qid=1753561921&sprefix=flash+drive%2Caps%2C146&sr=8-204&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D5VCJY87",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 12,
    "asin": "B0D5VCJY87",
    "title": "USB C Flash Drive 32GB 10 Pack, Wooolken Type-C Flash Drive + USB 2.0 Thumb Drive OTG Thumb Drive Compatible with iPhone 16/15, Android Smartphone/Tablets/Computers",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$33.99",
    "rating": 4.4,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "7 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/71sHutBVtTL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 33.99,
    "currency": "USD",
    "price_original": "$33.99"
  },
  {
    "product_url": "https://www.amazon.com/MOSDART-16GB-Flash-Drive-Pack/dp/B0D427B9ND/ref=sr_1_205?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.VWUjFGLr-cWbLGiJCIdq_IkXdcTRKp9BQcdksQ8rP11WXiINHzRJIc5LjZ6UjoQfaTpP6N3pOac5EZ5GcjiVX58pCgYmqARFjeh-x9EEalCJ7uM4YlmN9nRjORpn5f8H3xjhTzpI4AjDY2r6KwlIx_Cbh8TQ06uJj97UaP30TTeTQL_sLIU7nU-j0uTz9a6o.r8rt7_N6gUglsALVXB7qbQgI_BlD5oF8M4E5tXPsp34&dib_tag=se&keywords=flash+drives&qid=1753561921&sprefix=flash+drive%2Caps%2C146&sr=8-205&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D427B9ND",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 13,
    "asin": "B0D427B9ND",
    "title": "16GB Dual USB C Flash Drive, Type C and USB A 2.0 Thumb Drive, FAT32 Memory Stick for iPhone 15 and 16, Android Phone, iPad, MacBook and Laptops, Vibrant Colors (Pack of 5)",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$21.99",
    "rating": 4.4,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/61U2puTUQtL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 21.99,
    "currency": "USD",
    "price_original": "$21.99"
  },
  {
    "product_url": "https://www.amazon.com/Vibrant-10-Pack-Enfain-Multicolor-Drives/dp/B00NJB0T94/ref=sr_1_206?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.VWUjFGLr-cWbLGiJCIdq_IkXdcTRKp9BQcdksQ8rP11WXiINHzRJIc5LjZ6UjoQfaTpP6N3pOac5EZ5GcjiVX58pCgYmqARFjeh-x9EEalCJ7uM4YlmN9nRjORpn5f8H3xjhTzpI4AjDY2r6KwlIx_Cbh8TQ06uJj97UaP30TTeTQL_sLIU7nU-j0uTz9a6o.r8rt7_N6gUglsALVXB7qbQgI_BlD5oF8M4E5tXPsp34&dib_tag=se&keywords=flash+drives&qid=1753561921&sprefix=flash+drive%2Caps%2C146&sr=8-206&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B00NJB0T94",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 14,
    "asin": "B00NJB0T94",
    "title": "10-Pack 8GB USB 2.0 Flash Drives ‚Äì Colorful Thumb Drives for Photos, Videos, School & Office, 10 Assorted Colors",
    "brand": "10-Pack",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$16.79",
    "rating": 4.6,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/71BQ32Kl8xL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.79,
    "currency": "USD",
    "price_original": "$16.79"
  },
  {
    "product_url": "https://www.amazon.com/TOPESEL-UDP-Tech-Waterproof-Portable-Smartphone/dp/B0C536M847/ref=sr_1_207?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.VWUjFGLr-cWbLGiJCIdq_IkXdcTRKp9BQcdksQ8rP11WXiINHzRJIc5LjZ6UjoQfaTpP6N3pOac5EZ5GcjiVX58pCgYmqARFjeh-x9EEalCJ7uM4YlmN9nRjORpn5f8H3xjhTzpI4AjDY2r6KwlIx_Cbh8TQ06uJj97UaP30TTeTQL_sLIU7nU-j0uTz9a6o.r8rt7_N6gUglsALVXB7qbQgI_BlD5oF8M4E5tXPsp34&dib_tag=se&keywords=flash+drives&qid=1753561921&sprefix=flash+drive%2Caps%2C146&sr=8-207&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0C536M847",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 15,
    "asin": "B0C536M847",
    "title": "64GB USB C Flash Drive Dual USB 3.0 Flash Drive USB A & Type C Thumb Drive UDP-Tech Waterproof Type C Portable USB C OTG for Computer Mac Smartphone Tablet",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$8.49",
    "rating": 4.2,
    "review_count": 100,
    "special_features": "Waterproof",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "7 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/61ef1i3GPgL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 8.49,
    "currency": "USD",
    "price_original": "$8.49"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=13&crid=BALSGJKBQE1X&qid=1753561906&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_13#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 16,
    "asin": null,
    "title": "20 Pack 4GB Bulk USB 2.0 Flash Drives Thumb Drive Swivel Memory Stick JumpDrive, Black, 4 GB, 20 Pieces",
    "brand": 20,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$40.79",
    "rating": 4.4,
    "review_count": 5,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.4K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/71mcQ2I+JOL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 40.79,
    "currency": "USD",
    "price_original": "$40.79"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MTMzMjI1MDU0OTU3NTc3OjE3NTM1NjE5MjY6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDAxNzI0MjM0NDAyMTo6MDo6&url=%2FALMEMO-Drives-Swivel-Memory-JumpDrive%2Fdp%2FB07S6JRS5R%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07S6JRS5R%26pd_rd_r%3D84ac3757-f782-41b3-bcb4-1b7588c85dea%26pd_rd_w%3DIvyUG%26pd_rd_wg%3Dchx1O%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DRNE0Z89SX44XF9RKBWPM%26qid%3D1753561921%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-193-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07S6JRS5R",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 17,
    "asin": "B07S6JRS5R",
    "title": "20 Pack 4GB Bulk USB 2.0 Flash Drives Thumb Drive Swivel Memory Stick JumpDrive, Black, 4 GB, 20 Pieces",
    "brand": 20,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$40.79",
    "rating": 4.4,
    "review_count": 50,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.4K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/71mcQ2I+JOL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 40.79,
    "currency": "USD",
    "price_original": "$40.79"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MTMzMjI1MDU0OTU3NTc3OjE3NTM1NjE5MjY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDc0OTU3ODAxNjEwMjo6MTo6&url=%2FMOVE-SPEED-Solid-Keychain-Leather%2Fdp%2FB0C69TJPSK%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0C69TJPSK%26pd_rd_r%3D84ac3757-f782-41b3-bcb4-1b7588c85dea%26pd_rd_w%3DIvyUG%26pd_rd_wg%3Dchx1O%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DRNE0Z89SX44XF9RKBWPM%26qid%3D1753561921%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-194-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0C69TJPSK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 18,
    "asin": "B0C69TJPSK",
    "title": "1TB Solid State Flash Drive 570MB/s High Speed Type C + USB 3.2 Drive Dual Port, Thumb Drive Compatible with iPhone 15, 16 Series/Android Phone/MacBook/Audio/Smart TV",
    "brand": "1TB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$79.99",
    "rating": 4.3,
    "review_count": 2,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.3K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/51RqgjeakcL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "tb",
    "price_numeric": 79.99,
    "currency": "USD",
    "price_original": "$79.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MTMzMjI1MDU0OTU3NTc3OjE3NTM1NjE5MjY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDYyMDE4OTYxMjUwMjo6Mjo6&url=%2FRpanle-Professional-Antivirus-Protection-Software%2Fdp%2FB08Z3JZMMY%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB08Z3JZMMY%26pd_rd_r%3D84ac3757-f782-41b3-bcb4-1b7588c85dea%26pd_rd_w%3DIvyUG%26pd_rd_wg%3Dchx1O%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DRNE0Z89SX44XF9RKBWPM%26qid%3D1753561921%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-195-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B08Z3JZMMY",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 19,
    "asin": "B08Z3JZMMY",
    "title": "USB for Windows 10 Install Recover Repair Restore Boot USB Flash Drive, 32&64 Bit Systems Home&Professional, Antivirus Protection&Drivers Software, Fix PC, Laptop and Desktop, 16 GB USB - Blue",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$17.00",
    "rating": 4,
    "review_count": 300,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -596,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/51YPcwSyqqL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 17,
    "currency": "USD",
    "price_original": "$17.00"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MTMzMjI1MDU0OTU3NTc3OjE3NTM1NjE5MjY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDc5ODI3NTQ1MDQwMjo6Mzo6&url=%2FDrives-8GB-Multicolor-Storage-Transfer%2Fdp%2FB09BNDJ263%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB09BNDJ263%26pd_rd_r%3D84ac3757-f782-41b3-bcb4-1b7588c85dea%26pd_rd_w%3DIvyUG%26pd_rd_wg%3Dchx1O%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DRNE0Z89SX44XF9RKBWPM%26qid%3D1753561921%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-196-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B09BNDJ263",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 20,
    "asin": "B09BNDJ263",
    "title": "Flash Drives 8GB USB 3.0 Pack Multicolor 10 Pack for Data Storage High Speed Thumb Drives Swivel Zip Drive Jump Memory Stick for File Backup and Transfer",
    "brand": "Flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$36.99",
    "rating": 4.2,
    "review_count": 98,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -98,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/71qODOMvhsL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 36.99,
    "currency": "USD",
    "price_original": "$36.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MTMzMjI1MDU0OTU3NTc3OjE3NTM1NjE5MjY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1NjcyOTMwMTMwMjo6NDo6&url=%2FDrives-Indicator-Storage-Sharing-Multi-Color%2Fdp%2FB0925HQ2GR%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0925HQ2GR%26pd_rd_r%3D84ac3757-f782-41b3-bcb4-1b7588c85dea%26pd_rd_w%3DIvyUG%26pd_rd_wg%3Dchx1O%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DRNE0Z89SX44XF9RKBWPM%26qid%3D1753561921%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-197-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0925HQ2GR",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 21,
    "asin": "B0925HQ2GR",
    "title": "USB Flash Drive 8GB 10 Pack, Thumb Drives Memory Stick USB 2.0 Bulk Swivel Jump Drive Zip Drive with Led Indicator for Data Storage, File Sharing(10Pcs, Multi-Color,8 GB)",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$20.89",
    "rating": 4.6,
    "review_count": 1,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-13_files/71atcuKw17L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.89,
    "currency": "USD",
    "price_original": "$20.89"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=13&crid=BALSGJKBQE1X&qid=1753561906&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_13#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 22,
    "asin": null,
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (50,64GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$225.99",
    "rating": null,
    "review_count": 60,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-13_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 225.99,
    "currency": "USD",
    "price_original": "$225.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDI2OTE2OTk4NTc3MzI4OjE3NTM1NjE5MjY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5ODMwMjo6MTo6&url=%2FCustom-Drives-Personalized-Business-Promotions%2Fdp%2FB0FGX9SMY6%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGX9SMY6%26pd_rd_r%3D84ac3757-f782-41b3-bcb4-1b7588c85dea%26pd_rd_w%3DcL4Sp%26pd_rd_wg%3Dchx1O%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DRNE0Z89SX44XF9RKBWPM%26qid%3D1753561921%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-193-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGX9SMY6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 23,
    "asin": "B0FGX9SMY6",
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (50,64GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$225.99",
    "rating": null,
    "review_count": 225,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-13_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 225.99,
    "currency": "USD",
    "price_original": "$225.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDI2OTE2OTk4NTc3MzI4OjE3NTM1NjE5MjY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5MTkwMjo6Mjo6&url=%2FFlash-Drive-Customizable-Thumb-4GB-128GB%2Fdp%2FB0FGPZ2JQ1%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGPZ2JQ1%26pd_rd_r%3D84ac3757-f782-41b3-bcb4-1b7588c85dea%26pd_rd_w%3DcL4Sp%26pd_rd_wg%3Dchx1O%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DRNE0Z89SX44XF9RKBWPM%26qid%3D1753561921%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-194-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGPZ2JQ1",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 24,
    "asin": "B0FGPZ2JQ1",
    "title": "Mini USB Flash Drive Customizable Tiny Thumb Drive with Your Logo 4GB-128GB - Perfect for Corporate Events, Branded Promotions, Student Projects Plug and Play, PC Mac (50,8GB)",
    "brand": "Mini",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$169.99",
    "rating": null,
    "review_count": 169,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-13_files/41Y5IinJkAL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 169.99,
    "currency": "USD",
    "price_original": "$169.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDI2OTE2OTk4NTc3MzI4OjE3NTM1NjE5MjY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5NjMwMjo6Mzo6&url=%2FCustom-Personalized-Packaging-Business-Outreach%2Fdp%2FB0FGX5ZCD7%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGX5ZCD7%26pd_rd_r%3D84ac3757-f782-41b3-bcb4-1b7588c85dea%26pd_rd_w%3DcL4Sp%26pd_rd_wg%3Dchx1O%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DRNE0Z89SX44XF9RKBWPM%26qid%3D1753561921%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-195-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGX5ZCD7",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 25,
    "asin": "B0FGX5ZCD7",
    "title": "Custom Logo USB Drive 50 100 Count Personalized Packaging for School Business Outreach (50,4GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$159.99",
    "rating": null,
    "review_count": 159,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-13_files/41ckOfpOT5L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 159.99,
    "currency": "USD",
    "price_original": "$159.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDI2OTE2OTk4NTc3MzI4OjE3NTM1NjE5MjY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDgyNTUwOTI3MjMwMjo6NTo6&url=%2FZDETGU-Modern-Versatile-Storage-Computers%2Fdp%2FB0FDH6LB3R%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FDH6LB3R%26pd_rd_r%3D84ac3757-f782-41b3-bcb4-1b7588c85dea%26pd_rd_w%3DcL4Sp%26pd_rd_wg%3Dchx1O%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DRNE0Z89SX44XF9RKBWPM%26qid%3D1753561921%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-196-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FDH6LB3R",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 26,
    "asin": "B0FDH6LB3R",
    "title": "Modern Key Design USB Drive for Versatile Data Storage in Computers and Cars (64GB)",
    "brand": "Modern",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$12.64",
    "rating": null,
    "review_count": 12,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-13_files/51NEXdwi5iS._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.64,
    "currency": "USD",
    "price_original": "$12.64"
  },
  {
    "product_url": "https://aax-us-iad.amazon.com/x/c/JJS5kdgVXeJMLh09-QBIKT0AAAGYSG-L-gEAAAH2AQBvbm9fdHhuX2JpZDUgICBvbm9fdHhuX2ltcDIgICAX_s-q/clv1c_ek-YwQfSEsbeTZFGaQ1uOIh9jREdc3WATUvV5Vckd-4564muK3Dq_EDMfyd7X4jXfZbkD4kLc6xU9hZvBMnfuCjzBO33mbqHedCmAdfp360vDdS3qUX3LyC4o77yl1D0uFNgfdQTPjs3I373GA9nM8Baod_s9k6CcpVxqTUszo2fCvP9T1HMmRqp4ikOOjOiCaprkcTrFr1p3FdqwOctO-rACXsTgv8jGRgibqur-xZGUoksjenHFI0emM8c9_JyhFIltrwx7IMrBOMxMyU-reDIDVAVH6HqXK0p7g_XduptjHJyPu2Dm7-1H7ucxnDAPhj5fuuZ7rh42oNnDeIAB3CLKkM_oZH36sPt-J_JHR-qys6OsH9XT3Z_IMyJgyCklY_Q8cFcuFif4Yl9ruVDYQiiM-HAdD1pTWVt01Wf0WNewkQCDkca_EyWKcynotssJP9siL8HvfC46EzwQ9HWjA3n0esA0d6-Z5GSArK1vIXrZ7xlKi9cB28Cv1MT-gOmk0F4CxEehg4YmJc1jYGFg-lirta61CSk1ODxvKPCL2sfm2SlFfokxucoo00iV-zSqAIO0TTKw1uxlA0XQePq2LtPRY288qumLtsYPZq5OC9-Xul88ZdW-78P_BSxANHlsv5xdLqYpQMNNg7hFnYvZdE6GCn6SqJx8pMVDv6xLCieXrqXSFGTG4I3pJ2_4-07AfVSpjwQlGxMyVvfAggcHMKzCcWvJnzdxXihU3Jf_7kUpPvZwwYJe78HZfRy0ZPicknLvG8Kd5YdOZdMphfePG0ltuKK2_zVAI4R64FRA4ROsVUTJVayNjs-eu8D6sBaoqHobmGsR-EG-32XDoiNy9xRXsNqPvJhXWvU4nucEGgDAw-PuB7qfJGP9rl7g8Dz9FdbIB8k6zc8YDbSnAZM1v3Wo-HjBOnpW9_uu5uNOzbCGSdqkODetCJMql35PfvvN34nBjizK3xyRX0HdA/https://www.amazon.com/dp/B075GQ17GL?pd_rd_i=B075GQ17GL&pf_rd_p=2c8e5d59-6279-4999-832d-be45d1ca8e79&pf_rd_r=RNE0Z89SX44XF9RKBWPM&pd_rd_wg=Qa2aO&pd_rd_w=mnfnh&pd_rd_r=ae9c62e8-7ffc-47af-90d7-386284c1f9b2",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-13.html",
    "position": 27,
    "asin": null,
    "title": "Kepmem USB Flash Drive 4GB 10 Pack USB 2.0 Thumb Drives 4 GB Memory Sticks Portable Jump Drive Bulk Swivel 10 Pieces Zip Drives Mixed Colors Pendrive Data Storage and Backup",
    "brand": "Kepmem",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$23.99",
    "rating": 4.6,
    "review_count": 8,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(8.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-13_files/71lFJZly-9L._AC_UL640_QL65_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 23.99,
    "currency": "USD",
    "price_original": "$23.99"
  },
  {
    "product_url": "https://www.amazon.com/ABLAZE-Flash-Drives-Keychains-Pendrive/dp/B0CLR6CBKG/ref=sr_1_211?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.lte2re6NKRvNJmaKobxa8zQxMW2xrQNUU9zG7QKesATxyfqjMb2W3az-QONfRrJtDb-rMaNzM2fFJjUUA3VHM-6MwfnXqSZ3vW6_TTCZV_o7n47V2zjSCTMR_QeOvs4F4Y7JtvBDBdcdAN2Pn4cl_XOrypSct1VSslMRS4xbRky4IzketENtXmV3wiPGNUZoVwk9QoXWUGNKk8K7Tnfhkg8yoF1IxWU6gkJLPxg5M50.sGTMYYppZaPczp7qHrfuqklFnOmh7Tmtd2g_VsZFkhc&dib_tag=se&keywords=flash+drives&qid=1753561948&sprefix=flash+drive%2Caps%2C146&sr=8-211&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CLR6CBKG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 1,
    "asin": "B0CLR6CBKG",
    "title": "8GB Flash Drive 10 Pack, Metal USB 2.0 Thumb Drives with Keychains USB Sticks Pendrives (Sliver)",
    "brand": "8GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$23.99",
    "rating": 4.4,
    "review_count": 100,
    "special_features": "Metal, Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "11 sizes11 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/617oss6XE6L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 23.99,
    "currency": "USD",
    "price_original": "$23.99"
  },
  {
    "product_url": "https://www.amazon.com/JUANWE-64GB-Flash-Drive-Pack/dp/B0D46DTFCF/ref=sr_1_212?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.lte2re6NKRvNJmaKobxa8zQxMW2xrQNUU9zG7QKesATxyfqjMb2W3az-QONfRrJtDb-rMaNzM2fFJjUUA3VHM-6MwfnXqSZ3vW6_TTCZV_o7n47V2zjSCTMR_QeOvs4F4Y7JtvBDBdcdAN2Pn4cl_XOrypSct1VSslMRS4xbRky4IzketENtXmV3wiPGNUZoVwk9QoXWUGNKk8K7Tnfhkg8yoF1IxWU6gkJLPxg5M50.sGTMYYppZaPczp7qHrfuqklFnOmh7Tmtd2g_VsZFkhc&dib_tag=se&keywords=flash+drives&qid=1753561948&sprefix=flash+drive%2Caps%2C146&sr=8-212&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D46DTFCF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 2,
    "asin": "B0D46DTFCF",
    "title": "64GB USBC Flash Drive 3 Pack, Dual USB-A & Type-C Thumb Drive for Phone&Android Photo Storage Stick, Retractable & Dustproof Design USB C Drive Expand Memory for Photo/Video/Computer/Tablet",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$16.99",
    "rating": 4.2,
    "review_count": 50,
    "special_features": "Retractable, Dust Proof",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/51JykRJ60rL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.99,
    "currency": "USD",
    "price_original": "$16.99"
  },
  {
    "product_url": "https://www.amazon.com/Certified-iDiskk-Storage-Flashdrive-Photo-Stick/dp/B01N1UXH7S/ref=sr_1_213?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.lte2re6NKRvNJmaKobxa8zQxMW2xrQNUU9zG7QKesATxyfqjMb2W3az-QONfRrJtDb-rMaNzM2fFJjUUA3VHM-6MwfnXqSZ3vW6_TTCZV_o7n47V2zjSCTMR_QeOvs4F4Y7JtvBDBdcdAN2Pn4cl_XOrypSct1VSslMRS4xbRky4IzketENtXmV3wiPGNUZoVwk9QoXWUGNKk8K7Tnfhkg8yoF1IxWU6gkJLPxg5M50.sGTMYYppZaPczp7qHrfuqklFnOmh7Tmtd2g_VsZFkhc&dib_tag=se&keywords=flash+drives&qid=1753561948&sprefix=flash+drive%2Caps%2C146&sr=8-213&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B01N1UXH7S",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 3,
    "asin": "B01N1UXH7S",
    "title": "App-le Mfi Certified 128GB iDiskk iPhone Flash Drive,for Photos and Videos,Photo Stick, iPad Flashdrive,iPhone USB Storage, iPad iPhone Photo Storage Stick,for Mac,iPad,PC Thumb Drive Auto Backup",
    "brand": "App-le",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$35.99",
    "rating": 4.3,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/51ti3mMkFSL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 35.99,
    "currency": "USD",
    "price_original": "$35.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Ultra-Flair-Flash-SDCZ73-032G-G46/dp/B01FTQP7ZM/ref=sr_1_214?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.lte2re6NKRvNJmaKobxa8zQxMW2xrQNUU9zG7QKesATxyfqjMb2W3az-QONfRrJtDb-rMaNzM2fFJjUUA3VHM-6MwfnXqSZ3vW6_TTCZV_o7n47V2zjSCTMR_QeOvs4F4Y7JtvBDBdcdAN2Pn4cl_XOrypSct1VSslMRS4xbRky4IzketENtXmV3wiPGNUZoVwk9QoXWUGNKk8K7Tnfhkg8yoF1IxWU6gkJLPxg5M50.sGTMYYppZaPczp7qHrfuqklFnOmh7Tmtd2g_VsZFkhc&dib_tag=se&keywords=flash+drives&qid=1753561948&sprefix=flash+drive%2Caps%2C146&sr=8-214&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B01FTQP7ZM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 4,
    "asin": "B01FTQP7ZM",
    "title": "Ultra Flair USB 3.0 32GB Flash Drive SDCZ73-032G-G46 (Pack of 5)",
    "brand": "Ultra",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$30.78",
    "rating": 4.7,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -38,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/61yo4CJ+qbL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 30.78,
    "currency": "USD",
    "price_original": "$30.78"
  },
  {
    "product_url": "https://www.amazon.com/ZZ-Drives-Retractable-Laptop-Tablet/dp/B0D48JBWRR/ref=sr_1_215?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.lte2re6NKRvNJmaKobxa8zQxMW2xrQNUU9zG7QKesATxyfqjMb2W3az-QONfRrJtDb-rMaNzM2fFJjUUA3VHM-6MwfnXqSZ3vW6_TTCZV_o7n47V2zjSCTMR_QeOvs4F4Y7JtvBDBdcdAN2Pn4cl_XOrypSct1VSslMRS4xbRky4IzketENtXmV3wiPGNUZoVwk9QoXWUGNKk8K7Tnfhkg8yoF1IxWU6gkJLPxg5M50.sGTMYYppZaPczp7qHrfuqklFnOmh7Tmtd2g_VsZFkhc&dib_tag=se&keywords=flash+drives&qid=1753561948&sprefix=flash+drive%2Caps%2C146&sr=8-215&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D48JBWRR",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 5,
    "asin": "B0D48JBWRR",
    "title": "64GB Flash Drive 5 Pack USB Flash Drives 64 GB Thumb Drive Retractable USB 3.0 Drive Memory Stick Jump Drives Multipack 64G 3.0 (5 Colors: Black Red Blue Green Purple)",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$21.99",
    "rating": 4.5,
    "review_count": 100,
    "special_features": "Retractable",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/6114Y-pERML._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 21.99,
    "currency": "USD",
    "price_original": "$21.99"
  },
  {
    "product_url": "https://www.amazon.com/Vansuny-Type-C-Android-Smartphone-Computer/dp/B0BV6QZ23Y/ref=sr_1_217?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.lte2re6NKRvNJmaKobxa8zQxMW2xrQNUU9zG7QKesATxyfqjMb2W3az-QONfRrJtDb-rMaNzM2fFJjUUA3VHM-6MwfnXqSZ3vW6_TTCZV_o7n47V2zjSCTMR_QeOvs4F4Y7JtvBDBdcdAN2Pn4cl_XOrypSct1VSslMRS4xbRky4IzketENtXmV3wiPGNUZoVwk9QoXWUGNKk8K7Tnfhkg8yoF1IxWU6gkJLPxg5M50.sGTMYYppZaPczp7qHrfuqklFnOmh7Tmtd2g_VsZFkhc&dib_tag=se&keywords=flash+drives&qid=1753561948&sprefix=flash+drive%2Caps%2C146&sr=8-217&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BV6QZ23Y",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 6,
    "asin": "B0BV6QZ23Y",
    "title": "64GB 5 Pack USB Type-C Flash Drives 2-in-1 Dual Flash Drive USB A + USB C OTG Flash Drive for Android Smartphone Tablet Computer Laptop (Blue)",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$22.94",
    "rating": 4.2,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/61Xg8haxD6L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 22.94,
    "currency": "USD",
    "price_original": "$22.94"
  },
  {
    "product_url": "https://www.amazon.com/EASTBULL-Flash-Drives-Thumb-Strings/dp/B0D16YYGRS/ref=sr_1_218?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.lte2re6NKRvNJmaKobxa8zQxMW2xrQNUU9zG7QKesATxyfqjMb2W3az-QONfRrJtDb-rMaNzM2fFJjUUA3VHM-6MwfnXqSZ3vW6_TTCZV_o7n47V2zjSCTMR_QeOvs4F4Y7JtvBDBdcdAN2Pn4cl_XOrypSct1VSslMRS4xbRky4IzketENtXmV3wiPGNUZoVwk9QoXWUGNKk8K7Tnfhkg8yoF1IxWU6gkJLPxg5M50.sGTMYYppZaPczp7qHrfuqklFnOmh7Tmtd2g_VsZFkhc&dib_tag=se&keywords=flash+drives&qid=1753561948&sprefix=flash+drive%2Caps%2C146&sr=8-218&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D16YYGRS",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 7,
    "asin": "B0D16YYGRS",
    "title": "50 Pack of Flash Drives Bulk 16GB USB 2.0 Flash Drives Pack USB Drives Bulk Thumb Drives in Bulk with 50 Strings (16 GB)",
    "brand": 50,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$109.88",
    "rating": 4.4,
    "review_count": 150,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "7 sizes7 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/81Gt8r4pvyL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 109.88,
    "currency": "USD",
    "price_original": "$109.88"
  },
  {
    "product_url": "https://www.amazon.com/iPhone-LANSLSY-External-Storage-Android/dp/B098DPP17K/ref=sr_1_221?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.lte2re6NKRvNJmaKobxa8zQxMW2xrQNUU9zG7QKesATxyfqjMb2W3az-QONfRrJtDb-rMaNzM2fFJjUUA3VHM-6MwfnXqSZ3vW6_TTCZV_o7n47V2zjSCTMR_QeOvs4F4Y7JtvBDBdcdAN2Pn4cl_XOrypSct1VSslMRS4xbRky4IzketENtXmV3wiPGNUZoVwk9QoXWUGNKk8K7Tnfhkg8yoF1IxWU6gkJLPxg5M50.sGTMYYppZaPczp7qHrfuqklFnOmh7Tmtd2g_VsZFkhc&dib_tag=se&keywords=flash+drives&qid=1753561948&sprefix=flash+drive%2Caps%2C146&sr=8-221&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B098DPP17K",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 8,
    "asin": "B098DPP17K",
    "title": "256GB Flash Drive for Phone Photo Stick,Phone Flash Drive USB 3.0 External Storage,3 in 1 Memory Stick is Compatible with i 0S/Pad/Android/PC/Mac (256GB, Silver)",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$22.99",
    "rating": 4.1,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -919,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/61biaHukxzL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 22.99,
    "currency": "USD",
    "price_original": "$22.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=14&crid=BALSGJKBQE1X&qid=1753561906&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_13#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 9,
    "asin": null,
    "title": "32GB USB Flash Drives, USB Stick, Thumb Drive Rotated Design, Memory Stick with LED Light for External Storage and Backup Data, Jump Drive, 3 Pack 32GB (3 Colors: Black Red Blue)",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$9.99",
    "rating": 4.5,
    "review_count": 2,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/61Rje75BfpL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 9.99,
    "currency": "USD",
    "price_original": "$9.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDA0MjgyOTI1NTQ2ODU3OjE3NTM1NjE5NDk6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDAzMjYwNTY1MDM1MTo6MDo6&url=%2FSeeDete-Drives-Rotated-External-Storage%2Fdp%2FB08K4FN9L6%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB08K4FN9L6%26pd_rd_r%3Df1672ff5-7a28-46f5-b33e-bbc598750c1c%26pd_rd_w%3DCEaLN%26pd_rd_wg%3DUBNeX%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D8Y7863Z8AP9P2TMDA4JM%26qid%3D1753561948%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-209-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B08K4FN9L6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 10,
    "asin": "B08K4FN9L6",
    "title": "32GB USB Flash Drives, USB Stick, Thumb Drive Rotated Design, Memory Stick with LED Light for External Storage and Backup Data, Jump Drive, 3 Pack 32GB (3 Colors: Black Red Blue)",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$9.99",
    "rating": 4.5,
    "review_count": 400,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/61Rje75BfpL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 9.99,
    "currency": "USD",
    "price_original": "$9.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDA0MjgyOTI1NTQ2ODU3OjE3NTM1NjE5NDk6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDAzMDA3NDMzNzc0MTo6MTo6&url=%2FSamData-Drives-Memory-Storage-Backup%2Fdp%2FB08F9SVPGP%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB08F9SVPGP%26pd_rd_r%3Df1672ff5-7a28-46f5-b33e-bbc598750c1c%26pd_rd_w%3DCEaLN%26pd_rd_wg%3DUBNeX%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D8Y7863Z8AP9P2TMDA4JM%26qid%3D1753561948%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-210-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B08F9SVPGP",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 11,
    "asin": "B08F9SVPGP",
    "title": "64GB USB Flash Drives 5 Pack 64GB Thumb Drives Memory Stick Jump Drive with LED Light for Storage and Backup (5 Colors: Black Blue Green Red Silver)",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$21.99",
    "rating": 4.5,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(37.6K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/711c8S+SleL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 21.99,
    "currency": "USD",
    "price_original": "$21.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDA0MjgyOTI1NTQ2ODU3OjE3NTM1NjE5NDk6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDgyNjc2MjU4ODcwMjo6Mjo6&url=%2FDrives-Indicator-Storage-Sharing-Multi-Color%2Fdp%2FB0925H2GJC%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0925H2GJC%26pd_rd_r%3Df1672ff5-7a28-46f5-b33e-bbc598750c1c%26pd_rd_w%3DCEaLN%26pd_rd_wg%3DUBNeX%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D8Y7863Z8AP9P2TMDA4JM%26qid%3D1753561948%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-211-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0925H2GJC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 12,
    "asin": "B0925H2GJC",
    "title": "USB Flash Drive 4GB 10 Pack, Thumb Drives Memory Stick USB 2.0 Bulk Swivel Jump Drive Zip Drive with Led Indicator for Data Storage, File Sharing(10Pcs, Multi-Color,4 GB)",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.6,
    "review_count": 1,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/71atcuKw17L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDA0MjgyOTI1NTQ2ODU3OjE3NTM1NjE5NDk6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDY3Nzg4MTM3MDQwMjo6Mzo6&url=%2FCenton-Electronics-ValuePack-Black-S1-U3P6-128G-10B%2Fdp%2FB00MFD29DQ%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB00MFD29DQ%26pd_rd_r%3Df1672ff5-7a28-46f5-b33e-bbc598750c1c%26pd_rd_w%3DCEaLN%26pd_rd_wg%3DUBNeX%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D8Y7863Z8AP9P2TMDA4JM%26qid%3D1753561948%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-212-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B00MFD29DQ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 13,
    "asin": "B00MFD29DQ",
    "title": "Electronics MP Valuepack USB 3.2 Gen1 DataStick Pro Flash Drive, 128 GB, 10 USB Flash Drives, 10 Pack, Black",
    "brand": "Electronics",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$69.99",
    "rating": 4.5,
    "review_count": 250,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -250,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/61LCc9CEOBL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 69.99,
    "currency": "USD",
    "price_original": "$69.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDA0MjgyOTI1NTQ2ODU3OjE3NTM1NjE5NDk6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDA1NDc5ODg2Njk3MTo6NDo6&url=%2FVICFUN-Drives-Retractable-Memory-Storage%2Fdp%2FB08VJ199DR%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB08VJ199DR%26pd_rd_r%3Df1672ff5-7a28-46f5-b33e-bbc598750c1c%26pd_rd_w%3DCEaLN%26pd_rd_wg%3DUBNeX%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D8Y7863Z8AP9P2TMDA4JM%26qid%3D1753561948%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-213-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B08VJ199DR",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 14,
    "asin": "B08VJ199DR",
    "title": "2 Pack 32GB USB Flash Drives USB 3.0 Flash Drive 32GB Slide Retractable USB Memory Stick 32G Data Storage",
    "brand": 2,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$10.89",
    "rating": 4.2,
    "review_count": 612,
    "special_features": "Retractable",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -612,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/51+2N+2bL6L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 10.89,
    "currency": "USD",
    "price_original": "$10.89"
  },
  {
    "product_url": "https://www.amazon.com/Certified-iPhone-Storage-Compatible-Android/dp/B0CNT34ZQD/ref=sr_1_223?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.lte2re6NKRvNJmaKobxa8zQxMW2xrQNUU9zG7QKesATxyfqjMb2W3az-QONfRrJtDb-rMaNzM2fFJjUUA3VHM-6MwfnXqSZ3vW6_TTCZV_o7n47V2zjSCTMR_QeOvs4F4Y7JtvBDBdcdAN2Pn4cl_XOrypSct1VSslMRS4xbRky4IzketENtXmV3wiPGNUZoVwk9QoXWUGNKk8K7Tnfhkg8yoF1IxWU6gkJLPxg5M50.sGTMYYppZaPczp7qHrfuqklFnOmh7Tmtd2g_VsZFkhc&dib_tag=se&keywords=flash+drives&qid=1753561948&sprefix=flash+drive%2Caps%2C146&sr=8-223&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CNT34ZQD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 15,
    "asin": "B0CNT34ZQD",
    "title": "MFi Certified 128GB Flash Drive for iPhone Photo Stick, USB Thumb Drive Memory Stick High Speed USB Drive Photo Storage for iPhone Flash Drive Compatible for iPhone/iPad/Android/PC",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$22.99",
    "rating": 4.2,
    "review_count": 400,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/61uOPRk-GbL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 22.99,
    "currency": "USD",
    "price_original": "$22.99"
  },
  {
    "product_url": "https://www.amazon.com/128GB-RAOYI-Memory-Pendrives-Lanyard/dp/B08ZCTPV79/ref=sr_1_224?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.lte2re6NKRvNJmaKobxa8zQxMW2xrQNUU9zG7QKesATxyfqjMb2W3az-QONfRrJtDb-rMaNzM2fFJjUUA3VHM-6MwfnXqSZ3vW6_TTCZV_o7n47V2zjSCTMR_QeOvs4F4Y7JtvBDBdcdAN2Pn4cl_XOrypSct1VSslMRS4xbRky4IzketENtXmV3wiPGNUZoVwk9QoXWUGNKk8K7Tnfhkg8yoF1IxWU6gkJLPxg5M50.sGTMYYppZaPczp7qHrfuqklFnOmh7Tmtd2g_VsZFkhc&dib_tag=se&keywords=flash+drives&qid=1753561948&sprefix=flash+drive%2Caps%2C146&sr=8-224&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08ZCTPV79",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 16,
    "asin": "B08ZCTPV79",
    "title": "USB Stick 128GB USB 3.0 Flash Drive with Lanyard,128G Mini Fit Memory Stick Ultra Slim Thumb Drive Zip Drive for PC Desktop-Black",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.3,
    "review_count": 100,
    "special_features": "Lanyard, Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/51wX-0Hs5aL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/EATOP-Intended-Computers-Application-Required/dp/B0DPNGQTG7/ref=sr_1_225?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.lte2re6NKRvNJmaKobxa8zQxMW2xrQNUU9zG7QKesATxyfqjMb2W3az-QONfRrJtDb-rMaNzM2fFJjUUA3VHM-6MwfnXqSZ3vW6_TTCZV_o7n47V2zjSCTMR_QeOvs4F4Y7JtvBDBdcdAN2Pn4cl_XOrypSct1VSslMRS4xbRky4IzketENtXmV3wiPGNUZoVwk9QoXWUGNKk8K7Tnfhkg8yoF1IxWU6gkJLPxg5M50.sGTMYYppZaPczp7qHrfuqklFnOmh7Tmtd2g_VsZFkhc&dib_tag=se&keywords=flash+drives&qid=1753561948&sprefix=flash+drive%2Caps%2C146&sr=8-225&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DPNGQTG7",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 17,
    "asin": "B0DPNGQTG7",
    "title": "512GB Flash Drive Intended for iPhone iPad Android and Computers, 4 in 1 Photo Stick for Phone Memory Storage Easily Backup Photos Videos, Plug and Play, No Application Required (Light Pink)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$34.79",
    "rating": 4.1,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/71d-GtSRBUL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.79,
    "currency": "USD",
    "price_original": "$34.79"
  },
  {
    "product_url": "https://www.amazon.com/JBOS-Electronic-Accessories-Organizer-DriveThumb/dp/B07RTMTV92/ref=sr_1_226?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.lte2re6NKRvNJmaKobxa8zQxMW2xrQNUU9zG7QKesATxyfqjMb2W3az-QONfRrJtDb-rMaNzM2fFJjUUA3VHM-6MwfnXqSZ3vW6_TTCZV_o7n47V2zjSCTMR_QeOvs4F4Y7JtvBDBdcdAN2Pn4cl_XOrypSct1VSslMRS4xbRky4IzketENtXmV3wiPGNUZoVwk9QoXWUGNKk8K7Tnfhkg8yoF1IxWU6gkJLPxg5M50.sGTMYYppZaPczp7qHrfuqklFnOmh7Tmtd2g_VsZFkhc&dib_tag=se&keywords=flash+drives&qid=1753561948&sprefix=flash+drive%2Caps%2C146&sr=8-226&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07RTMTV92",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 18,
    "asin": "B07RTMTV92",
    "title": "Flash Drive Case USB Storage Case JBOS USB Holder Storage Bag, Electronic Accessories Organizer for USB Flash Drive, USB Case, Thumb Drive Caes, Jump Drive Case, USB Organizer",
    "brand": "Flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 0,
    "capacity_category": null,
    "memory_capacity_category": null,
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$6.99",
    "rating": 4.7,
    "review_count": 3,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/81AqU-cvj2L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "unknown",
    "price_numeric": 6.99,
    "currency": "USD",
    "price_original": "$6.99"
  },
  {
    "product_url": "https://www.amazon.com/256GB-Blink-Storage-Module-Included/dp/B08THG1DHQ/ref=sr_1_227?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.lte2re6NKRvNJmaKobxa8zQxMW2xrQNUU9zG7QKesATxyfqjMb2W3az-QONfRrJtDb-rMaNzM2fFJjUUA3VHM-6MwfnXqSZ3vW6_TTCZV_o7n47V2zjSCTMR_QeOvs4F4Y7JtvBDBdcdAN2Pn4cl_XOrypSct1VSslMRS4xbRky4IzketENtXmV3wiPGNUZoVwk9QoXWUGNKk8K7Tnfhkg8yoF1IxWU6gkJLPxg5M50.sGTMYYppZaPczp7qHrfuqklFnOmh7Tmtd2g_VsZFkhc&dib_tag=se&keywords=flash+drives&qid=1753561948&sprefix=flash+drive%2Caps%2C146&sr=8-227&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08THG1DHQ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 19,
    "asin": "B08THG1DHQ",
    "title": "256GB USB Flash Drive for Local Video Storage with The Blink Sync Module 2 Mount (Blink Add-On Sync Module 2 is NOT Included)",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$15.97",
    "rating": 4.5,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/51sMphqKTzL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 15.97,
    "currency": "USD",
    "price_original": "$15.97"
  },
  {
    "product_url": "https://www.amazon.com/Certified-External-Compatible-Transfer-512GB-Pink/dp/B0FFYG2JPP/ref=sr_1_228?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.lte2re6NKRvNJmaKobxa8zQxMW2xrQNUU9zG7QKesATxyfqjMb2W3az-QONfRrJtDb-rMaNzM2fFJjUUA3VHM-6MwfnXqSZ3vW6_TTCZV_o7n47V2zjSCTMR_QeOvs4F4Y7JtvBDBdcdAN2Pn4cl_XOrypSct1VSslMRS4xbRky4IzketENtXmV3wiPGNUZoVwk9QoXWUGNKk8K7Tnfhkg8yoF1IxWU6gkJLPxg5M50.sGTMYYppZaPczp7qHrfuqklFnOmh7Tmtd2g_VsZFkhc&dib_tag=se&keywords=flash+drives&qid=1753561948&sprefix=flash+drive%2Caps%2C146&sr=8-228&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0FFYG2JPP",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 20,
    "asin": "B0FFYG2JPP",
    "title": "MFi Certified 512GB Flash Drives 3.0 High Speed 3ni1 USB Stick External Storage Compatible for iPhone/PC/iPad/Android/More Devices for Photos and Videos Transfer Storage Backup(512GB-Pink)",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$25.99",
    "rating": 4.7,
    "review_count": 56,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -56,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/61dC11rWMhL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 25.99,
    "currency": "USD",
    "price_original": "$25.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=14&crid=BALSGJKBQE1X&qid=1753561906&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_13#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 21,
    "asin": null,
    "title": "20Pack 1GB USB 2.0 Flash Drive with Keychains,Swivel USB Thumb Drives Memory Stick USB Drive for PC Laptop Computer (Mixcolors)",
    "brand": "20Pack",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$33.29",
    "rating": 4.5,
    "review_count": 569,
    "special_features": "Keychain, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -569,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/71p78HH6PLL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 33.29,
    "currency": "USD",
    "price_original": "$33.29"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NTg2NzM4NTExMzg2MDk6MTc1MzU2MTk0OTpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDI2Mzg1ODQ5OTkwMjo6MDo6&url=%2FWooolken-20Pack-Keychains-Computer-Mixcolors%2Fdp%2FB0CXLZH7L3%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CXLZH7L3%26pd_rd_r%3Da85d0463-1247-4eb0-9e55-ed9ee28141f1%26pd_rd_w%3DgG9hA%26pd_rd_wg%3DfRQHS%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D8Y7863Z8AP9P2TMDA4JM%26qid%3D1753561948%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-209-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CXLZH7L3",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 22,
    "asin": "B0CXLZH7L3",
    "title": "20Pack 1GB USB 2.0 Flash Drive with Keychains,Swivel USB Thumb Drives Memory Stick USB Drive for PC Laptop Computer (Mixcolors)",
    "brand": "20Pack",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$33.29",
    "rating": 4.5,
    "review_count": 569,
    "special_features": "Keychain, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -569,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/71p78HH6PLL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 33.29,
    "currency": "USD",
    "price_original": "$33.29"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NTg2NzM4NTExMzg2MDk6MTc1MzU2MTk0OTpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDI2Mzg1ODQ5NjYwMjo6MTo6&url=%2FWooolken-Memory-Lanyards-Swivel-Pendrive%2Fdp%2FB0C5CZ9FRL%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0C5CZ9FRL%26pd_rd_r%3Da85d0463-1247-4eb0-9e55-ed9ee28141f1%26pd_rd_w%3DgG9hA%26pd_rd_wg%3DfRQHS%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D8Y7863Z8AP9P2TMDA4JM%26qid%3D1753561948%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-210-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0C5CZ9FRL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 23,
    "asin": "B0C5CZ9FRL",
    "title": "2GB Flash Drive 20 Pack, Wooolken USB 2.0 Memory Stick with LED Light and Lanyards USB Drive Stick for Data Storage and Backup (Mixed Colors)",
    "brand": "2GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$35.90",
    "rating": 4.6,
    "review_count": 700,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/71-kUjhphpL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 35.9,
    "currency": "USD",
    "price_original": "$35.90"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NTg2NzM4NTExMzg2MDk6MTc1MzU2MTk0OTpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDI2Mzg1ODQ5NzkwMjo6Mjo6&url=%2FWooolken-Keychains-Drives-Memory-Computer%2Fdp%2FB0CWRTJG8H%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CWRTJG8H%26pd_rd_r%3Da85d0463-1247-4eb0-9e55-ed9ee28141f1%26pd_rd_w%3DgG9hA%26pd_rd_wg%3DfRQHS%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D8Y7863Z8AP9P2TMDA4JM%26qid%3D1753561948%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-211-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CWRTJG8H",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 24,
    "asin": "B0CWRTJG8H",
    "title": "16GB USB Flash Drive 20 Pack, Wooolken Sleek Metal Thumb Drives with Keychains Swivel Memory Stick Pendrive USB 2.0 Jump Zip Drive USB Stick(Gold)",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$52.19",
    "rating": 4.4,
    "review_count": 681,
    "special_features": "Metal, Keychain, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -681,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/71hADI4NdsL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 52.19,
    "currency": "USD",
    "price_original": "$52.19"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NTg2NzM4NTExMzg2MDk6MTc1MzU2MTk0OTpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDI5OTcyNjUxMTkwMjo6Mzo6&url=%2FThumb-Drives-Memory-Backup-Transfer%2Fdp%2FB013R942VI%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB013R942VI%26pd_rd_r%3Da85d0463-1247-4eb0-9e55-ed9ee28141f1%26pd_rd_w%3DgG9hA%26pd_rd_wg%3DfRQHS%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D8Y7863Z8AP9P2TMDA4JM%26qid%3D1753561948%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-212-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B013R942VI",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 25,
    "asin": "B013R942VI",
    "title": "Flash-Drive 8 GB 10 Pack 2.0 USB Thumb Drive USB Drive Pack USB- Flash-Drives Memory Stick Jump Drive Zip-Drive for File Backup and Transfer",
    "brand": "Flash-Drive",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$23.39",
    "rating": 4.5,
    "review_count": 5,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/71lxOtSOxNL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 23.39,
    "currency": "USD",
    "price_original": "$23.39"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NTg2NzM4NTExMzg2MDk6MTc1MzU2MTk0OTpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDc5ODM5OTY0OTcwMjo6NDo6&url=%2FCertified-External-Photo-Backup-Expansion-Picture-Saver%2Fdp%2FB0956T13X6%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0956T13X6%26pd_rd_r%3Da85d0463-1247-4eb0-9e55-ed9ee28141f1%26pd_rd_w%3DgG9hA%26pd_rd_wg%3DfRQHS%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D8Y7863Z8AP9P2TMDA4JM%26qid%3D1753561948%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-213-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0956T13X6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-14.html",
    "position": 26,
    "asin": "B0956T13X6",
    "title": "MFi Certified 512GB Photo Stick for iPhone USB C Flash Drive External Storage for iPhone 16/15/14, iPad, Android Memory Expansion, Phone-Picture-Saver Portable Thumb Drive for Photos Videos",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$85.49",
    "rating": 4.3,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-14_files/61NjNgybYYL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 85.49,
    "currency": "USD",
    "price_original": "$85.49"
  },
  {
    "product_url": "https://www.amazon.com/TOSPLUS-Drives-Memory-Storage-Swivel/dp/B07R1974VT/ref=sr_1_227?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CbDJLlHYfvXsh1IvyZzvPyG04NB85CA4FHRr-C6-KM2XeXA4PHdXZzFPZ9fwSOmKHbW71Tegui1q32As_0Ey0UXVJ-Dpf1ZqcppV1RjayWDh3x9F8SU9Yr6rfwZdXSee_A-t4MAMByySwWNOCbeMFIPNQpaxQiiEFhWy32_-3bR1Ot3NCbHy-s_6C-GnEPTMsckSiI39bDYFrxwBOZQXT2J-Xhj4gG4pGAHBDPpPznE.Oe6uE-3flfG0nIm6O6FTzTy6uBy6gaS67tevmb0Emd4&dib_tag=se&keywords=flash+drives&qid=1753561969&sprefix=flash+drive%2Caps%2C146&sr=8-227&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07R1974VT",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 1,
    "asin": "B07R1974VT",
    "title": "5 Pack 16GB USB Flash Drives USB 2.0 Thumb Drives Memory Stick Data Storage Jump Drive Swivel Design (Black/Green/Blue/Red/Gold)",
    "brand": 5,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.5,
    "review_count": 213,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/61ff-NY-fqL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/WooTeck-Flash-Drive-Revolver-Bronze/dp/B01LZZMBU2/ref=sr_1_228?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CbDJLlHYfvXsh1IvyZzvPyG04NB85CA4FHRr-C6-KM2XeXA4PHdXZzFPZ9fwSOmKHbW71Tegui1q32As_0Ey0UXVJ-Dpf1ZqcppV1RjayWDh3x9F8SU9Yr6rfwZdXSee_A-t4MAMByySwWNOCbeMFIPNQpaxQiiEFhWy32_-3bR1Ot3NCbHy-s_6C-GnEPTMsckSiI39bDYFrxwBOZQXT2J-Xhj4gG4pGAHBDPpPznE.Oe6uE-3flfG0nIm6O6FTzTy6uBy6gaS67tevmb0Emd4&dib_tag=se&keywords=flash+drives&qid=1753561969&sprefix=flash+drive%2Caps%2C146&sr=8-228&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B01LZZMBU2",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 2,
    "asin": "B01LZZMBU2",
    "title": "128GB Metal Revolver Gun USB 3.0 Flash Drive Livid",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$17.99",
    "rating": 4.7,
    "review_count": 80,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/81immh0SrgL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 17.99,
    "currency": "USD",
    "price_original": "$17.99"
  },
  {
    "product_url": "https://www.amazon.com/2-Pack-Flash-Memory-Storage-Backup/dp/B0F8P6WMFT/ref=sr_1_229?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CbDJLlHYfvXsh1IvyZzvPyG04NB85CA4FHRr-C6-KM2XeXA4PHdXZzFPZ9fwSOmKHbW71Tegui1q32As_0Ey0UXVJ-Dpf1ZqcppV1RjayWDh3x9F8SU9Yr6rfwZdXSee_A-t4MAMByySwWNOCbeMFIPNQpaxQiiEFhWy32_-3bR1Ot3NCbHy-s_6C-GnEPTMsckSiI39bDYFrxwBOZQXT2J-Xhj4gG4pGAHBDPpPznE.Oe6uE-3flfG0nIm6O6FTzTy6uBy6gaS67tevmb0Emd4&dib_tag=se&keywords=flash+drives&qid=1753561969&sprefix=flash+drive%2Caps%2C146&sr=8-229&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0F8P6WMFT",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 3,
    "asin": "B0F8P6WMFT",
    "title": "2-Pack 64GB USB C Flash Drive Dual Flash Drive Type C + USB A Memory Stick Jump Drive 2-in-1 Thumb Drive for Storage and Backup (64GB*2 Black&Blue)",
    "brand": "2-Pack",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$14.99",
    "rating": 4.5,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/51Z3u2SmWyL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.99,
    "currency": "USD",
    "price_original": "$14.99"
  },
  {
    "product_url": "https://www.amazon.com/Aiibe-128GB-Memory-Keychain-Colors/dp/B0B8CLK6LT/ref=sr_1_231?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CbDJLlHYfvXsh1IvyZzvPyG04NB85CA4FHRr-C6-KM2XeXA4PHdXZzFPZ9fwSOmKHbW71Tegui1q32As_0Ey0UXVJ-Dpf1ZqcppV1RjayWDh3x9F8SU9Yr6rfwZdXSee_A-t4MAMByySwWNOCbeMFIPNQpaxQiiEFhWy32_-3bR1Ot3NCbHy-s_6C-GnEPTMsckSiI39bDYFrxwBOZQXT2J-Xhj4gG4pGAHBDPpPznE.Oe6uE-3flfG0nIm6O6FTzTy6uBy6gaS67tevmb0Emd4&dib_tag=se&keywords=flash+drives&qid=1753561969&sprefix=flash+drive%2Caps%2C146&sr=8-231&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0B8CLK6LT",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 4,
    "asin": "B0B8CLK6LT",
    "title": "128GB Flash Drive 2 Pack 128GB USB Flash Drive Thumb Drive Zip Drive USB 2.0 Memory Stick USB Drive with Keychain (128G, 2 Colors: Black Green)",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$16.99",
    "rating": 4.5,
    "review_count": 4,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "No",
    "image_url": "./drives-15_files/618IWD2QvcL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.99,
    "currency": "USD",
    "price_original": "$16.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Extreme-Type-Flash-Drive/dp/B08KSJ144R/ref=sr_1_232?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CbDJLlHYfvXsh1IvyZzvPyG04NB85CA4FHRr-C6-KM2XeXA4PHdXZzFPZ9fwSOmKHbW71Tegui1q32As_0Ey0UXVJ-Dpf1ZqcppV1RjayWDh3x9F8SU9Yr6rfwZdXSee_A-t4MAMByySwWNOCbeMFIPNQpaxQiiEFhWy32_-3bR1Ot3NCbHy-s_6C-GnEPTMsckSiI39bDYFrxwBOZQXT2J-Xhj4gG4pGAHBDPpPznE.Oe6uE-3flfG0nIm6O6FTzTy6uBy6gaS67tevmb0Emd4&dib_tag=se&keywords=flash+drives&qid=1753561969&sprefix=flash+drive%2Caps%2C146&sr=8-232&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08KSJ144R",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 5,
    "asin": "B08KSJ144R",
    "title": "64GB Extreme Go USB 3.2 Type-A Flash Drive - SDCZ810-064G-G46, Metallic Bronze/Gloss Black",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$17.99",
    "rating": 4.4,
    "review_count": 100,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "No",
    "is_available": "No",
    "image_url": "./drives-15_files/71zfu5EQ80L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 17.99,
    "currency": "USD",
    "price_original": "$17.99"
  },
  {
    "product_url": "https://www.amazon.com/ABLAZE-Android-Smartphone-Computers-Tablets/dp/B0D69QZWR5/ref=sr_1_233?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CbDJLlHYfvXsh1IvyZzvPyG04NB85CA4FHRr-C6-KM2XeXA4PHdXZzFPZ9fwSOmKHbW71Tegui1q32As_0Ey0UXVJ-Dpf1ZqcppV1RjayWDh3x9F8SU9Yr6rfwZdXSee_A-t4MAMByySwWNOCbeMFIPNQpaxQiiEFhWy32_-3bR1Ot3NCbHy-s_6C-GnEPTMsckSiI39bDYFrxwBOZQXT2J-Xhj4gG4pGAHBDPpPznE.Oe6uE-3flfG0nIm6O6FTzTy6uBy6gaS67tevmb0Emd4&dib_tag=se&keywords=flash+drives&qid=1753561969&sprefix=flash+drive%2Caps%2C146&sr=8-233&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D69QZWR5",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 6,
    "asin": "B0D69QZWR5",
    "title": "32GB Type C Flash Drive 10 Pack, Dual USB 2.0+USB C Memory Stick Thumb Drive Compatible with iPhone 16/15, Android Smartphone, Computers, Tablets, Mac,iPad,PC",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 4.3,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/71lv03FTiaL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": "https://www.amazon.com/Kingston-512GB-Protection-Mult-Password-IKVP50C/dp/B0CKR6Q4DD/ref=sr_1_234?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CbDJLlHYfvXsh1IvyZzvPyG04NB85CA4FHRr-C6-KM2XeXA4PHdXZzFPZ9fwSOmKHbW71Tegui1q32As_0Ey0UXVJ-Dpf1ZqcppV1RjayWDh3x9F8SU9Yr6rfwZdXSee_A-t4MAMByySwWNOCbeMFIPNQpaxQiiEFhWy32_-3bR1Ot3NCbHy-s_6C-GnEPTMsckSiI39bDYFrxwBOZQXT2J-Xhj4gG4pGAHBDPpPznE.Oe6uE-3flfG0nIm6O6FTzTy6uBy6gaS67tevmb0Emd4&dib_tag=se&keywords=flash+drives&qid=1753561969&sprefix=flash+drive%2Caps%2C146&sr=8-234&ufe=app_do%3Aamzn1.fos.9fe8cbfa-bf43-43d1-a707-3f4e65a4b666&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CKR6Q4DD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 7,
    "asin": "B0CKR6Q4DD",
    "title": "Ironkey Vault Privacy 50 USB-C 512GB Encrypted Flash Drive | FIPS 197 Certified | XTS-AES 256-bit | BadUSB and Brute Force Protection | Mult-Password Option | IKVP50C/512GB",
    "brand": "Ironkey",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$169.99",
    "rating": 4.4,
    "review_count": 255,
    "special_features": "Encrypted",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "No",
    "image_url": "./drives-15_files/71k0m41lXQL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 169.99,
    "currency": "USD",
    "price_original": "$169.99"
  },
  {
    "product_url": "https://www.amazon.com/Netac-Protection-Push-Pull-External-Sound-U335S/dp/B0CDWNHYWF/ref=sr_1_237?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CbDJLlHYfvXsh1IvyZzvPyG04NB85CA4FHRr-C6-KM2XeXA4PHdXZzFPZ9fwSOmKHbW71Tegui1q32As_0Ey0UXVJ-Dpf1ZqcppV1RjayWDh3x9F8SU9Yr6rfwZdXSee_A-t4MAMByySwWNOCbeMFIPNQpaxQiiEFhWy32_-3bR1Ot3NCbHy-s_6C-GnEPTMsckSiI39bDYFrxwBOZQXT2J-Xhj4gG4pGAHBDPpPznE.Oe6uE-3flfG0nIm6O6FTzTy6uBy6gaS67tevmb0Emd4&dib_tag=se&keywords=flash+drives&qid=1753561969&sprefix=flash+drive%2Caps%2C146&sr=8-237&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CDWNHYWF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 8,
    "asin": "B0CDWNHYWF",
    "title": "128GB USB 3.0 Flash Drive Up to 90MB/s Thumb Drive for Data Storage, Pen Drive Write Protection with Push-Pull Design Memory Stick for External Storage Data/Computer/PC/Laptop/Sound-U335S",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$11.10",
    "rating": 4.2,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/317yuA8UUyL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.1,
    "currency": "USD",
    "price_original": "$11.10"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=15&crid=BALSGJKBQE1X&qid=1753561906&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_13#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 9,
    "asin": null,
    "title": "128GB (5 Pack) NR34 128GB USB Flash Drive 5-Pack ‚Äì USB 3.2 Memory Stick with Keychain Loop, Plastic Capless Thumb Drive up to 120MB/s Read, 60MB/s Write ‚Äì Plug & Play for PC, Mac, TV, Car",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$27.59",
    "rating": 4.3,
    "review_count": 973,
    "special_features": "Keychain, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -973,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/61yz8ddF2HL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 27.59,
    "currency": "USD",
    "price_original": "$27.59"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NDg0NjI2NjE4ODM0MDI6MTc1MzU2MTk2OTpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwODMzNDE5OTg2MDAyOjowOjo&url=%2FLinkMore-128GB-Flash-Drive-5-Pack%2Fdp%2FB0FB84WTXC%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FB84WTXC%26pd_rd_r%3D252724eb-2881-4f09-a776-c16b2b1eeffa%26pd_rd_w%3DPtus9%26pd_rd_wg%3DhL2qv%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DQSRVTZZRY0KAFPJDXV6Y%26qid%3D1753561969%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-225-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FB84WTXC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 10,
    "asin": "B0FB84WTXC",
    "title": "128GB (5 Pack) NR34 128GB USB Flash Drive 5-Pack ‚Äì USB 3.2 Memory Stick with Keychain Loop, Plastic Capless Thumb Drive up to 120MB/s Read, 60MB/s Write ‚Äì Plug & Play for PC, Mac, TV, Car",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$27.59",
    "rating": 4.3,
    "review_count": 973,
    "special_features": "Keychain, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -973,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/61yz8ddF2HL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 27.59,
    "currency": "USD",
    "price_original": "$27.59"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NDg0NjI2NjE4ODM0MDI6MTc1MzU2MTk2OTpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwNzY2NjA2MTMwNDAyOjoxOjo&url=%2FFlash-Drives-EASTBULL-Memory-Swivel%2Fdp%2FB07RTHMDHD%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07RTHMDHD%26pd_rd_r%3D252724eb-2881-4f09-a776-c16b2b1eeffa%26pd_rd_w%3DPtus9%26pd_rd_wg%3DhL2qv%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DQSRVTZZRY0KAFPJDXV6Y%26qid%3D1753561969%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-226-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07RTHMDHD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 11,
    "asin": "B07RTHMDHD",
    "title": "20PCS 4GB Bulk Flash Drives EASTBULL USB 2.0 Metal 4GB Flash Drive Bulk Thumb Drive Pack Swivel USB Drives Pack (Blue 20Pack)",
    "brand": "20PCS",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$40.88",
    "rating": 4.5,
    "review_count": 100,
    "special_features": "Metal, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -992,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/71Ry9IcXpaL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 40.88,
    "currency": "USD",
    "price_original": "$40.88"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NDg0NjI2NjE4ODM0MDI6MTc1MzU2MTk2OTpzcF9zZWFyY2hfdGhlbWF0aWM6MjAwMDQ4MTcwODE4NjQxOjoyOjo&url=%2FiStorage-FL-DAP3-B-16-datAshur-Personal2-encrypted%2Fdp%2FB01N1Q24UT%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB01N1Q24UT%26pd_rd_r%3D252724eb-2881-4f09-a776-c16b2b1eeffa%26pd_rd_w%3DPtus9%26pd_rd_wg%3DhL2qv%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DQSRVTZZRY0KAFPJDXV6Y%26qid%3D1753561969%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-227-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B01N1Q24UT",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 12,
    "asin": "B01N1Q24UT",
    "title": "datAshur Personal2 16 GB | Secure Flash Drive | Password Protected | Portable | Military Grade Hardware Encryption",
    "brand": "datAshur",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$71.95",
    "rating": 4.3,
    "review_count": 257,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -257,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-15_files/81PXcO1YdvL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 71.95,
    "currency": "USD",
    "price_original": "$71.95"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NDg0NjI2NjE4ODM0MDI6MTc1MzU2MTk2OTpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwNTM2ODg0MzEyMTAyOjozOjo&url=%2FCenter-SuperSpeed-Memory-Storage-10-Pack%2Fdp%2FB09YCYQTWV%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB09YCYQTWV%26pd_rd_r%3D252724eb-2881-4f09-a776-c16b2b1eeffa%26pd_rd_w%3DPtus9%26pd_rd_wg%3DhL2qv%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DQSRVTZZRY0KAFPJDXV6Y%26qid%3D1753561969%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-228-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B09YCYQTWV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 13,
    "asin": "B09YCYQTWV",
    "title": "Micro Center SuperSpeed 10 Pack 16GB USB 3.0 Flash Drive Gum Size Memory Stick Thumb Drive Data Storage Jump Drive, 10X Faster Than USB 2.0 USB Drive (16G 10-Pack)",
    "brand": "Micro",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$33.99",
    "rating": 4.6,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(24.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/81Xurws4TCL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 33.99,
    "currency": "USD",
    "price_original": "$33.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NDg0NjI2NjE4ODM0MDI6MTc1MzU2MTk2OTpzcF9zZWFyY2hfdGhlbWF0aWM6MjAwMDc4NDc3MzAzMzk4Ojo0Ojo&url=%2FDEEKOO-Drives-Memory-Sticks-Colors%2Fdp%2FB0B8P129H6%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0B8P129H6%26pd_rd_r%3D252724eb-2881-4f09-a776-c16b2b1eeffa%26pd_rd_w%3DPtus9%26pd_rd_wg%3DhL2qv%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DQSRVTZZRY0KAFPJDXV6Y%26qid%3D1753561969%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-229-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0B8P129H6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 14,
    "asin": "B0B8P129H6",
    "title": "Flash Drive 16GB Thumb Drives Memory Sticks Jump Drive 5Pack 16GB USB 2.0 Flash Drives Mixed Colors: Black Red Blue Purple Green",
    "brand": "Flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$11.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/813a39D5VQL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.99,
    "currency": "USD",
    "price_original": "$11.99"
  },
  {
    "product_url": "https://www.amazon.com/Certified-External-Storage-Transfer-Picture/dp/B0DTTKTQWF/ref=sr_1_238?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CbDJLlHYfvXsh1IvyZzvPyG04NB85CA4FHRr-C6-KM2XeXA4PHdXZzFPZ9fwSOmKHbW71Tegui1q32As_0Ey0UXVJ-Dpf1ZqcppV1RjayWDh3x9F8SU9Yr6rfwZdXSee_A-t4MAMByySwWNOCbeMFIPNQpaxQiiEFhWy32_-3bR1Ot3NCbHy-s_6C-GnEPTMsckSiI39bDYFrxwBOZQXT2J-Xhj4gG4pGAHBDPpPznE.Oe6uE-3flfG0nIm6O6FTzTy6uBy6gaS67tevmb0Emd4&dib_tag=se&keywords=flash+drives&qid=1753561969&sprefix=flash+drive%2Caps%2C146&sr=8-238&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DTTKTQWF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 15,
    "asin": "B0DTTKTQWF",
    "title": "MFi Certified 512GB Flash Drive Photo Stick for iPhone, External Memory Photo Keeper Storage for Data Saver/Backup/Transfer Files/Picture/Video, Thumb Drive for iPhone/iPad/iOS/Android/PC,Gray",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$56.99",
    "rating": 4.4,
    "review_count": 300,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/51MTRO-XB8L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 56.99,
    "currency": "USD",
    "price_original": "$56.99"
  },
  {
    "product_url": "https://www.amazon.com/THKAILAR-High-Speed-Android-Durable-Compact/dp/B0DXDTJR78/ref=sr_1_239?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CbDJLlHYfvXsh1IvyZzvPyG04NB85CA4FHRr-C6-KM2XeXA4PHdXZzFPZ9fwSOmKHbW71Tegui1q32As_0Ey0UXVJ-Dpf1ZqcppV1RjayWDh3x9F8SU9Yr6rfwZdXSee_A-t4MAMByySwWNOCbeMFIPNQpaxQiiEFhWy32_-3bR1Ot3NCbHy-s_6C-GnEPTMsckSiI39bDYFrxwBOZQXT2J-Xhj4gG4pGAHBDPpPznE.Oe6uE-3flfG0nIm6O6FTzTy6uBy6gaS67tevmb0Emd4&dib_tag=se&keywords=flash+drives&qid=1753561969&sprefix=flash+drive%2Caps%2C146&sr=8-239&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DXDTJR78",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 16,
    "asin": "B0DXDTJR78",
    "title": "32GB USB C Flash Drive 5 Pack,2-in-1 Dual USB-A&Type-C Thumb Drive USB 3.0 Memory Stick,High-Speed Flash Drive USB C for iPhone 15/16,Android,Mac,PC,PS4,Plug&Play,Durable&Compact Design",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$24.83",
    "rating": 4.3,
    "review_count": 2,
    "special_features": "Compact",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "7 sizes7 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/71ZoTQxwELL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.83,
    "currency": "USD",
    "price_original": "$24.83"
  },
  {
    "product_url": "https://www.amazon.com/Apricorn-256-Bit-Encrypted-Validated-ASK3-NX-512GB/dp/B0DM6TWLRJ/ref=sr_1_240?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CbDJLlHYfvXsh1IvyZzvPyG04NB85CA4FHRr-C6-KM2XeXA4PHdXZzFPZ9fwSOmKHbW71Tegui1q32As_0Ey0UXVJ-Dpf1ZqcppV1RjayWDh3x9F8SU9Yr6rfwZdXSee_A-t4MAMByySwWNOCbeMFIPNQpaxQiiEFhWy32_-3bR1Ot3NCbHy-s_6C-GnEPTMsckSiI39bDYFrxwBOZQXT2J-Xhj4gG4pGAHBDPpPznE.Oe6uE-3flfG0nIm6O6FTzTy6uBy6gaS67tevmb0Emd4&dib_tag=se&keywords=flash+drives&qid=1753561969&sprefix=flash+drive%2Caps%2C146&sr=8-240&ufe=app_do%3Aamzn1.fos.5998aa40-ec6f-4947-a68f-cd087fee0848&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DM6TWLRJ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 17,
    "asin": "B0DM6TWLRJ",
    "title": "512GB Aegis Secure Key 3 NX 256-Bit Encrypted FIPS 140-2 Level 3 Validated Secure USB 3.0 Flash Drive (ASK3-NX-512GB)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$318.24",
    "rating": 4.6,
    "review_count": 663,
    "special_features": "Encrypted",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/51dUSFWUK+L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 318.24,
    "currency": "USD",
    "price_original": "$318.24"
  },
  {
    "product_url": "https://www.amazon.com/Qainerly-Models-Transfer-Storage-Android/dp/B0FHK67WL3/ref=sr_1_241?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CbDJLlHYfvXsh1IvyZzvPyG04NB85CA4FHRr-C6-KM2XeXA4PHdXZzFPZ9fwSOmKHbW71Tegui1q32As_0Ey0UXVJ-Dpf1ZqcppV1RjayWDh3x9F8SU9Yr6rfwZdXSee_A-t4MAMByySwWNOCbeMFIPNQpaxQiiEFhWy32_-3bR1Ot3NCbHy-s_6C-GnEPTMsckSiI39bDYFrxwBOZQXT2J-Xhj4gG4pGAHBDPpPznE.Oe6uE-3flfG0nIm6O6FTzTy6uBy6gaS67tevmb0Emd4&dib_tag=se&keywords=flash+drives&qid=1753561969&sprefix=flash+drive%2Caps%2C146&sr=8-241&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0FHK67WL3",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 18,
    "asin": "B0FHK67WL3",
    "title": "512GB Photo Stick for Phone, Qainerly USB Flash Drive for Phone All Models, 4-in-1 Design Transfer Storage, iPad/PC/Android",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$25.99",
    "rating": 4.3,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -17,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/612KBZjgIAL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 25.99,
    "currency": "USD",
    "price_original": "$25.99"
  },
  {
    "product_url": "https://www.amazon.com/Certified-Lightning-Functional-External-Storage/dp/B07BQMJ6V6/ref=sr_1_242?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CbDJLlHYfvXsh1IvyZzvPyG04NB85CA4FHRr-C6-KM2XeXA4PHdXZzFPZ9fwSOmKHbW71Tegui1q32As_0Ey0UXVJ-Dpf1ZqcppV1RjayWDh3x9F8SU9Yr6rfwZdXSee_A-t4MAMByySwWNOCbeMFIPNQpaxQiiEFhWy32_-3bR1Ot3NCbHy-s_6C-GnEPTMsckSiI39bDYFrxwBOZQXT2J-Xhj4gG4pGAHBDPpPznE.Oe6uE-3flfG0nIm6O6FTzTy6uBy6gaS67tevmb0Emd4&dib_tag=se&keywords=flash+drives&qid=1753561969&sprefix=flash+drive%2Caps%2C146&sr=8-242&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07BQMJ6V6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 19,
    "asin": "B07BQMJ6V6",
    "title": "MFi Certified iDiskk 128GB Flash Drive for iPhone 15 16 iPad USB 3.0 Lightning Drive 4 in 1 Multi Functional External Storage for iOS and Android Samsung Phones Type c Devices and MacBook Photo Drive",
    "brand": "Samsung",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$37.99",
    "rating": 4.2,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/6154R5FbsAL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.99,
    "currency": "USD",
    "price_original": "$37.99"
  },
  {
    "product_url": "https://www.amazon.com/GARMESE-Storage-Compatible-Smartphone-Computer/dp/B0DRG7LC8R/ref=sr_1_243?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CbDJLlHYfvXsh1IvyZzvPyG04NB85CA4FHRr-C6-KM2XeXA4PHdXZzFPZ9fwSOmKHbW71Tegui1q32As_0Ey0UXVJ-Dpf1ZqcppV1RjayWDh3x9F8SU9Yr6rfwZdXSee_A-t4MAMByySwWNOCbeMFIPNQpaxQiiEFhWy32_-3bR1Ot3NCbHy-s_6C-GnEPTMsckSiI39bDYFrxwBOZQXT2J-Xhj4gG4pGAHBDPpPznE.Oe6uE-3flfG0nIm6O6FTzTy6uBy6gaS67tevmb0Emd4&dib_tag=se&keywords=flash+drives&qid=1753561969&sprefix=flash+drive%2Caps%2C146&sr=8-243&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DRG7LC8R",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 20,
    "asin": "B0DRG7LC8R",
    "title": "256GB USB C Flash Drive Up to 450MB/s USB 3.2 Solid State Thumb Drive Type-A + Type-C 2-in-1 Flash Drive Memory Stick Data Storage Compatible with Smartphone Tablet Computer Game Console",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 4.1,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/51szitUaUHL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": "https://www.amazon.com/Kingston-DataTraveler-Exodia-Flash-10-Pack/dp/B0BYPF3D2D/ref=sr_1_244?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CbDJLlHYfvXsh1IvyZzvPyG04NB85CA4FHRr-C6-KM2XeXA4PHdXZzFPZ9fwSOmKHbW71Tegui1q32As_0Ey0UXVJ-Dpf1ZqcppV1RjayWDh3x9F8SU9Yr6rfwZdXSee_A-t4MAMByySwWNOCbeMFIPNQpaxQiiEFhWy32_-3bR1Ot3NCbHy-s_6C-GnEPTMsckSiI39bDYFrxwBOZQXT2J-Xhj4gG4pGAHBDPpPznE.Oe6uE-3flfG0nIm6O6FTzTy6uBy6gaS67tevmb0Emd4&dib_tag=se&keywords=flash+drives&qid=1753561969&sprefix=flash+drive%2Caps%2C146&sr=8-244&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BYPF3D2D",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 21,
    "asin": "B0BYPF3D2D",
    "title": "64GB DataTraveler Exodia Onyx USB 3.2 Flash Drive (Matte Black) (10-Pack)",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$59.99",
    "rating": 4.1,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -20,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-15_files/712B-B1GJbL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 59.99,
    "currency": "USD",
    "price_original": "$59.99"
  },
  {
    "product_url": "https://aax-us-iad.amazon.com/x/c/JHBclfy72Azp_B-SXapgHZkAAAGYSHAzvQEAAAH2AQBvbm9fdHhuX2JpZDEgICBvbm9fdHhuX2ltcDEgICCDx3NC/clv1c_ek-Y2oHXFcbCzoHOZIcZsmPqBEoXNEDTznh9LgbivGuVjzaDNoOOMv-bsMMOzSVEC5LxXoB8uYChA1A5NtVejA6Uz3OhWeIRW-xkIFnXXg1oGO7gINwhTSv8h6woblDDiVtLxsUsUH_rJ3YVLMdnw9Qr4O709sRr8EezTTZq5vKvkeMtRai9X3qqhgu1wll7qQbHLz0G1h4d6H4m1onuuWABfjJSp1ojIZpLflo1gY5kSJndb830GUYk2qKPAS__mO8lVlgW4JSCz3BDKPtDA6OZkTnllikTeSHcvwuH99ebNRHARKsfOBosaczQJ9CMrMbzuBMjG6tIjq4bG4noIjmWxK3uCT9eA26hQW0dZlvUHW95sODQtDZC1l_FKd-C2AnF1YK7nAUDZPkH61L495-mgR-LQhQnsBzTY9tVWQHR2Ph6BR1uFvHE45f0DMbay_HmNcm_sa7-f6vONzMtET0eV-hRiuFqR26nRufkYaIYSi_-Nr1HAhU6bU8gHuyJdngXcLgNz9xgtwI0_I_EM4GNBEYJrUA1rlkKb3jz9hoHi24ZYw58vOmXsM2QP6Vf_b1qAVbxpbLEz00YeOSMbWbOQxKgTNAjuWZnUKmw0Jc6kXwT_L9BbuJfZVojxKaJsRnJYiVrj-gRdfxe1NLncVdNfkwFkWSvXk10k6L4eYO7ifzg2087eQLG_2nGuvncU8hIxhq0P3I9_hTWy_oDcHFKv1bs5L4J22xih2h3zdI-7_8sws1lJ8UBNlYRkd2EhM7m611KIhTlk_5OT08I4JibxlNUXnNq3tocQarJWLMktIUklCpIqYAkEVY-R3szzoBnxjuvBPFaeNCItKQZ2C-57eR4nKSS0L8tXLihz-g2CS5GUjyVPND-uOLknkhx5T0lFC41EfEsApVPRPNbGxgzjTpLBBT5AhV5PlDjiQyGEkMlFXMl4Nu3-5NVSMFaP6HUImiKZZNvpJSBFjyLubjf6NojKPQ/https://www.amazon.com/dp/B075GQ17GL?pd_rd_i=B075GQ17GL&pf_rd_p=2c8e5d59-6279-4999-832d-be45d1ca8e79&pf_rd_r=QSRVTZZRY0KAFPJDXV6Y&pd_rd_wg=uVo0P&pd_rd_w=APkmW&pd_rd_r=5d30246d-0a16-4980-a13c-6c03598209fc",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-15.html",
    "position": 22,
    "asin": null,
    "title": "Kepmem USB Flash Drive 4GB 10 Pack USB 2.0 Thumb Drives 4 GB Memory Sticks Portable Jump Drive Bulk Swivel 10 Pieces Zip Drives Mixed Colors Pendrive Data Storage and Backup",
    "brand": "Kepmem",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$23.99",
    "rating": 4.6,
    "review_count": 8,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(8.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-15_files/71lFJZly-9L._AC_UL640_QL65_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 23.99,
    "currency": "USD",
    "price_original": "$23.99"
  },
  {
    "product_url": "https://www.amazon.com/Space-Saving-Bracket-Outdoor-Security-Included/dp/B0DK8J5F4Y/ref=sr_1_243?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-243&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DK8J5F4Y",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 1,
    "asin": "B0DK8J5F4Y",
    "title": "256GB Blink USB Flash Drive, with Outlet Wall Mount for Sync Module, Space-Saving Mount Bracket Holder for Blink Outdoor/Indoor Security System (Sync Module 2 is NOT Included),1Pack",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$14.24",
    "rating": 4.6,
    "review_count": 2,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/51KXyMsevJL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.24,
    "currency": "USD",
    "price_original": "$14.24"
  },
  {
    "product_url": "https://www.amazon.com/TEARMOS-Intended-Compatible-Application-Required/dp/B0DTFJR7BQ/ref=sr_1_244?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-244&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DTFJR7BQ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 2,
    "asin": "B0DTFJR7BQ",
    "title": "512GB Flash Drive Intended for iPhone iPad, Memory Stick Storage for Photos and Videos Backup, Compatible with iPhone iPad Android PC, Plug and Play, No Application Required (Metal Silver)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$37.79",
    "rating": 4.2,
    "review_count": 200,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -178,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/61oePbDLTUL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.79,
    "currency": "USD",
    "price_original": "$37.79"
  },
  {
    "product_url": "https://www.amazon.com/Portable-Type-C-Smartphone-Tablet-Computer/dp/B0DKXBQ3DF/ref=sr_1_245?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-245&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DKXBQ3DF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 3,
    "asin": "B0DKXBQ3DF",
    "title": "64GB USB C Flash Drive Dual USB 3.0 Flash Drive Type C + USB A Portable Type-C Flash Drive 2-in-1 USB-C Thumb Drive for Smartphone Tablet Computer Mac iPhone 16 (2packs)",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.5,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/61R4a+q1flL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/AUAMOZ-Intended-Compatible-Application-Required/dp/B0DNFSPFYJ/ref=sr_1_246?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-246&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DNFSPFYJ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 4,
    "asin": "B0DNFSPFYJ",
    "title": "512GB Flash Drives Intended for iPhone, Memory Stick Storage for Photos and Videos Backup, Compatible with iPhone iPad Android PC, Plug and Play, No Application Required (Dark Blue)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$37.09",
    "rating": 4.2,
    "review_count": 300,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/71524vyaO3L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.09,
    "currency": "USD",
    "price_original": "$37.09"
  },
  {
    "product_url": "https://www.amazon.com/Certified-High-Speed-Storage-Compatible-Android/dp/B0F21S7ZS3/ref=sr_1_247?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-247&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0F21S7ZS3",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 5,
    "asin": "B0F21S7ZS3",
    "title": "Apple MFi Certified Flash Drive 512GB, Photo Stick for iPhone Memory Stick for Photo/Video Backup Stick, High-Speed USB Thumb Drive for iPhone Storage Compatible for iPhone/iPad/Android/PC (Silver)",
    "brand": "Apple",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$69.99",
    "rating": 4.6,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -107,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/61Mlwnq97BL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 69.99,
    "currency": "USD",
    "price_original": "$69.99"
  },
  {
    "product_url": "https://www.amazon.com/EATOP-Intended-Compatible-Application-Required/dp/B0F5Y77FCT/ref=sr_1_248?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-248&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0F5Y77FCT",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 6,
    "asin": "B0F5Y77FCT",
    "title": "512GB Flash Drive Intended for iPhone iPad, Memory Stick Storage for Photos and Videos Backup, Compatible with iPhone iPad Android PC, Plug and Play, No Application Required (Purple)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$28.00",
    "rating": 4.3,
    "review_count": 300,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/61R3hhXRCnL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 28,
    "currency": "USD",
    "price_original": "$28.00"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Computers-SDCZ600-064G-G35-Everything-Stromboli/dp/B084P39R5F/ref=sr_1_249?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-249&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B084P39R5F",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 7,
    "asin": "B084P39R5F",
    "title": "64GB Cruzer Glide 3.0 USB Flash Drives (50 Pack) Pen Drive Works with Laptop Computers with USB 2.0/3.0 Port (SDCZ600-064G-G35) Bundle with (25) Everything But Stromboli Lanyards",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "SD",
    "price": "$304.92",
    "rating": 5,
    "review_count": 1,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -1,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "No",
    "image_url": "./drives-16_files/810YBMxWEaL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 304.92,
    "currency": "USD",
    "price_original": "$304.92"
  },
  {
    "product_url": "https://www.amazon.com/Thkailar-Flash-Compatible-Android-MacBook/dp/B081DFZRPX/ref=sr_1_250?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-250&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B081DFZRPX",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 8,
    "asin": "B081DFZRPX",
    "title": "USB C Flash Drive 256GB,USB Flash Drive with Type C and Type A 3.1 Port Compatible with Android Phone,MacBook Pro,PC(Red)",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$21.74",
    "rating": 4.3,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "11 sizes11 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/61NmFQ4XFvL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 21.74,
    "currency": "USD",
    "price_original": "$21.74"
  },
  {
    "product_url": "https://www.amazon.com/SCICNCE-Intended-Application-Compatible-Computers/dp/B0F4NN6351/ref=sr_1_253?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-253&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0F4NN6351",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 9,
    "asin": "B0F4NN6351",
    "title": "512GB Flash Drive Intended for iPhone, USB Memory Photo Stick Storage for Photos Videos, Plug and Play No Application Required, Compatible with iPhone iPad Android and Computers (Dark Gray)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$28.38",
    "rating": 4.3,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -48,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/61neQlBzLcL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 28.38,
    "currency": "USD",
    "price_original": "$28.38"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=16&crid=BALSGJKBQE1X&qid=1753561906&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_13#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 10,
    "asin": null,
    "title": "10-Pack 16GB USB 2.0 Flash Drives Bulk Memory Stick Swivel Thumb Drives 16 GB for Universal Data Storage at Home and Office for Storing Photo/Video/Music/File by",
    "brand": "10-Pack",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$26.99",
    "rating": 4.3,
    "review_count": 294,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -294,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/71mD37xLnuL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 26.99,
    "currency": "USD",
    "price_original": "$26.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NjUwNTk1NzUyMjU0OjE3NTM1NjE5ODk6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDM3MDczMjMxMzMwMjo6MDo6&url=%2F10-Pack-Universal-Storage-Storing-Kepmem%2Fdp%2FB0D2X8LDMP%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0D2X8LDMP%26pd_rd_r%3Dbe585486-c90e-4f19-ba4f-061a32c6580d%26pd_rd_w%3DHKFb9%26pd_rd_wg%3DMyIcq%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D0C3N9YNRN9S20RNKXVWJ%26qid%3D1753561989%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-241-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0D2X8LDMP",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 11,
    "asin": "B0D2X8LDMP",
    "title": "10-Pack 16GB USB 2.0 Flash Drives Bulk Memory Stick Swivel Thumb Drives 16 GB for Universal Data Storage at Home and Office for Storing Photo/Video/Music/File by",
    "brand": "10-Pack",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$26.99",
    "rating": 4.3,
    "review_count": 50,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -294,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/71mD37xLnuL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 26.99,
    "currency": "USD",
    "price_original": "$26.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NjUwNTk1NzUyMjU0OjE3NTM1NjE5ODk6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDAyOTE4MjY2NjU5ODo6MTo6&url=%2FDrives-Kepmem-Swivel-Portable-Assorted%2Fdp%2FB075GQ58JV%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB075GQ58JV%26pd_rd_r%3Dbe585486-c90e-4f19-ba4f-061a32c6580d%26pd_rd_w%3DHKFb9%26pd_rd_wg%3DMyIcq%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D0C3N9YNRN9S20RNKXVWJ%26qid%3D1753561989%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-242-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B075GQ58JV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 12,
    "asin": "B075GQ58JV",
    "title": "Bulk Flash Drive 2GB Pack of 10 USB Thumb Drives, USB2.0 Jump Drive 10 Pieces Zip Drives 2 GB, Swivel USB 2.0 Memory Stick Portable Pen Drive 2 Gig Metal U Disk Assorted Colors",
    "brand": "Bulk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$22.99",
    "rating": 4.6,
    "review_count": 8,
    "special_features": "Metal, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(8.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/71lFJZly-9L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 22.99,
    "currency": "USD",
    "price_original": "$22.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NjUwNTk1NzUyMjU0OjE3NTM1NjE5ODk6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDAxMjYxOTYxNzU3MTo6Mjo6&url=%2FVICFUN-Flash-Drives-Memory-USB2-0-Blue%2Fdp%2FB07K59N9XY%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07K59N9XY%26pd_rd_r%3Dbe585486-c90e-4f19-ba4f-061a32c6580d%26pd_rd_w%3DHKFb9%26pd_rd_wg%3DMyIcq%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D0C3N9YNRN9S20RNKXVWJ%26qid%3D1753561989%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-243-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07K59N9XY",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 13,
    "asin": "B07K59N9XY",
    "title": "10 Pack 32GB USB Flash Drives Bulk 32GB Flash Drive 10 Pack USB Memory Stick 32GB USB2.0-Blue",
    "brand": 10,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 4.6,
    "review_count": 2,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2.6K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/71ZKeIHxplL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NjUwNTk1NzUyMjU0OjE3NTM1NjE5ODk6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDAzMjIzODQ2NTgxMTo6Mzo6&url=%2FDrives-Memory-JBOS-Digital-Storage%2Fdp%2FB07G6P4N13%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07G6P4N13%26pd_rd_r%3Dbe585486-c90e-4f19-ba4f-061a32c6580d%26pd_rd_w%3DHKFb9%26pd_rd_wg%3DMyIcq%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D0C3N9YNRN9S20RNKXVWJ%26qid%3D1753561989%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-244-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07G6P4N13",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 14,
    "asin": "B07G6P4N13",
    "title": "2GB USB Flash Drive 10 Pack JBOS 2 GB USB Drives Memory Stick Swivel 2G Thumb Drives Gig Stick USB2.0 Pen Drive for Date Storage, 2 Gig UBS Flash Drive, Zip Drive, Jump Drive, USB Stick, Mixed Color",
    "brand": "2GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$18.95",
    "rating": 4.6,
    "review_count": 300,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.9K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/61lrRFxDPHL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.95,
    "currency": "USD",
    "price_original": "$18.95"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NjUwNTk1NzUyMjU0OjE3NTM1NjE5ODk6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDA3MTQzNjM4NDYyMTo6NDo6&url=%2FFlash-Drive-Memory-JumpDrive-Colors%2Fdp%2FB093T1FVRK%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB093T1FVRK%26pd_rd_r%3Dbe585486-c90e-4f19-ba4f-061a32c6580d%26pd_rd_w%3DHKFb9%26pd_rd_wg%3DMyIcq%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D0C3N9YNRN9S20RNKXVWJ%26qid%3D1753561989%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-245-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B093T1FVRK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 15,
    "asin": "B093T1FVRK",
    "title": "5 Pack 4GB USB Flash Drive USB 2.0 Thumb Drive Memory Stick JumpDrive Pen Drive Zip Drive (5 Colors: Black,Blue,Green,Purple,Yellow, 4 GiG)",
    "brand": 5,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$8.99",
    "rating": 4.4,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/61ar0czsFtL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 8.99,
    "currency": "USD",
    "price_original": "$8.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=16&crid=BALSGJKBQE1X&qid=1753561906&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_13#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 16,
    "asin": null,
    "title": "512GB Flash Drive Intended for iPhone, Memory Stick Storage Files Photos Videos Backup, Compatible with iPhone iPad Android PC, Plug and Play, No Application Required (Metal Silver)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$37.09",
    "rating": 4.6,
    "review_count": 60,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -32,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/61vpyoZTx9L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.09,
    "currency": "USD",
    "price_original": "$37.09"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NTgyMTEzODA5OTIxMDUxOjE3NTM1NjE5ODk6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0MDU2Njc0NzkwMjo6MTo6&url=%2FAUAMOZ-Intended-Compatible-Application-Required%2Fdp%2FB0FBSB6XH6%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FBSB6XH6%26pd_rd_r%3Dbe585486-c90e-4f19-ba4f-061a32c6580d%26pd_rd_w%3DnvBsJ%26pd_rd_wg%3DMyIcq%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D0C3N9YNRN9S20RNKXVWJ%26qid%3D1753561989%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-241-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FBSB6XH6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 17,
    "asin": "B0FBSB6XH6",
    "title": "512GB Flash Drive Intended for iPhone, Memory Stick Storage Files Photos Videos Backup, Compatible with iPhone iPad Android PC, Plug and Play, No Application Required (Metal Silver)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$37.09",
    "rating": 4.6,
    "review_count": 32,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -32,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/61vpyoZTx9L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.09,
    "currency": "USD",
    "price_original": "$37.09"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NTgyMTEzODA5OTIxMDUxOjE3NTM1NjE5ODk6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5ODkwMjo6Mjo6&url=%2FCustom-Drives-Personalized-Business-Promotions%2Fdp%2FB0FGQ7Q51R%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQ7Q51R%26pd_rd_r%3Dbe585486-c90e-4f19-ba4f-061a32c6580d%26pd_rd_w%3DnvBsJ%26pd_rd_wg%3DMyIcq%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D0C3N9YNRN9S20RNKXVWJ%26qid%3D1753561989%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-242-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ7Q51R",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 18,
    "asin": "B0FGQ7Q51R",
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (100,32GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$410.99",
    "rating": null,
    "review_count": 410,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-16_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 410.99,
    "currency": "USD",
    "price_original": "$410.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NTgyMTEzODA5OTIxMDUxOjE3NTM1NjE5ODk6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5MjEwMjo6Mzo6&url=%2FFlash-Drive-Customizable-Thumb-4GB-128GB%2Fdp%2FB0FGPYVGFJ%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGPYVGFJ%26pd_rd_r%3Dbe585486-c90e-4f19-ba4f-061a32c6580d%26pd_rd_w%3DnvBsJ%26pd_rd_wg%3DMyIcq%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D0C3N9YNRN9S20RNKXVWJ%26qid%3D1753561989%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-243-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGPYVGFJ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 19,
    "asin": "B0FGPYVGFJ",
    "title": "Mini USB Flash Drive Customizable Tiny Thumb Drive with Your Logo 4GB-128GB - Perfect for Corporate Events, Branded Promotions, Student Projects Plug and Play, PC Mac (100,64GB)",
    "brand": "Mini",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$450.99",
    "rating": null,
    "review_count": 450,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-16_files/41Y5IinJkAL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 450.99,
    "currency": "USD",
    "price_original": "$450.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NTgyMTEzODA5OTIxMDUxOjE3NTM1NjE5ODk6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MTM0NTA2MTkwMjo6NDo6&url=%2FPortable-Memory-Storage-External-Android%2Fdp%2FB0FHWNSDWC%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FHWNSDWC%26pd_rd_r%3Dbe585486-c90e-4f19-ba4f-061a32c6580d%26pd_rd_w%3DnvBsJ%26pd_rd_wg%3DMyIcq%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D0C3N9YNRN9S20RNKXVWJ%26qid%3D1753561989%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-244-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FHWNSDWC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 20,
    "asin": "B0FHWNSDWC",
    "title": "4 in 1 Flash Drive, Portable High Speed USB 3.0 Memory Storage,External Memory Photo Keeper Storage Stick for iPhone/iPad/Android/PC (Silver,128GB)",
    "brand": 4,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$16.98",
    "rating": null,
    "review_count": 16,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-16_files/51a5hXBjjrL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.98,
    "currency": "USD",
    "price_original": "$16.98"
  },
  {
    "product_url": "https://www.amazon.com/Pre-loaded-Flash-Drive-Teaching-Interviews/dp/B00ALI6GI6/ref=sr_1_254?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-254&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B00ALI6GI6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 21,
    "asin": "B00ALI6GI6",
    "title": "Pre-loaded Flash Drive - Teaching What We Need to Learn - 46 Audio Interviews",
    "brand": "Pre-loaded",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 0,
    "capacity_category": null,
    "memory_capacity_category": null,
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": null,
    "rating": null,
    "review_count": null,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-16_files/41zD-9BR8iL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "unknown",
    "price_numeric": 0,
    "currency": null,
    "price_original": null
  },
  {
    "product_url": "https://www.amazon.com/Aiibe-Flash-Drive-Memory-Stick/dp/B07GN6CGDF/ref=sr_1_255?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-255&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07GN6CGDF",
    "blank": null,
    "affiliate_link": "https://amzn.to/3ULSv1s",
    "source_file": "drives-16.html",
    "position": 22,
    "asin": "B07GN6CGDF",
    "title": "32GB USB Flash Drive Memory Stick Thumb Drive Black",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$4.99",
    "rating": 4.5,
    "review_count": 300,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/51GavfB+HEL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 4.99,
    "currency": "USD",
    "price_original": "$4.99"
  },
  {
    "product_url": "https://www.amazon.com/TEARMOS-Intended-Compatible-Application-Required/dp/B0DZ35FMST/ref=sr_1_256?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-256&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DZ35FMST",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 23,
    "asin": "B0DZ35FMST",
    "title": "512GB Flash Drive Intended for iPhone iPad, Memory Stick Storage for Photos and Videos Backup, Compatible with iPhone iPad Android PC, Plug and Play, No Application Required (Dark Gray)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$41.99",
    "rating": 4.4,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -199,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/616IOPGnzWL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 41.99,
    "currency": "USD",
    "price_original": "$41.99"
  },
  {
    "product_url": "https://www.amazon.com/Sunany-External-Storage-Android-Devices/dp/B0BZW5L91T/ref=sr_1_257?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-257&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BZW5L91T",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 24,
    "asin": "B0BZW5L91T",
    "title": "Flash Drive 512GB Thumb Drive USB Memory Stick High Speed External Storage USB Stick Photo Stick for Phone, Pad, Android, PC and More Devices (Pink)",
    "brand": "Flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$34.39",
    "rating": 3.8,
    "review_count": 788,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/61jpxuz0f0L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.39,
    "currency": "USD",
    "price_original": "$34.39"
  },
  {
    "product_url": "https://www.amazon.com/256GB-PNY-Elite-X-Type-C-Flash/dp/B0DSLRSPS4/ref=sr_1_258?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-258&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DSLRSPS4",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 25,
    "asin": "B0DSLRSPS4",
    "title": "256GB PNY Elite-X Fit Type-C USB 3.2 Flash Drive ‚Äì Up to 200MB/s Read, Up to 100MB/s Write, Advanced Performance, Convenient Portable Data Storage, Ultra Compact Fit Design, Type-C Connector",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$23.99",
    "rating": 4.3,
    "review_count": 400,
    "special_features": "Compact",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/51qSwVIFELL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 23.99,
    "currency": "USD",
    "price_original": "$23.99"
  },
  {
    "product_url": "https://www.amazon.com/Kingston-DataTraveler-Exodia-64GB-DTX/dp/B08JD5PV9F/ref=sr_1_259?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-259&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08JD5PV9F",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 26,
    "asin": "B08JD5PV9F",
    "title": "DataTraveler Exodia 64GB USB 3.2 Flash Drive DTX/64GB",
    "brand": "DataTraveler",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$7.69",
    "rating": 4.5,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(19.4K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/414M-xDP8TL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 7.69,
    "currency": "USD",
    "price_original": "$7.69"
  },
  {
    "product_url": "https://www.amazon.com/Gulloe-Intended-Compatible-Application-Required/dp/B0DQLRX46W/ref=sr_1_260?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.HREAljKQv2PKcY7NTzu1YMx7Z19xQF84moo-tMCnCdeYrd6cKMug_U_-_RflUDnsW1n72WLjOIQqjRkVtqx-fIfLrBt4_7GTqYwqfz5Sn3M-xNosnotZ_dlNnHslfJlPNQdCdAOcD6ALhZm5BUVQSOdmxOyc5S0L8EFx9yBKviTlaiaVUwCZ_TGnkGkcAig2p_YUFl7zUjGHJxwaNO9t0Z_qZTi2NLHdw0Op6j_bpQQ.ua_oFYXfXJECwfqe80GcDIKJY6BAi7qxPSAUtpFhIXc&dib_tag=se&keywords=flash+drives&qid=1753561989&sprefix=flash+drive%2Caps%2C146&sr=8-260&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DQLRX46W",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 27,
    "asin": "B0DQLRX46W",
    "title": "512GB USB Flash Drive Intended for iPhone iPad, Memory Stick Storage for Photos and Videos Backup, Compatible with iPhone iPad Android PC, Plug and Play, No Application Required (Pink)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$37.79",
    "rating": 4.1,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -328,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/615xBuN8V1L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.79,
    "currency": "USD",
    "price_original": "$37.79"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=16&crid=BALSGJKBQE1X&qid=1753561906&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_13#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 28,
    "asin": null,
    "title": "USB Flash Drives 1GB 10 Pack, Wooolken USB 2.0 Thumb Drives with Keychains Memory Stick USB Drive Pendrive for PC Laptop Computer (Black)",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$17.95",
    "rating": 4.5,
    "review_count": 569,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -569,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/61qsQyM2VvL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 17.95,
    "currency": "USD",
    "price_original": "$17.95"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMjMyMjM2NDg0Nzc5Nzk5OjE3NTM1NjE5ODk6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyNjM4NTg1MDIwMDI6OjA6Og&url=%2FWooolken-10Pack-Keychains-Swivel-Computer%2Fdp%2FB0CXM59LNB%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CXM59LNB%26pd_rd_r%3Df1ab90a3-24f3-42d4-b381-f3afc4fff6cd%26pd_rd_w%3DeZimE%26pd_rd_wg%3DPVOWK%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D0C3N9YNRN9S20RNKXVWJ%26qid%3D1753561989%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-241-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CXM59LNB",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 29,
    "asin": "B0CXM59LNB",
    "title": "USB Flash Drives 1GB 10 Pack, Wooolken USB 2.0 Thumb Drives with Keychains Memory Stick USB Drive Pendrive for PC Laptop Computer (Black)",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$17.95",
    "rating": 4.5,
    "review_count": 569,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -569,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/61qsQyM2VvL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 17.95,
    "currency": "USD",
    "price_original": "$17.95"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMjMyMjM2NDg0Nzc5Nzk5OjE3NTM1NjE5ODk6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyNjM4NTg0OTg4MDI6OjE6Og&url=%2FDrives-Wooolken-Perfect-Weddings-Storage%2Fdp%2FB0C7CLHXLJ%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0C7CLHXLJ%26pd_rd_r%3Df1ab90a3-24f3-42d4-b381-f3afc4fff6cd%26pd_rd_w%3DeZimE%26pd_rd_wg%3DPVOWK%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D0C3N9YNRN9S20RNKXVWJ%26qid%3D1753561989%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-242-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0C7CLHXLJ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 30,
    "asin": "B0C7CLHXLJ",
    "title": "4GB Flash Drives 100 Pack, Wooolken USB 2.0 Thumb Drive with Lanyards Bulk USB Sticks for Weddings,Office, School, Data Storage Backup",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$152.99",
    "rating": 4.6,
    "review_count": 700,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/61bG6tJRBKL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 152.99,
    "currency": "USD",
    "price_original": "$152.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMjMyMjM2NDg0Nzc5Nzk5OjE3NTM1NjE5ODk6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyMzk0NzMwMDUyMDI6OjI6Og&url=%2FPortable-Keychain-External-Storage-Black%2Fdp%2FB098XCPTQ5%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB098XCPTQ5%26pd_rd_r%3Df1ab90a3-24f3-42d4-b381-f3afc4fff6cd%26pd_rd_w%3DeZimE%26pd_rd_wg%3DPVOWK%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D0C3N9YNRN9S20RNKXVWJ%26qid%3D1753561989%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-243-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B098XCPTQ5",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 31,
    "asin": "B098XCPTQ5",
    "title": "64GB USB Flash Drive Portable Metal Thumb Drive with Keychain USB 2.0 Memory Stick Pen Drive for External Data Storage, Black",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$14.23",
    "rating": 4.2,
    "review_count": 50,
    "special_features": "Metal, Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -382,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/51J9K52MhNS._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.23,
    "currency": "USD",
    "price_original": "$14.23"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMjMyMjM2NDg0Nzc5Nzk5OjE3NTM1NjE5ODk6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyMzk0NjgwOTU3MDI6OjM6Og&url=%2FCartoon-Drives-Memory-External-Storage%2Fdp%2FB0B158YW6Q%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0B158YW6Q%26pd_rd_r%3Df1ab90a3-24f3-42d4-b381-f3afc4fff6cd%26pd_rd_w%3DeZimE%26pd_rd_wg%3DPVOWK%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D0C3N9YNRN9S20RNKXVWJ%26qid%3D1753561989%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-244-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0B158YW6Q",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 32,
    "asin": "B0B158YW6Q",
    "title": "USB Flash Drive 64GB Cartoon Nurse Model USB Drive Thumb Drives USB 2.0 Memory Stick for External Data Storage, White",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$11.69",
    "rating": 4.6,
    "review_count": 319,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -319,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/517U0yywiYL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.69,
    "currency": "USD",
    "price_original": "$11.69"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxMjMyMjM2NDg0Nzc5Nzk5OjE3NTM1NjE5ODk6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjoyMDAxMDU3NTc0NTEzMTE6OjQ6Og&url=%2FCrystal-Flash-Drive-Memory-Pendrive%2Fdp%2FB07H9X55F2%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07H9X55F2%26pd_rd_r%3Df1ab90a3-24f3-42d4-b381-f3afc4fff6cd%26pd_rd_w%3DeZimE%26pd_rd_wg%3DPVOWK%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D0C3N9YNRN9S20RNKXVWJ%26qid%3D1753561989%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-245-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07H9X55F2",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-16.html",
    "position": 33,
    "asin": "B07H9X55F2",
    "title": "Rose Gold Crystal 32GB USB 2.0 Flash Drive LED Light Glass Pen Drive Thumb Drive Memory Stick Gift for Boy Girls Kids Adults Pendrive USB Stick",
    "brand": "Rose",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$11.71",
    "rating": 4,
    "review_count": 828,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -828,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-16_files/31zu5qakS4L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.71,
    "currency": "USD",
    "price_original": "$11.71"
  },
  {
    "product_url": "https://www.amazon.com/Drives-Keychains-Wooolken-Swivel-Memory/dp/B0D5CHC4NY/ref=sr_1_259?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-259&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D5CHC4NY",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 1,
    "asin": "B0D5CHC4NY",
    "title": "Flash Drives 128MB 20 Pack with Keychains, Swivel USB 2.0 Thumb Drives Bulk USB Drive Memory Stick USB Stick Pack (Black)",
    "brand": "Flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$24.99",
    "rating": 4.5,
    "review_count": 569,
    "special_features": "Keychain, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "11 sizes11 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/71Aw2AB2hQL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "mb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/ThePhotoStick%C2%AE-Flash-Drive-Memory-Stick/dp/B0BDT2N5XD/ref=sr_1_260?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-260&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BDT2N5XD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 2,
    "asin": "B0BDT2N5XD",
    "title": "Omni 64GB USB Flash Drive & Memory Stick ‚Äì Photo & Video Backup for iPhone, Android, Mac & PC ‚Äì Multiport Connection to Easily Store & Transfer Files",
    "brand": "Omni",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$54.99",
    "rating": 3.9,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -901,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/71nLPjDU0gL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 54.99,
    "currency": "USD",
    "price_original": "$54.99"
  },
  {
    "product_url": "https://www.amazon.com/KOOTION-Drives-2-Pack-Swivel-Storage/dp/B0DK1FVPZR/ref=sr_1_261?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-261&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DK1FVPZR",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 3,
    "asin": "B0DK1FVPZR",
    "title": "128GB USB Flash Drives 2-Pack, Jump Drive 2.0 USB Drive 128 GB Thumb Drive Swivel Memory Stick for Storage and Backup (2 Colors: Blue Black)",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$13.29",
    "rating": 4,
    "review_count": 46,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -46,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/51rgZFkLM5L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 13.29,
    "currency": "USD",
    "price_original": "$13.29"
  },
  {
    "product_url": "https://www.amazon.com/Micro-Center-SuperSpeed-Storage-Android/dp/B0FDXQK752/ref=sr_1_262?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-262&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0FDXQK752",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 4,
    "asin": "B0FDXQK752",
    "title": "SuperSpeed 128GB 3 Pack USB 3.2 Gen 1 Dual Drive Type-C & OTG Type-A 2-in-1 up to 200MB/s Swivel Metal Flash Drive Memory Storage Stick for Android Phones Tablets Mac Laptop",
    "brand": "SuperSpeed",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$39.99",
    "rating": 4,
    "review_count": 16,
    "special_features": "Metal, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -16,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/61moLpTP+sL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 39.99,
    "currency": "USD",
    "price_original": "$39.99"
  },
  {
    "product_url": "https://www.amazon.com/SCICNCE-Intended-Compatible-Application-Required/dp/B0DNRC1TWL/ref=sr_1_263?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-263&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DNRC1TWL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 5,
    "asin": "B0DNRC1TWL",
    "title": "512GB Flash Drive Intended for iPhone iPad, Memory Stick Storage for Photos and Videos Backup, Compatible with iPhone iPad Android PC, Plug and Play, No Application Required (Rose Gold)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$31.26",
    "rating": 4.3,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/615At0DMx7L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 31.26,
    "currency": "USD",
    "price_original": "$31.26"
  },
  {
    "product_url": "https://www.amazon.com/Gulloe-Intended-Application-Required-Compatible/dp/B0F2ZCXRJ6/ref=sr_1_264?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-264&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0F2ZCXRJ6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 6,
    "asin": "B0F2ZCXRJ6",
    "title": "512GB Flash Drive Intended for iPhone, Plug and Play, No Application Required, Memory Stick Storage for Photos and Videos Backup, Compatible with iPhone iPad Android PC (Dark Grey)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$41.99",
    "rating": 4.3,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -91,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/61msfT8IvNL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 41.99,
    "currency": "USD",
    "price_original": "$41.99"
  },
  {
    "product_url": "https://www.amazon.com/256GB-Flash-Drive-Outlet-Module/dp/B0CJFYF6VG/ref=sr_1_265?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-265&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CJFYF6VG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 7,
    "asin": "B0CJFYF6VG",
    "title": "256GB USB Flash Drive & Outlet Wall Mount for Blink Sync Module 2 with Short Cable - Save Space - No Messy Wires - Easy Move Mount Bracket Holder for Blink Outdoor Indoor Security Camera (1 Pack)",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.5,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/51-ZBjmITLL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/SUMK-DashCam-Rotation-Protection-Compatible/dp/B0C48R76TK/ref=sr_1_266?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-266&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0C48R76TK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 8,
    "asin": "B0C48R76TK",
    "title": "3.2 USB Flash Drive for Tesla Model 3/Y/S/X, [Universal Model] 128GB, 200MB/S Memory Stick Compatible for Car Audio System & Dashcam Sentry Mode, Laptop, Tablet, Smart TV and Gaming Console",
    "brand": 3.2,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$26.99",
    "rating": 4.1,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -967,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/61wTBoP6fRL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 26.99,
    "currency": "USD",
    "price_original": "$26.99"
  },
  {
    "product_url": "https://www.amazon.com/EASTBULL-Drives-Adapter-Storage-Lanyards/dp/B0DYJML9V9/ref=sr_1_269?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-269&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DYJML9V9",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 9,
    "asin": "B0DYJML9V9",
    "title": "4GB Small Flash Drives 5 Pack USB2.0 Mini USB Drive with a USB-C Adapter, FAT32 Mini Thumb Drive 4 GB 5 Pack for Data Storage (Black, 1 Adapter, Lanyards)",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$10.34",
    "rating": 4.5,
    "review_count": 100,
    "special_features": "Lanyard, Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/61ezXFsV44L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 10.34,
    "currency": "USD",
    "price_original": "$10.34"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=17&crid=BALSGJKBQE1X&qid=1753561906&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_13#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 10,
    "asin": null,
    "title": "USB Flash Drive 64GB 10 Pack USB 3.0 Thumb Drives Value 64 GB Memory Sticks Mixed Colors Pendrive Portable 64 Giga Jump Drive Bulk Swivel 10 Pieces Zip Drives for Data Storage and Backup",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$49.99",
    "rating": 4.2,
    "review_count": 150,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -150,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/71lFJZly-9L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 49.99,
    "currency": "USD",
    "price_original": "$49.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2ODAzMjgzMDUxNzY1MzgyOjE3NTM1NjIwMDk6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDEzODc5NzYzODMwMjo6MDo6&url=%2FDrives-Kepmem-Pendrive-Portable-Storage%2Fdp%2FB09D3NPJBN%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB09D3NPJBN%26pd_rd_r%3D147442ec-8f6a-4572-9b0a-e738ac98341e%26pd_rd_w%3DvjJRH%26pd_rd_wg%3D2cXrE%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DGK0P2Z4R1VGYJX17VS0M%26qid%3D1753562008%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-257-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B09D3NPJBN",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 11,
    "asin": "B09D3NPJBN",
    "title": "USB Flash Drive 64GB 10 Pack USB 3.0 Thumb Drives Value 64 GB Memory Sticks Mixed Colors Pendrive Portable 64 Giga Jump Drive Bulk Swivel 10 Pieces Zip Drives for Data Storage and Backup",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$49.99",
    "rating": 4.2,
    "review_count": 150,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -150,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/71lFJZly-9L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 49.99,
    "currency": "USD",
    "price_original": "$49.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2ODAzMjgzMDUxNzY1MzgyOjE3NTM1NjIwMDk6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1MDc2MTg5ODQwMjo6Mjo6&url=%2FCertified-External-Storage-Android-PC%25EF%25BC%2588Pink%25EF%25BC%2589%2Fdp%2FB0FHHQM7H8%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FHHQM7H8%26pd_rd_r%3D147442ec-8f6a-4572-9b0a-e738ac98341e%26pd_rd_w%3DvjJRH%26pd_rd_wg%3D2cXrE%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DGK0P2Z4R1VGYJX17VS0M%26qid%3D1753562008%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-259-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FHHQM7H8",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 12,
    "asin": "B0FHHQM7H8",
    "title": "MFi Certified Flash Drive 256GB for iPhone USB Memory Stick Thumb Drives High Speed USB Stick,Photo Stick External Storage for iPhone/iPad/Android/PCÔºàPinkÔºâ",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$49.99",
    "rating": 4.2,
    "review_count": 6,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(6.3K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/61Gbr9fHehL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 49.99,
    "currency": "USD",
    "price_original": "$49.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2ODAzMjgzMDUxNzY1MzgyOjE3NTM1NjIwMDk6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDU4MjUxNjY0NzAwMjo6Mzo6&url=%2FDrives-TATMOHIK-Swivel-Design-Indicator%2Fdp%2FB0CQ43V98G%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CQ43V98G%26pd_rd_r%3D147442ec-8f6a-4572-9b0a-e738ac98341e%26pd_rd_w%3DvjJRH%26pd_rd_wg%3D2cXrE%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DGK0P2Z4R1VGYJX17VS0M%26qid%3D1753562008%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-260-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CQ43V98G",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 13,
    "asin": "B0CQ43V98G",
    "title": "Bulk USB Flash Drive 4GB 20 Pack TATMOHIK USB2.0 Flash Drives Pack Thumb Drive Swivel USB Drive Pack Memory Sticks Jump Drives Pen Drive, Muticolor, 4 GB, 20 Pieces",
    "brand": "Bulk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$37.99",
    "rating": 4.6,
    "review_count": 102,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -102,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/81Ara6Oe8WL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.99,
    "currency": "USD",
    "price_original": "$37.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2ODAzMjgzMDUxNzY1MzgyOjE3NTM1NjIwMDk6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDAxNDE3OTU4NDAzMTo6NDo6&url=%2FKALSAN-Drives-Flash-Memory-Stick-Blue%2Fdp%2FB07K14G3R5%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07K14G3R5%26pd_rd_r%3D147442ec-8f6a-4572-9b0a-e738ac98341e%26pd_rd_w%3DvjJRH%26pd_rd_wg%3D2cXrE%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DGK0P2Z4R1VGYJX17VS0M%26qid%3D1753562008%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-261-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07K14G3R5",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 14,
    "asin": "B07K14G3R5",
    "title": "100 Pack 16GB USB Flash Drives - Bulk USB 2.0 Memory Stick - Blue",
    "brand": 100,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$222.98",
    "rating": 4.4,
    "review_count": 405,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -405,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-17_files/618AvyiWNrL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 222.98,
    "currency": "USD",
    "price_original": "$222.98"
  },
  {
    "product_url": "https://www.amazon.com/MOVE-SPEED-Pendrive-Compatible-Android/dp/B0DP9N3X9P/ref=sr_1_270?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-270&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DP9N3X9P",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 15,
    "asin": "B0DP9N3X9P",
    "title": "128GB Memory Stick, 130 MB/s Thumb Drive with Type-C + USB 3.2 Dual Port, High Speed Pendrive Compatible with 3.1/3.0/2.0 for iPhone 16/15 Series, Android, MacBook/Pro/Air(1 Pack)",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.5,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/616aRghZ3CL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/MOVE-SPEED-Interface-Keychain-Leather/dp/B0CF2FZJ95/ref=sr_1_271?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-271&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CF2FZJ95",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 16,
    "asin": "B0CF2FZJ95",
    "title": "256GB Thumb Drive, 1000MB/s Read Write Speed, USB 3.2 Gen2+Type C Dual Interface SSD Drive with Leather Case Memory Stick for iPhone 15, 16 Series/MacBook/Android/Audio etc(1 Pack)",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$44.99",
    "rating": 4.4,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -393,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/51iC9ZixLfL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 44.99,
    "currency": "USD",
    "price_original": "$44.99"
  },
  {
    "product_url": "https://www.amazon.com/Flash-EASTBULL-Swivel-Memory-Storage/dp/B07W54X2F3/ref=sr_1_272?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-272&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07W54X2F3",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 17,
    "asin": "B07W54X2F3",
    "title": "1GB USB Flash Drive 1PCS EASTBULL USB 2.0 Thumb Drive Swivel USB Stick Bulk Gig Stick Memory Stick Metal Thumb Drives (Black)",
    "brand": "1GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$5.59",
    "rating": 4.5,
    "review_count": 200,
    "special_features": "Metal, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/51+QakzcftL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 5.59,
    "currency": "USD",
    "price_original": "$5.59"
  },
  {
    "product_url": "https://www.amazon.com/Kepmem-Portable-Keychain-Colorful-Multipack/dp/B09D3R4C2Z/ref=sr_1_273?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-273&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09D3R4C2Z",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 18,
    "asin": "B09D3R4C2Z",
    "title": "Swivel Pen Drive 8GB USB 3.0 Memory Stick Pack of 10, Colorful Multipack Zip Drives for Data Storage",
    "brand": "Swivel",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 4.2,
    "review_count": 50,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -150,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/71lFJZly-9L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": "https://www.amazon.com/Computer-Laptop-Indicator-External-Storage/dp/B0DH23X1DS/ref=sr_1_274?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-274&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DH23X1DS",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 19,
    "asin": "B0DH23X1DS",
    "title": "Flash Drive 64GB for Computer/Laptop,USB 2.0 Memory Stick with Led Indicator, Thumb Drives High Speed USB Stick,Photo Stick External Storage for PC(Black",
    "brand": "Flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$5.50",
    "rating": 4.5,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/61PmV1hKBRL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 5.5,
    "currency": "USD",
    "price_original": "$5.50"
  },
  {
    "product_url": "https://www.amazon.com/THKAILAR-Thunderbolt-Tablet-MacBook-Smartphones/dp/B08L5Z31JY/ref=sr_1_275?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-275&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08L5Z31JY",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 20,
    "asin": "B08L5Z31JY",
    "title": "512GB Flash Drive 2 in 1 USB Flash Drive with Type C & Type A Ports,Thumb Drive,USB Stick for Android Phone/Tablet/PC/MacBook Pro/Air",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$36.99",
    "rating": 4.3,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/61CmLPmIoyL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 36.99,
    "currency": "USD",
    "price_original": "$36.99"
  },
  {
    "product_url": "https://www.amazon.com/Zealearn-Organizer-Storage-Compatible-Samsung/dp/B0CYQDLNZ2/ref=sr_1_276?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.aDpw4LYCpKAeGTcm1pniw8qyp0Xe-KxHziu8v3J3gUuhliXe1w-IvtpcUp3ZhUbhcCu0qiNgyLZ8_hBaFcPPXG0VwUMqbwxNgjHvURIGpIyMAaot0mZARVnv8ksD-ek6X1SrySSvsvl8ZQlY3U2voaeazwih36ukNLTHUIkiRTt3Hu_0ZBGjw4RFS7hA-vcVL7QS2zvDB_7RWCc0gf8cNmyplYauMHYvc35Jw0SQuC0.A86e0bqF32MNPUa-sNEaG3ZZxf_nvANkdKxah5JYOi0&dib_tag=se&keywords=flash+drives&qid=1753562008&sprefix=flash+drive%2Caps%2C146&sr=8-276&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CYQDLNZ2",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 21,
    "asin": "B0CYQDLNZ2",
    "title": "USB Flash Drive Case with Labels, Gifts for Men, USBs Case Organizer Holds 30 Pcs, USBs Storage Cases, USB Sticks Holder, Thumb Drive Cases, Fits for Samsung/Sandisk/Jump Drive, etc, Black",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 0,
    "capacity_category": null,
    "memory_capacity_category": null,
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$15.99",
    "rating": 4.7,
    "review_count": 300,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -248,
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/81g0mIpi2fL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "unknown",
    "price_numeric": 15.99,
    "currency": "USD",
    "price_original": "$15.99"
  },
  {
    "product_url": "https://aax-us-iad.amazon.com/x/c/JFuvrXZq7p5mP2Us7byOuloAAAGYSHDOYgEAAAH2AQBvbm9fdHhuX2JpZDMgICBvbm9fdHhuX2ltcDEgICBjajSk/clv1c_ek-YwQfSLcbCDdnOWU0Q7MCssz5PcuiE_5aKEFelT0xVx_JjyaF3D6gEPoGaWIjbfWzm6BtqV1zZupFd_loUmA9Z-kGCYv6T31GFi95guMQs-BxFcdixDGnl-20_TYuYXUBeGpisZaycD5MLCFZm-trZpH2HdpVJkA30wzKwzCFPmMg_XW8NzkSqQXF3_gGjuwgVTsDNtox7gpJSWIFAq3j-EZTn7gh9nu2PgnX4VGBFOtHvjkVcEZUkDSaxw8Q_vWA-yy1FjYGGr5NiVhrbjl25VpCY2dyh_KX2CG5dl9Zm0qQvmkpRi0r0yuqGNBSMBRA1snIgtnkUqBUhQHxEdGcuLklsG6jGjcW51tFG3Qp0q7BZAqwfTHHrXv9US1QOrc6wEgVEdDK4Y5Jy2V5sM5Av1v5HfH0z9tD6rQwyS69x-qV2zOQ8BC_FwVgBuVNcjdHFVTSG1z01uFCmyTZkyOilLKR_ZSGhfYJTYchxQvdnK15Cdeh0KuHoiTFVri5u7FwQ3dCXRzTyQcOTE6SegS0Aght5TpnKHqnfRTc9qTRXIH_zAnS9FKuhlg9T5SQP7R1Fn_3yX7En4lWwCrNVRT3CxwbbEC7K2bxo7GYbkzyJpcb2fqgvPNsWix3kszT9-kxuMR5W1d6hz9qwxO28yzFoA6H1x8Urcf5KKX_u-tzNiCfSMsMdTsN8RJM6ViPyuZ5FjgTqaEty6u50FXqkarP1gGXTPYw64g99mZJXiRg7thGBO9xju2NB1WomuCjlKwsQTTUCd-OFnNdtHMmsGTUi5wQ3SbnL7kr5yGJGbqpq-A4jA_7ME01hHULN-sd_szH6dSQqMRaB-8j433oZWCF2R6zNV5RggQFwhRm_h_TR-tCqtP5k5CZ50HvAJhLcGtJcoMnhVwBYJ_LwMIdiA5mHi4wu6lszIbobDt5N2rVPCKPBie-GHNwA3M6oBbXREC2kYQgrNDH3VDCaCus/https://www.amazon.com/dp/B0998WHY69?pd_rd_i=B0998WHY69&pf_rd_p=2c8e5d59-6279-4999-832d-be45d1ca8e79&pf_rd_r=GK0P2Z4R1VGYJX17VS0M&pd_rd_wg=XCy9X&pd_rd_w=1c45j&pd_rd_r=790ecac2-348e-4832-9ca2-512a4d90ad61",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-17.html",
    "position": 22,
    "asin": null,
    "title": "Vansuny 64GB Flash Drive Metal Waterproof USB Drive USB 3.0 Ultra High Speed Memory Stick, Portable Thumb Drive for PC/Tablets/Mac/Laptop",
    "brand": "Vansuny",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$7.99",
    "rating": 4.5,
    "review_count": 300,
    "special_features": "Waterproof, Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.2K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-17_files/41gl+3RV10L._AC_UL640_QL65_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 7.99,
    "currency": "USD",
    "price_original": "$7.99"
  },
  {
    "product_url": "https://www.amazon.com/Bilious-Space-Rabbit-Waterproof-Memory/dp/B0BGC3TR48/ref=sr_1_275?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-275&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BGC3TR48",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 1,
    "asin": "B0BGC3TR48",
    "title": "Cute Space Rabbit USB Flash Drive, Thumb Drive Waterproof USB 2.0 Memory Stick Small Size USB Drive Gift (128G, Cyan)",
    "brand": "Cute",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 0,
    "capacity_category": null,
    "memory_capacity_category": null,
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$13.99",
    "rating": 4.7,
    "review_count": 50,
    "special_features": "Waterproof",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/61rwBABqPBL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "unknown",
    "price_numeric": 13.99,
    "currency": "USD",
    "price_original": "$13.99"
  },
  {
    "product_url": "https://www.amazon.com/PNY-External-Compatible-Smartphone-Desktops/dp/B0FC3SFQLH/ref=sr_1_276?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-276&ufe=app_do%3Aamzn1.fos.9fe8cbfa-bf43-43d1-a707-3f4e65a4b666&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0FC3SFQLH",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 2,
    "asin": "B0FC3SFQLH",
    "title": "2TB Duo Link V3 USB 3.2 Gen 2 Type-C & Type-A OTG Flash Drive Extreme Speeds Read/Write 1000/800MB/s External Mobile Storage Compatible with Smartphone/Tablet/Laptops/Desktops",
    "brand": "2TB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 2",
    "memory_type": "USB",
    "price": "$158.28",
    "rating": 4.8,
    "review_count": 7,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/41xA9yrYeFL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "tb",
    "price_numeric": 158.28,
    "currency": "USD",
    "price_original": "$158.28"
  },
  {
    "product_url": "https://www.amazon.com/Verbatim-128GB-Pinstripe-Flash-Drive/dp/B009GX7D0M/ref=sr_1_277?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-277&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B009GX7D0M",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 3,
    "asin": "B009GX7D0M",
    "title": "128GB PinStripe Retractable USB 2.0 Flash Thumb Drive with Microban Antimicrobial Product Protection ‚Äì Black",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$17.99",
    "rating": 4.3,
    "review_count": 50,
    "special_features": "Retractable",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/71NKKEKkkyL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 17.99,
    "currency": "USD",
    "price_original": "$17.99"
  },
  {
    "product_url": "https://www.amazon.com/StarTech-com-Standalone-Duplicator-Multiple-USBDUPE115/dp/B076J1337Z/ref=sr_1_278?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-278&ufe=app_do%3Aamzn1.fos.5998aa40-ec6f-4947-a68f-cd087fee0848&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B076J1337Z",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 4,
    "asin": "B076J1337Z",
    "title": "StarTech.com Standalone 1 to 15 USB Flash Drive Duplicator/Cloner/Eraser, Multiple USB Thumb Drive Copier / Sanitizer, System File / Sector-by-Sector Copy, 1.5 GB/min, 3-Pass Erase, LCD, TAA",
    "brand": "StarTech.com",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 5000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$1,013.99",
    "rating": 4.4,
    "review_count": 354,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -354,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "No",
    "image_url": "./drives-18_files/61T+OlJelOL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 1,
    "currency": "USD",
    "price_original": "$1,013.99"
  },
  {
    "product_url": "https://www.amazon.com/AGECASH-Drives-Swivel-Pendrive-Lanyards/dp/B0CBK24XC4/ref=sr_1_279?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-279&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CBK24XC4",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 5,
    "asin": "B0CBK24XC4",
    "title": "Thumb Drive 2GB USB Flash Drives 20 Pack AGECASH A USB 2.0 Memory Stick Jump Drives Zip Drive Flashdrive Pendrive for Data Storage & Transfer with 20PCS Lanyard (Multi-Colored 2GB)",
    "brand": "Thumb",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$34.04",
    "rating": 4.6,
    "review_count": 50,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/81xaaPBewUL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.04,
    "currency": "USD",
    "price_original": "$34.04"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Cruzer-Glide-Flash-SDCZ60-032G/dp/B00XJXYONO/ref=sr_1_280?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-280&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B00XJXYONO",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 6,
    "asin": "B00XJXYONO",
    "title": "Cruzer Glide 32GB (5 Pack) USB 2.0 Flash Drive (SDCZ60-032G) Pen Drive Bundle with (2) Everything But Stromboli Lanyards",
    "brand": "Cruzer",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "SD",
    "price": "$27.30",
    "rating": 4.7,
    "review_count": 100,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -306,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "No",
    "image_url": "./drives-18_files/71cu166QMVL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 27.3,
    "currency": "USD",
    "price_original": "$27.30"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Ultra-Flair-128GB-Performance/dp/B01CYWK4CU/ref=sr_1_281?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-281&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B01CYWK4CU",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 7,
    "asin": "B01CYWK4CU",
    "title": "Ultra Flair USB (5 Pack) 3.0 128GB Flash Drive High Performance up to 150MB/s - with (2) Everything But Stromboli (tm) Lanyard",
    "brand": "Ultra",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$62.26",
    "rating": 4.6,
    "review_count": 437,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "No",
    "image_url": "./drives-18_files/81BleiVE8NL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 62.26,
    "currency": "USD",
    "price_original": "$62.26"
  },
  {
    "product_url": "https://www.amazon.com/ThePhotoStick-Omni-128GB-Backup-Devices/dp/B09GW86W6Y/ref=sr_1_282?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-282&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09GW86W6Y",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 8,
    "asin": "B09GW86W6Y",
    "title": "Omni 128GB USB Flash Drive & Memory Stick ‚Äì Photo & Video Backup for iPhone, Android, Mac & PC ‚Äì Multiport Connection to Easily Store & Transfer Files",
    "brand": "Omni",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$79.99",
    "rating": 3.8,
    "review_count": 3,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(7.2K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/71PcbjUbyXL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 79.99,
    "currency": "USD",
    "price_original": "$79.99"
  },
  {
    "product_url": "https://www.amazon.com/Possibox-Flash-USB3-0-Writable-Memory/dp/B0D1K63KZQ/ref=sr_1_285?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-285&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D1K63KZQ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 9,
    "asin": "B0D1K63KZQ",
    "title": "Type C&USB A 2-in-1 USB Flash Drive 64GB High Speed USB3.0 Writable Dual Memory Stick 5 Pack",
    "brand": "Type",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$39.90",
    "rating": 4.4,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -68,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/61ApecTpuTL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 39.9,
    "currency": "USD",
    "price_original": "$39.90"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=18&crid=BALSGJKBQE1X&qid=1753561906&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_13#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 10,
    "asin": null,
    "title": "256GB Pinstripe USB 3.2 Gen 1 Flash Drive Retractable Thumb Drive - Black",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$20.68",
    "rating": 4.4,
    "review_count": 4,
    "special_features": "Retractable",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.7K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/61jFTnoNhSS._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.68,
    "currency": "USD",
    "price_original": "$20.68"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1Njk3MjA1OTA5ODM4NzE0OjE3NTM1NjIwMzY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDI4OTc1ODI4OTMwMjo6MDo6&url=%2F256GB-Pinstripe-USB-Flash-Drive%2Fdp%2FB01DWNMGJY%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB01DWNMGJY%26pd_rd_r%3Da201c237-9b41-4197-be7c-dc4d1f781277%26pd_rd_w%3DSCAI7%26pd_rd_wg%3DYPKnb%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D59P3HH17KPWJNPZY8VEZ%26qid%3D1753562036%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-273-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B01DWNMGJY",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 11,
    "asin": "B01DWNMGJY",
    "title": "256GB Pinstripe USB 3.2 Gen 1 Flash Drive Retractable Thumb Drive - Black",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$20.68",
    "rating": 4.4,
    "review_count": 4,
    "special_features": "Retractable",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.7K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/61jFTnoNhSS._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.68,
    "currency": "USD",
    "price_original": "$20.68"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1Njk3MjA1OTA5ODM4NzE0OjE3NTM1NjIwMzY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDgzMTkyNzgzNDgwMjo6MTo6&url=%2FJOIOT-Portable-Type-C-Smartphone-Computer%2Fdp%2FB0FC1J4YJX%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FC1J4YJX%26pd_rd_r%3Da201c237-9b41-4197-be7c-dc4d1f781277%26pd_rd_w%3DSCAI7%26pd_rd_wg%3DYPKnb%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D59P3HH17KPWJNPZY8VEZ%26qid%3D1753562036%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-274-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FC1J4YJX",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 12,
    "asin": "B0FC1J4YJX",
    "title": "512GB USB C Flash Drive Dual USB 3.0 Flash Drive Type C + USB A Portable Type-C Flash Drive 2-in-1 USB-C Thumb Drive for Smartphone Tablet Computer Mac iPhone 16 Black",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$49.39",
    "rating": 4.4,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -946,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/51+i7bh+4rL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 49.39,
    "currency": "USD",
    "price_original": "$49.39"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1Njk3MjA1OTA5ODM4NzE0OjE3NTM1NjIwMzY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDA2MTQ3MzQ3MzMwMjo6Mjo6&url=%2FGigastone-Capless-Retractable-Interface-Compatible%2Fdp%2FB09KZFLRDK%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB09KZFLRDK%26pd_rd_r%3Da201c237-9b41-4197-be7c-dc4d1f781277%26pd_rd_w%3DSCAI7%26pd_rd_wg%3DYPKnb%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D59P3HH17KPWJNPZY8VEZ%26qid%3D1753562036%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-275-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1%26smid%3DA2SFGDK0SQGMP8",
    "product_link": "https://www.amazon.com/dp/B09KZFLRDK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 13,
    "asin": "B09KZFLRDK",
    "title": "128GB Flash Drive (5 Pack) Z60 USB 3.2 Gen 1, 120MB/s Ultra Fast, Retractable Capless Slider Design, Data Storage, Backup for PC/Mac/TV/Car Audio, USB 2.0/3.0/3.1 Compatible",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$59.99",
    "rating": 4,
    "review_count": 82,
    "special_features": "Retractable, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -82,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/41OkehdiYhL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 59.99,
    "currency": "USD",
    "price_original": "$59.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1Njk3MjA1OTA5ODM4NzE0OjE3NTM1NjIwMzY6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDAwOTI1MzY5Mzc3MTo6Mzo6&url=%2FVICFUN-Flash-Drives-Memory-USB2-0-Black%2Fdp%2FB07K5B829J%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07K5B829J%26pd_rd_r%3Da201c237-9b41-4197-be7c-dc4d1f781277%26pd_rd_w%3DSCAI7%26pd_rd_wg%3DYPKnb%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D59P3HH17KPWJNPZY8VEZ%26qid%3D1753562036%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-276-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07K5B829J",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 14,
    "asin": "B07K5B829J",
    "title": "20 Pack 16GB USB Flash Drives Bulk 16GB Flash Drive 20 Pack USB Memory Stick 16GB USB 2.0-Black",
    "brand": 20,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$51.99",
    "rating": 4.6,
    "review_count": 2,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2.6K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/71EQH+PQoqL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 51.99,
    "currency": "USD",
    "price_original": "$51.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1Njk3MjA1OTA5ODM4NzE0OjE3NTM1NjIwMzY6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDEzNTM2MDMyMTE5ODo6NDo6&url=%2FGIGASTONE-64GB-Keychain-Push-Pull-Compatible%2Fdp%2FB09V15VCJ4%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB09V15VCJ4%26pd_rd_r%3Da201c237-9b41-4197-be7c-dc4d1f781277%26pd_rd_w%3DSCAI7%26pd_rd_wg%3DYPKnb%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D59P3HH17KPWJNPZY8VEZ%26qid%3D1753562036%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-277-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B09V15VCJ4",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 15,
    "asin": "B09V15VCJ4",
    "title": "64GB Flash Drive (2 Pack) Z30 USB 3.2 Gen 1, 80MB/s Ultra Fast, Keychain Loop, Carbon Fiber Style, Push-Pull Design, Data Storage, Backup for PC/Mac/TV/Car, USB 2.0/3.0/3.1 Compatible",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$16.99",
    "rating": 4.3,
    "review_count": 107,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -107,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/51SfSBZepgL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.99,
    "currency": "USD",
    "price_original": "$16.99"
  },
  {
    "product_url": "https://www.amazon.com/Bilious-Animal-Waterproof-Cartoon-Memory/dp/B0B9FWMWSH/ref=sr_1_286?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-286&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0B9FWMWSH",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 16,
    "asin": "B0B9FWMWSH",
    "title": "64GB Flash Drive Animal Series Waterproof USB 3.0 Thumb Drive Cute Cartoon Memory Stick Small Size USB Drive Gift",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$9.99",
    "rating": 4.4,
    "review_count": 154,
    "special_features": "Waterproof",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/610w874hPbL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 9.99,
    "currency": "USD",
    "price_original": "$9.99"
  },
  {
    "product_url": "https://www.amazon.com/AUAMOZ-Intended-Compatible-Application-Required/dp/B0F8JZFGZL/ref=sr_1_287?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-287&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0F8JZFGZL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 17,
    "asin": "B0F8JZFGZL",
    "title": "512GB Flash Drive Intended for iPhone, Memory Stick Storage Files Photos Videos Backup, Compatible with iPhone iPad Android PC, Plug and Play, No Application Required (Metal Silver)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$52.49",
    "rating": 4.5,
    "review_count": 100,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -35,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/61uWct3lQQL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 52.49,
    "currency": "USD",
    "price_original": "$52.49"
  },
  {
    "product_url": "https://www.amazon.com/PNY-Attache-Everything-Stromboli-P-FD64GTBOP-GE/dp/B0822YXY1Y/ref=sr_1_288?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-288&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0822YXY1Y",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 18,
    "asin": "B0822YXY1Y",
    "title": "64GB USB 3.0 Flash Drive Turbo Attache 3 (50 Pack Bulk) Thumb Drives Bundle with (25) Everything But Stromboli Lanyard (P-FD64GTBOP-GE)",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$278.01",
    "rating": 5,
    "review_count": 1,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -1,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "No",
    "image_url": "./drives-18_files/911dc-OvjQL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 278.01,
    "currency": "USD",
    "price_original": "$278.01"
  },
  {
    "product_url": "https://www.amazon.com/ClearClick-Flash-Drives-Compatibility-6-Pack/dp/B0DJTL4Q6R/ref=sr_1_289?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-289&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DJTL4Q6R",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 19,
    "asin": "B0DJTL4Q6R",
    "title": "64GB USB 3.2 Flash Drives with USB-A and USB-C Compatibility (6-Pack)",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$49.95",
    "rating": 4.5,
    "review_count": 32,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -32,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "No",
    "image_url": "./drives-18_files/61QhMhvK4tL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 49.95,
    "currency": "USD",
    "price_original": "$49.95"
  },
  {
    "product_url": "https://www.amazon.com/lcwamy-USB3-0-Flash-Drive-Drives/dp/B0DNCGH7BH/ref=sr_1_290?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-290&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DNCGH7BH",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 20,
    "asin": "B0DNCGH7BH",
    "title": "16GB Flash Drive USB3.0 USB Drive 16GB USB Flash Drive USB Stick Thumb Drive Black Metal Mini Flash Drive",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$5.99",
    "rating": 4.7,
    "review_count": 50,
    "special_features": "Metal, Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "15 sizes15 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/61N4W5xWm7L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 5.99,
    "currency": "USD",
    "price_original": "$5.99"
  },
  {
    "product_url": "https://www.amazon.com/AreTop-Portable-Android-Smartphone-Computers/dp/B0DNQGDRP6/ref=sr_1_291?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-291&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DNQGDRP6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 21,
    "asin": "B0DNQGDRP6",
    "title": "4GB USB C Thumb Drive Dual USB 2.0 Flash Drive 4GB USB Drive Swivel Design 2-in-1 Portable Type-C Memory Stick for Android Smartphone, Computers, MacBook, Tablets, PC, 5 Pack",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$17.93",
    "rating": 4.6,
    "review_count": 41,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-18_files/71TTwtrbr6L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 17.93,
    "currency": "USD",
    "price_original": "$17.93"
  },
  {
    "product_url": "https://www.amazon.com/Attach%C3%A9-Multi-Colored-Flash-Drive-60-Pack/dp/B0F22RSYS7/ref=sr_1_292?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Cu6bUyPAI0UcoDPKxfRO86-OTPrQVkm17u6DZg0IYHTMjhqNogpMQrb05aXm-FsqJXybLmN05XubKTMHqmyXl-EODeuIAaSIQpv4NWVx8Jo_M9eT9yP_A49PlOH3hyoNGh7cthOeejkOBcCwuV3Uuq7Qbs0IXL-0Ta6V1cY0jI4ZjKLd0LCVdviXitEi-V3MUG5vecTmL-4vM7KgRTcjMWupbmp6NlRMF9LrLFCSyZQ.5hIiKnnlpsfKNa0Ehx89_-A4bmwGAIrRuL_xKzD2Lzc&dib_tag=se&keywords=flash+drives&qid=1753562036&sprefix=flash+drive%2Caps%2C146&sr=8-292&ufe=app_do%3Aamzn1.fos.9fe8cbfa-bf43-43d1-a707-3f4e65a4b666&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0F22RSYS7",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-18.html",
    "position": 22,
    "asin": "B0F22RSYS7",
    "title": "16GB Attach√© 4 USB 2.0 Multi-Colored Flash Drive 60-Pack - Durable Reliable Portable Storage to Store and Transfer Data",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$146.01",
    "rating": 4.5,
    "review_count": 231,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "No",
    "image_url": "./drives-18_files/61adZm9boRL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 146.01,
    "currency": "USD",
    "price_original": "$146.01"
  },
  {
    "product_url": "https://www.amazon.com/fanxiang-512GB-External-Android-Windows/dp/B0DDKZR41D/ref=sr_1_291?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.4UOmLVfzEoRBwRBhyvcQfmuN5E3lfV0ya6zIz5db-y6F5Y4XJEsj6X-8qorNl3Dv-Zh-zMCkIQov9Vs3DZqaL6RtgcPoGWIuX6kqOBLbmtnVGI2BSCdb6yn3JCaUcbwC-ef9-OknBqO1-hJ_wIOzcIp9OpiMR_tQHYLImcVaf78tPnXACN5xVtzPfmpeXWnnZv94vU0z1Kf1S-Tw5nDI4QirdSOgp9_Xkv_GZLIZGYk.nS994TcRI2mvmVsTdKOvf-m9ICS-v0iO-axJMIiqGTA&dib_tag=se&keywords=flash+drives&qid=1753562053&sprefix=flash+drive%2Caps%2C146&sr=8-291&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DDKZR41D",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 1,
    "asin": "B0DDKZR41D",
    "title": "512GB Fast External SSD Flash Drive Up to 2000MB/s USB3.2 Gen2, 2-in-1 Dual USB A +Type-C Drive, USB Memory Stick Solid State Thumb Drive for iPhone 15/16/Android/Windows/MacPC/Laptops",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$59.99",
    "rating": 4.4,
    "review_count": 75,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -75,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/61tz6DtI+pL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 59.99,
    "currency": "USD",
    "price_original": "$59.99"
  },
  {
    "product_url": "https://www.amazon.com/GARRULAX-Rotatable-Storage-Pendrive-Smartphones/dp/B0CT5KRQHM/ref=sr_1_292?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.4UOmLVfzEoRBwRBhyvcQfmuN5E3lfV0ya6zIz5db-y6F5Y4XJEsj6X-8qorNl3Dv-Zh-zMCkIQov9Vs3DZqaL6RtgcPoGWIuX6kqOBLbmtnVGI2BSCdb6yn3JCaUcbwC-ef9-OknBqO1-hJ_wIOzcIp9OpiMR_tQHYLImcVaf78tPnXACN5xVtzPfmpeXWnnZv94vU0z1Kf1S-Tw5nDI4QirdSOgp9_Xkv_GZLIZGYk.nS994TcRI2mvmVsTdKOvf-m9ICS-v0iO-axJMIiqGTA&dib_tag=se&keywords=flash+drives&qid=1753562053&sprefix=flash+drive%2Caps%2C146&sr=8-292&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CT5KRQHM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 2,
    "asin": "B0CT5KRQHM",
    "title": "USB Flash Drive, 128GB 2 in 1 OTG Type C USB 2.0 Rotatable Memory Stick Date Storage Pendrive Thumb for Android Smartphones, MacBook, Tablets, PC",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$8.99",
    "rating": 4.1,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/71VNsaiq3GL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 8.99,
    "currency": "USD",
    "price_original": "$8.99"
  },
  {
    "product_url": "https://www.amazon.com/PNY-128GB-Flash-Drive-Silver/dp/B0C795JGGM/ref=sr_1_293?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.4UOmLVfzEoRBwRBhyvcQfmuN5E3lfV0ya6zIz5db-y6F5Y4XJEsj6X-8qorNl3Dv-Zh-zMCkIQov9Vs3DZqaL6RtgcPoGWIuX6kqOBLbmtnVGI2BSCdb6yn3JCaUcbwC-ef9-OknBqO1-hJ_wIOzcIp9OpiMR_tQHYLImcVaf78tPnXACN5xVtzPfmpeXWnnZv94vU0z1Kf1S-Tw5nDI4QirdSOgp9_Xkv_GZLIZGYk.nS994TcRI2mvmVsTdKOvf-m9ICS-v0iO-axJMIiqGTA&dib_tag=se&keywords=flash+drives&qid=1753562053&sprefix=flash+drive%2Caps%2C146&sr=8-293&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0C795JGGM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 3,
    "asin": "B0C795JGGM",
    "title": "128GB Duo Link iOS USB 3.2 Dual Flash Drive",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$29.99",
    "rating": 4,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -60,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/61hxDvEXM7L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 29.99,
    "currency": "USD",
    "price_original": "$29.99"
  },
  {
    "product_url": "https://www.amazon.com/OSCOO-Portable-Smartphones-Laptops-Tablets/dp/B0F6MXMDVX/ref=sr_1_294?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.4UOmLVfzEoRBwRBhyvcQfmuN5E3lfV0ya6zIz5db-y6F5Y4XJEsj6X-8qorNl3Dv-Zh-zMCkIQov9Vs3DZqaL6RtgcPoGWIuX6kqOBLbmtnVGI2BSCdb6yn3JCaUcbwC-ef9-OknBqO1-hJ_wIOzcIp9OpiMR_tQHYLImcVaf78tPnXACN5xVtzPfmpeXWnnZv94vU0z1Kf1S-Tw5nDI4QirdSOgp9_Xkv_GZLIZGYk.nS994TcRI2mvmVsTdKOvf-m9ICS-v0iO-axJMIiqGTA&dib_tag=se&keywords=flash+drives&qid=1753562053&sprefix=flash+drive%2Caps%2C146&sr=8-294&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0F6MXMDVX",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 4,
    "asin": "B0F6MXMDVX",
    "title": "32GB USB Flash Drive USB 3.1 Gen1 Dual USB-A & Type-C, Portable Thumb Drive for Smartphones, Laptops & Tablets",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$16.99",
    "rating": 4.4,
    "review_count": 7,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/51PxnRm-CUL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.99,
    "currency": "USD",
    "price_original": "$16.99"
  },
  {
    "product_url": "https://www.amazon.com/THKAILAR-256GB-High-Speed-Compatible-iPhone15-Android/dp/B0CQ1VTXQJ/ref=sr_1_295?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.4UOmLVfzEoRBwRBhyvcQfmuN5E3lfV0ya6zIz5db-y6F5Y4XJEsj6X-8qorNl3Dv-Zh-zMCkIQov9Vs3DZqaL6RtgcPoGWIuX6kqOBLbmtnVGI2BSCdb6yn3JCaUcbwC-ef9-OknBqO1-hJ_wIOzcIp9OpiMR_tQHYLImcVaf78tPnXACN5xVtzPfmpeXWnnZv94vU0z1Kf1S-Tw5nDI4QirdSOgp9_Xkv_GZLIZGYk.nS994TcRI2mvmVsTdKOvf-m9ICS-v0iO-axJMIiqGTA&dib_tag=se&keywords=flash+drives&qid=1753562053&sprefix=flash+drive%2Caps%2C146&sr=8-295&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CQ1VTXQJ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 5,
    "asin": "B0CQ1VTXQJ",
    "title": "256GB Flash Drive USB 3.2 Gen2 Solid State External SSD,Dual-Port USB-C+USB-A Memory Stick,High-Speed 400MB/s Portable Thumb Drive for iPhone 15/16 Series,Mac,PC,PS4,Android,Windows,Smart TVs",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$29.44",
    "rating": 4.2,
    "review_count": 86,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/41S-Zi1DCNL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 29.44,
    "currency": "USD",
    "price_original": "$29.44"
  },
  {
    "product_url": "https://www.amazon.com/Swivel-Drives-Memory-Storage-Orange/dp/B0925BWHKZ/ref=sr_1_297?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.4UOmLVfzEoRBwRBhyvcQfmuN5E3lfV0ya6zIz5db-y6F5Y4XJEsj6X-8qorNl3Dv-Zh-zMCkIQov9Vs3DZqaL6RtgcPoGWIuX6kqOBLbmtnVGI2BSCdb6yn3JCaUcbwC-ef9-OknBqO1-hJ_wIOzcIp9OpiMR_tQHYLImcVaf78tPnXACN5xVtzPfmpeXWnnZv94vU0z1Kf1S-Tw5nDI4QirdSOgp9_Xkv_GZLIZGYk.nS994TcRI2mvmVsTdKOvf-m9ICS-v0iO-axJMIiqGTA&dib_tag=se&keywords=flash+drives&qid=1753562053&sprefix=flash+drive%2Caps%2C146&sr=8-297&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0925BWHKZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 6,
    "asin": "B0925BWHKZ",
    "title": "Flash Drive 16GB 5 Pack USB 2.0 Swivel Thumb Drives Bulk Memory Stick Jump Drive Pendrive Zip Drive for Data Storage,Black/Blue/Orange/Green/Purple (16G, 5Pcs Mixed Color)",
    "brand": "Flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$13.29",
    "rating": 4.6,
    "review_count": 1,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/71XYT05xT6L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 13.29,
    "currency": "USD",
    "price_original": "$13.29"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Cruzer-Glide-Flash-Drive/dp/B007RB0VJK/ref=sr_1_298?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.4UOmLVfzEoRBwRBhyvcQfmuN5E3lfV0ya6zIz5db-y6F5Y4XJEsj6X-8qorNl3Dv-Zh-zMCkIQov9Vs3DZqaL6RtgcPoGWIuX6kqOBLbmtnVGI2BSCdb6yn3JCaUcbwC-ef9-OknBqO1-hJ_wIOzcIp9OpiMR_tQHYLImcVaf78tPnXACN5xVtzPfmpeXWnnZv94vU0z1Kf1S-Tw5nDI4QirdSOgp9_Xkv_GZLIZGYk.nS994TcRI2mvmVsTdKOvf-m9ICS-v0iO-axJMIiqGTA&dib_tag=se&keywords=flash+drives&qid=1753562053&sprefix=flash+drive%2Caps%2C146&sr=8-298&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B007RB0VJK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 7,
    "asin": "B007RB0VJK",
    "title": "Cruzer Glide USB 16GB Flash Drive",
    "brand": "Cruzer",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$6.92",
    "rating": 4.6,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -319,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "No",
    "is_available": "No",
    "image_url": "./drives-19_files/61U+HgyDU3L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 6.92,
    "currency": "USD",
    "price_original": "$6.92"
  },
  {
    "product_url": "https://www.amazon.com/Drives-JUANWE-Memory-Storage-Red-Black/dp/B0B466ZSGG/ref=sr_1_301?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.4UOmLVfzEoRBwRBhyvcQfmuN5E3lfV0ya6zIz5db-y6F5Y4XJEsj6X-8qorNl3Dv-Zh-zMCkIQov9Vs3DZqaL6RtgcPoGWIuX6kqOBLbmtnVGI2BSCdb6yn3JCaUcbwC-ef9-OknBqO1-hJ_wIOzcIp9OpiMR_tQHYLImcVaf78tPnXACN5xVtzPfmpeXWnnZv94vU0z1Kf1S-Tw5nDI4QirdSOgp9_Xkv_GZLIZGYk.nS994TcRI2mvmVsTdKOvf-m9ICS-v0iO-axJMIiqGTA&dib_tag=se&keywords=flash+drives&qid=1753562053&sprefix=flash+drive%2Caps%2C146&sr=8-301&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0B466ZSGG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 8,
    "asin": "B0B466ZSGG",
    "title": "5 Pack 32GB USB 3.0 Flash Drive 32GB Thumb Drives High Speed USB Memory Stick USB Drive Zip Drive with LED Indicator for Data Storage",
    "brand": 5,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$20.89",
    "rating": 4.4,
    "review_count": 388,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/61TFZPk3w8L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.89,
    "currency": "USD",
    "price_original": "$20.89"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=19&crid=BALSGJKBQE1X&qid=1753561906&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_13#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 9,
    "asin": null,
    "title": "8GB DataStick Pro by Centon, 100 Pack, USB 2.0 Flash Drive Memory Stick for Storage and Backup",
    "brand": "8GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$269.99",
    "rating": 4.5,
    "review_count": 181,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -181,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/61xYGE3z+QL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 269.99,
    "currency": "USD",
    "price_original": "$269.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozNTI1NjI5NTA1MDI4ODc1OjE3NTM1NjIwNTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDY2OTYyMjU3OTIwMjo6MDo6&url=%2FCenton-DataStick-Flash-Drive-Grey%2Fdp%2FB072M7MDFB%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB072M7MDFB%26pd_rd_r%3Dc8893b4b-4c8b-471c-8110-38212b8e9ff0%26pd_rd_w%3DxrTUI%26pd_rd_wg%3DUlFoz%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D27510FZXTTE7TYF1VFGG%26qid%3D1753562053%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-289-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B072M7MDFB",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 10,
    "asin": "B072M7MDFB",
    "title": "8GB DataStick Pro by Centon, 100 Pack, USB 2.0 Flash Drive Memory Stick for Storage and Backup",
    "brand": "8GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$269.99",
    "rating": 4.5,
    "review_count": 181,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -181,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/61xYGE3z+QL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 269.99,
    "currency": "USD",
    "price_original": "$269.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozNTI1NjI5NTA1MDI4ODc1OjE3NTM1NjIwNTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDY2MzE2MjcxMzAwMjo6MTo6&url=%2FCenton-DSP2GB10PK-10-MultiPack-DataStick-Drives%2Fdp%2FB001N0RJQO%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB001N0RJQO%26pd_rd_r%3Dc8893b4b-4c8b-471c-8110-38212b8e9ff0%26pd_rd_w%3DxrTUI%26pd_rd_wg%3DUlFoz%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D27510FZXTTE7TYF1VFGG%26qid%3D1753562053%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-290-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B001N0RJQO",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 11,
    "asin": "B001N0RJQO",
    "title": "Electronics DataStick Pro USB 2.0 Flash Drive, 2 GB, 10 USB Flash Drives, 10 Bulk Pack, Grey",
    "brand": "Electronics",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$29.99",
    "rating": 4.4,
    "review_count": 263,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -263,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/61K745ge9VL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 29.99,
    "currency": "USD",
    "price_original": "$29.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozNTI1NjI5NTA1MDI4ODc1OjE3NTM1NjIwNTM6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDA0ODE3MDgxOTM0MTo6Mjo6&url=%2FiStorage-FL-DAP3-B-64-datAshur-Personal2-encrypted%2Fdp%2FB01N2RN6FE%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB01N2RN6FE%26pd_rd_r%3Dc8893b4b-4c8b-471c-8110-38212b8e9ff0%26pd_rd_w%3DxrTUI%26pd_rd_wg%3DUlFoz%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D27510FZXTTE7TYF1VFGG%26qid%3D1753562053%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-291-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B01N2RN6FE",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 12,
    "asin": "B01N2RN6FE",
    "title": "datAshur Personal2 64 GB - Secure Flash Drive - Password Protected - Portable - Military Grade Hardware Encryption",
    "brand": "datAshur",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$99.95",
    "rating": 4.3,
    "review_count": 257,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -257,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/81PXcO1YdvL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 99.95,
    "currency": "USD",
    "price_original": "$99.95"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozNTI1NjI5NTA1MDI4ODc1OjE3NTM1NjIwNTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1ODg0NjM4NjcwMjo6Mzo6&url=%2FCertified-External-Storage-Picture-Android%2Fdp%2FB0DL5VCVCG%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DL5VCVCG%26pd_rd_r%3Dc8893b4b-4c8b-471c-8110-38212b8e9ff0%26pd_rd_w%3DxrTUI%26pd_rd_wg%3DUlFoz%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D27510FZXTTE7TYF1VFGG%26qid%3D1753562053%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-292-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DL5VCVCG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 13,
    "asin": "B0DL5VCVCG",
    "title": "MFi Certified USB 3.0 Flash Drive 128GB for iPhone, 3in1 External Memory Photo Keeper Storage Stick for Picture/Video/Data Saver/Backup, High Speed Thumb/Jump/Hard Drives for iPhone/iPad/Android/PC",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$20.69",
    "rating": 4.3,
    "review_count": 5,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.2K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/7131xiPczVL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.69,
    "currency": "USD",
    "price_original": "$20.69"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozNTI1NjI5NTA1MDI4ODc1OjE3NTM1NjIwNTM6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDAxMjYxOTYxNzY3MTo6NDo6&url=%2FVICFUN-Flash-Drives-Drive-USB2-0-Blue%2Fdp%2FB07S9JDTVB%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07S9JDTVB%26pd_rd_r%3Dc8893b4b-4c8b-471c-8110-38212b8e9ff0%26pd_rd_w%3DxrTUI%26pd_rd_wg%3DUlFoz%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D27510FZXTTE7TYF1VFGG%26qid%3D1753562053%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-293-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07S9JDTVB",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 14,
    "asin": "B07S9JDTVB",
    "title": "20 Pack 32GB USB Flash Drives Bulk 32GB Flash Drive 20 Pack USB2.0-Blue",
    "brand": 20,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$63.99",
    "rating": 4.6,
    "review_count": 2,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2.6K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/610wot9ohKL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 63.99,
    "currency": "USD",
    "price_original": "$63.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=19&crid=BALSGJKBQE1X&qid=1753561906&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_13#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 15,
    "asin": null,
    "title": "1pc Black Bracelet USB 16GB Flash Drive Wristband Pen Drive Creative Gifts Memory Stick Water Proof External Storag Stylish and Durable",
    "brand": "1pc",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$4.06",
    "rating": null,
    "review_count": 60,
    "special_features": "Water Proof",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-19_files/41GhAWM+jKL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 4.06,
    "currency": "USD",
    "price_original": "$4.06"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NTk1MTE5MDk2NTU0NjgwOjE3NTM1NjIwNTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0Mjc2MDkyNDQwMjo6MTo6&url=%2FBracelet-Wristband-Creative-External-Stylish%2Fdp%2FB0FGXRYH9L%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGXRYH9L%26pd_rd_r%3Dc8893b4b-4c8b-471c-8110-38212b8e9ff0%26pd_rd_w%3DYCDka%26pd_rd_wg%3DUlFoz%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D27510FZXTTE7TYF1VFGG%26qid%3D1753562053%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-289-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGXRYH9L",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 16,
    "asin": "B0FGXRYH9L",
    "title": "1pc Black Bracelet USB 16GB Flash Drive Wristband Pen Drive Creative Gifts Memory Stick Water Proof External Storag Stylish and Durable",
    "brand": "1pc",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$4.06",
    "rating": null,
    "review_count": 4,
    "special_features": "Water Proof",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-19_files/41GhAWM+jKL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 4.06,
    "currency": "USD",
    "price_original": "$4.06"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NTk1MTE5MDk2NTU0NjgwOjE3NTM1NjIwNTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0Mjc2MDkyNTMwMjo6Mjo6&url=%2FCreative-External-Storage-Durable-Stylish%2Fdp%2FB0FH1713SK%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FH1713SK%26pd_rd_r%3Dc8893b4b-4c8b-471c-8110-38212b8e9ff0%26pd_rd_w%3DYCDka%26pd_rd_wg%3DUlFoz%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D27510FZXTTE7TYF1VFGG%26qid%3D1753562053%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-290-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FH1713SK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 17,
    "asin": "B0FH1713SK",
    "title": "1pc Retro Metal USB Flash Drive 64GB Key Memory Stick Creative Gift 64GB External Storage Durable and Stylish",
    "brand": "1pc",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$12.64",
    "rating": null,
    "review_count": 12,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-19_files/41nwK+9owpL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.64,
    "currency": "USD",
    "price_original": "$12.64"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NTk1MTE5MDk2NTU0NjgwOjE3NTM1NjIwNTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0Mjc2MDkyNTkwMjo6Mzo6&url=%2FWaterproof-Pendrive-External-Storage-Durable%2Fdp%2FB0FH1GS4WX%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FH1GS4WX%26pd_rd_r%3Dc8893b4b-4c8b-471c-8110-38212b8e9ff0%26pd_rd_w%3DYCDka%26pd_rd_wg%3DUlFoz%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D27510FZXTTE7TYF1VFGG%26qid%3D1753562053%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-291-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FH1GS4WX",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 18,
    "asin": "B0FH1GS4WX",
    "title": "1pc White 32GB Memory Stick High Speed USB Flash Drive Mini Metal Button Pen Drive Waterproof Pendrive Silver External Storage Durable and Stylish",
    "brand": "1pc",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$10.97",
    "rating": null,
    "review_count": 10,
    "special_features": "Waterproof, Metal, Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-19_files/51mc-R99oBL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 10.97,
    "currency": "USD",
    "price_original": "$10.97"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NTk1MTE5MDk2NTU0NjgwOjE3NTM1NjIwNTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0MDExMjcxOTcwMjo6NDo6&url=%2FWaterproof-Capacity-Memory-ThumbdriveProfessional-Fashion%2Fdp%2FB0FGWS38M7%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGWS38M7%26pd_rd_r%3Dc8893b4b-4c8b-471c-8110-38212b8e9ff0%26pd_rd_w%3DYCDka%26pd_rd_wg%3DUlFoz%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D27510FZXTTE7TYF1VFGG%26qid%3D1753562053%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-292-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGWS38M7",
    "blank": null,
    "affiliate_link": "https://amzn.to/45jMDRR",
    "source_file": "drives-19.html",
    "position": 19,
    "asin": "B0FGWS38M7",
    "title": "1pc Super Mini USB Flash Drive Waterproof 16GB Real Capacity USB 2.0 Memory Stick ThumbdriveProfessional and Fashion",
    "brand": "1pc",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$3.26",
    "rating": null,
    "review_count": 3,
    "special_features": "Waterproof, Cap, Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-19_files/41atrUdamCL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 3.26,
    "currency": "USD",
    "price_original": "$3.26"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NTk1MTE5MDk2NTU0NjgwOjE3NTM1NjIwNTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDgwMDc4MTMxMDQwMjo6NTo6&url=%2FCustom-Memory-Personalized-Company-Photography%2Fdp%2FB0FC2K24TZ%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FC2K24TZ%26pd_rd_r%3Dc8893b4b-4c8b-471c-8110-38212b8e9ff0%26pd_rd_w%3DYCDka%26pd_rd_wg%3DUlFoz%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D27510FZXTTE7TYF1VFGG%26qid%3D1753562053%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-293-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FC2K24TZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 20,
    "asin": "B0FC2K24TZ",
    "title": "Metal USB Flash Drive, 32GB 64GB 128GB Memory Stick Personalized Mini Thumb Drives Carved Your Logo for Office/School/Company Ads/Photography - Customize Exclusive Text & Logo",
    "brand": "Metal",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$7.29",
    "rating": null,
    "review_count": 7,
    "special_features": "Metal, Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-19_files/61C2NLPURxL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 7.29,
    "currency": "USD",
    "price_original": "$7.29"
  },
  {
    "product_url": "https://www.amazon.com/DataLocker-K350-256-Encrypted-Drive/dp/B09C1LDWH2/ref=sr_1_302?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.4UOmLVfzEoRBwRBhyvcQfmuN5E3lfV0ya6zIz5db-y6F5Y4XJEsj6X-8qorNl3Dv-Zh-zMCkIQov9Vs3DZqaL6RtgcPoGWIuX6kqOBLbmtnVGI2BSCdb6yn3JCaUcbwC-ef9-OknBqO1-hJ_wIOzcIp9OpiMR_tQHYLImcVaf78tPnXACN5xVtzPfmpeXWnnZv94vU0z1Kf1S-Tw5nDI4QirdSOgp9_Xkv_GZLIZGYk.nS994TcRI2mvmVsTdKOvf-m9ICS-v0iO-axJMIiqGTA&dib_tag=se&keywords=flash+drives&qid=1753562053&sprefix=flash+drive%2Caps%2C146&sr=8-302&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09C1LDWH2",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 21,
    "asin": "B09C1LDWH2",
    "title": "Sentry K350 256GB Encrypted USB Flash Drive Keypad, Easy Screen Guided Setup AES 256, TAA Compliant Ruggedized Mil-Std 810-G, IP68 OS Independent, USB-A, FIPS 140-3 Level 3 Pending",
    "brand": "Sentry",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$347.39",
    "rating": 5,
    "review_count": 3,
    "special_features": "Encrypted",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-19_files/71vKQ8TzmML._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 347.39,
    "currency": "USD",
    "price_original": "$347.39"
  },
  {
    "product_url": "https://www.amazon.com/Certified-Photo-Stick-iPhone-Storage-iPhone-Memory-External/dp/B08THR2JSD/ref=sr_1_303?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.4UOmLVfzEoRBwRBhyvcQfmuN5E3lfV0ya6zIz5db-y6F5Y4XJEsj6X-8qorNl3Dv-Zh-zMCkIQov9Vs3DZqaL6RtgcPoGWIuX6kqOBLbmtnVGI2BSCdb6yn3JCaUcbwC-ef9-OknBqO1-hJ_wIOzcIp9OpiMR_tQHYLImcVaf78tPnXACN5xVtzPfmpeXWnnZv94vU0z1Kf1S-Tw5nDI4QirdSOgp9_Xkv_GZLIZGYk.nS994TcRI2mvmVsTdKOvf-m9ICS-v0iO-axJMIiqGTA&dib_tag=se&keywords=flash+drives&qid=1753562053&sprefix=flash+drive%2Caps%2C146&sr=8-303&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08THR2JSD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 22,
    "asin": "B08THR2JSD",
    "title": "Genuine Apple MFi Certified iPhone USB Flash Drive 512GB - Real Capacity - No Fake Storage, Genuine Lightning, encrypted Auto Backup Photo Stick for iPhone iPad Photos/Videos - Avoid Fake MFi Clones!",
    "brand": "Genuine",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "Lightning",
    "memory_type": "USB",
    "price": "$76.79",
    "rating": 4.2,
    "review_count": 18,
    "special_features": "Encrypted, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/71EwXGTY0jL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 76.79,
    "currency": "USD",
    "price_original": "$76.79"
  },
  {
    "product_url": "https://www.amazon.com/fanxiang-2050MB-Android-Windows-Laptops/dp/B0DL5LDT1S/ref=sr_1_304?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.4UOmLVfzEoRBwRBhyvcQfmuN5E3lfV0ya6zIz5db-y6F5Y4XJEsj6X-8qorNl3Dv-Zh-zMCkIQov9Vs3DZqaL6RtgcPoGWIuX6kqOBLbmtnVGI2BSCdb6yn3JCaUcbwC-ef9-OknBqO1-hJ_wIOzcIp9OpiMR_tQHYLImcVaf78tPnXACN5xVtzPfmpeXWnnZv94vU0z1Kf1S-Tw5nDI4QirdSOgp9_Xkv_GZLIZGYk.nS994TcRI2mvmVsTdKOvf-m9ICS-v0iO-axJMIiqGTA&dib_tag=se&keywords=flash+drives&qid=1753562053&sprefix=flash+drive%2Caps%2C146&sr=8-304&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DL5LDT1S",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 23,
    "asin": "B0DL5LDT1S",
    "title": "256GB Flash Drive, Up to 2050MB/s USB 3.2 Gen22, USB A+C, 2-in-1 Memory Stick for iPhone/Android/Windows/MacPC/Laptops, FF958",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$47.49",
    "rating": 4.5,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/71kqFWyMWjL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 47.49,
    "currency": "USD",
    "price_original": "$47.49"
  },
  {
    "product_url": "https://www.amazon.com/Kingston-DataTraveler-1TB-USB-C-Performance/dp/B09DVQ32XQ/ref=sr_1_305?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.4UOmLVfzEoRBwRBhyvcQfmuN5E3lfV0ya6zIz5db-y6F5Y4XJEsj6X-8qorNl3Dv-Zh-zMCkIQov9Vs3DZqaL6RtgcPoGWIuX6kqOBLbmtnVGI2BSCdb6yn3JCaUcbwC-ef9-OknBqO1-hJ_wIOzcIp9OpiMR_tQHYLImcVaf78tPnXACN5xVtzPfmpeXWnnZv94vU0z1Kf1S-Tw5nDI4QirdSOgp9_Xkv_GZLIZGYk.nS994TcRI2mvmVsTdKOvf-m9ICS-v0iO-axJMIiqGTA&dib_tag=se&keywords=flash+drives&qid=1753562053&sprefix=flash+drive%2Caps%2C146&sr=8-305&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09DVQ32XQ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 24,
    "asin": "B09DVQ32XQ",
    "title": "DataTraveler Max 1TB USB-C Flash Drive with USB 3.2 Gen 2 Performance",
    "brand": "DataTraveler",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 2",
    "memory_type": "USB",
    "price": "$101.99",
    "rating": 4.3,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/71yptg7ttTL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "tb",
    "price_numeric": 101.99,
    "currency": "USD",
    "price_original": "$101.99"
  },
  {
    "product_url": "https://www.amazon.com/Retract-Flash-Drive-32GB-P-FD32GX2RTC-GE/dp/B07QGGQBB3/ref=sr_1_306?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.4UOmLVfzEoRBwRBhyvcQfmuN5E3lfV0ya6zIz5db-y6F5Y4XJEsj6X-8qorNl3Dv-Zh-zMCkIQov9Vs3DZqaL6RtgcPoGWIuX6kqOBLbmtnVGI2BSCdb6yn3JCaUcbwC-ef9-OknBqO1-hJ_wIOzcIp9OpiMR_tQHYLImcVaf78tPnXACN5xVtzPfmpeXWnnZv94vU0z1Kf1S-Tw5nDI4QirdSOgp9_Xkv_GZLIZGYk.nS994TcRI2mvmVsTdKOvf-m9ICS-v0iO-axJMIiqGTA&dib_tag=se&keywords=flash+drives&qid=1753562053&sprefix=flash+drive%2Caps%2C146&sr=8-306&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07QGGQBB3",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 25,
    "asin": "B07QGGQBB3",
    "title": "PNY Retract USB 2.0 Flash Drive, 32GB 2-Pk, Gray & Red (P-FD32GX2RTC-GE)",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$20.07",
    "rating": 4.5,
    "review_count": 356,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -356,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "No",
    "image_url": "./drives-19_files/51no8a0KaPL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.07,
    "currency": "USD",
    "price_original": "$20.07"
  },
  {
    "product_url": "https://www.amazon.com/HUNPINS-Hight-Speed-Memory-Compatible-Android/dp/B0D4HMGMWW/ref=sr_1_307?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.4UOmLVfzEoRBwRBhyvcQfmuN5E3lfV0ya6zIz5db-y6F5Y4XJEsj6X-8qorNl3Dv-Zh-zMCkIQov9Vs3DZqaL6RtgcPoGWIuX6kqOBLbmtnVGI2BSCdb6yn3JCaUcbwC-ef9-OknBqO1-hJ_wIOzcIp9OpiMR_tQHYLImcVaf78tPnXACN5xVtzPfmpeXWnnZv94vU0z1Kf1S-Tw5nDI4QirdSOgp9_Xkv_GZLIZGYk.nS994TcRI2mvmVsTdKOvf-m9ICS-v0iO-axJMIiqGTA&dib_tag=se&keywords=flash+drives&qid=1753562053&sprefix=flash+drive%2Caps%2C146&sr=8-307&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D4HMGMWW",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 26,
    "asin": "B0D4HMGMWW",
    "title": "Flash Drive 256GB for Phone, HUPINS USB C Thumb Drive 170M/S Hight-Speed, Multi Port Memory Stick Compatible Android Phone/Tablet and PC (Black)",
    "brand": "Flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$34.79",
    "rating": 4.2,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -195,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/51XgN6CSyjL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.79,
    "currency": "USD",
    "price_original": "$34.79"
  },
  {
    "product_url": "https://www.amazon.com/32GB-Lilac-Breeze-Flash-Drive/dp/B0DYKN795C/ref=sr_1_308?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.4UOmLVfzEoRBwRBhyvcQfmuN5E3lfV0ya6zIz5db-y6F5Y4XJEsj6X-8qorNl3Dv-Zh-zMCkIQov9Vs3DZqaL6RtgcPoGWIuX6kqOBLbmtnVGI2BSCdb6yn3JCaUcbwC-ef9-OknBqO1-hJ_wIOzcIp9OpiMR_tQHYLImcVaf78tPnXACN5xVtzPfmpeXWnnZv94vU0z1Kf1S-Tw5nDI4QirdSOgp9_Xkv_GZLIZGYk.nS994TcRI2mvmVsTdKOvf-m9ICS-v0iO-axJMIiqGTA&dib_tag=se&keywords=flash+drives&qid=1753562053&sprefix=flash+drive%2Caps%2C146&sr=8-308&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DYKN795C",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 27,
    "asin": "B0DYKN795C",
    "title": "HP 32GB v168 USB 2.0 Lilac Breeze Flash Drive ‚Äì Reliable Portable Storage to Store, Transfer, & Protect Important Data, 5-Pack",
    "brand": "HP",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$23.55",
    "rating": 5,
    "review_count": 3,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -3,
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/41-SUdVWAxL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 23.55,
    "currency": "USD",
    "price_original": "$23.55"
  },
  {
    "product_url": "https://aax-us-iad.amazon.com/x/c/JDW81xBZG0ZYCPVmaFWWGAsAAAGYSHF7FwEAAAH2AQBvbm9fdHhuX2JpZDcgICBvbm9fdHhuX2ltcDIgICA_tW8R/clv1c_ek-YwQfWLcTCDRVIBM0SNmKQvh4OuByUBHFs3G7D4EdlTdJbiWdbqQPX7XKdF6jbWffIEBqio0kpmw5A8XpemAurGTLDl7KJvgrY3NKl7si7shZFsVixDG3j-3W84p1GwusX7coatLeuUfvQTcVsqxBaoGudh3fAoogwn5ervIwKe0Ev6sqnXuIybQJedtKk8xHPc5wGijCyHA6ofCgA3pq5C5yPYEWb3gJvYgmi3vuldw3FzTJ30IMPIJebXwfWTsXw2lx6JT1ebkmgoaUR7uysbbV6rUcVb89vOKxv70c8ILHSLGDq6QUu_dZ9_MxiIxQ8gyJM45kjP6retgVMnzVKd6iN9pvI96Gjto5Yo8Mdql7zEGUavgcE9p1OVYohoNi8r3Q3jRWwLYOmDartLwwNC0-Toq4M-wXrdekDvVylDx8Qmn24OOWelswsM430Otz62X-bZodp-Mcp76xtPOlyXG3ipordMPhAOF0An2cA0sl3mhArf68z33Frre6Cu4-HqUf-eQZOQb-3EqyoQjje-sU2Bc3QsPgxGET5qTR3IH_zAnSNlEicmrb7YRMEhF7fmnLVuSR-ZL36ta9yes8c10bjiGj7Eo5r7CstRg99fcn2HqQn6Y6fsN6wtcCNV0x-8uJX3Sp1uS0yL8tZHzznpQQKYrnyNaNmOUTKnZfc2NyquGsRZRSm_xmictGwh47TZOAiIYzNr_HWff0CdbubEvJH0ALwgJF3LF7DbE9TPbD7v2SDiIZaN80jJg196O98bZ7him6KvbxwdnJc4e3m7S_XjkCa4GL7to93OJuKDXuAEC2nuK_xgIHnjjQOvmXWPm38BKD0xynxS2aBhiaEKvvXAHt0TLJtM_bk4ouzjIy3HBoxROOM8im_chhVqYMTgBvkOTaHW_R97JrVXUq_7kCw3FDI3k01ElDUOWwHD-6vzkoS9yBnYVgjF9HptiF7OF0Z5c2JEDPQBA/https://www.amazon.com/dp/B07H26NHWW?pd_rd_i=B07H26NHWW&pf_rd_p=2c8e5d59-6279-4999-832d-be45d1ca8e79&pf_rd_r=27510FZXTTE7TYF1VFGG&pd_rd_wg=xj1FS&pd_rd_w=2Vo5e&pd_rd_r=287cbce6-cbba-488c-9a85-716b6a1f6397",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-19.html",
    "position": 28,
    "asin": null,
    "title": "K&ZZ 5 Pack 64GB Flash Drive 64 GB USB Flash Drives USB 2.0 Thumb Drive Gig Zip Drive Stick 64G Flash Memory Stick Jump Drives for PC Laptop, Multicolored",
    "brand": "K&ZZ",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.98",
    "rating": 4.5,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2.9K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-19_files/71TmU8mY+MS._AC_UL640_QL65_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.98,
    "currency": "USD",
    "price_original": "$19.98"
  },
  {
    "product_url": "https://www.amazon.com/PNY-Attach%C3%A9-Flash-Drive-10-Pack/dp/B0866QKPP6/ref=sr_1_20?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.8o7W389wAE2Mv-K4xXX7eVE7SBOUKQkwctavDkm-5lfGjHj071QN20LucGBJIEps.yNEeW-c6XOzjQQCG7ql-5JkvWYvnDQItVwnaVreKPnY&dib_tag=se&keywords=flash+drives&qid=1753559156&sprefix=flash+drive%2Caps%2C146&sr=8-20&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0866QKPP6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 1,
    "asin": "B0866QKPP6",
    "title": "PNY P-FD32GX10ATT03-MP 32GB Attach√© 3 USB 2.0 Flash Drive,Black (Pack of 10)",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$29.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.6K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/813msDRnYZL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 29.99,
    "currency": "USD",
    "price_original": "$29.99"
  },
  {
    "product_url": "https://www.amazon.com/PNY-Turbo-Attach%C3%A9-Flash-5-Pack/dp/B08HW32VG6/ref=sr_1_21?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.8o7W389wAE2Mv-K4xXX7eVE7SBOUKQkwctavDkm-5lfGjHj071QN20LucGBJIEps.yNEeW-c6XOzjQQCG7ql-5JkvWYvnDQItVwnaVreKPnY&dib_tag=se&keywords=flash+drives&qid=1753559156&sprefix=flash+drive%2Caps%2C146&sr=8-21&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08HW32VG6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 2,
    "asin": "B08HW32VG6",
    "title": "PNY 32GB Turbo Attache 3 USB 3.0 Flash Drive, Grey (Pack of 5)",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.6,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2.6K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/517pH++UAjL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/SeeDete-Drives-Rotated-External-Storage/dp/B08Y5PMNXS/ref=sr_1_17?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.L-zcdkWhZpYIuiY9LsEUYOHmiwX8v8T-DcX-tumelx5p9kUK0GC7jo2No-S31xG0ThBqsDaMW51STIYKyWuPwIaKQ-ZhR0bGpEpZXN9ignY2rJ-TTpKG-BfxPpC6jgF8xOfp5iZ5F7Z1oY_zQkEEWRpVJt_QYxloi-bLZQBZ6TzCCiYAWWsPUV4Ezgn7c_WI.byDwACmq1gZllRsMBNxuW8cLOK7Gks6ETJ3-qZ2KjIQ&dib_tag=se&keywords=flash+drives&qid=1753559156&sprefix=flash+drive%2Caps%2C146&sr=8-17&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08Y5PMNXS",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 3,
    "asin": "B08Y5PMNXS",
    "title": "64GB USB Flash Drives, USB Stick, Thumb Drive Rotated Design, Memory Stick with LED Light for External Storage and Backup Data, Jump Drive, 3 Pack 64GB (3 Colors: Black Red Blue)",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$10.99",
    "rating": 4.5,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/61TgILXQH1L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 10.99,
    "currency": "USD",
    "price_original": "$10.99"
  },
  {
    "product_url": "https://www.amazon.com/Aiibe-Pieces-Memory-Thumbdrives-Colors/dp/B07DFYZ8FF/ref=sr_1_18?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.L-zcdkWhZpYIuiY9LsEUYOHmiwX8v8T-DcX-tumelx5p9kUK0GC7jo2No-S31xG0ThBqsDaMW51STIYKyWuPwIaKQ-ZhR0bGpEpZXN9ignY2rJ-TTpKG-BfxPpC6jgF8xOfp5iZ5F7Z1oY_zQkEEWRpVJt_QYxloi-bLZQBZ6TzCCiYAWWsPUV4Ezgn7c_WI.byDwACmq1gZllRsMBNxuW8cLOK7Gks6ETJ3-qZ2KjIQ&dib_tag=se&keywords=flash+drives&qid=1753559156&sprefix=flash+drive%2Caps%2C146&sr=8-18&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07DFYZ8FF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 4,
    "asin": "B07DFYZ8FF",
    "title": "Aiibe 10 Pieces 32GB USB Flash Drive 10 Pack USB 2.0 Memory Stick Thumbdrives (Mix Colors : Black Blue Red Green Orange White Yellow Pink Purple Silver)",
    "brand": "Aiibe",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$29.99",
    "rating": 4.6,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "10 sizes10 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/71kBggJ6-uL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 29.99,
    "currency": "USD",
    "price_original": "$29.99"
  },
  {
    "product_url": "https://www.amazon.com/Lexar-Type-CTM-Housing-Swivel-Design/dp/B0DH1MKVQV/ref=sr_1_19?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.L-zcdkWhZpYIuiY9LsEUYOHmiwX8v8T-DcX-tumelx5p9kUK0GC7jo2No-S31xG0ThBqsDaMW51STIYKyWuPwIaKQ-ZhR0bGpEpZXN9ignY2rJ-TTpKG-BfxPpC6jgF8xOfp5iZ5F7Z1oY_zQkEEWRpVJt_QYxloi-bLZQBZ6TzCCiYAWWsPUV4Ezgn7c_WI.byDwACmq1gZllRsMBNxuW8cLOK7Gks6ETJ3-qZ2KjIQ&dib_tag=se&keywords=flash+drives&qid=1753559156&sprefix=flash+drive%2Caps%2C146&sr=8-19&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DH1MKVQV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 5,
    "asin": "B0DH1MKVQV",
    "title": "Lexar D40E 128GB Dual USB 3.2 Gen 1 Type-C Jump Drive, USB-C Flash Metal Housing Swivel Design Thumb Drive",
    "brand": "Lexar",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$16.99",
    "rating": 4.5,
    "review_count": 5,
    "special_features": "Metal, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/5170woTzckL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.99,
    "currency": "USD",
    "price_original": "$16.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Cruzer-Ultra-Flash-SDCZ48-016G-U46/dp/B00NIEIRVY/ref=sr_1_20?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.L-zcdkWhZpYIuiY9LsEUYOHmiwX8v8T-DcX-tumelx5p9kUK0GC7jo2No-S31xG0ThBqsDaMW51STIYKyWuPwIaKQ-ZhR0bGpEpZXN9ignY2rJ-TTpKG-BfxPpC6jgF8xOfp5iZ5F7Z1oY_zQkEEWRpVJt_QYxloi-bLZQBZ6TzCCiYAWWsPUV4Ezgn7c_WI.byDwACmq1gZllRsMBNxuW8cLOK7Gks6ETJ3-qZ2KjIQ&dib_tag=se&keywords=flash+drives&qid=1753559156&sprefix=flash+drive%2Caps%2C146&sr=8-20&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B00NIEIRVY",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 6,
    "asin": "B00NIEIRVY",
    "title": "SanDisk Cruzer Ultra 16GB USB 3.0 Flash Drive SDCZ48-016G-U46 up to 100MB/s (Pack of 5)",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$26.57",
    "rating": 4.7,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2K)",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/51Jho0jaI4L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 26.57,
    "currency": "USD",
    "price_original": "$26.57"
  },
  {
    "product_url": "https://www.amazon.com/KEXIN-Memory-Drives-Storage-Colors/dp/B0CD26GP52/ref=sr_1_21?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.L-zcdkWhZpYIuiY9LsEUYOHmiwX8v8T-DcX-tumelx5p9kUK0GC7jo2No-S31xG0ThBqsDaMW51STIYKyWuPwIaKQ-ZhR0bGpEpZXN9ignY2rJ-TTpKG-BfxPpC6jgF8xOfp5iZ5F7Z1oY_zQkEEWRpVJt_QYxloi-bLZQBZ6TzCCiYAWWsPUV4Ezgn7c_WI.byDwACmq1gZllRsMBNxuW8cLOK7Gks6ETJ3-qZ2KjIQ&dib_tag=se&keywords=flash+drives&qid=1753559156&sprefix=flash+drive%2Caps%2C146&sr=8-21&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CD26GP52",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 7,
    "asin": "B0CD26GP52",
    "title": "KEXIN Flash Drive 64GB Thumb Drive 5 Pack 64 GB USB Flash Drive USB 2.0 Memory Stick 64G Thumb Drives Jump Drive Data Storage (64GB, 5 Mixed Colors)",
    "brand": "KEXIN",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.4,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "10 sizes10 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/6121Isn0w0L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/SIMMAX-Memory-Storage-Swivel-Design/dp/B01GXJTFHK/ref=sr_1_24?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.L-zcdkWhZpYIuiY9LsEUYOHmiwX8v8T-DcX-tumelx5p9kUK0GC7jo2No-S31xG0ThBqsDaMW51STIYKyWuPwIaKQ-ZhR0bGpEpZXN9ignY2rJ-TTpKG-BfxPpC6jgF8xOfp5iZ5F7Z1oY_zQkEEWRpVJt_QYxloi-bLZQBZ6TzCCiYAWWsPUV4Ezgn7c_WI.byDwACmq1gZllRsMBNxuW8cLOK7Gks6ETJ3-qZ2KjIQ&dib_tag=se&keywords=flash+drives&qid=1753559156&sprefix=flash+drive%2Caps%2C146&sr=8-24&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B01GXJTFHK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 8,
    "asin": "B01GXJTFHK",
    "title": "5Pcs 8GB USB Flash Drive USB 2.0 Flash Drive Memory Stick Fold Storage Thumb Stick Pen Swivel Design(Five Mixed Colors: Black Blue Green Purple Red)(Mix Color1)",
    "brand": "5Pcs",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$9.99",
    "rating": 4.6,
    "review_count": 1,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/61CUpQAsbBL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 9.99,
    "currency": "USD",
    "price_original": "$9.99"
  },
  {
    "product_url": "https://www.amazon.com/Samsung-BAR-Plus-256GB-MUF-256BE3/dp/B07BPKKTGL/ref=sr_1_25?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.L-zcdkWhZpYIuiY9LsEUYOHmiwX8v8T-DcX-tumelx5p9kUK0GC7jo2No-S31xG0ThBqsDaMW51STIYKyWuPwIaKQ-ZhR0bGpEpZXN9ignY2rJ-TTpKG-BfxPpC6jgF8xOfp5iZ5F7Z1oY_zQkEEWRpVJt_QYxloi-bLZQBZ6TzCCiYAWWsPUV4Ezgn7c_WI.byDwACmq1gZllRsMBNxuW8cLOK7Gks6ETJ3-qZ2KjIQ&dib_tag=se&keywords=flash+drives&qid=1753559156&sprefix=flash+drive%2Caps%2C146&sr=8-25&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07BPKKTGL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 9,
    "asin": "B07BPKKTGL",
    "title": "SAMSUNG BAR Plus 256GB - 400MB/s USB 3.1 Flash Drive Champagne Silver (MUF-256BE3/AM)",
    "brand": "Samsung",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$21.99",
    "rating": 4.7,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(48.3K)",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/81JJHlQjIiL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 21.99,
    "currency": "USD",
    "price_original": "$21.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-3-Pack-Cruzer-Glide-3x32GB/dp/B0978ZCNSJ/ref=sr_1_26?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.L-zcdkWhZpYIuiY9LsEUYOHmiwX8v8T-DcX-tumelx5p9kUK0GC7jo2No-S31xG0ThBqsDaMW51STIYKyWuPwIaKQ-ZhR0bGpEpZXN9ignY2rJ-TTpKG-BfxPpC6jgF8xOfp5iZ5F7Z1oY_zQkEEWRpVJt_QYxloi-bLZQBZ6TzCCiYAWWsPUV4Ezgn7c_WI.byDwACmq1gZllRsMBNxuW8cLOK7Gks6ETJ3-qZ2KjIQ&dib_tag=se&keywords=flash+drives&qid=1753559156&sprefix=flash+drive%2Caps%2C146&sr=8-26&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0978ZCNSJ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 10,
    "asin": "B0978ZCNSJ",
    "title": "SanDisk 32GB 3-Pack Cruzer Glide USB 2.0 Flash Drive (3x32GB) - SDCZ60-032G-G46T, Black",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "SD",
    "price": "$15.99",
    "rating": 4.7,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/51pe0ND7gGL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 15.99,
    "currency": "USD",
    "price_original": "$15.99"
  },
  {
    "product_url": "https://www.amazon.com/Verbatim-64GB-ToughMAX-Flash-Drive/dp/B07G5F2G89/ref=sr_1_27?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.L-zcdkWhZpYIuiY9LsEUYOHmiwX8v8T-DcX-tumelx5p9kUK0GC7jo2No-S31xG0ThBqsDaMW51STIYKyWuPwIaKQ-ZhR0bGpEpZXN9ignY2rJ-TTpKG-BfxPpC6jgF8xOfp5iZ5F7Z1oY_zQkEEWRpVJt_QYxloi-bLZQBZ6TzCCiYAWWsPUV4Ezgn7c_WI.byDwACmq1gZllRsMBNxuW8cLOK7Gks6ETJ3-qZ2KjIQ&dib_tag=se&keywords=flash+drives&qid=1753559156&sprefix=flash+drive%2Caps%2C146&sr=8-27&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07G5F2G89",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 11,
    "asin": "B07G5F2G89",
    "title": "Verbatim 64GB ToughMAX USB 2.0 Flash Drive - Extremely Durable Thumb Drive - Black, 70058",
    "brand": "Verbatim",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$5.50",
    "rating": 4.5,
    "review_count": 2,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -879,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/61-8C-A9oqL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 5.5,
    "currency": "USD",
    "price_original": "$5.50"
  },
  {
    "product_url": "https://www.amazon.com/EASTFUN-Flash-Drive-Memory-Colors/dp/B01CKT1DTA/ref=sr_1_28?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.L-zcdkWhZpYIuiY9LsEUYOHmiwX8v8T-DcX-tumelx5p9kUK0GC7jo2No-S31xG0ThBqsDaMW51STIYKyWuPwIaKQ-ZhR0bGpEpZXN9ignY2rJ-TTpKG-BfxPpC6jgF8xOfp5iZ5F7Z1oY_zQkEEWRpVJt_QYxloi-bLZQBZ6TzCCiYAWWsPUV4Ezgn7c_WI.byDwACmq1gZllRsMBNxuW8cLOK7Gks6ETJ3-qZ2KjIQ&dib_tag=se&keywords=flash+drives&qid=1753559156&sprefix=flash+drive%2Caps%2C146&sr=8-28&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B01CKT1DTA",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 12,
    "asin": "B01CKT1DTA",
    "title": "EASTFUN 5Pcs 8GB USB Flash Drive USB 2.0 Flash Memory Stick Thumb Stick Pen(Five Mixed Colors: Blue Purple Rose Green Gold)",
    "brand": "EASTFUN",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$11.99",
    "rating": 4.6,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/61LFANbLl1L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.99,
    "currency": "USD",
    "price_original": "$11.99"
  },
  {
    "product_url": "https://www.amazon.com/MOVE-SPEED-Solid-Keychain-Leather/dp/B0C69TJPSK/ref=sr_1_29?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.L-zcdkWhZpYIuiY9LsEUYOHmiwX8v8T-DcX-tumelx5p9kUK0GC7jo2No-S31xG0ThBqsDaMW51STIYKyWuPwIaKQ-ZhR0bGpEpZXN9ignY2rJ-TTpKG-BfxPpC6jgF8xOfp5iZ5F7Z1oY_zQkEEWRpVJt_QYxloi-bLZQBZ6TzCCiYAWWsPUV4Ezgn7c_WI.byDwACmq1gZllRsMBNxuW8cLOK7Gks6ETJ3-qZ2KjIQ&dib_tag=se&keywords=flash+drives&qid=1753559156&sprefix=flash+drive%2Caps%2C146&sr=8-29&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0C69TJPSK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 13,
    "asin": "B0C69TJPSK",
    "title": "MOVE SPEED 1TB Solid State Flash Drive 570MB/s High Speed Type C + USB 3.2 Drive Dual Port, Thumb Drive Compatible with iPhone 15, 16 Series/Android Phone/MacBook/Audio/Smart TV",
    "brand": "MOVE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$79.99",
    "rating": 4.3,
    "review_count": 2,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/51RqgjeakcL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "tb",
    "price_numeric": 79.99,
    "currency": "USD",
    "price_original": "$79.99"
  },
  {
    "product_url": "https://www.amazon.com/Aiibe-Drives-Memory-Swivel-Indicator/dp/B07GLFK3VH/ref=sr_1_30?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.L-zcdkWhZpYIuiY9LsEUYOHmiwX8v8T-DcX-tumelx5p9kUK0GC7jo2No-S31xG0ThBqsDaMW51STIYKyWuPwIaKQ-ZhR0bGpEpZXN9ignY2rJ-TTpKG-BfxPpC6jgF8xOfp5iZ5F7Z1oY_zQkEEWRpVJt_QYxloi-bLZQBZ6TzCCiYAWWsPUV4Ezgn7c_WI.byDwACmq1gZllRsMBNxuW8cLOK7Gks6ETJ3-qZ2KjIQ&dib_tag=se&keywords=flash+drives&qid=1753559156&sprefix=flash+drive%2Caps%2C146&sr=8-30&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07GLFK3VH",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 14,
    "asin": "B07GLFK3VH",
    "title": "Aiibe 5 Pack 64GB USB Flash Drive 64 GB Flash Drives Thumb Drive Swivel USB Stick USB 2.0 Pen Drive (64G, 5 Mixed Colors: Black Red Yellow White Purple)",
    "brand": "Aiibe",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.5,
    "review_count": 1,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "7 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/61RTaGT9vhL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/SSK-External-Storage-Android-Windows/dp/B0C365PLCC/ref=sr_1_31?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.L-zcdkWhZpYIuiY9LsEUYOHmiwX8v8T-DcX-tumelx5p9kUK0GC7jo2No-S31xG0ThBqsDaMW51STIYKyWuPwIaKQ-ZhR0bGpEpZXN9ignY2rJ-TTpKG-BfxPpC6jgF8xOfp5iZ5F7Z1oY_zQkEEWRpVJt_QYxloi-bLZQBZ6TzCCiYAWWsPUV4Ezgn7c_WI.byDwACmq1gZllRsMBNxuW8cLOK7Gks6ETJ3-qZ2KjIQ&dib_tag=se&keywords=flash+drives&qid=1753559156&sprefix=flash+drive%2Caps%2C146&sr=8-31&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0C365PLCC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 15,
    "asin": "B0C365PLCC",
    "title": "SSK External USB C SSD Flash Drive 512GB, Up to 550MB/s 2-in-1 Type C+ USB A USB3.2 Gen2 Solid State Thumb Drive, Memory Stick Data Storage for iPhone 15/PS4/PS5/Android Phone/Windows/Mac",
    "brand": "SSK",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$49.99",
    "rating": 4.6,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.1K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/61qwibhHQeL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 49.99,
    "currency": "USD",
    "price_original": "$49.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=2&xpid=0pS0dlS6IFFFB&crid=BALSGJKBQE1X&qid=1753559140&sprefix=flash+drive%2Caps%2C146&ref=sr_pg_1#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 16,
    "asin": null,
    "title": "SanDisk 512GB Ultra USB 3.0 Flash Drive - SDCZ48-512G-G46, Black",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$34.33",
    "rating": 4.7,
    "review_count": 47,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(47.3K)",
    "premium_brand": "Premium Brands",
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/61T85CGI4ZL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.33,
    "currency": "USD",
    "price_original": "$34.33"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0Mzc1OTUxMjY5MzExMDM2OjE3NTM1NTkyMTM6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDExNDU1ODgyMTg5ODo6MDo6&url=%2FSanDisk-512GB-Ultra-Flash-Drive%2Fdp%2FB083ZLJ5MG%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB083ZLJ5MG%26pd_rd_r%3D10140c59-eaf6-4a09-a6e6-e5b2479be0a7%26pd_rd_w%3DP0cb8%26pd_rd_wg%3DTOuYt%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D32A9X5NBZBX0SZ9A1483%26qid%3D1753559156%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-17-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B083ZLJ5MG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 17,
    "asin": "B083ZLJ5MG",
    "title": "SanDisk 512GB Ultra USB 3.0 Flash Drive - SDCZ48-512G-G46, Black",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$34.33",
    "rating": 4.7,
    "review_count": 8,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(47.3K)",
    "premium_brand": "Premium Brands",
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/61T85CGI4ZL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.33,
    "currency": "USD",
    "price_original": "$34.33"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0Mzc1OTUxMjY5MzExMDM2OjE3NTM1NTkyMTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MDkzNTgzMjEwMjo6MTo6&url=%2F20PACK-AGECASH-Pendrive-Lanyards-Storage%2Fdp%2FB0CXM4ZH2T%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CXM4ZH2T%26pd_rd_r%3D10140c59-eaf6-4a09-a6e6-e5b2479be0a7%26pd_rd_w%3DP0cb8%26pd_rd_wg%3DTOuYt%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D32A9X5NBZBX0SZ9A1483%26qid%3D1753559156%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-18-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CXM4ZH2T",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 18,
    "asin": "B0CXM4ZH2T",
    "title": "512MB Flash Drive 20PACK AGECASH Thumb Drive Bulk USB 2.0 Flash Drives Multi Pack Green Swivel 512MB USB Memory Stick Zip Drive Pendrive with Labels & Lanyards, USB Jump Drive Pack for Data Storage",
    "brand": "512MB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$29.44",
    "rating": 4.5,
    "review_count": 388,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -388,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/71GfnlOheQL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "mb",
    "price_numeric": 29.44,
    "currency": "USD",
    "price_original": "$29.44"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0Mzc1OTUxMjY5MzExMDM2OjE3NTM1NTkyMTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDQ2NzE2ODA3ODIwMjo6Mjo6&url=%2FKOOTION-Portable-Stylish-Computers-Protector%2Fdp%2FB09Y98XQ63%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB09Y98XQ63%26pd_rd_r%3D10140c59-eaf6-4a09-a6e6-e5b2479be0a7%26pd_rd_w%3DP0cb8%26pd_rd_wg%3DTOuYt%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D32A9X5NBZBX0SZ9A1483%26qid%3D1753559156%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-19-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B09Y98XQ63",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 19,
    "asin": "B09Y98XQ63",
    "title": "256 GB USB 3.0 Flash Drive KOOTION Flash Drive 3.0 Thumb Drive Retractable 256G Memory Stick USB Drive Jump Drive Rugged with LED Indicator for Data Storage and Transfer",
    "brand": "KOOTION",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.5,
    "review_count": 200,
    "special_features": "Retractable",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.9K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/51fnWdAOBGL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0Mzc1OTUxMjY5MzExMDM2OjE3NTM1NTkyMTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDIzMzY4NTczMTkwMjo6Mzo6&url=%2FKepmem-Portable-Colorful-Multipack-Storage%2Fdp%2FB09D3QK71Y%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB09D3QK71Y%26pd_rd_r%3D10140c59-eaf6-4a09-a6e6-e5b2479be0a7%26pd_rd_w%3DP0cb8%26pd_rd_wg%3DTOuYt%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D32A9X5NBZBX0SZ9A1483%26qid%3D1753559156%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-20-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B09D3QK71Y",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 20,
    "asin": "B09D3QK71Y",
    "title": "Kepmem Flash Drive 64GB Pack of 10 Thumb Drives Bulk 64 Giga USB Drives Value Metal USB 2.0 Memory Sticks Swivel Pen Drive 64 GB Portable Jump Drive Colorful Multipack Zip Drives for Data Storage",
    "brand": "Kepmem",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$37.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": "Metal, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -622,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/71lFJZly-9L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.99,
    "currency": "USD",
    "price_original": "$37.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0Mzc1OTUxMjY5MzExMDM2OjE3NTM1NTkyMTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0MjcyMjMzMTAwMjo6NDo6&url=%2FJUANWE-Flash-Drives-Drive-Pack%2Fdp%2FB089K1Y1CF%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB089K1Y1CF%26pd_rd_r%3D10140c59-eaf6-4a09-a6e6-e5b2479be0a7%26pd_rd_w%3DP0cb8%26pd_rd_wg%3DTOuYt%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D32A9X5NBZBX0SZ9A1483%26qid%3D1753559156%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-21-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B089K1Y1CF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 21,
    "asin": "B089K1Y1CF",
    "title": "JUANWE USB Flash Drive 256GB High Speed 3.0 Memory Stick Flash Drive Retractable Slide 256GB Jump Drive Zip Drive USB for Computers PC Laptop with Lanyard Hole",
    "brand": "JUANWE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$18.59",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Retractable, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.4K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/41wjoWZoZbL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.59,
    "currency": "USD",
    "price_original": "$18.59"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=2&xpid=0pS0dlS6IFFFB&crid=BALSGJKBQE1X&qid=1753559140&sprefix=flash+drive%2Caps%2C146&ref=sr_pg_1#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 22,
    "asin": null,
    "title": "32GB USB Flash Drive USB 3.1 Gen1 Dual USB-A & Type-C, Portable Thumb Drive for Smartphones, Laptops & Tablets",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$16.99",
    "rating": 4.4,
    "review_count": 60,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -7,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/51PxnRm-CUL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.99,
    "currency": "USD",
    "price_original": "$16.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxNTI2NDkxMDc4ODI0OTc2OjE3NTM1NTkyMTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MDY1Njc2NjIwMjo6MTo6&url=%2FOSCOO-Portable-Smartphones-Laptops-Tablets%2Fdp%2FB0F6MXMDVX%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0F6MXMDVX%26pd_rd_r%3D10140c59-eaf6-4a09-a6e6-e5b2479be0a7%26pd_rd_w%3DZtZ1a%26pd_rd_wg%3DTOuYt%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D32A9X5NBZBX0SZ9A1483%26qid%3D1753559156%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-17-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0F6MXMDVX",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 23,
    "asin": "B0F6MXMDVX",
    "title": "32GB USB Flash Drive USB 3.1 Gen1 Dual USB-A & Type-C, Portable Thumb Drive for Smartphones, Laptops & Tablets",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$16.99",
    "rating": 4.4,
    "review_count": 7,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -7,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/51PxnRm-CUL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.99,
    "currency": "USD",
    "price_original": "$16.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxNTI2NDkxMDc4ODI0OTc2OjE3NTM1NTkyMTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1NzYxMTExMjAwMjo6Mjo6&url=%2FSCICNCE-Intended-Required-Compatible-Computers%2Fdp%2FB0FFJPXSKZ%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FFJPXSKZ%26pd_rd_r%3D10140c59-eaf6-4a09-a6e6-e5b2479be0a7%26pd_rd_w%3DZtZ1a%26pd_rd_wg%3DTOuYt%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D32A9X5NBZBX0SZ9A1483%26qid%3D1753559156%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-18-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FFJPXSKZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 24,
    "asin": "B0FFJPXSKZ",
    "title": "SCICNCE 256GB Flash Drive Intended for iPhone, USB Memory Stick Storage Backup for Photos Videos, Plug and Play No APP Required, Compatible with iPhone iPad Android and Computers (Metal Gray)",
    "brand": "SCICNCE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$39.99",
    "rating": 4.6,
    "review_count": 39,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -39,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/61rBOw2g9FL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 39.99,
    "currency": "USD",
    "price_original": "$39.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxNTI2NDkxMDc4ODI0OTc2OjE3NTM1NTkyMTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1MDgwNDE5MzEwMjo6Mzo6&url=%2F256GB-USB-Flash-Drive-Compatible%2Fdp%2FB0FF4YTMLZ%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FF4YTMLZ%26pd_rd_r%3D10140c59-eaf6-4a09-a6e6-e5b2479be0a7%26pd_rd_w%3DZtZ1a%26pd_rd_wg%3DTOuYt%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D32A9X5NBZBX0SZ9A1483%26qid%3D1753559156%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-19-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FF4YTMLZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 25,
    "asin": "B0FF4YTMLZ",
    "title": "256GB USB Flash Drive ‚Äì 2 in 1 Flash Drive with USB 3.0 and Type C Connector ‚Äì High Speed Thumb Drive, Plug and Play Photo Stick, Memory Stick Compatible with Laptop, Android, PC",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$23.99",
    "rating": null,
    "review_count": 23,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/51Ri+2TBGwL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 23.99,
    "currency": "USD",
    "price_original": "$23.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxNTI2NDkxMDc4ODI0OTc2OjE3NTM1NTkyMTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5MjIwMjo6NDo6&url=%2F4GB-128GB-Personalized-Promotions-Corporate-Compatible%2Fdp%2FB0FGQ3ZM1L%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQ3ZM1L%26pd_rd_r%3D10140c59-eaf6-4a09-a6e6-e5b2479be0a7%26pd_rd_w%3DZtZ1a%26pd_rd_wg%3DTOuYt%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D32A9X5NBZBX0SZ9A1483%26qid%3D1753559156%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-20-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ3ZM1L",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 26,
    "asin": "B0FGQ3ZM1L",
    "title": "Mini Custom USB Flash Drive 4GB-128GB Tiny Personalized Thumb Drive with Logo for Business Promotions, Corporate Gifts, Trade Shows Bulk Mini USB Memory Stick, PC Mac Compatible (50,16GB)",
    "brand": "Mini",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$189.99",
    "rating": null,
    "review_count": 189,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-2_files/31Dd1PlYHIL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 189.99,
    "currency": "USD",
    "price_original": "$189.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToxNTI2NDkxMDc4ODI0OTc2OjE3NTM1NTkyMTM6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU4ODQwMjo6NTo6&url=%2FCustom-Drives-Personalized-Business-Promotions%2Fdp%2FB0FGQBSDMM%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQBSDMM%26pd_rd_r%3D10140c59-eaf6-4a09-a6e6-e5b2479be0a7%26pd_rd_w%3DZtZ1a%26pd_rd_wg%3DTOuYt%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D32A9X5NBZBX0SZ9A1483%26qid%3D1753559156%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-21-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQBSDMM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 27,
    "asin": "B0FGQBSDMM",
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (100,4GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$320.99",
    "rating": null,
    "review_count": 320,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-2_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 320.99,
    "currency": "USD",
    "price_original": "$320.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=2&xpid=0pS0dlS6IFFFB&crid=BALSGJKBQE1X&qid=1753559140&sprefix=flash+drive%2Caps%2C146&ref=sr_pg_1#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 28,
    "asin": null,
    "title": "JUANWE USB Flash Drive 256GB High Speed 3.0 Memory Stick Flash Drive Retractable Slide 256GB Jump Drive Zip Drive USB for Computers PC Laptop with Lanyard Hole",
    "brand": "JUANWE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$18.59",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Retractable, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.4K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/41wjoWZoZbL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.59,
    "currency": "USD",
    "price_original": "$18.59"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1NDU5Nzk5MTE2MzkyNDEwOjE3NTM1NTkyMTM6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4NDI3MjIzMzEwMDI6OjA6Og&url=%2FJUANWE-Flash-Drives-Drive-Pack%2Fdp%2FB089K1Y1CF%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB089K1Y1CF%26pd_rd_r%3Da8e1ccf2-1eae-4863-9978-82bee8961b02%26pd_rd_w%3DSqZkB%26pd_rd_wg%3D64Vt1%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D32A9X5NBZBX0SZ9A1483%26qid%3D1753559156%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-17-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B089K1Y1CF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 29,
    "asin": "B089K1Y1CF",
    "title": "JUANWE USB Flash Drive 256GB High Speed 3.0 Memory Stick Flash Drive Retractable Slide 256GB Jump Drive Zip Drive USB for Computers PC Laptop with Lanyard Hole",
    "brand": "JUANWE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$18.59",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Retractable, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.4K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/41wjoWZoZbL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.59,
    "currency": "USD",
    "price_original": "$18.59"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1NDU5Nzk5MTE2MzkyNDEwOjE3NTM1NTkyMTM6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAxOTk1OTIzMjMxMDI6OjE6Og&url=%2FWooolken-Drives-Memory-Lanyards-Storage%2Fdp%2FB0C5CYWMMC%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0C5CYWMMC%26pd_rd_r%3Da8e1ccf2-1eae-4863-9978-82bee8961b02%26pd_rd_w%3DSqZkB%26pd_rd_wg%3D64Vt1%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D32A9X5NBZBX0SZ9A1483%26qid%3D1753559156%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-18-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0C5CYWMMC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 30,
    "asin": "B0C5CYWMMC",
    "title": "1GB Flash Drive 20 Pack, Wooolken USB 2.0 Thumb Drives Memory Stick with LED Light and Lanyards for Storage and Backup (Mixed Colors: Black Red Blue Orange Green)",
    "brand": "1GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$32.39",
    "rating": 4.6,
    "review_count": 50,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/71-kUjhphpL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 32.39,
    "currency": "USD",
    "price_original": "$32.39"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1NDU5Nzk5MTE2MzkyNDEwOjE3NTM1NTkyMTM6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4NDA4NTYwMDM3MDI6OjI6Og&url=%2F64GB-Flash-Memory-Storage-Colors%2Fdp%2FB09C3JD1DZ%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB09C3JD1DZ%26pd_rd_r%3Da8e1ccf2-1eae-4863-9978-82bee8961b02%26pd_rd_w%3DSqZkB%26pd_rd_wg%3D64Vt1%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D32A9X5NBZBX0SZ9A1483%26qid%3D1753559156%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-19-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B09C3JD1DZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 31,
    "asin": "B09C3JD1DZ",
    "title": "FEBNISCTE 64GB Flash Drive 10 Pack, Thumb Drive High Capacity Multicolour, Bulk USB Flash Drives 64 GB Metal Swivel, USB 2.0 Jump Drive Portable, Pen Drive Zip High Speed for Data Storage",
    "brand": "FEBNISCTE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$32.39",
    "rating": 4.5,
    "review_count": 300,
    "special_features": "Metal, Swivel, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/71lxOtSOxNL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 32.39,
    "currency": "USD",
    "price_original": "$32.39"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1NDU5Nzk5MTE2MzkyNDEwOjE3NTM1NTkyMTM6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA0NzAxMTA4OTk1MDI6OjM6Og&url=%2FGARMESE-Waterproof-Portable-Keychain-Computer%2Fdp%2FB0D5H7XH7L%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0D5H7XH7L%26pd_rd_r%3Da8e1ccf2-1eae-4863-9978-82bee8961b02%26pd_rd_w%3DSqZkB%26pd_rd_wg%3D64Vt1%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D32A9X5NBZBX0SZ9A1483%26qid%3D1753559156%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-20-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0D5H7XH7L",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 32,
    "asin": "B0D5H7XH7L",
    "title": "64GB USB 3.0 Flash Drive, Waterproof Metal USB Memory Stick, Slim Thumb Drive Portable Pen Drive with Keychain Hole Stylish Jump Drive for PC Computer Car - Gray",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$7.59",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Waterproof, Metal, Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -360,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/51LdJJjyyOL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 7.59,
    "currency": "USD",
    "price_original": "$7.59"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1NDU5Nzk5MTE2MzkyNDEwOjE3NTM1NTkyMTM6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA3OTU3NDQyOTk1MDI6OjQ6Og&url=%2FDrives-JUANWE-Memory-Storage-Red-Black%2Fdp%2FB0B466ZSGG%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0B466ZSGG%26pd_rd_r%3Da8e1ccf2-1eae-4863-9978-82bee8961b02%26pd_rd_w%3DSqZkB%26pd_rd_wg%3D64Vt1%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D32A9X5NBZBX0SZ9A1483%26qid%3D1753559156%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-21-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0B466ZSGG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-2.html",
    "position": 33,
    "asin": "B0B466ZSGG",
    "title": "JUANWE 5 Pack 32GB USB 3.0 Flash Drive 32GB Thumb Drives High Speed USB Memory Stick USB Drive Zip Drive with LED Indicator for Data Storage",
    "brand": "JUANWE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$20.89",
    "rating": 4.4,
    "review_count": 388,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -388,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-2_files/61TFZPk3w8L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.89,
    "currency": "USD",
    "price_original": "$20.89"
  },
  {
    "product_url": "https://www.amazon.com/KEXIN-Mini-Size-Android-Smartphones-Tablets/dp/B0DW8L6XJV/ref=sr_1_307?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.uFd1jGeNQw-JM2UbHY_BeIqVaILgm_5_Nn-6n9MtO9s.2vscUU3aY_96JEd75ZMVtSb5OrJMLle1EEhxYpG6WRc&dib_tag=se&keywords=flash+drives&qid=1753562073&sprefix=flash+drive%2Caps%2C146&sr=8-307&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DW8L6XJV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-20.html",
    "position": 1,
    "asin": "B0DW8L6XJV",
    "title": "64G USB C Flash Drive USB 3.0 Metal Dual Drive 64 GB USB Stick Mini-Size OTG Memory Stick for Type-C Android Smartphones Tablets",
    "brand": "64G",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$11.89",
    "rating": 4.3,
    "review_count": 228,
    "special_features": "Metal, Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-20_files/51QpX1KTrbL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.89,
    "currency": "USD",
    "price_original": "$11.89"
  },
  {
    "product_url": "https://www.amazon.com/Smozer-Computer-Wedding-Anniversary-Photography/dp/B0CGPJRGFS/ref=sr_1_308?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.uFd1jGeNQw-JM2UbHY_BeIqVaILgm_5_Nn-6n9MtO9s.2vscUU3aY_96JEd75ZMVtSb5OrJMLle1EEhxYpG6WRc&dib_tag=se&keywords=flash+drives&qid=1753562073&sprefix=flash+drive%2Caps%2C146&sr=8-308&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CGPJRGFS",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-20.html",
    "position": 2,
    "asin": "B0CGPJRGFS",
    "title": "64GB USB 2.0 Flash Drive,Smozer Metal Love Heart Key Shaped USB Drive Thumb Drive USB Computer Memory Drive Nice Gifts for Wedding/Anniversary/Photography (64GB, 1 Pack with Gift Box)",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.7,
    "review_count": 50,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-20_files/514-+T+KglL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=20&crid=BALSGJKBQE1X&qid=1753562053&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_20#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-20.html",
    "position": 3,
    "asin": null,
    "title": "512GB Ultra USB 3.0 Flash Drive - SDCZ48-512G-G46, Black",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$34.33",
    "rating": 4.7,
    "review_count": 47,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(47.3K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-20_files/61T85CGI4ZL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.33,
    "currency": "USD",
    "price_original": "$34.33"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MTczMzY0ODY5Mzg0MDA0OjE3NTM1NjIwNzY6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDExNDU1ODgyMTg5ODo6MDo6&url=%2FSanDisk-512GB-Ultra-Flash-Drive%2Fdp%2FB083ZLJ5MG%2Fref%3Dsxin_14_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB083ZLJ5MG%26pd_rd_r%3Df06a903b-3d03-457a-a8c2-09ed11481a08%26pd_rd_w%3DcRJZo%26pd_rd_wg%3DWIV5q%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DSXTKHM3JMMSZV2CYTMQ6%26qid%3D1753562073%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-305-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B083ZLJ5MG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-20.html",
    "position": 4,
    "asin": "B083ZLJ5MG",
    "title": "512GB Ultra USB 3.0 Flash Drive - SDCZ48-512G-G46, Black",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$34.33",
    "rating": 4.7,
    "review_count": 8,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(47.3K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-20_files/61T85CGI4ZL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.33,
    "currency": "USD",
    "price_original": "$34.33"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MTczMzY0ODY5Mzg0MDA0OjE3NTM1NjIwNzY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDc4NzY4ODAzOTYwMjo6MTo6&url=%2FJUANWE-Storage-Memory-Swivel-Keychain%2Fdp%2FB08FSWHTDZ%2Fref%3Dsxin_14_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB08FSWHTDZ%26pd_rd_r%3Df06a903b-3d03-457a-a8c2-09ed11481a08%26pd_rd_w%3DcRJZo%26pd_rd_wg%3DWIV5q%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DSXTKHM3JMMSZV2CYTMQ6%26qid%3D1753562073%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-306-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B08FSWHTDZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-20.html",
    "position": 5,
    "asin": "B08FSWHTDZ",
    "title": "128GB Flash Drive 2 PCS, 2.0 Thumb Drive USB Drives Pendrive for File Storage Data Transfer, High Capacity Zip Drive Portable USB Storage Flashdrives 360¬∞ Swivel Cap, Jump Drive 128G√ó2 Black",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$16.99",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Swivel, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-20_files/61P2-oyA90L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.99,
    "currency": "USD",
    "price_original": "$16.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MTczMzY0ODY5Mzg0MDA0OjE3NTM1NjIwNzY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MDkzNTgzMjIwMjo6Mjo6&url=%2FAGECASH-Flashdrive-Pendrive-Transfer-Multi-Colored%2Fdp%2FB0CBK1HRHK%2Fref%3Dsxin_14_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CBK1HRHK%26pd_rd_r%3Df06a903b-3d03-457a-a8c2-09ed11481a08%26pd_rd_w%3DcRJZo%26pd_rd_wg%3DWIV5q%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DSXTKHM3JMMSZV2CYTMQ6%26qid%3D1753562073%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-307-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CBK1HRHK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-20.html",
    "position": 6,
    "asin": "B0CBK1HRHK",
    "title": "USB Flash Drives 20 Pack 512MB Flash Drive AGECASH A USB 2.0 Thumb Drive Jump Zip Drive Flashdrive Memory Stick Pendrive for Data Storage & Transfer with 20PCS Lanyard (Multi-Colored 512MB)",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$27.54",
    "rating": 4.6,
    "review_count": 143,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -143,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-20_files/81xaaPBewUL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "mb",
    "price_numeric": 27.54,
    "currency": "USD",
    "price_original": "$27.54"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MTczMzY0ODY5Mzg0MDA0OjE3NTM1NjIwNzY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDQ3MTQzNzAxMTQwMjo6Mzo6&url=%2FPNY-128GB-Turbo-Attach%25C3%25A9-5-Pack%2Fdp%2FB0DDYCT5YS%2Fref%3Dsxin_14_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DDYCT5YS%26pd_rd_r%3Df06a903b-3d03-457a-a8c2-09ed11481a08%26pd_rd_w%3DcRJZo%26pd_rd_wg%3DWIV5q%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DSXTKHM3JMMSZV2CYTMQ6%26qid%3D1753562073%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-308-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DDYCT5YS",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-20.html",
    "position": 7,
    "asin": "B0DDYCT5YS",
    "title": "128GB Turbo Attach√© 3 USB 3.0 Flash Drive 5-Pack ‚Äì Grey, P-FD128X5TBOP-MP, 100MB/s, Light-Weight Durable - Data Storage and Transfer",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$29.99",
    "rating": 4.6,
    "review_count": 10,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(40.4K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-20_files/6155RbbYkAL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 29.99,
    "currency": "USD",
    "price_original": "$29.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MTczMzY0ODY5Mzg0MDA0OjE3NTM1NjIwNzY6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDY2OTU2MTIzNzkwMjo6NDo6&url=%2FPNY-Advanced-Performance-Everyday-Computers%2Fdp%2FB0DSR9D4PL%2Fref%3Dsxin_14_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DSR9D4PL%26pd_rd_r%3Df06a903b-3d03-457a-a8c2-09ed11481a08%26pd_rd_w%3DcRJZo%26pd_rd_wg%3DWIV5q%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DSXTKHM3JMMSZV2CYTMQ6%26qid%3D1753562073%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-309-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DSR9D4PL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-20.html",
    "position": 8,
    "asin": "B0DSR9D4PL",
    "title": "256GB Attach√© X USB 3.2 Gen 1 Flash Drive, Advanced Performance Up to 130MB/s Read, Everyday Data Store & Transfer, Reliable Portable Storage, Durable, Type-A, Computers, Laptops, Desktops",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$14.99",
    "rating": 4.5,
    "review_count": 2,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-20_files/41Oo++SA0+L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.99,
    "currency": "USD",
    "price_original": "$14.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=20&crid=BALSGJKBQE1X&qid=1753562053&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_20#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-20.html",
    "position": 9,
    "asin": null,
    "title": "128GB Flash Drive 2 PCS, 2.0 Thumb Drive USB Drives Pendrive for File Storage Data Transfer, High Capacity Zip Drive Portable USB Storage Flashdrives 360¬∞ Swivel Cap, Jump Drive 128G√ó2 Black",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$16.99",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Swivel, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-20_files/61P2-oyA90L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.99,
    "currency": "USD",
    "price_original": "$16.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NzEzNDEwNjExODY3MzIwOjE3NTM1NjIwNzY6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA3ODc2ODgwMzk2MDI6OjA6Og&url=%2FJUANWE-Storage-Memory-Swivel-Keychain%2Fdp%2FB08FSWHTDZ%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB08FSWHTDZ%26pd_rd_r%3Df1af6471-b0eb-4e69-9dbc-33f3cb26c37c%26pd_rd_w%3DhH0Ys%26pd_rd_wg%3Dfyz0n%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DSXTKHM3JMMSZV2CYTMQ6%26qid%3D1753562073%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-305-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B08FSWHTDZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-20.html",
    "position": 10,
    "asin": "B08FSWHTDZ",
    "title": "128GB Flash Drive 2 PCS, 2.0 Thumb Drive USB Drives Pendrive for File Storage Data Transfer, High Capacity Zip Drive Portable USB Storage Flashdrives 360¬∞ Swivel Cap, Jump Drive 128G√ó2 Black",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$16.99",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Swivel, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-20_files/61P2-oyA90L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.99,
    "currency": "USD",
    "price_original": "$16.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NzEzNDEwNjExODY3MzIwOjE3NTM1NjIwNzY6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4NDI3MjIzMzEwMDI6OjE6Og&url=%2FJUANWE-Flash-Drives-Drive-Pack%2Fdp%2FB089K1Y1CF%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB089K1Y1CF%26pd_rd_r%3Df1af6471-b0eb-4e69-9dbc-33f3cb26c37c%26pd_rd_w%3DhH0Ys%26pd_rd_wg%3Dfyz0n%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DSXTKHM3JMMSZV2CYTMQ6%26qid%3D1753562073%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-306-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B089K1Y1CF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-20.html",
    "position": 11,
    "asin": "B089K1Y1CF",
    "title": "USB Flash Drive 256GB High Speed 3.0 Memory Stick Flash Drive Retractable Slide 256GB Jump Drive Zip Drive USB for Computers PC Laptop with Lanyard Hole",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$18.59",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Retractable, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.4K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-20_files/41wjoWZoZbL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.59,
    "currency": "USD",
    "price_original": "$18.59"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NzEzNDEwNjExODY3MzIwOjE3NTM1NjIwNzY6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyNjM4NTg1MDI5MDI6OjI6Og&url=%2FWooolken-20Pack-Keychains-Swivel-Computer%2Fdp%2FB0CXLYMJLB%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CXLYMJLB%26pd_rd_r%3Df1af6471-b0eb-4e69-9dbc-33f3cb26c37c%26pd_rd_w%3DhH0Ys%26pd_rd_wg%3Dfyz0n%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DSXTKHM3JMMSZV2CYTMQ6%26qid%3D1753562073%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-307-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CXLYMJLB",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-20.html",
    "position": 12,
    "asin": "B0CXLYMJLB",
    "title": "USB Flash Drives 1GB 20 Pack, Wooolken USB 2.0 Thumb Drives with Keychains Memory Stick USB Drive Pendrive for PC Laptop Computer (Black)",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$33.29",
    "rating": 4.5,
    "review_count": 569,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -569,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-20_files/71Aw2AB2hQL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 33.29,
    "currency": "USD",
    "price_original": "$33.29"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NzEzNDEwNjExODY3MzIwOjE3NTM1NjIwNzY6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyNjM4NTg0OTg2MDI6OjM6Og&url=%2FDrives-Wooolken-Perfect-Weddings-Storage%2Fdp%2FB0C7CHGR74%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0C7CHGR74%26pd_rd_r%3Df1af6471-b0eb-4e69-9dbc-33f3cb26c37c%26pd_rd_w%3DhH0Ys%26pd_rd_wg%3Dfyz0n%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DSXTKHM3JMMSZV2CYTMQ6%26qid%3D1753562073%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-308-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0C7CHGR74",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-20.html",
    "position": 13,
    "asin": "B0C7CHGR74",
    "title": "2GB Flash Drives 100 Pack, Wooolken USB 2.0 Thumb Drive with Lanyards Bulk USB Sticks for Weddings,Office, School, Data Storage Backup",
    "brand": "2GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$144.49",
    "rating": 4.6,
    "review_count": 700,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-20_files/61bG6tJRBKL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 144.49,
    "currency": "USD",
    "price_original": "$144.49"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NzEzNDEwNjExODY3MzIwOjE3NTM1NjIwNzY6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyMzk0NzMwMDc0MDI6OjQ6Og&url=%2FPortable-Keychain-External-Storage-Red%2Fdp%2FB098XCNFVX%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB098XCNFVX%26pd_rd_r%3Df1af6471-b0eb-4e69-9dbc-33f3cb26c37c%26pd_rd_w%3DhH0Ys%26pd_rd_wg%3Dfyz0n%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DSXTKHM3JMMSZV2CYTMQ6%26qid%3D1753562073%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-309-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B098XCNFVX",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-20.html",
    "position": 14,
    "asin": "B098XCNFVX",
    "title": "64GB USB Flash Drive Portable Metal Thumb Drive with Keychain USB 2.0 Memory Stick Pen Drive for External Data Storage, Red",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$14.39",
    "rating": 4.2,
    "review_count": 382,
    "special_features": "Metal, Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -382,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-20_files/512Rins2WSS._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.39,
    "currency": "USD",
    "price_original": "$14.39"
  },
  {
    "product_url": "https://www.amazon.com/Samsung-MUF-128AB-AM-Plus-128GB/dp/B07D7PDLXC/ref=sr_1_35?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.nAKD1DHvizizYqLARIGOmfy_Osd75Ku_TX2TreNhN93GjHj071QN20LucGBJIEps.1Ah2gZQb44sQ86CE-vMZz4CmPbigGHbnV-74OD43_6E&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-35&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07D7PDLXC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 1,
    "asin": "B07D7PDLXC",
    "title": "SAMSUNG FIT Plus 3.1 USB Flash Drive, 128GB, 400MB/s, Plug In and Stay, Storage Expansion for Laptop, Tablet, Smart TV, Car Audio System, Gaming Console, MUF-128AB/AM,Gunmetal Gray",
    "brand": "Samsung",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$14.99",
    "rating": 4.7,
    "review_count": 4,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/51qdrdt4rTL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.99,
    "currency": "USD",
    "price_original": "$14.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Ultra-Flash-Drive-Plug/dp/B0DJ336HC8/ref=sr_1_36?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.nAKD1DHvizizYqLARIGOmfy_Osd75Ku_TX2TreNhN93GjHj071QN20LucGBJIEps.1Ah2gZQb44sQ86CE-vMZz4CmPbigGHbnV-74OD43_6E&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-36&ufe=app_do%3Aamzn1.fos.9fe8cbfa-bf43-43d1-a707-3f4e65a4b666&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DJ336HC8",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 2,
    "asin": "B0DJ336HC8",
    "title": "SanDisk 1TB Ultra Fit USB 3.2 Gen 1 Flash Drive - Up to 400MB/s, Plug-and-Stay Design - SDCZ430-1T00-G46",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$84.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes6 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/81YqKSxxXEL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "tb",
    "price_numeric": 84.99,
    "currency": "USD",
    "price_original": "$84.99"
  },
  {
    "product_url": "https://www.amazon.com/Kepmem-Portable-Keychain-Colorful-Multipack/dp/B07HCH26MC/ref=sr_1_37?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.nAKD1DHvizizYqLARIGOmfy_Osd75Ku_TX2TreNhN93GjHj071QN20LucGBJIEps.1Ah2gZQb44sQ86CE-vMZz4CmPbigGHbnV-74OD43_6E&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-37&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07HCH26MC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 3,
    "asin": "B07HCH26MC",
    "title": "Kepmem 32GB USB Stick Pack of 10 USB 2.0 Memory Sticks Bulk, Metal 32 Giga Flash Drive Swivel Pendrive Portable Keychain Pen Drives 32 GB Colorful Multipack U Disk for Data Storage Paper Works",
    "brand": "Kepmem",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$34.22",
    "rating": 4.6,
    "review_count": 500,
    "special_features": "Metal, Keychain, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(8.5K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/71lFJZly-9L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.22,
    "currency": "USD",
    "price_original": "$34.22"
  },
  {
    "product_url": "https://www.amazon.com/SuperSpeed-64GB-USB-3-0-Storage/dp/B07T4J6X1N/ref=sr_1_33?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.xEDLrniWUzDp4kXula1Ag9ac5ujBLCO7F0LOTnUs44_HCA5GID5ttdzjSc4i-8vzFNMMC1kkq8gKWfJnLLK0Wm0jHymsYEcDKXgv1I364YSZMRP1GC79zDgb2JjwzdzS-SLnY7x0d-0CphezFdCUItjzydpmKz6g1qa-HucRUiJXhvhzNQiBfXjQKL0tJnS3.6RTyW5HP5Q3whVbXqUQHF8nyWxd8VgSlJP3i3GXlfHE&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-33&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07T4J6X1N",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 4,
    "asin": "B07T4J6X1N",
    "title": "Micro Center SuperSpeed 5 Pack 64GB USB 3.0 Flash Drive Gum Size Memory Stick Thumb Drive Data Storage Jump Drive (64G 5-Pack)",
    "brand": "Micro",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.6,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(24.5K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/817QTq8xiZL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/Flash-Drive-Drives-Swivel-Memory/dp/B09TK3WP2C/ref=sr_1_34?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.xEDLrniWUzDp4kXula1Ag9ac5ujBLCO7F0LOTnUs44_HCA5GID5ttdzjSc4i-8vzFNMMC1kkq8gKWfJnLLK0Wm0jHymsYEcDKXgv1I364YSZMRP1GC79zDgb2JjwzdzS-SLnY7x0d-0CphezFdCUItjzydpmKz6g1qa-HucRUiJXhvhzNQiBfXjQKL0tJnS3.6RTyW5HP5Q3whVbXqUQHF8nyWxd8VgSlJP3i3GXlfHE&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-34&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09TK3WP2C",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 5,
    "asin": "B09TK3WP2C",
    "title": "10 Pack 16GB USB Flash Drives, Bulk USB 2.0 Thumb Drives with Swivel Cap",
    "brand": 10,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$23.99",
    "rating": 4.5,
    "review_count": 200,
    "special_features": "Swivel, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/61-lx1wYivL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 23.99,
    "currency": "USD",
    "price_original": "$23.99"
  },
  {
    "product_url": "https://www.amazon.com/KEXIN-Flash-Drive-Storage-Memory/dp/B07MLGYB5F/ref=sr_1_35?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.xEDLrniWUzDp4kXula1Ag9ac5ujBLCO7F0LOTnUs44_HCA5GID5ttdzjSc4i-8vzFNMMC1kkq8gKWfJnLLK0Wm0jHymsYEcDKXgv1I364YSZMRP1GC79zDgb2JjwzdzS-SLnY7x0d-0CphezFdCUItjzydpmKz6g1qa-HucRUiJXhvhzNQiBfXjQKL0tJnS3.6RTyW5HP5Q3whVbXqUQHF8nyWxd8VgSlJP3i3GXlfHE&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-35&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07MLGYB5F",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 6,
    "asin": "B07MLGYB5F",
    "title": "KEXIN 10 Pack 32GB Flash Drive USB Drive Memory Stick Thumb Drive, Black USB 2.0",
    "brand": "KEXIN",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$29.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "11 sizes11 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/61DLDQHeTvL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 29.99,
    "currency": "USD",
    "price_original": "$29.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Cruzer-Blade-8GB-SDCZ50-008G/dp/B07D7WFVK5/ref=sr_1_36?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.xEDLrniWUzDp4kXula1Ag9ac5ujBLCO7F0LOTnUs44_HCA5GID5ttdzjSc4i-8vzFNMMC1kkq8gKWfJnLLK0Wm0jHymsYEcDKXgv1I364YSZMRP1GC79zDgb2JjwzdzS-SLnY7x0d-0CphezFdCUItjzydpmKz6g1qa-HucRUiJXhvhzNQiBfXjQKL0tJnS3.6RTyW5HP5Q3whVbXqUQHF8nyWxd8VgSlJP3i3GXlfHE&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-36&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07D7WFVK5",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 7,
    "asin": "B07D7WFVK5",
    "title": "SanDisk 8GB Cruzer Blade USB 2.0 Flash Memory Drive SDCZ50-008G (10 Pack)",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "SD",
    "price": "$39.02",
    "rating": 4.7,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.4K)",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/71v7S+c12ML._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 39.02,
    "currency": "USD",
    "price_original": "$39.02"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Extreme-Solid-State-Flash/dp/B08GYPZ8GN/ref=sr_1_37?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.xEDLrniWUzDp4kXula1Ag9ac5ujBLCO7F0LOTnUs44_HCA5GID5ttdzjSc4i-8vzFNMMC1kkq8gKWfJnLLK0Wm0jHymsYEcDKXgv1I364YSZMRP1GC79zDgb2JjwzdzS-SLnY7x0d-0CphezFdCUItjzydpmKz6g1qa-HucRUiJXhvhzNQiBfXjQKL0tJnS3.6RTyW5HP5Q3whVbXqUQHF8nyWxd8VgSlJP3i3GXlfHE&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-37&ufe=app_do%3Aamzn1.fos.9fe8cbfa-bf43-43d1-a707-3f4e65a4b666&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08GYPZ8GN",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 8,
    "asin": "B08GYPZ8GN",
    "title": "SanDisk 1TB Extreme PRO USB 3.2 Solid State Flash Drive - Up to 420MB/s, Durable Aluminum Metal Casting - SDCZ880-1T00-GAM46",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$108.94",
    "rating": 4.6,
    "review_count": 1,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/71eKXcpG0vL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "tb",
    "price_numeric": 108.94,
    "currency": "USD",
    "price_original": "$108.94"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Ultra-Transfer-Speeds-SDCZ48-064G-UAM46/dp/B00KYK2ABI/ref=sr_1_40?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.xEDLrniWUzDp4kXula1Ag9ac5ujBLCO7F0LOTnUs44_HCA5GID5ttdzjSc4i-8vzFNMMC1kkq8gKWfJnLLK0Wm0jHymsYEcDKXgv1I364YSZMRP1GC79zDgb2JjwzdzS-SLnY7x0d-0CphezFdCUItjzydpmKz6g1qa-HucRUiJXhvhzNQiBfXjQKL0tJnS3.6RTyW5HP5Q3whVbXqUQHF8nyWxd8VgSlJP3i3GXlfHE&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-40&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B00KYK2ABI",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 9,
    "asin": "B00KYK2ABI",
    "title": "SanDisk 64GB Ultra USB 3.0 Flash Drive - SDCZ48-064G-UAM46",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$8.85",
    "rating": 4.7,
    "review_count": 3,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/41noUryXa7L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 8.85,
    "currency": "USD",
    "price_original": "$8.85"
  },
  {
    "product_url": "https://www.amazon.com/Center-SuperSpeed-Memory-Storage-10-Pack/dp/B09YCXYVCL/ref=sr_1_41?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.xEDLrniWUzDp4kXula1Ag9ac5ujBLCO7F0LOTnUs44_HCA5GID5ttdzjSc4i-8vzFNMMC1kkq8gKWfJnLLK0Wm0jHymsYEcDKXgv1I364YSZMRP1GC79zDgb2JjwzdzS-SLnY7x0d-0CphezFdCUItjzydpmKz6g1qa-HucRUiJXhvhzNQiBfXjQKL0tJnS3.6RTyW5HP5Q3whVbXqUQHF8nyWxd8VgSlJP3i3GXlfHE&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-41&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09YCXYVCL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 10,
    "asin": "B09YCXYVCL",
    "title": "INLAND Micro Center SuperSpeed 10 Pack 64GB USB 3.0 Flash Drive Gum Size Memory Stick Thumb Drive Data Storage Jump Drive, 10X Faster Than USB 2.0 USB Drive (64G 10-Pack)",
    "brand": "INLAND",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$37.99",
    "rating": 4.6,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(8.9K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/81W-fR7QCqL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.99,
    "currency": "USD",
    "price_original": "$37.99"
  },
  {
    "product_url": "https://www.amazon.com/ENUODA-Memory-Swivel-Indicator-Storage/dp/B09WY73DSN/ref=sr_1_42?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.xEDLrniWUzDp4kXula1Ag9ac5ujBLCO7F0LOTnUs44_HCA5GID5ttdzjSc4i-8vzFNMMC1kkq8gKWfJnLLK0Wm0jHymsYEcDKXgv1I364YSZMRP1GC79zDgb2JjwzdzS-SLnY7x0d-0CphezFdCUItjzydpmKz6g1qa-HucRUiJXhvhzNQiBfXjQKL0tJnS3.6RTyW5HP5Q3whVbXqUQHF8nyWxd8VgSlJP3i3GXlfHE&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-42&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09WY73DSN",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 11,
    "asin": "B09WY73DSN",
    "title": "ENUODA 128GB USB Flash Drive Thumb Drive 128GB Swivel Design USB 2.0 Memory Stick High Capacity Jump Drive Pen Drive for Laptop PC Computer (Black)",
    "brand": "ENUODA",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$6.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": "Swivel, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/61e-b54BEcL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 6.99,
    "currency": "USD",
    "price_original": "$6.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=3&crid=BALSGJKBQE1X&qid=1753559156&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_2#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 12,
    "asin": null,
    "title": "„ÄêGIGASTONE„Äë Z90 128GB 2-Pack USB 3.2 Gen1 Flash Drive, Mini Fit Metal Waterproof Compact Pen Drive, Reliable Performance Thumb Drive, USB 2.0/3.0/3.1 Interface Compatible",
    "brand": "Gigastone",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$22.99",
    "rating": 4.3,
    "review_count": 869,
    "special_features": "Waterproof, Metal, Compact, Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -869,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/718IldIBTWL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 22.99,
    "currency": "USD",
    "price_original": "$22.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0ODc3NDkyMTgwODgyMDAzOjE3NTM1NTkyMzc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDYwMzkzNzY1OTIwMjo6MDo6&url=%2FGigastone-Waterproof-Performance-Interface-Compatible%2Fdp%2FB0886FJPP1%2Fref%3Dsxin_14_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0886FJPP1%26pd_rd_r%3Dc12bc508-d897-4e79-b359-2c8bd4775b97%26pd_rd_w%3DXSUo8%26pd_rd_wg%3Djr1gv%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D5D78GCKCXYHJCA5AJYZQ%26qid%3D1753559235%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-33-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0886FJPP1",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 13,
    "asin": "B0886FJPP1",
    "title": "„ÄêGIGASTONE„Äë Z90 128GB 2-Pack USB 3.2 Gen1 Flash Drive, Mini Fit Metal Waterproof Compact Pen Drive, Reliable Performance Thumb Drive, USB 2.0/3.0/3.1 Interface Compatible",
    "brand": "Gigastone",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$22.99",
    "rating": 4.3,
    "review_count": 100,
    "special_features": "Waterproof, Metal, Compact, Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -869,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/718IldIBTWL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 22.99,
    "currency": "USD",
    "price_original": "$22.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0ODc3NDkyMTgwODgyMDAzOjE3NTM1NTkyMzc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDUyODMzOTM1MDQwMjo6MTo6&url=%2FPNY-128GB-Attach%25C3%25A9-Flash-5-Pack%2Fdp%2FB0BDT8FTMP%2Fref%3Dsxin_14_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0BDT8FTMP%26pd_rd_r%3Dc12bc508-d897-4e79-b359-2c8bd4775b97%26pd_rd_w%3DXSUo8%26pd_rd_wg%3Djr1gv%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D5D78GCKCXYHJCA5AJYZQ%26qid%3D1753559235%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-34-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0BDT8FTMP",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 14,
    "asin": "B0BDT8FTMP",
    "title": "PNY 128GB Attach√© 3 USB 2.0 Flash Drive, Black (Pack of 5)",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$24.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.6K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/51L3dUD+jkL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0ODc3NDkyMTgwODgyMDAzOjE3NTM1NTkyMzc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDAxMzk4OTYzNDAwMjo6Mjo6&url=%2FFlash-KOOTION-Drives-Keychain-Memory%2Fdp%2FB0BZ45SMMG%2Fref%3Dsxin_14_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0BZ45SMMG%26pd_rd_r%3Dc12bc508-d897-4e79-b359-2c8bd4775b97%26pd_rd_w%3DXSUo8%26pd_rd_wg%3Djr1gv%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D5D78GCKCXYHJCA5AJYZQ%26qid%3D1753559235%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-35-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0BZ45SMMG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 15,
    "asin": "B0BZ45SMMG",
    "title": "64GB Flash Drive KOOTION 10 Pack USB 2.0 Flash Drive 64GB USB Flash Drives Thumb Drive Jump Drives Keychain Memory Stick Black",
    "brand": "KOOTION",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$35.99",
    "rating": 4.6,
    "review_count": 50,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2.4K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/61cDvE0WCZL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 35.99,
    "currency": "USD",
    "price_original": "$35.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0ODc3NDkyMTgwODgyMDAzOjE3NTM1NTkyMzc6c3Bfc2VhcmNoX3RoZW1hdGljOjIwMDE1NDczNjg2NTc5ODo6Mzo6&url=%2FKootion-Drives-Keychain-Memory-Mixcolored%2Fdp%2FB07PXQ81YH%2Fref%3Dsxin_14_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07PXQ81YH%26pd_rd_r%3Dc12bc508-d897-4e79-b359-2c8bd4775b97%26pd_rd_w%3DXSUo8%26pd_rd_wg%3Djr1gv%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D5D78GCKCXYHJCA5AJYZQ%26qid%3D1753559235%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-36-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07PXQ81YH",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 16,
    "asin": "B07PXQ81YH",
    "title": "USB 3.0 Flash Drive KOOTION 10 Pack 32GB Thumb Drive 3.0 USB Stick Keychain Memory Stick Swivel Jump Drives, Mixcolors",
    "brand": "KOOTION",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 4.5,
    "review_count": 100,
    "special_features": "Keychain, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(9.3K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/61G7boSqjQL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0ODc3NDkyMTgwODgyMDAzOjE3NTM1NTkyMzc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1OTYyOTMxNDkwMjo6NDo6&url=%2FFlash-Drive-16GB-Pack-AGECASH%2Fdp%2FB0F8MDVXD6%2Fref%3Dsxin_14_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0F8MDVXD6%26pd_rd_r%3Dc12bc508-d897-4e79-b359-2c8bd4775b97%26pd_rd_w%3DXSUo8%26pd_rd_wg%3Djr1gv%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D5D78GCKCXYHJCA5AJYZQ%26qid%3D1753559235%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-37-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0F8MDVXD6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 17,
    "asin": "B0F8MDVXD6",
    "title": "USB Flash Drive 16GB Flash Drives 20 Pack, AGECASH USB 2.0 Thumb Drive 20 Pack Swivel Pendrive Memory Stick Zip Jump Drives Multipack with 20PCS Black Lanyards (Colorful, 16GB)",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$47.99",
    "rating": 4.6,
    "review_count": 143,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -143,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/71ewhlqH8GL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 47.99,
    "currency": "USD",
    "price_original": "$47.99"
  },
  {
    "product_url": "https://www.amazon.com/PNY-Turbo-Attach%C3%A9-Flash-3-Pack/dp/B08Y2HMH5X/ref=sr_1_43?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.xEDLrniWUzDp4kXula1Ag9ac5ujBLCO7F0LOTnUs44_HCA5GID5ttdzjSc4i-8vzFNMMC1kkq8gKWfJnLLK0Wm0jHymsYEcDKXgv1I364YSZMRP1GC79zDgb2JjwzdzS-SLnY7x0d-0CphezFdCUItjzydpmKz6g1qa-HucRUiJXhvhzNQiBfXjQKL0tJnS3.6RTyW5HP5Q3whVbXqUQHF8nyWxd8VgSlJP3i3GXlfHE&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-43&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08Y2HMH5X",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 18,
    "asin": "B08Y2HMH5X",
    "title": "PNY 64GB Turbo Attach√© 3 USB 3.0 Flash Drive,Grey (Pack of 3)",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$14.99",
    "rating": 4.6,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2.8K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/61uI5uuOrCL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.99,
    "currency": "USD",
    "price_original": "$14.99"
  },
  {
    "product_url": "https://www.amazon.com/Aiibe-Memory-Sticks-Drives-Yellow/dp/B0BJPXC26G/ref=sr_1_44?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.xEDLrniWUzDp4kXula1Ag9ac5ujBLCO7F0LOTnUs44_HCA5GID5ttdzjSc4i-8vzFNMMC1kkq8gKWfJnLLK0Wm0jHymsYEcDKXgv1I364YSZMRP1GC79zDgb2JjwzdzS-SLnY7x0d-0CphezFdCUItjzydpmKz6g1qa-HucRUiJXhvhzNQiBfXjQKL0tJnS3.6RTyW5HP5Q3whVbXqUQHF8nyWxd8VgSlJP3i3GXlfHE&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-44&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BJPXC26G",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 19,
    "asin": "B0BJPXC26G",
    "title": "Aiibe 128GB Flash Drive 5 Pack 128GB USB Flash Drives Thumb Drive 128 GB USB Drive USB 2.0 Memory Sticks Jump Drives 128G (5 Pack, Red Green Cyan Yellow Purple)",
    "brand": "Aiibe",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$39.99",
    "rating": 4.3,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/51dXpywFjWL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 39.99,
    "currency": "USD",
    "price_original": "$39.99"
  },
  {
    "product_url": "https://www.amazon.com/Pnstaw-Swivel-Storage-Sharing-Multi-Color/dp/B07DNQ92F2/ref=sr_1_45?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.xEDLrniWUzDp4kXula1Ag9ac5ujBLCO7F0LOTnUs44_HCA5GID5ttdzjSc4i-8vzFNMMC1kkq8gKWfJnLLK0Wm0jHymsYEcDKXgv1I364YSZMRP1GC79zDgb2JjwzdzS-SLnY7x0d-0CphezFdCUItjzydpmKz6g1qa-HucRUiJXhvhzNQiBfXjQKL0tJnS3.6RTyW5HP5Q3whVbXqUQHF8nyWxd8VgSlJP3i3GXlfHE&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-45&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07DNQ92F2",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 20,
    "asin": "B07DNQ92F2",
    "title": "32GB USB 2.0 Flash Drive Pnstaw Swivel Memory Stick Thumb Drive Pen Drives Jump Drive for Data Storage, File Sharing(10 Pack,Multi-Color) (32GB)",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$29.99",
    "rating": 4.5,
    "review_count": 100,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "10 sizes10 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/61CHGc76PaL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 29.99,
    "currency": "USD",
    "price_original": "$29.99"
  },
  {
    "product_url": "https://www.amazon.com/DataOcean-64GB-Memory-Drives-Swivel/dp/B07Q3Y5J5T/ref=sr_1_46?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.xEDLrniWUzDp4kXula1Ag9ac5ujBLCO7F0LOTnUs44_HCA5GID5ttdzjSc4i-8vzFNMMC1kkq8gKWfJnLLK0Wm0jHymsYEcDKXgv1I364YSZMRP1GC79zDgb2JjwzdzS-SLnY7x0d-0CphezFdCUItjzydpmKz6g1qa-HucRUiJXhvhzNQiBfXjQKL0tJnS3.6RTyW5HP5Q3whVbXqUQHF8nyWxd8VgSlJP3i3GXlfHE&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-46&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07Q3Y5J5T",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 21,
    "asin": "B07Q3Y5J5T",
    "title": "2 Pack 64GB USB 2.0 Flash Drive Memory Stick Thumb Drives Swivel Design(2 X 64GB: Black Silver)",
    "brand": 2,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$7.99",
    "rating": 4.5,
    "review_count": 1,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/71arPE1Bm-S._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 7.99,
    "currency": "USD",
    "price_original": "$7.99"
  },
  {
    "product_url": "https://www.amazon.com/128MB-Drives-Pack-EASTBULL-Storage/dp/B08T1RXN4S/ref=sr_1_47?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.xEDLrniWUzDp4kXula1Ag9ac5ujBLCO7F0LOTnUs44_HCA5GID5ttdzjSc4i-8vzFNMMC1kkq8gKWfJnLLK0Wm0jHymsYEcDKXgv1I364YSZMRP1GC79zDgb2JjwzdzS-SLnY7x0d-0CphezFdCUItjzydpmKz6g1qa-HucRUiJXhvhzNQiBfXjQKL0tJnS3.6RTyW5HP5Q3whVbXqUQHF8nyWxd8VgSlJP3i3GXlfHE&dib_tag=se&keywords=flash+drives&qid=1753559235&sprefix=flash+drive%2Caps%2C146&sr=8-47&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08T1RXN4S",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 22,
    "asin": "B08T1RXN4S",
    "title": "128MB Bulk Flash Drives 100 Pack, EASTBULL USB 2.0 Flash Drives Bulk USB Drive Bulk Storage Flash Drive Pack (Black)",
    "brand": "128MB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$115.88",
    "rating": 4.5,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -376,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/71YJniBq6EL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "mb",
    "price_numeric": 115.88,
    "currency": "USD",
    "price_original": "$115.88"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=3&crid=BALSGJKBQE1X&qid=1753559156&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_2#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 23,
    "asin": null,
    "title": "512GB USB SSD Flash Drive‚ÄìUSB 3.2 Gen1 High-Speed Thumb Drive, Up to 550MB/s, Dual USB-C & A Ports, Compatible with Smartphones, Android, PC, Laptop‚ÄìPortable Photo & Video Backup Stick",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$60.99",
    "rating": 4.4,
    "review_count": 60,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -7,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/51RMzbFwRsL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 60.99,
    "currency": "USD",
    "price_original": "$60.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NzAwMTMxNjM5NDYyMTQ1OjE3NTM1NTkyMzc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MDY1Njc2NjcwMjo6MTo6&url=%2FOSCOO-High-Speed-Compatible-Smartphones-Laptop-Portable%2Fdp%2FB0F6MYR7G1%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0F6MYR7G1%26pd_rd_r%3Dc12bc508-d897-4e79-b359-2c8bd4775b97%26pd_rd_w%3DWISAI%26pd_rd_wg%3Djr1gv%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D5D78GCKCXYHJCA5AJYZQ%26qid%3D1753559235%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-33-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0F6MYR7G1",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 24,
    "asin": "B0F6MYR7G1",
    "title": "512GB USB SSD Flash Drive‚ÄìUSB 3.2 Gen1 High-Speed Thumb Drive, Up to 550MB/s, Dual USB-C & A Ports, Compatible with Smartphones, Android, PC, Laptop‚ÄìPortable Photo & Video Backup Stick",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$60.99",
    "rating": 4.4,
    "review_count": 7,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -7,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/51RMzbFwRsL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 60.99,
    "currency": "USD",
    "price_original": "$60.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NzAwMTMxNjM5NDYyMTQ1OjE3NTM1NTkyMzc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1NzYxMTExMTkwMjo6Mjo6&url=%2FSCICNCE-Intended-Required-Compatible-Computers%2Fdp%2FB0FFJPLDMV%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FFJPLDMV%26pd_rd_r%3Dc12bc508-d897-4e79-b359-2c8bd4775b97%26pd_rd_w%3DWISAI%26pd_rd_wg%3Djr1gv%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D5D78GCKCXYHJCA5AJYZQ%26qid%3D1753559235%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-34-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FFJPLDMV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 25,
    "asin": "B0FFJPLDMV",
    "title": "SCICNCE 256GB Flash Drive Intended for iPhone, USB Memory Stick Storage Backup for Photos Videos, Plug and Play No APP Required, Compatible with iPhone iPad Android and Computers (Rose Gold)",
    "brand": "SCICNCE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$39.99",
    "rating": 4.6,
    "review_count": 39,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -39,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/71lZnj7ZftL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 39.99,
    "currency": "USD",
    "price_original": "$39.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NzAwMTMxNjM5NDYyMTQ1OjE3NTM1NTkyMzc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1MDYyMDcyOTcwMjo6Mzo6&url=%2F64GB-USB-Flash-Drive-Compatible%2Fdp%2FB0FF4TX5LV%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FF4TX5LV%26pd_rd_r%3Dc12bc508-d897-4e79-b359-2c8bd4775b97%26pd_rd_w%3DWISAI%26pd_rd_wg%3Djr1gv%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D5D78GCKCXYHJCA5AJYZQ%26qid%3D1753559235%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-35-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FF4TX5LV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 26,
    "asin": "B0FF4TX5LV",
    "title": "64GB USB Flash Drive ‚Äì 4 in 1 USB C Flash Drive with USB 3.0, Type C, Micro USB & iOS Connector ‚Äì High Speed Thumb Drive, Plug and Play Photo Stick, Memory Stick Compatible with Laptop, Android, PC",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$15.99",
    "rating": null,
    "review_count": 15,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/710hPP0F8FL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 15.99,
    "currency": "USD",
    "price_original": "$15.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0NzAwMTMxNjM5NDYyMTQ1OjE3NTM1NTkyMzc6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5MzMwMjo6NTo6&url=%2FFlash-Drive-Customizable-Thumb-4GB-128GB%2Fdp%2FB0FGPZBXMK%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGPZBXMK%26pd_rd_r%3Dc12bc508-d897-4e79-b359-2c8bd4775b97%26pd_rd_w%3DWISAI%26pd_rd_wg%3Djr1gv%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D5D78GCKCXYHJCA5AJYZQ%26qid%3D1753559235%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-37-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGPZBXMK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 27,
    "asin": "B0FGPZBXMK",
    "title": "Mini USB Flash Drive Customizable Tiny Thumb Drive with Your Logo 4GB-128GB - Perfect for Corporate Events, Branded Promotions, Student Projects Plug and Play, PC Mac (100,128GB)",
    "brand": "Mini",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$654.99",
    "rating": null,
    "review_count": 654,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-3_files/41Y5IinJkAL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 654.99,
    "currency": "USD",
    "price_original": "$654.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=3&crid=BALSGJKBQE1X&qid=1753559156&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_2#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 28,
    "asin": null,
    "title": "4GB USB Flash Drive 10 Pack, Wooolken USB 2.0 Thumb Drives with Lanyards Swivel Memory Stick for Data Storage and Backup (Mixed Colors)",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.31",
    "rating": 4.6,
    "review_count": 700,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/71xGy6SiMEL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.31,
    "currency": "USD",
    "price_original": "$19.31"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozODI1NTMxMzExMzE3MDI4OjE3NTM1NTkyMzc6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA2OTc5MzQ5MDcwMDI6OjA6Og&url=%2FWooolken-Memory-Lanyards-Swivel-Pendrive%2Fdp%2FB0C4NWQ3LL%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0C4NWQ3LL%26pd_rd_r%3D70f14069-42c5-4c41-85cf-3d27ffb9e5f8%26pd_rd_w%3DiKY7J%26pd_rd_wg%3DPonej%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D5D78GCKCXYHJCA5AJYZQ%26qid%3D1753559235%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-33-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0C4NWQ3LL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 29,
    "asin": "B0C4NWQ3LL",
    "title": "4GB USB Flash Drive 10 Pack, Wooolken USB 2.0 Thumb Drives with Lanyards Swivel Memory Stick for Data Storage and Backup (Mixed Colors)",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.31",
    "rating": 4.6,
    "review_count": 700,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/71xGy6SiMEL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.31,
    "currency": "USD",
    "price_original": "$19.31"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozODI1NTMxMzExMzE3MDI4OjE3NTM1NTkyMzc6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4MjY2NjQwMjM1MDI6OjE6Og&url=%2FWooolken-10Pack-Keychains-Computer-Mixcolors%2Fdp%2FB0CXLXBDXM%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CXLXBDXM%26pd_rd_r%3D70f14069-42c5-4c41-85cf-3d27ffb9e5f8%26pd_rd_w%3DiKY7J%26pd_rd_wg%3DPonej%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D5D78GCKCXYHJCA5AJYZQ%26qid%3D1753559235%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-34-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CXLXBDXM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 30,
    "asin": "B0CXLXBDXM",
    "title": "Flash Drives 4GB 10 Pack, Wooolken USB 2.0 Thumb Drives with Keychains Memory Stick USB Drive Pendrive for PC Laptop Computer (Mixcolors)",
    "brand": "Flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$20.69",
    "rating": 4.5,
    "review_count": 569,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -569,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/71LZG0ddZrL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.69,
    "currency": "USD",
    "price_original": "$20.69"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozODI1NTMxMzExMzE3MDI4OjE3NTM1NTkyMzc6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4NjA5ODM3MDU4MDI6OjI6Og&url=%2F32GB-Multi-Color-Portable-FEBNISCTE-Multipack%2Fdp%2FB004WMEAQC%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB004WMEAQC%26pd_rd_r%3D70f14069-42c5-4c41-85cf-3d27ffb9e5f8%26pd_rd_w%3DiKY7J%26pd_rd_wg%3DPonej%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D5D78GCKCXYHJCA5AJYZQ%26qid%3D1753559235%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-35-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B004WMEAQC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 31,
    "asin": "B004WMEAQC",
    "title": "FEBNISCTE 32GB Flash Drive 10 Pack, Thumb Drive High Capacity, Bulk USB Flash Drives 32 GB Metal Swivel, USB 2.0 Jump Drive Memory Stick Portable, Pen Drive Zip High Speed for Data Storage",
    "brand": "FEBNISCTE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$24.99",
    "rating": 4.5,
    "review_count": 5,
    "special_features": "Metal, Swivel, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/71lxOtSOxNL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozODI1NTMxMzExMzE3MDI4OjE3NTM1NTkyMzc6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA1NjcwMTIyNTA5MDI6OjM6Og&url=%2FCertified-iPhone-Memory-Compatible-Android%2Fdp%2FB0DCZLGJGM%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DCZLGJGM%26pd_rd_r%3D70f14069-42c5-4c41-85cf-3d27ffb9e5f8%26pd_rd_w%3DiKY7J%26pd_rd_wg%3DPonej%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D5D78GCKCXYHJCA5AJYZQ%26qid%3D1753559235%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-36-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DCZLGJGM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 32,
    "asin": "B0DCZLGJGM",
    "title": "Apple MFi Certified 128GB Flash Drive for iPhone Thumb Drive Photo Stick, USB Memory Stick iPhone Flash Drive for Photos Videos, High Speed Jump Drive Compatible for iPhone/iPad/Android/PC (Blue)",
    "brand": "Apple",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$18.98",
    "rating": 4.2,
    "review_count": 3,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/61mO23ePr1L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.98,
    "currency": "USD",
    "price_original": "$18.98"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozODI1NTMxMzExMzE3MDI4OjE3NTM1NTkyMzc6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4NTg4NDYzODY3MDI6OjQ6Og&url=%2FCertified-External-Storage-Picture-Android%2Fdp%2FB0DL5VCVCG%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DL5VCVCG%26pd_rd_r%3D70f14069-42c5-4c41-85cf-3d27ffb9e5f8%26pd_rd_w%3DiKY7J%26pd_rd_wg%3DPonej%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D5D78GCKCXYHJCA5AJYZQ%26qid%3D1753559235%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-37-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DL5VCVCG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-3.html",
    "position": 33,
    "asin": "B0DL5VCVCG",
    "title": "MFi Certified USB 3.0 Flash Drive 128GB for iPhone, 3in1 External Memory Photo Keeper Storage Stick for Picture/Video/Data Saver/Backup, High Speed Thumb/Jump/Hard Drives for iPhone/iPad/Android/PC",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$20.69",
    "rating": 4.3,
    "review_count": 5,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.2K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-3_files/7131xiPczVL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.69,
    "currency": "USD",
    "price_original": "$20.69"
  },
  {
    "product_url": "https://www.amazon.com/128MB-Drives-Pack-EASTBULL-Storage/dp/B08T1RXN4S/ref=sr_1_51?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ZcdmsAivH9_6pio--U3fEZFEJiYyKj8_C2rQblbLUFnGjHj071QN20LucGBJIEps.ML4BkfemxzfRtv-tPpCg6-hiYB3LKOe0eSldmoN3Q8o&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-51&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08T1RXN4S",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 1,
    "asin": "B08T1RXN4S",
    "title": "128MB Bulk Flash Drives 100 Pack, EASTBULL USB 2.0 Flash Drives Bulk USB Drive Bulk Storage Flash Drive Pack (Black)",
    "brand": "128MB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$115.88",
    "rating": 4.5,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -376,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/71YJniBq6EL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "mb",
    "price_numeric": 115.88,
    "currency": "USD",
    "price_original": "$115.88"
  },
  {
    "product_url": "https://www.amazon.com/Kootion-20pcs-Drives-Memory-Swivel/dp/B07J28FSFR/ref=sr_1_52?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ZcdmsAivH9_6pio--U3fEZFEJiYyKj8_C2rQblbLUFnGjHj071QN20LucGBJIEps.ML4BkfemxzfRtv-tPpCg6-hiYB3LKOe0eSldmoN3Q8o&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-52&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07J28FSFR",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 2,
    "asin": "B07J28FSFR",
    "title": "16GB USB Flash Drive KOOTION 20 Pack USB Drive Thumb Drive Bulk USB Stick Swivel for Data Storage, Black",
    "brand": "KOOTION",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$51.29",
    "rating": 4.5,
    "review_count": 100,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "10 sizes10 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/61VHlnEV6WL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 51.29,
    "currency": "USD",
    "price_original": "$51.29"
  },
  {
    "product_url": "https://www.amazon.com/Kepmem-Portable-Colorful-Multipack-Storage/dp/B09D3QK71Y/ref=sr_1_53?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.ZcdmsAivH9_6pio--U3fEZFEJiYyKj8_C2rQblbLUFnGjHj071QN20LucGBJIEps.ML4BkfemxzfRtv-tPpCg6-hiYB3LKOe0eSldmoN3Q8o&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-53&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09D3QK71Y",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 3,
    "asin": "B09D3QK71Y",
    "title": "Kepmem Flash Drive 64GB Pack of 10 Thumb Drives Bulk 64 Giga USB Drives Value Metal USB 2.0 Memory Sticks Swivel Pen Drive 64 GB Portable Jump Drive Colorful Multipack Zip Drives for Data Storage",
    "brand": "Kepmem",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$37.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": "Metal, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -622,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/71lFJZly-9L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.99,
    "currency": "USD",
    "price_original": "$37.99"
  },
  {
    "product_url": "https://www.amazon.com/EASTBULL-Drives-Lanyards-Memory-Storage/dp/B0CMD2B7XX/ref=sr_1_49?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.vq7ZafUg9BNy9-iNh_tUr303gFMif-aofXAUPpP0ZEys6wfqdQ1K8rembDoFGAIfbDhTEjdnwhEtDCDp9Zh5jykd5ENzxBWw8pWgC4Ogs5OD8GVht4LXklWv9AgG2CcGla0yW2sjWdDroPNOAYSTjPwLcUcgEnGcBHhSJmQY5b4XdkoZX9Eazy7PKu2U7xsa.J46alyQrpHIwh-T2y--_Qy2cf8vyxoV0HUTFubm9LJo&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-49&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CMD2B7XX",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 4,
    "asin": "B0CMD2B7XX",
    "title": "EASTBULL 8GB USB Flash Drive Bulk Thumb Drives 20 Pack with Lanyards USB 2.0 8GB Memory Sticks Zip Drive Pen Drive for Storage and Backup Black 20PCS",
    "brand": "EASTBULL",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$38.56",
    "rating": 4.6,
    "review_count": 100,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "13 sizes13 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/61lQL4w1eEL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 38.56,
    "currency": "USD",
    "price_original": "$38.56"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Ultra-Flash-Drive-Performance/dp/B01EG7DJ6O/ref=sr_1_50?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.vq7ZafUg9BNy9-iNh_tUr303gFMif-aofXAUPpP0ZEys6wfqdQ1K8rembDoFGAIfbDhTEjdnwhEtDCDp9Zh5jykd5ENzxBWw8pWgC4Ogs5OD8GVht4LXklWv9AgG2CcGla0yW2sjWdDroPNOAYSTjPwLcUcgEnGcBHhSJmQY5b4XdkoZX9Eazy7PKu2U7xsa.J46alyQrpHIwh-T2y--_Qy2cf8vyxoV0HUTFubm9LJo&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-50&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B01EG7DJ6O",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 5,
    "asin": "B01EG7DJ6O",
    "title": "SanDisk Ultra USB (5 Pack) 3.0 64GB CZ48 Flash Drive High Performance Jump Drive/Thumb Drive/Pen Drive up to 100MB/s - with (2) Everything But Stromboli (tm) Lanyard",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$39.65",
    "rating": 4.7,
    "review_count": 300,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -461,
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/71LGWHsY48L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 39.65,
    "currency": "USD",
    "price_original": "$39.65"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Cruzer-Glide-Flash-SDCZ600-064G-B35/dp/B017RD10X8/ref=sr_1_51?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.vq7ZafUg9BNy9-iNh_tUr303gFMif-aofXAUPpP0ZEys6wfqdQ1K8rembDoFGAIfbDhTEjdnwhEtDCDp9Zh5jykd5ENzxBWw8pWgC4Ogs5OD8GVht4LXklWv9AgG2CcGla0yW2sjWdDroPNOAYSTjPwLcUcgEnGcBHhSJmQY5b4XdkoZX9Eazy7PKu2U7xsa.J46alyQrpHIwh-T2y--_Qy2cf8vyxoV0HUTFubm9LJo&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-51&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B017RD10X8",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 6,
    "asin": "B017RD10X8",
    "title": "SanDisk 64GB Cruzer Glide USB 3.0 Flash Drive SDCZ600-064G-B35",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$8.21",
    "rating": 4.6,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2K)",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/51gckc6-M+L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 8.21,
    "currency": "USD",
    "price_original": "$8.21"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Cruzer-Blade-Drive-SDCZ50-008G-B35/dp/B002U28LZC/ref=sr_1_52?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.vq7ZafUg9BNy9-iNh_tUr303gFMif-aofXAUPpP0ZEys6wfqdQ1K8rembDoFGAIfbDhTEjdnwhEtDCDp9Zh5jykd5ENzxBWw8pWgC4Ogs5OD8GVht4LXklWv9AgG2CcGla0yW2sjWdDroPNOAYSTjPwLcUcgEnGcBHhSJmQY5b4XdkoZX9Eazy7PKu2U7xsa.J46alyQrpHIwh-T2y--_Qy2cf8vyxoV0HUTFubm9LJo&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-52&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B002U28LZC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 7,
    "asin": "B002U28LZC",
    "title": "SanDisk Cruzer Blade 8GB USB 2.0 Flash Drive- SDCZ50-008G-B35",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "SD",
    "price": "$7.95",
    "rating": 4.6,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(296.4K)",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/612jvLoXWZL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 7.95,
    "currency": "USD",
    "price_original": "$7.95"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-512GB-Ultra-Flash-Drive/dp/B0BY2XZW6L/ref=sr_1_53?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.vq7ZafUg9BNy9-iNh_tUr303gFMif-aofXAUPpP0ZEys6wfqdQ1K8rembDoFGAIfbDhTEjdnwhEtDCDp9Zh5jykd5ENzxBWw8pWgC4Ogs5OD8GVht4LXklWv9AgG2CcGla0yW2sjWdDroPNOAYSTjPwLcUcgEnGcBHhSJmQY5b4XdkoZX9Eazy7PKu2U7xsa.J46alyQrpHIwh-T2y--_Qy2cf8vyxoV0HUTFubm9LJo&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-53&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BY2XZW6L",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 8,
    "asin": "B0BY2XZW6L",
    "title": "SanDisk 512GB Ultra Luxe USB 3.2 Gen 1 Flash Drive - SDCZ74-512G-GAM46",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$42.99",
    "rating": 4.5,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(16.2K)",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/41SoegdWA1L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 42.99,
    "currency": "USD",
    "price_original": "$42.99"
  },
  {
    "product_url": "https://www.amazon.com/Lexar-JumpDrive-Flash-3-Pack-LJDV100032G-B3NNU/dp/B087BJS2MF/ref=sr_1_56?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.vq7ZafUg9BNy9-iNh_tUr303gFMif-aofXAUPpP0ZEys6wfqdQ1K8rembDoFGAIfbDhTEjdnwhEtDCDp9Zh5jykd5ENzxBWw8pWgC4Ogs5OD8GVht4LXklWv9AgG2CcGla0yW2sjWdDroPNOAYSTjPwLcUcgEnGcBHhSJmQY5b4XdkoZX9Eazy7PKu2U7xsa.J46alyQrpHIwh-T2y--_Qy2cf8vyxoV0HUTFubm9LJo&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-56&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B087BJS2MF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 9,
    "asin": "B087BJS2MF",
    "title": "Lexar 32GB 3-Pack JumpDrive V100 USB 3.2 Gen 1 Flash Drive for Storage Expansion and Backup, Up To 100MB/s Read, Gray, Pink, Blue (LJDV100032G-B3NNU)",
    "brand": "Lexar",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.7,
    "review_count": 400,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2.5K)",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/61Y0hdbUV+L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-3-Pack-Ultra-Flash-3x32GB/dp/B09FFK1QLR/ref=sr_1_57?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.vq7ZafUg9BNy9-iNh_tUr303gFMif-aofXAUPpP0ZEys6wfqdQ1K8rembDoFGAIfbDhTEjdnwhEtDCDp9Zh5jykd5ENzxBWw8pWgC4Ogs5OD8GVht4LXklWv9AgG2CcGla0yW2sjWdDroPNOAYSTjPwLcUcgEnGcBHhSJmQY5b4XdkoZX9Eazy7PKu2U7xsa.J46alyQrpHIwh-T2y--_Qy2cf8vyxoV0HUTFubm9LJo&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-57&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09FFK1QLR",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 10,
    "asin": "B09FFK1QLR",
    "title": "SanDisk 32GB 3-Pack Ultra Fit USB 3.1 Flash Drive (3x32GB) - SDCZ430-032G-G46T, Black",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$21.87",
    "rating": 4.6,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/814UO5-h7pL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 21.87,
    "currency": "USD",
    "price_original": "$21.87"
  },
  {
    "product_url": "https://www.amazon.com/DataOcean-Flash-Memory-Drives-Colors/dp/B09XLMFCH3/ref=sr_1_58?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.vq7ZafUg9BNy9-iNh_tUr303gFMif-aofXAUPpP0ZEys6wfqdQ1K8rembDoFGAIfbDhTEjdnwhEtDCDp9Zh5jykd5ENzxBWw8pWgC4Ogs5OD8GVht4LXklWv9AgG2CcGla0yW2sjWdDroPNOAYSTjPwLcUcgEnGcBHhSJmQY5b4XdkoZX9Eazy7PKu2U7xsa.J46alyQrpHIwh-T2y--_Qy2cf8vyxoV0HUTFubm9LJo&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-58&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09XLMFCH3",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 11,
    "asin": "B09XLMFCH3",
    "title": "10 Pack 8GB USB 2.0 Flash Drive Memory Stick Thumb Drives (8GB X 10 Mixed Colors)",
    "brand": 10,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.54",
    "rating": 4.5,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/711PvLdMjwL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.54,
    "currency": "USD",
    "price_original": "$19.54"
  },
  {
    "product_url": "https://www.amazon.com/ABLAZE-Memory-Lanyards-Pendrive-Mixcolor/dp/B09FXTSMC4/ref=sr_1_59?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.vq7ZafUg9BNy9-iNh_tUr303gFMif-aofXAUPpP0ZEys6wfqdQ1K8rembDoFGAIfbDhTEjdnwhEtDCDp9Zh5jykd5ENzxBWw8pWgC4Ogs5OD8GVht4LXklWv9AgG2CcGla0yW2sjWdDroPNOAYSTjPwLcUcgEnGcBHhSJmQY5b4XdkoZX9Eazy7PKu2U7xsa.J46alyQrpHIwh-T2y--_Qy2cf8vyxoV0HUTFubm9LJo&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-59&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09FXTSMC4",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 12,
    "asin": "B09FXTSMC4",
    "title": "ABLAZE 4GB Flash Drive 10 Pack, USB 2.0 Memory Stick with Lanyards Swivel Thumb Drives Bulk 4GB Pendrive U Disk for Data Storage (Mixcolors)",
    "brand": "ABLAZE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$20.02",
    "rating": 4.5,
    "review_count": 50,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "11 sizes11 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/71T-gxHQU+L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.02,
    "currency": "USD",
    "price_original": "$20.02"
  },
  {
    "product_url": "https://www.amazon.com/AreTop-Portable-Keychain-Multipack-Mix-Colors/dp/B07DW1QS67/ref=sr_1_60?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.vq7ZafUg9BNy9-iNh_tUr303gFMif-aofXAUPpP0ZEys6wfqdQ1K8rembDoFGAIfbDhTEjdnwhEtDCDp9Zh5jykd5ENzxBWw8pWgC4Ogs5OD8GVht4LXklWv9AgG2CcGla0yW2sjWdDroPNOAYSTjPwLcUcgEnGcBHhSJmQY5b4XdkoZX9Eazy7PKu2U7xsa.J46alyQrpHIwh-T2y--_Qy2cf8vyxoV0HUTFubm9LJo&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-60&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07DW1QS67",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 13,
    "asin": "B07DW1QS67",
    "title": "AreTop 32GB Flash Drive, Pack of 10 USB Drive, Portable Keychain Lanyard Thumb Drive for Date Storage, Jump Drive Colorful Multipack, USB2.0 USB Flash Drive 10 Pack(10 Pack 32GB, Mix-Colors)",
    "brand": "AreTop",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$27.54",
    "rating": 4.6,
    "review_count": 500,
    "special_features": "Keychain, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "9 sizes9 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/71GjLByfkGL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 27.54,
    "currency": "USD",
    "price_original": "$27.54"
  },
  {
    "product_url": "https://www.amazon.com/MAKACTUA-Memory-Drives-Storage-Multiple/dp/B0CMXBZ4M8/ref=sr_1_61?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.vq7ZafUg9BNy9-iNh_tUr303gFMif-aofXAUPpP0ZEys6wfqdQ1K8rembDoFGAIfbDhTEjdnwhEtDCDp9Zh5jykd5ENzxBWw8pWgC4Ogs5OD8GVht4LXklWv9AgG2CcGla0yW2sjWdDroPNOAYSTjPwLcUcgEnGcBHhSJmQY5b4XdkoZX9Eazy7PKu2U7xsa.J46alyQrpHIwh-T2y--_Qy2cf8vyxoV0HUTFubm9LJo&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-61&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CMXBZ4M8",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 14,
    "asin": "B0CMXBZ4M8",
    "title": "5 Pack 8GB USB Flash Drive, USB 2.0 Memory Stick Thumb Drive Pen Drives Jump Drive for Data Storage Multiple Color",
    "brand": 5,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.4,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/61ya3m2XOiL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/Aiibe-Flash-Memory-Drives-Colors/dp/B09W5P8XVJ/ref=sr_1_62?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.vq7ZafUg9BNy9-iNh_tUr303gFMif-aofXAUPpP0ZEys6wfqdQ1K8rembDoFGAIfbDhTEjdnwhEtDCDp9Zh5jykd5ENzxBWw8pWgC4Ogs5OD8GVht4LXklWv9AgG2CcGla0yW2sjWdDroPNOAYSTjPwLcUcgEnGcBHhSJmQY5b4XdkoZX9Eazy7PKu2U7xsa.J46alyQrpHIwh-T2y--_Qy2cf8vyxoV0HUTFubm9LJo&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-62&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09W5P8XVJ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 15,
    "asin": "B09W5P8XVJ",
    "title": "Aiibe 64GB Flash Drive 3.0 5 Pack 64GB USB 3.0 Thumb Drive USB Drives 64 GB Jump Drive Memory Stick Multi Pack 64 GB Flash Drives (64G, 5 Mixed Colors: Black Red Cyan Green Purple)",
    "brand": "Aiibe",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$22.99",
    "rating": 4.5,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/61G1tDXEiNL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 22.99,
    "currency": "USD",
    "price_original": "$22.99"
  },
  {
    "product_url": "https://www.amazon.com/64GB-Flash-Memory-Storage-Colors/dp/B09C3JD1DZ/ref=sr_1_63?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.vq7ZafUg9BNy9-iNh_tUr303gFMif-aofXAUPpP0ZEys6wfqdQ1K8rembDoFGAIfbDhTEjdnwhEtDCDp9Zh5jykd5ENzxBWw8pWgC4Ogs5OD8GVht4LXklWv9AgG2CcGla0yW2sjWdDroPNOAYSTjPwLcUcgEnGcBHhSJmQY5b4XdkoZX9Eazy7PKu2U7xsa.J46alyQrpHIwh-T2y--_Qy2cf8vyxoV0HUTFubm9LJo&dib_tag=se&keywords=flash+drives&qid=1753561719&sprefix=flash+drive%2Caps%2C146&sr=8-63&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09C3JD1DZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 16,
    "asin": "B09C3JD1DZ",
    "title": "FEBNISCTE 64GB Flash Drive 10 Pack, Thumb Drive High Capacity Multicolour, Bulk USB Flash Drives 64 GB Metal Swivel, USB 2.0 Jump Drive Portable, Pen Drive Zip High Speed for Data Storage",
    "brand": "FEBNISCTE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$32.39",
    "rating": 4.5,
    "review_count": 300,
    "special_features": "Metal, Swivel, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.1K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/71lxOtSOxNL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 32.39,
    "currency": "USD",
    "price_original": "$32.39"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=4&crid=BALSGJKBQE1X&qid=1753561712&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_4#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 17,
    "asin": null,
    "title": "PNY 32GB Turbo Attach√© 3 USB 3.0 Flash Drive, Silver (Pack of 10)",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 4.6,
    "review_count": 464,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -464,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/616cOXMmVZL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0MDAxNzQwNzE0NDEzNTE6MTc1MzU2MTcyMDpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwMDA0NDYxMzIwNjAyOjowOjo&url=%2FPNY-Turbo-Attach%25C3%25A9-10-Pack-Silver%2Fdp%2FB0BPJVH88Y%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0BPJVH88Y%26pd_rd_r%3D7ab323c0-94d9-4508-83fe-68c5d688008f%26pd_rd_w%3Dv1Bdf%26pd_rd_wg%3DTzrEE%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DXDDS5AMN7VY3AF6SCRE4%26qid%3D1753561719%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-49-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0BPJVH88Y",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 18,
    "asin": "B0BPJVH88Y",
    "title": "PNY 32GB Turbo Attach√© 3 USB 3.0 Flash Drive, Silver (Pack of 10)",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 4.6,
    "review_count": 3,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -464,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/616cOXMmVZL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0MDAxNzQwNzE0NDEzNTE6MTc1MzU2MTcyMDpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwNDY2MTE1ODI1MTAyOjoxOjo&url=%2FGigastone-Capless-Retractable-Interface-Compatible%2Fdp%2FB0C49KR4MB%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0C49KR4MB%26pd_rd_r%3D7ab323c0-94d9-4508-83fe-68c5d688008f%26pd_rd_w%3Dv1Bdf%26pd_rd_wg%3DTzrEE%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DXDDS5AMN7VY3AF6SCRE4%26qid%3D1753561719%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-50-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0C49KR4MB",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 19,
    "asin": "B0C49KR4MB",
    "title": "GIGASTONE 512GB Flash Drive, Z60 USB 3.2 Gen 1, 120MB/s Ultra Fast, Retractable Capless Slider Design, Data Storage, Backup for PC/Mac/TV/Car Audio, USB 2.0/3.0/3.1 Compatible",
    "brand": "Gigastone",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 4.3,
    "review_count": 200,
    "special_features": "Retractable, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -671,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/31D9GInVR1L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0MDAxNzQwNzE0NDEzNTE6MTc1MzU2MTcyMDpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwODU5NjI5MzE0OTAyOjoyOjo&url=%2FFlash-Drive-16GB-Pack-AGECASH%2Fdp%2FB0F8MDVXD6%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0F8MDVXD6%26pd_rd_r%3D7ab323c0-94d9-4508-83fe-68c5d688008f%26pd_rd_w%3Dv1Bdf%26pd_rd_wg%3DTzrEE%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DXDDS5AMN7VY3AF6SCRE4%26qid%3D1753561719%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-51-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0F8MDVXD6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 20,
    "asin": "B0F8MDVXD6",
    "title": "USB Flash Drive 16GB Flash Drives 20 Pack, AGECASH USB 2.0 Thumb Drive 20 Pack Swivel Pendrive Memory Stick Zip Jump Drives Multipack with 20PCS Black Lanyards (Colorful, 16GB)",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$47.99",
    "rating": 4.6,
    "review_count": 143,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -143,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/71ewhlqH8GL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 47.99,
    "currency": "USD",
    "price_original": "$47.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo0MDAxNzQwNzE0NDEzNTE6MTc1MzU2MTcyMDpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwNTM3ODk1MjQwMTAyOjozOjo&url=%2FZZ-Drives-Retractable-Memory-Multipack%2Fdp%2FB0D48LKT5K%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0D48LKT5K%26pd_rd_r%3D7ab323c0-94d9-4508-83fe-68c5d688008f%26pd_rd_w%3Dv1Bdf%26pd_rd_wg%3DTzrEE%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DXDDS5AMN7VY3AF6SCRE4%26qid%3D1753561719%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-52-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0D48LKT5K",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 21,
    "asin": "B0D48LKT5K",
    "title": "K&ZZ 32 GB Flash Drive 5 Pack USB Flash Drives 32GB USB 3.0 Drive Retractable Thumb Drive Memory Stick Jump Drives Multipack 32G 3.0 (5 Colors: Black Red Blue Green Purple)",
    "brand": "K&ZZ",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$19.54",
    "rating": 4.5,
    "review_count": 251,
    "special_features": "Retractable",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -251,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/61yV4XLD3rL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.54,
    "currency": "USD",
    "price_original": "$19.54"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=4&crid=BALSGJKBQE1X&qid=1753561712&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_4#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 22,
    "asin": null,
    "title": "256GB USB SSD Flash Drive‚ÄìUSB 3.2 Gen1 High-Speed Thumb Drive, Up to 550MB/s, Dual USB-C & A Ports, Compatible with Smartphones, Android, PC, Laptop‚ÄìPortable Photo & Video Backup Stick",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$43.99",
    "rating": 4.4,
    "review_count": 60,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -7,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/51hobZIf-jL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 43.99,
    "currency": "USD",
    "price_original": "$43.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozODExMzc4NjgzMDI0NjM0OjE3NTM1NjE3MjA6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MDY1Njc2NjYwMjo6MTo6&url=%2FOSCOO-High-Speed-Compatible-Smartphones-Laptop-Portable%2Fdp%2FB0F6MVZSTH%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0F6MVZSTH%26pd_rd_r%3D7ab323c0-94d9-4508-83fe-68c5d688008f%26pd_rd_w%3DDS2oI%26pd_rd_wg%3DTzrEE%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DXDDS5AMN7VY3AF6SCRE4%26qid%3D1753561719%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-49-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0F6MVZSTH",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 23,
    "asin": "B0F6MVZSTH",
    "title": "256GB USB SSD Flash Drive‚ÄìUSB 3.2 Gen1 High-Speed Thumb Drive, Up to 550MB/s, Dual USB-C & A Ports, Compatible with Smartphones, Android, PC, Laptop‚ÄìPortable Photo & Video Backup Stick",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$43.99",
    "rating": 4.4,
    "review_count": 7,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -7,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/51hobZIf-jL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 43.99,
    "currency": "USD",
    "price_original": "$43.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozODExMzc4NjgzMDI0NjM0OjE3NTM1NjE3MjA6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1NzYxMTExMjAwMjo6Mjo6&url=%2FSCICNCE-Intended-Required-Compatible-Computers%2Fdp%2FB0FFJPXSKZ%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FFJPXSKZ%26pd_rd_r%3D7ab323c0-94d9-4508-83fe-68c5d688008f%26pd_rd_w%3DDS2oI%26pd_rd_wg%3DTzrEE%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DXDDS5AMN7VY3AF6SCRE4%26qid%3D1753561719%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-50-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FFJPXSKZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 24,
    "asin": "B0FFJPXSKZ",
    "title": "SCICNCE 256GB Flash Drive Intended for iPhone, USB Memory Stick Storage Backup for Photos Videos, Plug and Play No APP Required, Compatible with iPhone iPad Android and Computers (Metal Gray)",
    "brand": "SCICNCE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$39.99",
    "rating": 4.6,
    "review_count": 39,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -39,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/61rBOw2g9FL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 39.99,
    "currency": "USD",
    "price_original": "$39.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozODExMzc4NjgzMDI0NjM0OjE3NTM1NjE3MjA6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0MzU2ODI3MDUwMjo6Mzo6&url=%2FIMEASON-Keychain-Portable-Flashdrive-Storage%2Fdp%2FB0F8VWPYNC%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0F8VWPYNC%26pd_rd_r%3D7ab323c0-94d9-4508-83fe-68c5d688008f%26pd_rd_w%3DDS2oI%26pd_rd_wg%3DTzrEE%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DXDDS5AMN7VY3AF6SCRE4%26qid%3D1753561719%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-51-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0F8VWPYNC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 25,
    "asin": "B0F8VWPYNC",
    "title": "Swivel Design 16GB USB Flash Drive with Keychain, USB 2.0 Portable Thumb Drive Memory Stick, FAT32 Format Flashdrive for Data Storage, Photos, Music, Files (Black, 16 GB)",
    "brand": "Swivel",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$5.59",
    "rating": 5,
    "review_count": 50,
    "special_features": "Keychain, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -2,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/5182C62G4QL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 5.59,
    "currency": "USD",
    "price_original": "$5.59"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozODExMzc4NjgzMDI0NjM0OjE3NTM1NjE3MjA6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1MDYyMDcyOTcwMjo6NDo6&url=%2F64GB-USB-Flash-Drive-Compatible%2Fdp%2FB0FF4TX5LV%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FF4TX5LV%26pd_rd_r%3D7ab323c0-94d9-4508-83fe-68c5d688008f%26pd_rd_w%3DDS2oI%26pd_rd_wg%3DTzrEE%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DXDDS5AMN7VY3AF6SCRE4%26qid%3D1753561719%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-52-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FF4TX5LV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 26,
    "asin": "B0FF4TX5LV",
    "title": "64GB USB Flash Drive ‚Äì 4 in 1 USB C Flash Drive with USB 3.0, Type C, Micro USB & iOS Connector ‚Äì High Speed Thumb Drive, Plug and Play Photo Stick, Memory Stick Compatible with Laptop, Android, PC",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$15.99",
    "rating": null,
    "review_count": 15,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/710hPP0F8FL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 15.99,
    "currency": "USD",
    "price_original": "$15.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozODExMzc4NjgzMDI0NjM0OjE3NTM1NjE3MjA6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU4ODQwMjo6NTo6&url=%2FCustom-Drives-Personalized-Business-Promotions%2Fdp%2FB0FGQBSDMM%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQBSDMM%26pd_rd_r%3D7ab323c0-94d9-4508-83fe-68c5d688008f%26pd_rd_w%3DDS2oI%26pd_rd_wg%3DTzrEE%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DXDDS5AMN7VY3AF6SCRE4%26qid%3D1753561719%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-53-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQBSDMM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 27,
    "asin": "B0FGQBSDMM",
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (100,4GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$320.99",
    "rating": null,
    "review_count": 320,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-4_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 320.99,
    "currency": "USD",
    "price_original": "$320.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=4&crid=BALSGJKBQE1X&qid=1753561712&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_4#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 28,
    "asin": null,
    "title": "MFi Certified USB 3.0 Flash Drive 128GB for iPhone, 3in1 External Memory Photo Keeper Storage Stick for Picture/Video/Data Saver/Backup, High Speed Thumb/Jump/Hard Drives for iPhone/iPad/Android/PC",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$20.69",
    "rating": 4.3,
    "review_count": 5,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.2K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/7131xiPczVL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.69,
    "currency": "USD",
    "price_original": "$20.69"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NzQxNjI0Mzc5MTYzMDA6MTc1MzU2MTcyMDpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDg1ODg0NjM4NjcwMjo6MDo6&url=%2FCertified-External-Storage-Picture-Android%2Fdp%2FB0DL5VCVCG%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DL5VCVCG%26pd_rd_r%3D5ab5e0d0-621e-4bcc-9fe4-a67df1472ba6%26pd_rd_w%3DsAXBb%26pd_rd_wg%3DM0sZP%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DXDDS5AMN7VY3AF6SCRE4%26qid%3D1753561719%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-49-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DL5VCVCG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 29,
    "asin": "B0DL5VCVCG",
    "title": "MFi Certified USB 3.0 Flash Drive 128GB for iPhone, 3in1 External Memory Photo Keeper Storage Stick for Picture/Video/Data Saver/Backup, High Speed Thumb/Jump/Hard Drives for iPhone/iPad/Android/PC",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$20.69",
    "rating": 4.3,
    "review_count": 5,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.2K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/7131xiPczVL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.69,
    "currency": "USD",
    "price_original": "$20.69"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NzQxNjI0Mzc5MTYzMDA6MTc1MzU2MTcyMDpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDQ3MDExMDg5OTUwMjo6MTo6&url=%2FGARMESE-Waterproof-Portable-Keychain-Computer%2Fdp%2FB0D5H7XH7L%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0D5H7XH7L%26pd_rd_r%3D5ab5e0d0-621e-4bcc-9fe4-a67df1472ba6%26pd_rd_w%3DsAXBb%26pd_rd_wg%3DM0sZP%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DXDDS5AMN7VY3AF6SCRE4%26qid%3D1753561719%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-50-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0D5H7XH7L",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 30,
    "asin": "B0D5H7XH7L",
    "title": "64GB USB 3.0 Flash Drive, Waterproof Metal USB Memory Stick, Slim Thumb Drive Portable Pen Drive with Keychain Hole Stylish Jump Drive for PC Computer Car - Gray",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$7.59",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Waterproof, Metal, Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -360,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/51LdJJjyyOL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 7.59,
    "currency": "USD",
    "price_original": "$7.59"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NzQxNjI0Mzc5MTYzMDA6MTc1MzU2MTcyMDpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDcwNjgzNDgwMzIwMjo6Mjo6&url=%2F64GB-Flash-Memory-Storage-Colors%2Fdp%2FB09C3JD1DZ%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB09C3JD1DZ%26pd_rd_r%3D5ab5e0d0-621e-4bcc-9fe4-a67df1472ba6%26pd_rd_w%3DsAXBb%26pd_rd_wg%3DM0sZP%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DXDDS5AMN7VY3AF6SCRE4%26qid%3D1753561719%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-51-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B09C3JD1DZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 31,
    "asin": "B09C3JD1DZ",
    "title": "FEBNISCTE 64GB Flash Drive 10 Pack, Thumb Drive High Capacity Multicolour, Bulk USB Flash Drives 64 GB Metal Swivel, USB 2.0 Jump Drive Portable, Pen Drive Zip High Speed for Data Storage",
    "brand": "FEBNISCTE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$32.39",
    "rating": 4.5,
    "review_count": 300,
    "special_features": "Metal, Swivel, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/71lxOtSOxNL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 32.39,
    "currency": "USD",
    "price_original": "$32.39"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NzQxNjI0Mzc5MTYzMDA6MTc1MzU2MTcyMDpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDMyNzU5ODEzMTQwMjo6Mzo6&url=%2FCertified-External-Storage-Compatible-Android%2Fdp%2FB0BHWGMPZ2%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0BHWGMPZ2%26pd_rd_r%3D5ab5e0d0-621e-4bcc-9fe4-a67df1472ba6%26pd_rd_w%3DsAXBb%26pd_rd_wg%3DM0sZP%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DXDDS5AMN7VY3AF6SCRE4%26qid%3D1753561719%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-52-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0BHWGMPZ2",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 32,
    "asin": "B0BHWGMPZ2",
    "title": "MFi Certified 128GB Photo Stick for iPhone Flash Drive,USB Memory Stick Thumb Drives High Speed USB Stick External Storage Compatible for iPhone/iPad/Android/PC",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$17.99",
    "rating": 4.2,
    "review_count": 3,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(6.3K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/61wk1z9PrZL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 17.99,
    "currency": "USD",
    "price_original": "$17.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4NzQxNjI0Mzc5MTYzMDA6MTc1MzU2MTcyMDpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDg1MjM4ODEzNzcwMjo6NDo6&url=%2FGARMESE-Storage-Compatible-Smartphone-Computer%2Fdp%2FB0DRG3FKJM%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DRG3FKJM%26pd_rd_r%3D5ab5e0d0-621e-4bcc-9fe4-a67df1472ba6%26pd_rd_w%3DsAXBb%26pd_rd_wg%3DM0sZP%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DXDDS5AMN7VY3AF6SCRE4%26qid%3D1753561719%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-53-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DRG3FKJM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-4.html",
    "position": 33,
    "asin": "B0DRG3FKJM",
    "title": "128GB USB C Flash Drive Up to 450MB/s USB 3.2 Solid State Thumb Drive 2-in-1 Dual Flash Drive Data Storage Memory Stick Compatible with Smartphone Tablet Computer Game Console",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$17.47",
    "rating": 4.1,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -41,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-4_files/61NHGXonA4L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 17.47,
    "currency": "USD",
    "price_original": "$17.47"
  },
  {
    "product_url": "https://www.amazon.com/KOOTION-Drives-Multicolor-Retractable-Indicator/dp/B0DBV514TK/ref=sr_1_67?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Q9dHCPdTKCSd7pwkER0WdzcmhvRFDspI_ztZfgqAYJrGjHj071QN20LucGBJIEps.Nb4hYhRbpE7Q1MgyWlEsV7dRyyMXFFPacOaoQljv-9s&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-67&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DBV514TK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 1,
    "asin": "B0DBV514TK",
    "title": "KOOTION 128GB Flash Drive 3 Pack USB Flash Drives Multicolor USB Drive Retractable Thumb Drive USB 2.0 Flash Drive Zip Drives High Speed Jump Drives with LED Indicator - 3Pack (Red, Green, Blue)",
    "brand": "KOOTION",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$21.84",
    "rating": 4.5,
    "review_count": 300,
    "special_features": "Retractable",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/51i0bb8twbL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 21.84,
    "currency": "USD",
    "price_original": "$21.84"
  },
  {
    "product_url": "https://www.amazon.com/Lexar-128GB-JumpDrive-Type-C-LJDD400128G-BNQNU/dp/B0BWLXVXB7/ref=sr_1_68?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Q9dHCPdTKCSd7pwkER0WdzcmhvRFDspI_ztZfgqAYJrGjHj071QN20LucGBJIEps.Nb4hYhRbpE7Q1MgyWlEsV7dRyyMXFFPacOaoQljv-9s&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-68&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BWLXVXB7",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 2,
    "asin": "B0BWLXVXB7",
    "title": "Lexar 128GB JumpDrive Dual Drive D400 USB 3.2 Type-C & Type-A Flash Drive for Storage Expansion, Photo Back-up for iPhone 15, Up to 130MB/s, Metal Housing & Swivel Design, Titanium (LJDD400128G-BNQNU)",
    "brand": "Lexar",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$15.49",
    "rating": 4.5,
    "review_count": 300,
    "special_features": "Metal, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/41CdCp++QXL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 15.49,
    "currency": "USD",
    "price_original": "$15.49"
  },
  {
    "product_url": "https://www.amazon.com/TEAMGROUP-External-Compatible-Computer-TC17531TBB01/dp/B0CS2LY4VD/ref=sr_1_69?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.Q9dHCPdTKCSd7pwkER0WdzcmhvRFDspI_ztZfgqAYJrGjHj071QN20LucGBJIEps.Nb4hYhRbpE7Q1MgyWlEsV7dRyyMXFFPacOaoQljv-9s&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-69&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CS2LY4VD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 3,
    "asin": "B0CS2LY4VD",
    "title": "TEAMGROUP C175 1TB USB 3.2 Gen 1 (USB 3.1/3.0) Read 100MB/s Flash Thumb Drive, External Data Storage Memory Stick Compatible with Computer/Laptop Matte Black TC17531TBB01",
    "brand": "TEAMGROUP",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$54.99",
    "rating": 4.4,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "18 sizes18 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/61qcJXAKP1L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "tb",
    "price_numeric": 54.99,
    "currency": "USD",
    "price_original": "$54.99"
  },
  {
    "product_url": "https://www.amazon.com/Memory-JBOS-Swivel-Digital-Storage/dp/B07FLHLBT4/ref=sr_1_65?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.AcXy7B9_HPcoPjZ6T61spU0sIWJQ11b3mWQ78z7OjoMCkxuVRomIX5Fn9c3_yaDds4hJ-kTulubDQ6OEOIk7FQHwLM0ysa9hXJNLBETw9KEkUa9TWNekRF-KgGSOu3iRtXTr7ys5dgItEHp58ZsIrLWXavrG8syL76ufIXE1IKJ9iM4r2pO4XxFAis7EnUBz.x6gC6U4t7hKEIOSyxe0k6QhHu9y3cj5GOvEqCRNurUY&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-65&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07FLHLBT4",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 4,
    "asin": "B07FLHLBT4",
    "title": "32GB Flash Drive Thumb Drives 10 Pack, JBOS USB Drive 32 GB USB2.0 Swivel Metal USB Memory Sticks, Multipack Jump Drives Colorfufl Pen Drives for Data Storage Backup",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$28.99",
    "rating": 4.6,
    "review_count": 50,
    "special_features": "Metal, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "16 sizes16 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/61lrRFxDPHL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 28.99,
    "currency": "USD",
    "price_original": "$28.99"
  },
  {
    "product_url": "https://www.amazon.com/KEXIN-Flash-Drive-Memory-Colors/dp/B07C5P6K6V/ref=sr_1_66?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.AcXy7B9_HPcoPjZ6T61spU0sIWJQ11b3mWQ78z7OjoMCkxuVRomIX5Fn9c3_yaDds4hJ-kTulubDQ6OEOIk7FQHwLM0ysa9hXJNLBETw9KEkUa9TWNekRF-KgGSOu3iRtXTr7ys5dgItEHp58ZsIrLWXavrG8syL76ufIXE1IKJ9iM4r2pO4XxFAis7EnUBz.x6gC6U4t7hKEIOSyxe0k6QhHu9y3cj5GOvEqCRNurUY&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-66&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07C5P6K6V",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 5,
    "asin": "B07C5P6K6V",
    "title": "16GB Flash Drive 10 Pack USB Flash Drive 16 gb KEXIN Thumb Drive Memory Stick Zip Drive USB 2.0, 5 Colors (Black, Blue, Green, White, Red)",
    "brand": "16GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$26.99",
    "rating": 4.6,
    "review_count": 300,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "11 sizes11 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/61jFbOnmejL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 26.99,
    "currency": "USD",
    "price_original": "$26.99"
  },
  {
    "product_url": "https://www.amazon.com/ThePhotoStick%C2%AE-Flash-Drive-Memory-Stick/dp/B0DT31KYBR/ref=sr_1_67?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.AcXy7B9_HPcoPjZ6T61spU0sIWJQ11b3mWQ78z7OjoMCkxuVRomIX5Fn9c3_yaDds4hJ-kTulubDQ6OEOIk7FQHwLM0ysa9hXJNLBETw9KEkUa9TWNekRF-KgGSOu3iRtXTr7ys5dgItEHp58ZsIrLWXavrG8syL76ufIXE1IKJ9iM4r2pO4XxFAis7EnUBz.x6gC6U4t7hKEIOSyxe0k6QhHu9y3cj5GOvEqCRNurUY&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-67&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DT31KYBR",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 6,
    "asin": "B0DT31KYBR",
    "title": "ThePhotoStick¬Æ Omni 32GB Memory Stick & USB Flash Drive ‚Äì Photo & Video Backup for iPhone, Android, Mac & PC ‚Äì Multiport Connection to Easily Store & Transfer Files",
    "brand": "ThePhotoStick",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$34.99",
    "rating": 3.8,
    "review_count": 3,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -510,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/71nLPjDU0gL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.99,
    "currency": "USD",
    "price_original": "$34.99"
  },
  {
    "product_url": "https://www.amazon.com/KAISLE-External-Portable-Flashdrive-Computers/dp/B0DZSLKPT9/ref=sr_1_68?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.AcXy7B9_HPcoPjZ6T61spU0sIWJQ11b3mWQ78z7OjoMCkxuVRomIX5Fn9c3_yaDds4hJ-kTulubDQ6OEOIk7FQHwLM0ysa9hXJNLBETw9KEkUa9TWNekRF-KgGSOu3iRtXTr7ys5dgItEHp58ZsIrLWXavrG8syL76ufIXE1IKJ9iM4r2pO4XxFAis7EnUBz.x6gC6U4t7hKEIOSyxe0k6QhHu9y3cj5GOvEqCRNurUY&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-68&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DZSLKPT9",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 7,
    "asin": "B0DZSLKPT9",
    "title": "64GB USB Flash Drive, External USB Flash Memory Storage Thumb Drive, Portable Flashdrive with Keychain, 64 GB USB 2.0 Memory Stick exFAT Data Storage Jump Drives for Computers",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$4.99",
    "rating": 4.6,
    "review_count": 300,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -331,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/61Dyo2tGfLL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 4.99,
    "currency": "USD",
    "price_original": "$4.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Extreme-Dual-Drive-Type/dp/B0DSG46KH6/ref=sr_1_69?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.AcXy7B9_HPcoPjZ6T61spU0sIWJQ11b3mWQ78z7OjoMCkxuVRomIX5Fn9c3_yaDds4hJ-kTulubDQ6OEOIk7FQHwLM0ysa9hXJNLBETw9KEkUa9TWNekRF-KgGSOu3iRtXTr7ys5dgItEHp58ZsIrLWXavrG8syL76ufIXE1IKJ9iM4r2pO4XxFAis7EnUBz.x6gC6U4t7hKEIOSyxe0k6QhHu9y3cj5GOvEqCRNurUY&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-69&ufe=app_do%3Aamzn1.fos.9fe8cbfa-bf43-43d1-a707-3f4e65a4b666&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DSG46KH6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 8,
    "asin": "B0DSG46KH6",
    "title": "SanDisk 2TB Extreme PRO Dual Drive USB - Up to 1,000MB/s, USB Type-C, and USB Type-A, High-Performance Flash Drive - SDDDE1-2T00-G46",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$159.99",
    "rating": 4.4,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/61SO6cMhVvL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "tb",
    "price_numeric": 159.99,
    "currency": "USD",
    "price_original": "$159.99"
  },
  {
    "product_url": "https://www.amazon.com/Kootion-10-Memory-Keychain-Design/dp/B07CSVWBVV/ref=sr_1_72?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.AcXy7B9_HPcoPjZ6T61spU0sIWJQ11b3mWQ78z7OjoMCkxuVRomIX5Fn9c3_yaDds4hJ-kTulubDQ6OEOIk7FQHwLM0ysa9hXJNLBETw9KEkUa9TWNekRF-KgGSOu3iRtXTr7ys5dgItEHp58ZsIrLWXavrG8syL76ufIXE1IKJ9iM4r2pO4XxFAis7EnUBz.x6gC6U4t7hKEIOSyxe0k6QhHu9y3cj5GOvEqCRNurUY&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-72&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07CSVWBVV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 9,
    "asin": "B07CSVWBVV",
    "title": "KOOTION 32GB USB Flash Drive 32 gb Flash Drive 10 Pack Thumb Drive Memory Stick Pen Drive Keychain Design Black",
    "brand": "KOOTION",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$27.99",
    "rating": 4.6,
    "review_count": 100,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/612uXay-9oL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 27.99,
    "currency": "USD",
    "price_original": "$27.99"
  },
  {
    "product_url": "https://www.amazon.com/DEEKOO-Drives-Memory-Sticks-Colors/dp/B0B8P129H6/ref=sr_1_73?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.AcXy7B9_HPcoPjZ6T61spU0sIWJQ11b3mWQ78z7OjoMCkxuVRomIX5Fn9c3_yaDds4hJ-kTulubDQ6OEOIk7FQHwLM0ysa9hXJNLBETw9KEkUa9TWNekRF-KgGSOu3iRtXTr7ys5dgItEHp58ZsIrLWXavrG8syL76ufIXE1IKJ9iM4r2pO4XxFAis7EnUBz.x6gC6U4t7hKEIOSyxe0k6QhHu9y3cj5GOvEqCRNurUY&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-73&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0B8P129H6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 10,
    "asin": "B0B8P129H6",
    "title": "Flash Drive 16GB Thumb Drives Memory Sticks Jump Drive 5Pack 16GB USB 2.0 Flash Drives Mixed Colors: Black Red Blue Purple Green",
    "brand": "Flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$11.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/813a39D5VQL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.99,
    "currency": "USD",
    "price_original": "$11.99"
  },
  {
    "product_url": "https://www.amazon.com/Flash-Drives-Pack-Drive-Multi-Colored/dp/B0CBJZ6BW4/ref=sr_1_74?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.AcXy7B9_HPcoPjZ6T61spU0sIWJQ11b3mWQ78z7OjoMCkxuVRomIX5Fn9c3_yaDds4hJ-kTulubDQ6OEOIk7FQHwLM0ysa9hXJNLBETw9KEkUa9TWNekRF-KgGSOu3iRtXTr7ys5dgItEHp58ZsIrLWXavrG8syL76ufIXE1IKJ9iM4r2pO4XxFAis7EnUBz.x6gC6U4t7hKEIOSyxe0k6QhHu9y3cj5GOvEqCRNurUY&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-74&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CBJZ6BW4",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 11,
    "asin": "B0CBJZ6BW4",
    "title": "USB Flash Drives 10 Pack 1GB Flash Drive - AGECASH A USB 2.0 Thumb Drive Jump Zip Drive Flashdrive, USB Memory Stick Pendrive for Data Storage & Transfer with 10PCS Lanyard (Multi-Colored)",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$17.94",
    "rating": 4.5,
    "review_count": 200,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "10 sizes10 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/81IEDqEE-3L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 17.94,
    "currency": "USD",
    "price_original": "$17.94"
  },
  {
    "product_url": "https://www.amazon.com/Kingston-DataTraveler-256GB-Performance-DTMAXA/dp/B0B57T5G5L/ref=sr_1_75?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.AcXy7B9_HPcoPjZ6T61spU0sIWJQ11b3mWQ78z7OjoMCkxuVRomIX5Fn9c3_yaDds4hJ-kTulubDQ6OEOIk7FQHwLM0ysa9hXJNLBETw9KEkUa9TWNekRF-KgGSOu3iRtXTr7ys5dgItEHp58ZsIrLWXavrG8syL76ufIXE1IKJ9iM4r2pO4XxFAis7EnUBz.x6gC6U4t7hKEIOSyxe0k6QhHu9y3cj5GOvEqCRNurUY&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-75&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0B57T5G5L",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 12,
    "asin": "B0B57T5G5L",
    "title": "Kingston DataTraveler Max Type-A 256GB High Performance USB Flash Drive USB 3.2 Gen 2 Up to 1000 MB/s Sliding Cap Design DTMAXA/256GB",
    "brand": "Kingston",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 2",
    "memory_type": "USB",
    "price": "$32.95",
    "rating": 4.4,
    "review_count": 500,
    "special_features": "Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/71LZSzMik0L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 32.95,
    "currency": "USD",
    "price_original": "$32.95"
  },
  {
    "product_url": "https://www.amazon.com/Gigastone-Waterproof-Performance-Interface-Compatible/dp/B0886FJPP1/ref=sr_1_76?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.AcXy7B9_HPcoPjZ6T61spU0sIWJQ11b3mWQ78z7OjoMCkxuVRomIX5Fn9c3_yaDds4hJ-kTulubDQ6OEOIk7FQHwLM0ysa9hXJNLBETw9KEkUa9TWNekRF-KgGSOu3iRtXTr7ys5dgItEHp58ZsIrLWXavrG8syL76ufIXE1IKJ9iM4r2pO4XxFAis7EnUBz.x6gC6U4t7hKEIOSyxe0k6QhHu9y3cj5GOvEqCRNurUY&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-76&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0886FJPP1",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 13,
    "asin": "B0886FJPP1",
    "title": "„ÄêGIGASTONE„Äë Z90 128GB 2-Pack USB 3.2 Gen1 Flash Drive, Mini Fit Metal Waterproof Compact Pen Drive, Reliable Performance Thumb Drive, USB 2.0/3.0/3.1 Interface Compatible",
    "brand": "Gigastone",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$22.99",
    "rating": 4.3,
    "review_count": 100,
    "special_features": "Waterproof, Metal, Compact, Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/718IldIBTWL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 22.99,
    "currency": "USD",
    "price_original": "$22.99"
  },
  {
    "product_url": "https://www.amazon.com/Aiibe-Push-Pull-Memory-Smartphone-Computer/dp/B0D3PNR3XD/ref=sr_1_77?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.AcXy7B9_HPcoPjZ6T61spU0sIWJQ11b3mWQ78z7OjoMCkxuVRomIX5Fn9c3_yaDds4hJ-kTulubDQ6OEOIk7FQHwLM0ysa9hXJNLBETw9KEkUa9TWNekRF-KgGSOu3iRtXTr7ys5dgItEHp58ZsIrLWXavrG8syL76ufIXE1IKJ9iM4r2pO4XxFAis7EnUBz.x6gC6U4t7hKEIOSyxe0k6QhHu9y3cj5GOvEqCRNurUY&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-77&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0D3PNR3XD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 14,
    "asin": "B0D3PNR3XD",
    "title": "Aiibe 128GB USB C Flash Drive Dual Type C + USB A 128GB Jump Drive Push-Pull Thumb Drive for iPhone 15 Smartphone Tablet Computer",
    "brand": "Aiibe",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$9.99",
    "rating": 4.3,
    "review_count": 300,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "7 sizes7 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/51H9GC78XnL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 9.99,
    "currency": "USD",
    "price_original": "$9.99"
  },
  {
    "product_url": "https://www.amazon.com/Flash-Drive-ALMEMO-Memory-Drives/dp/B07WGD7VW5/ref=sr_1_78?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.AcXy7B9_HPcoPjZ6T61spU0sIWJQ11b3mWQ78z7OjoMCkxuVRomIX5Fn9c3_yaDds4hJ-kTulubDQ6OEOIk7FQHwLM0ysa9hXJNLBETw9KEkUa9TWNekRF-KgGSOu3iRtXTr7ys5dgItEHp58ZsIrLWXavrG8syL76ufIXE1IKJ9iM4r2pO4XxFAis7EnUBz.x6gC6U4t7hKEIOSyxe0k6QhHu9y3cj5GOvEqCRNurUY&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-78&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07WGD7VW5",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 15,
    "asin": "B07WGD7VW5",
    "title": "USB Flash Drive 32GB, Maspen Thumb Drive 2.0 High Speed Memory Stick Jump/ Zip/ Pen Drive,Blue,32 GB",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$4.99",
    "rating": 4.4,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/51DKaFP6bEL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 4.99,
    "currency": "USD",
    "price_original": "$4.99"
  },
  {
    "product_url": "https://www.amazon.com/WesData-2-Pack-Drives-Adapter-Memory/dp/B0F5NZS3J6/ref=sr_1_79?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.AcXy7B9_HPcoPjZ6T61spU0sIWJQ11b3mWQ78z7OjoMCkxuVRomIX5Fn9c3_yaDds4hJ-kTulubDQ6OEOIk7FQHwLM0ysa9hXJNLBETw9KEkUa9TWNekRF-KgGSOu3iRtXTr7ys5dgItEHp58ZsIrLWXavrG8syL76ufIXE1IKJ9iM4r2pO4XxFAis7EnUBz.x6gC6U4t7hKEIOSyxe0k6QhHu9y3cj5GOvEqCRNurUY&dib_tag=se&keywords=flash+drives&qid=1753561745&sprefix=flash+drive%2Caps%2C146&sr=8-79&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0F5NZS3J6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 16,
    "asin": "B0F5NZS3J6",
    "title": "2-Pack 64GB Small USB Flash Drives with 1 USB C Adapter Cable, Zinc Alloy Metal Shell, Thumb Drive, Memory Stick, Pen Drive for PC/Mac/Phone/Laptop/Car Black",
    "brand": "2-Pack",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$9.99",
    "rating": 4.9,
    "review_count": 100,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -29,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/61XYuQ4IjVL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 9.99,
    "currency": "USD",
    "price_original": "$9.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=5&crid=BALSGJKBQE1X&qid=1753561719&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_5#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 17,
    "asin": null,
    "title": "4GB USB Flash Drive 20 Pack AGECASH A USB 2.0 Flash Drive 4GB Thumb Drive 20Pack Jump Zip Drive USB Key Memory Stick Pendrive for Data Storage & Transfer with 10PCS Lanyard (Multicolor 4 GB)",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$40.67",
    "rating": 4.6,
    "review_count": 143,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -143,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/81xaaPBewUL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 40.67,
    "currency": "USD",
    "price_original": "$40.67"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozOTg0NDM3NDU5NjI4Nzc5OjE3NTM1NjE3NDg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MjAzNTQ1NzQwMjo6MDo6&url=%2FAGECASH-Drives-Swivel-Pendrive-Lanyard%2Fdp%2FB0CBK1V7XG%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CBK1V7XG%26pd_rd_r%3Dc8d0b9ba-e95c-4292-a7fa-ff36b7d19779%26pd_rd_w%3D1snw8%26pd_rd_wg%3DRg8Pl%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DF0GH1SVPK60J2GB2PY47%26qid%3D1753561745%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-65-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CBK1V7XG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 18,
    "asin": "B0CBK1V7XG",
    "title": "4GB USB Flash Drive 20 Pack AGECASH A USB 2.0 Flash Drive 4GB Thumb Drive 20Pack Jump Zip Drive USB Key Memory Stick Pendrive for Data Storage & Transfer with 10PCS Lanyard (Multicolor 4 GB)",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$40.67",
    "rating": 4.6,
    "review_count": 143,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -143,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/81xaaPBewUL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 40.67,
    "currency": "USD",
    "price_original": "$40.67"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozOTg0NDM3NDU5NjI4Nzc5OjE3NTM1NjE3NDg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MjAzNTQ1NzMwMjo6MTo6&url=%2FAGECASH-8GB-USB-Pack-Drive%2Fdp%2FB0DNSQHTQW%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DNSQHTQW%26pd_rd_r%3Dc8d0b9ba-e95c-4292-a7fa-ff36b7d19779%26pd_rd_w%3D1snw8%26pd_rd_wg%3DRg8Pl%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DF0GH1SVPK60J2GB2PY47%26qid%3D1753561745%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-66-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DNSQHTQW",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 19,
    "asin": "B0DNSQHTQW",
    "title": "AGECASH 8GB Flash Drives 20 Pack USB 2.0 Flash Drives 8GB Thumb Drive 20 Packs Swivel Pendrive Zip Drive USB Memory Stick with 20PCS Lanyard Jump Drive Multipack Gray",
    "brand": "AGECASH",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$37.04",
    "rating": 4.5,
    "review_count": 388,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -388,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/71+QDSTp+oL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.04,
    "currency": "USD",
    "price_original": "$37.04"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozOTg0NDM3NDU5NjI4Nzc5OjE3NTM1NjE3NDg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDY2NDM4Mjk5OTMwMjo6Mjo6&url=%2FDataStick-Pro-Black-1TB-Pack%2Fdp%2FB0BTMSTCJ9%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0BTMSTCJ9%26pd_rd_r%3Dc8d0b9ba-e95c-4292-a7fa-ff36b7d19779%26pd_rd_w%3D1snw8%26pd_rd_wg%3DRg8Pl%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DF0GH1SVPK60J2GB2PY47%26qid%3D1753561745%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-67-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0BTMSTCJ9",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 20,
    "asin": "B0BTMSTCJ9",
    "title": "1TB DataStick Pro by Centon, USB 3.2 Gen1 Flash Drive Memory Stick for Storage and Backup",
    "brand": "1TB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$54.99",
    "rating": 4.5,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -250,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/41VtL6vtkJL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "tb",
    "price_numeric": 54.99,
    "currency": "USD",
    "price_original": "$54.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozOTg0NDM3NDU5NjI4Nzc5OjE3NTM1NjE3NDg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDUyODMzOTM1MDQwMjo6Mzo6&url=%2FPNY-128GB-Attach%25C3%25A9-Flash-5-Pack%2Fdp%2FB0BDT8FTMP%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0BDT8FTMP%26pd_rd_r%3Dc8d0b9ba-e95c-4292-a7fa-ff36b7d19779%26pd_rd_w%3D1snw8%26pd_rd_wg%3DRg8Pl%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DF0GH1SVPK60J2GB2PY47%26qid%3D1753561745%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-68-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0BDT8FTMP",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 21,
    "asin": "B0BDT8FTMP",
    "title": "PNY 128GB Attach√© 3 USB 2.0 Flash Drive, Black (Pack of 5)",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$24.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.6K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/51L3dUD+jkL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTozOTg0NDM3NDU5NjI4Nzc5OjE3NTM1NjE3NDg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1NTk1NTg4MDIwMjo6NDo6&url=%2F2GB-Nicepicten-Multipack-Green-20PCS%2Fdp%2FB0D8QHKHLM%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0D8QHKHLM%26pd_rd_r%3Dc8d0b9ba-e95c-4292-a7fa-ff36b7d19779%26pd_rd_w%3D1snw8%26pd_rd_wg%3DRg8Pl%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DF0GH1SVPK60J2GB2PY47%26qid%3D1753561745%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-69-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0D8QHKHLM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 22,
    "asin": "B0D8QHKHLM",
    "title": "USB Thumb Drive 2GB Flash Drive 20 Pack Nicepicten Zip Drive USB 2.0 Flash Drives Jump Drive Multipack Memory Stick Pendrive for Events Office Shared Data Storage, Green 20PCS 2GB",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 2000000000,
    "capacity_category": "2 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$36.88",
    "rating": 4.6,
    "review_count": 116,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -116,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/81V4MON7pTL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 36.88,
    "currency": "USD",
    "price_original": "$36.88"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=5&crid=BALSGJKBQE1X&qid=1753561719&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_5#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 23,
    "asin": null,
    "title": "32GB USB Flash Drive USB 3.1 Gen1 Dual USB-A & Type-C, Portable Thumb Drive for Smartphones, Laptops & Tablets",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$16.99",
    "rating": 4.4,
    "review_count": 60,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -7,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/51PxnRm-CUL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.99,
    "currency": "USD",
    "price_original": "$16.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2OTQ3NjY0NzcxOTk2NjQxOjE3NTM1NjE3NDg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MDY1Njc2NjIwMjo6MTo6&url=%2FOSCOO-Portable-Smartphones-Laptops-Tablets%2Fdp%2FB0F6MXMDVX%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0F6MXMDVX%26pd_rd_r%3Dc8d0b9ba-e95c-4292-a7fa-ff36b7d19779%26pd_rd_w%3DgMK6i%26pd_rd_wg%3DRg8Pl%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DF0GH1SVPK60J2GB2PY47%26qid%3D1753561745%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-65-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0F6MXMDVX",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 24,
    "asin": "B0F6MXMDVX",
    "title": "32GB USB Flash Drive USB 3.1 Gen1 Dual USB-A & Type-C, Portable Thumb Drive for Smartphones, Laptops & Tablets",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$16.99",
    "rating": 4.4,
    "review_count": 7,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -7,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/51PxnRm-CUL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.99,
    "currency": "USD",
    "price_original": "$16.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2OTQ3NjY0NzcxOTk2NjQxOjE3NTM1NjE3NDg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1NzYxMTExMjMwMjo6Mjo6&url=%2FSCICNCE-Intended-Required-Compatible-Computers%2Fdp%2FB0FDMQMYQJ%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FDMQMYQJ%26pd_rd_r%3Dc8d0b9ba-e95c-4292-a7fa-ff36b7d19779%26pd_rd_w%3DgMK6i%26pd_rd_wg%3DRg8Pl%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DF0GH1SVPK60J2GB2PY47%26qid%3D1753561745%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-66-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FDMQMYQJ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 25,
    "asin": "B0FDMQMYQJ",
    "title": "SCICNCE 512GB Flash Drive Intended for iPhone, USB Memory Stick Storage Backup for Photos Videos, Plug and Play No APP Required, Compatible with iPhone iPad Android and Computers (Metal Gray)",
    "brand": "SCICNCE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$63.99",
    "rating": 4.6,
    "review_count": 39,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -39,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/61rBOw2g9FL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 63.99,
    "currency": "USD",
    "price_original": "$63.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2OTQ3NjY0NzcxOTk2NjQxOjE3NTM1NjE3NDg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1NTU4ODgyODUwMjo6Mzo6&url=%2F32GB-USB-Flash-Drive-Compatible%2Fdp%2FB0FF4SQ4Q3%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FF4SQ4Q3%26pd_rd_r%3Dc8d0b9ba-e95c-4292-a7fa-ff36b7d19779%26pd_rd_w%3DgMK6i%26pd_rd_wg%3DRg8Pl%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DF0GH1SVPK60J2GB2PY47%26qid%3D1753561745%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-67-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FF4SQ4Q3",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 26,
    "asin": "B0FF4SQ4Q3",
    "title": "32GB USB Flash Drive ‚Äì 4 in 1 Flash Drive with USB 3.0, Type C, Micro USB & iOS Connector ‚Äì High Speed Thumb Drive, Memory Stick Compatible with Laptop, Android, PC - Blue",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$15.19",
    "rating": null,
    "review_count": 15,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/61tRQYjvflL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 15.19,
    "currency": "USD",
    "price_original": "$15.19"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2OTQ3NjY0NzcxOTk2NjQxOjE3NTM1NjE3NDg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5MDIwMjo6NDo6&url=%2FCustom-Drives-Personalized-Business-Promotions%2Fdp%2FB0FGQ99G62%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQ99G62%26pd_rd_r%3Dc8d0b9ba-e95c-4292-a7fa-ff36b7d19779%26pd_rd_w%3DgMK6i%26pd_rd_wg%3DRg8Pl%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DF0GH1SVPK60J2GB2PY47%26qid%3D1753561745%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-68-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ99G62",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 27,
    "asin": "B0FGQ99G62",
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (100,8GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$340.99",
    "rating": null,
    "review_count": 340,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-5_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 340.99,
    "currency": "USD",
    "price_original": "$340.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2OTQ3NjY0NzcxOTk2NjQxOjE3NTM1NjE3NDg6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5MzUwMjo6NTo6&url=%2FFlash-Drive-Customizable-Thumb-4GB-128GB%2Fdp%2FB0FGQ2VHH1%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQ2VHH1%26pd_rd_r%3Dc8d0b9ba-e95c-4292-a7fa-ff36b7d19779%26pd_rd_w%3DgMK6i%26pd_rd_wg%3DRg8Pl%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DF0GH1SVPK60J2GB2PY47%26qid%3D1753561745%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-69-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ2VHH1",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 28,
    "asin": "B0FGQ2VHH1",
    "title": "Mini USB Flash Drive Customizable Tiny Thumb Drive with Your Logo 4GB-128GB - Perfect for Corporate Events, Branded Promotions, Student Projects Plug and Play, PC Mac (50,32GB)",
    "brand": "Mini",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$205.99",
    "rating": null,
    "review_count": 205,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-5_files/41Y5IinJkAL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 205.99,
    "currency": "USD",
    "price_original": "$205.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=5&crid=BALSGJKBQE1X&qid=1753561719&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_5#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 29,
    "asin": null,
    "title": "1GB Flash Drive 20 Pack, Wooolken USB 2.0 Thumb Drives Memory Stick with LED Light and Lanyards for Storage and Backup (Mixed Colors: Black Red Blue Orange Green)",
    "brand": "1GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$32.39",
    "rating": 4.6,
    "review_count": 50,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/71-kUjhphpL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 32.39,
    "currency": "USD",
    "price_original": "$32.39"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4MjM4MDg5MDMwMjMzMjE6MTc1MzU2MTc0ODpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDE5OTU5MjMyMzEwMjo6MDo6&url=%2FWooolken-Drives-Memory-Lanyards-Storage%2Fdp%2FB0C5CYWMMC%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0C5CYWMMC%26pd_rd_r%3D5724ab32-f560-4766-9be9-d5489c87fd64%26pd_rd_w%3DKcKjN%26pd_rd_wg%3DTaKn7%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DF0GH1SVPK60J2GB2PY47%26qid%3D1753561745%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-65-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0C5CYWMMC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 30,
    "asin": "B0C5CYWMMC",
    "title": "1GB Flash Drive 20 Pack, Wooolken USB 2.0 Thumb Drives Memory Stick with LED Light and Lanyards for Storage and Backup (Mixed Colors: Black Red Blue Orange Green)",
    "brand": "1GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000,
    "capacity_category": "Up to 1 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$32.39",
    "rating": 4.6,
    "review_count": 50,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/71-kUjhphpL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 32.39,
    "currency": "USD",
    "price_original": "$32.39"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4MjM4MDg5MDMwMjMzMjE6MTc1MzU2MTc0ODpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDc5NTc0NDI5OTUwMjo6MTo6&url=%2FDrives-JUANWE-Memory-Storage-Red-Black%2Fdp%2FB0B466ZSGG%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0B466ZSGG%26pd_rd_r%3D5724ab32-f560-4766-9be9-d5489c87fd64%26pd_rd_w%3DKcKjN%26pd_rd_wg%3DTaKn7%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DF0GH1SVPK60J2GB2PY47%26qid%3D1753561745%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-66-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0B466ZSGG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 31,
    "asin": "B0B466ZSGG",
    "title": "JUANWE 5 Pack 32GB USB 3.0 Flash Drive 32GB Thumb Drives High Speed USB Memory Stick USB Drive Zip Drive with LED Indicator for Data Storage",
    "brand": "JUANWE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$20.89",
    "rating": 4.4,
    "review_count": 388,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -388,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/61TFZPk3w8L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.89,
    "currency": "USD",
    "price_original": "$20.89"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4MjM4MDg5MDMwMjMzMjE6MTc1MzU2MTc0ODpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDg2MDk4MzcwNTgwMjo6Mjo6&url=%2F32GB-Multi-Color-Portable-FEBNISCTE-Multipack%2Fdp%2FB004WMEAQC%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB004WMEAQC%26pd_rd_r%3D5724ab32-f560-4766-9be9-d5489c87fd64%26pd_rd_w%3DKcKjN%26pd_rd_wg%3DTaKn7%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DF0GH1SVPK60J2GB2PY47%26qid%3D1753561745%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-67-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B004WMEAQC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 32,
    "asin": "B004WMEAQC",
    "title": "FEBNISCTE 32GB Flash Drive 10 Pack, Thumb Drive High Capacity, Bulk USB Flash Drives 32 GB Metal Swivel, USB 2.0 Jump Drive Memory Stick Portable, Pen Drive Zip High Speed for Data Storage",
    "brand": "FEBNISCTE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$24.99",
    "rating": 4.5,
    "review_count": 5,
    "special_features": "Metal, Swivel, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(5.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/71lxOtSOxNL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4MjM4MDg5MDMwMjMzMjE6MTc1MzU2MTc0ODpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDU2NzAxMjI1MDkwMjo6Mzo6&url=%2FCertified-iPhone-Memory-Compatible-Android%2Fdp%2FB0DCZLGJGM%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DCZLGJGM%26pd_rd_r%3D5724ab32-f560-4766-9be9-d5489c87fd64%26pd_rd_w%3DKcKjN%26pd_rd_wg%3DTaKn7%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DF0GH1SVPK60J2GB2PY47%26qid%3D1753561745%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-68-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DCZLGJGM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 33,
    "asin": "B0DCZLGJGM",
    "title": "Apple MFi Certified 128GB Flash Drive for iPhone Thumb Drive Photo Stick, USB Memory Stick iPhone Flash Drive for Photos Videos, High Speed Jump Drive Compatible for iPhone/iPad/Android/PC (Blue)",
    "brand": "Apple",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$18.98",
    "rating": 4.2,
    "review_count": 3,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/61mO23ePr1L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.98,
    "currency": "USD",
    "price_original": "$18.98"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4MjM4MDg5MDMwMjMzMjE6MTc1MzU2MTc0ODpzcF9zZWFyY2hfdGhlbWF0aWNfYnRmOjMwMDczNTUwODgwOTYwMjo6NDo6&url=%2FKeychains-Wooolken-Drives-Memory-Computer%2Fdp%2FB0DYNCXSBN%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DYNCXSBN%26pd_rd_r%3D5724ab32-f560-4766-9be9-d5489c87fd64%26pd_rd_w%3DKcKjN%26pd_rd_wg%3DTaKn7%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DF0GH1SVPK60J2GB2PY47%26qid%3D1753561745%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-69-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DYNCXSBN",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-5.html",
    "position": 34,
    "asin": "B0DYNCXSBN",
    "title": "4GB USB Flash Drive 2 Pack with Keychains, Wooolken Sleek Metal USB 2.0 Thumb Drives Memory Stick for PC Laptop Computer",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$7.73",
    "rating": 4.4,
    "review_count": 681,
    "special_features": "Metal, Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -681,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-5_files/51IPWm9hsDL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 7.73,
    "currency": "USD",
    "price_original": "$7.73"
  },
  {
    "product_url": "https://www.amazon.com/Maspen-Memory-Drives-Pendrive-Storage/dp/B0CMXMX4NM/ref=sr_1_84?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CyqE39t73oBtZHS-XqObCnsvJJplTx26vTmWV8ntI5PGjHj071QN20LucGBJIEps.EhyjAJgqN82wEte2uqjZVE1SXk-iu75KviU980MhK2Q&dib_tag=se&keywords=flash+drives&qid=1753561763&sprefix=flash+drive%2Caps%2C146&sr=8-84&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CMXMX4NM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 1,
    "asin": "B0CMXMX4NM",
    "title": "64GB USB Flash Drive 2 Pack 64 GB USB Thumb Drive Memory Stick Jump Drives Pendrive for Storage (2 Colors, 64G)",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$8.99",
    "rating": 4.4,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/51aZAGvMEhL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 8.99,
    "currency": "USD",
    "price_original": "$8.99"
  },
  {
    "product_url": "https://www.amazon.com/TosMemo-2Pack-Flash-Drive-Memory/dp/B07H285LHH/ref=sr_1_85?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.CyqE39t73oBtZHS-XqObCnsvJJplTx26vTmWV8ntI5PGjHj071QN20LucGBJIEps.EhyjAJgqN82wEte2uqjZVE1SXk-iu75KviU980MhK2Q&dib_tag=se&keywords=flash+drives&qid=1753561763&sprefix=flash+drive%2Caps%2C146&sr=8-85&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07H285LHH",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 2,
    "asin": "B07H285LHH",
    "title": "2Pack 8GB USB 2.0 Flash Drive 8GB Thumb Drive Memory Stick Jump Drive (Black/Blue)",
    "brand": "2Pack",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$5.99",
    "rating": 4.4,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/61npYBWpDoL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 5.99,
    "currency": "USD",
    "price_original": "$5.99"
  },
  {
    "product_url": "https://www.amazon.com/Lanyards-Portable-Pendrive-Indicator-Business/dp/B0F6LQXPD6/ref=sr_1_81?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.fCai60OZV9js3lmrpANvUsjj3KIUXT38NbffVPcqNxanlCmNBef4sb4kMIRv3biBJsNe14ivUE_VHXVbsFGdH6CBqO5uUMXjzIvyA3gawSOb5Ej1BG-hHLs14v0g6bNMGFl0sZolL4rsdJWVO6L48miDhVvXulZ0qHvO6IVZVI7qNkG8RljCHv-Znm6ec85C.fZKpxW2pg6WmOUCg340KSGWxpMxepH3HyftH1IbkBQU&dib_tag=se&keywords=flash+drives&qid=1753561763&sprefix=flash+drive%2Caps%2C146&sr=8-81&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0F6LQXPD6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 3,
    "asin": "B0F6LQXPD6",
    "title": "4GB USB Flash Drive 10 Pack, Swivel Memory Stick Thumb Drives with Lanyards, Portable Photo Stick Jump Drives Pendrive Zip Drive USB Key with LED Indicator for Data Storage Office Business Students",
    "brand": "4GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$14.66",
    "rating": 4.6,
    "review_count": 200,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "2 sizes2 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/71RotXDgq9L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.66,
    "currency": "USD",
    "price_original": "$14.66"
  },
  {
    "product_url": "https://www.amazon.com/Verbatim-Pinstripe-Drives-Assorted-Colors/dp/B085BDHZYB/ref=sr_1_82?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.fCai60OZV9js3lmrpANvUsjj3KIUXT38NbffVPcqNxanlCmNBef4sb4kMIRv3biBJsNe14ivUE_VHXVbsFGdH6CBqO5uUMXjzIvyA3gawSOb5Ej1BG-hHLs14v0g6bNMGFl0sZolL4rsdJWVO6L48miDhVvXulZ0qHvO6IVZVI7qNkG8RljCHv-Znm6ec85C.fZKpxW2pg6WmOUCg340KSGWxpMxepH3HyftH1IbkBQU&dib_tag=se&keywords=flash+drives&qid=1753561763&sprefix=flash+drive%2Caps%2C146&sr=8-82&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B085BDHZYB",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 4,
    "asin": "B085BDHZYB",
    "title": "Verbatim 16GB Pinstripe USB 3.2 Gen 1 Flash Drive Retractable Thumb Drive- 5 Pack - Multicolor (Green, Blue, Red, Purple, Cyan)",
    "brand": "Verbatim",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$21.37",
    "rating": 4.4,
    "review_count": 50,
    "special_features": "Retractable",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/81KbOtpVl5L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 21.37,
    "currency": "USD",
    "price_original": "$21.37"
  },
  {
    "product_url": "https://www.amazon.com/RAOYI-Memory-Storage-Backup-Multicolor/dp/B0B7QK533N/ref=sr_1_83?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.fCai60OZV9js3lmrpANvUsjj3KIUXT38NbffVPcqNxanlCmNBef4sb4kMIRv3biBJsNe14ivUE_VHXVbsFGdH6CBqO5uUMXjzIvyA3gawSOb5Ej1BG-hHLs14v0g6bNMGFl0sZolL4rsdJWVO6L48miDhVvXulZ0qHvO6IVZVI7qNkG8RljCHv-Znm6ec85C.fZKpxW2pg6WmOUCg340KSGWxpMxepH3HyftH1IbkBQU&dib_tag=se&keywords=flash+drives&qid=1753561763&sprefix=flash+drive%2Caps%2C146&sr=8-83&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0B7QK533N",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 5,
    "asin": "B0B7QK533N",
    "title": "RAOYI 5 Pack 16GB Flash Drive, USB 3.0 High Speed Memory Stick Thumb Drive Jump Drive Zip Drive for Data Storage and Backup (Multicolor)",
    "brand": "RAOYI",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$18.99",
    "rating": 4.5,
    "review_count": 50,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/71pkKebQZML._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.99,
    "currency": "USD",
    "price_original": "$18.99"
  },
  {
    "product_url": "https://www.amazon.com/KOOTION-Samsung-Oneplus-MacBook-Chromebook/dp/B088LMS5VV/ref=sr_1_85?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.fCai60OZV9js3lmrpANvUsjj3KIUXT38NbffVPcqNxanlCmNBef4sb4kMIRv3biBJsNe14ivUE_VHXVbsFGdH6CBqO5uUMXjzIvyA3gawSOb5Ej1BG-hHLs14v0g6bNMGFl0sZolL4rsdJWVO6L48miDhVvXulZ0qHvO6IVZVI7qNkG8RljCHv-Znm6ec85C.fZKpxW2pg6WmOUCg340KSGWxpMxepH3HyftH1IbkBQU&dib_tag=se&keywords=flash+drives&qid=1753561763&sprefix=flash+drive%2Caps%2C146&sr=8-85&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B088LMS5VV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 6,
    "asin": "B088LMS5VV",
    "title": "KOOTION USB C Flash Drive 128GB 2 in 1 OTG USB 3.0/Type C Thumb Drive Dual Drive USB C Memory Stick for Smartphone/Laptop/Tablet/PC - 128G, Blue",
    "brand": "KOOTION",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$10.99",
    "rating": 4.4,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "4 sizes4 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/61AKufkgmnL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 10.99,
    "currency": "USD",
    "price_original": "$10.99"
  },
  {
    "product_url": "https://www.amazon.com/KEXIN-Flash-Drives-Memory-Yellow/dp/B09GDXQ3MS/ref=sr_1_88?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.fCai60OZV9js3lmrpANvUsjj3KIUXT38NbffVPcqNxanlCmNBef4sb4kMIRv3biBJsNe14ivUE_VHXVbsFGdH6CBqO5uUMXjzIvyA3gawSOb5Ej1BG-hHLs14v0g6bNMGFl0sZolL4rsdJWVO6L48miDhVvXulZ0qHvO6IVZVI7qNkG8RljCHv-Znm6ec85C.fZKpxW2pg6WmOUCg340KSGWxpMxepH3HyftH1IbkBQU&dib_tag=se&keywords=flash+drives&qid=1753561763&sprefix=flash+drive%2Caps%2C146&sr=8-88&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09GDXQ3MS",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 7,
    "asin": "B09GDXQ3MS",
    "title": "KEXIN 3 Pack 64GB Flash Drive USB Drive Thumb Drive 64 GB USB Flash Drive Jump Drive 64G Flash Drives Photo Memory Stick Pen Drive Zip Drive Pink Yellow Blue",
    "brand": "KEXIN",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$14.99",
    "rating": 4.4,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "9 sizes9 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/41NADv275WL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.99,
    "currency": "USD",
    "price_original": "$14.99"
  },
  {
    "product_url": "https://www.amazon.com/MOSDART-128GB-Flash-Drive-Keychain/dp/B0C7GJLT8W/ref=sr_1_89?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.fCai60OZV9js3lmrpANvUsjj3KIUXT38NbffVPcqNxanlCmNBef4sb4kMIRv3biBJsNe14ivUE_VHXVbsFGdH6CBqO5uUMXjzIvyA3gawSOb5Ej1BG-hHLs14v0g6bNMGFl0sZolL4rsdJWVO6L48miDhVvXulZ0qHvO6IVZVI7qNkG8RljCHv-Znm6ec85C.fZKpxW2pg6WmOUCg340KSGWxpMxepH3HyftH1IbkBQU&dib_tag=se&keywords=flash+drives&qid=1753561763&sprefix=flash+drive%2Caps%2C146&sr=8-89&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0C7GJLT8W",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 8,
    "asin": "B0C7GJLT8W",
    "title": "MOSDART 128GB Dual USB C Flash Drive, Speed Up to 150MB/S Type C 3.1 Thumb Drive with Keychain and LED Indicator, exFAT Memory Stick for iPhone 15 and 16, iPad, Android Phone, Tablet, Laptop, Purple",
    "brand": "MOSDART",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$17.99",
    "rating": 4.3,
    "review_count": 500,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "8 sizes8 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/71lMazY6XIL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 17.99,
    "currency": "USD",
    "price_original": "$17.99"
  },
  {
    "product_url": "https://www.amazon.com/Certified-External-Storage-Compatible-Android/dp/B0BHWGMPZ2/ref=sr_1_90?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.fCai60OZV9js3lmrpANvUsjj3KIUXT38NbffVPcqNxanlCmNBef4sb4kMIRv3biBJsNe14ivUE_VHXVbsFGdH6CBqO5uUMXjzIvyA3gawSOb5Ej1BG-hHLs14v0g6bNMGFl0sZolL4rsdJWVO6L48miDhVvXulZ0qHvO6IVZVI7qNkG8RljCHv-Znm6ec85C.fZKpxW2pg6WmOUCg340KSGWxpMxepH3HyftH1IbkBQU&dib_tag=se&keywords=flash+drives&qid=1753561763&sprefix=flash+drive%2Caps%2C146&sr=8-90&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BHWGMPZ2",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 9,
    "asin": "B0BHWGMPZ2",
    "title": "MFi Certified 128GB Photo Stick for iPhone Flash Drive,USB Memory Stick Thumb Drives High Speed USB Stick External Storage Compatible for iPhone/iPad/Android/PC",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$17.99",
    "rating": 4.2,
    "review_count": 3,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/61wk1z9PrZL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 17.99,
    "currency": "USD",
    "price_original": "$17.99"
  },
  {
    "product_url": "https://www.amazon.com/JUANWE-Portable-Waterproof-Computers-Pendrive/dp/B0C2BQRM13/ref=sr_1_91?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.fCai60OZV9js3lmrpANvUsjj3KIUXT38NbffVPcqNxanlCmNBef4sb4kMIRv3biBJsNe14ivUE_VHXVbsFGdH6CBqO5uUMXjzIvyA3gawSOb5Ej1BG-hHLs14v0g6bNMGFl0sZolL4rsdJWVO6L48miDhVvXulZ0qHvO6IVZVI7qNkG8RljCHv-Znm6ec85C.fZKpxW2pg6WmOUCg340KSGWxpMxepH3HyftH1IbkBQU&dib_tag=se&keywords=flash+drives&qid=1753561763&sprefix=flash+drive%2Caps%2C146&sr=8-91&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0C2BQRM13",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 10,
    "asin": "B0C2BQRM13",
    "title": "JUANWE 64GB USB Flash Drive Bulk 5 Pack, Key Shape Mix Color Thumb Drive Metal Jump Drive 2.0, Mutipacks Memory Storage Stick Portable Waterproof Pendrive, Ideal Zip Drive for Data Backup & Transfer",
    "brand": "JUANWE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$18.99",
    "rating": 4.4,
    "review_count": 50,
    "special_features": "Waterproof, Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/61FYusa9iHL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.99,
    "currency": "USD",
    "price_original": "$18.99"
  },
  {
    "product_url": "https://www.amazon.com/SSK-Thunderbolt-Transfer-Android-Tablets/dp/B0BFH9QZ49/ref=sr_1_92?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.fCai60OZV9js3lmrpANvUsjj3KIUXT38NbffVPcqNxanlCmNBef4sb4kMIRv3biBJsNe14ivUE_VHXVbsFGdH6CBqO5uUMXjzIvyA3gawSOb5Ej1BG-hHLs14v0g6bNMGFl0sZolL4rsdJWVO6L48miDhVvXulZ0qHvO6IVZVI7qNkG8RljCHv-Znm6ec85C.fZKpxW2pg6WmOUCg340KSGWxpMxepH3HyftH1IbkBQU&dib_tag=se&keywords=flash+drives&qid=1753561763&sprefix=flash+drive%2Caps%2C146&sr=8-92&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BFH9QZ49",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 11,
    "asin": "B0BFH9QZ49",
    "title": "SSK 64GB USB C Flash Drive Dual Drive 2 in 1 OTG USB A 3.2 + Type C Memory Stick Thumb Drive, Thunderbolt Pendrive up to 200MB/s Transfer Speed Photo Stick for Android Phones/Tablets/Mac/Laptop",
    "brand": "SSK",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$9.99",
    "rating": 4.4,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/513Hd4AwzTL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 9.99,
    "currency": "USD",
    "price_original": "$9.99"
  },
  {
    "product_url": "https://www.amazon.com/WesData-Adapter-Tablets-MacBook-Storage/dp/B0CWD4Z7X7/ref=sr_1_93?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.fCai60OZV9js3lmrpANvUsjj3KIUXT38NbffVPcqNxanlCmNBef4sb4kMIRv3biBJsNe14ivUE_VHXVbsFGdH6CBqO5uUMXjzIvyA3gawSOb5Ej1BG-hHLs14v0g6bNMGFl0sZolL4rsdJWVO6L48miDhVvXulZ0qHvO6IVZVI7qNkG8RljCHv-Znm6ec85C.fZKpxW2pg6WmOUCg340KSGWxpMxepH3HyftH1IbkBQU&dib_tag=se&keywords=flash+drives&qid=1753561763&sprefix=flash+drive%2Caps%2C146&sr=8-93&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CWD4Z7X7",
    "blank": null,
    "affiliate_link": "https://amzn.to/41y2Amn",
    "source_file": "drives-6.html",
    "position": 12,
    "asin": "B0CWD4Z7X7",
    "title": "8GB USB 2.0 Flash Drive and 1 USB C Adapter, Thumb Drive USB Memory Stick Jump Drive, Compatible with OTG Type C Phones, Tablets, Laptop, PC (Blue)",
    "brand": "8GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$4.99",
    "rating": 4.4,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/61aFszkwpuL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 4.99,
    "currency": "USD",
    "price_original": "$4.99"
  },
  {
    "product_url": "https://www.amazon.com/JUANWE-Storage-Memory-Swivel-Keychain/dp/B08FSWHTDZ/ref=sr_1_94?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.fCai60OZV9js3lmrpANvUsjj3KIUXT38NbffVPcqNxanlCmNBef4sb4kMIRv3biBJsNe14ivUE_VHXVbsFGdH6CBqO5uUMXjzIvyA3gawSOb5Ej1BG-hHLs14v0g6bNMGFl0sZolL4rsdJWVO6L48miDhVvXulZ0qHvO6IVZVI7qNkG8RljCHv-Znm6ec85C.fZKpxW2pg6WmOUCg340KSGWxpMxepH3HyftH1IbkBQU&dib_tag=se&keywords=flash+drives&qid=1753561763&sprefix=flash+drive%2Caps%2C146&sr=8-94&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08FSWHTDZ",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 13,
    "asin": "B08FSWHTDZ",
    "title": "JUANWE 128GB Flash Drive 2 PCS, 2.0 Thumb Drive USB Drives Pendrive for File Storage Data Transfer, High Capacity Zip Drive Portable USB Storage Flashdrives 360¬∞ Swivel Cap, Jump Drive 128G√ó2 Black",
    "brand": "JUANWE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$16.99",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Swivel, Cap",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "7 sizes7 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/61P2-oyA90L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 16.99,
    "currency": "USD",
    "price_original": "$16.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Flash-Ultra-SDCZ48-016G-UAM46-Performance/dp/B01EG6TTPK/ref=sr_1_95?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.fCai60OZV9js3lmrpANvUsjj3KIUXT38NbffVPcqNxanlCmNBef4sb4kMIRv3biBJsNe14ivUE_VHXVbsFGdH6CBqO5uUMXjzIvyA3gawSOb5Ej1BG-hHLs14v0g6bNMGFl0sZolL4rsdJWVO6L48miDhVvXulZ0qHvO6IVZVI7qNkG8RljCHv-Znm6ec85C.fZKpxW2pg6WmOUCg340KSGWxpMxepH3HyftH1IbkBQU&dib_tag=se&keywords=flash+drives&qid=1753561763&sprefix=flash+drive%2Caps%2C146&sr=8-95&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B01EG6TTPK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 14,
    "asin": "B01EG6TTPK",
    "title": "SanDisk Flash Ultra USB (10 Pack) 3.0 16GB SDCZ48-016G-UAM46 Flash Drive High Performance Pen Drive up to 100MB/s - with (5) Everything But Stromboli (tm) Lanyard",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "SD",
    "price": "$62.67",
    "rating": 4.5,
    "review_count": 145,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/71KRJGVPlgL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 62.67,
    "currency": "USD",
    "price_original": "$62.67"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=6&crid=BALSGJKBQE1X&qid=1753561745&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_6#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 15,
    "asin": null,
    "title": "256GB USB C Flash Drive Dual USB 3.0 Flash Drive Type C + USB A Portable Type-C Flash Drive 2-in-1 USB-C Thumb Drive for Smartphone Tablet Computer Mac iPhone 15 Black",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$25.99",
    "rating": 4.4,
    "review_count": 946,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -946,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/51jrkzCmUML._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 25.99,
    "currency": "USD",
    "price_original": "$25.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2NTYyMjI5MDIxNjkwMDI6MTc1MzU2MTc2NTpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwNzA2MzU4MDU2NzAyOjowOjo&url=%2FJOIOT-Portable-Type-C-Smartphone-Computer%2Fdp%2FB0DW7P5FB2%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DW7P5FB2%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3DHcTa5%26pd_rd_wg%3DylG2r%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-81-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DW7P5FB2",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 16,
    "asin": "B0DW7P5FB2",
    "title": "256GB USB C Flash Drive Dual USB 3.0 Flash Drive Type C + USB A Portable Type-C Flash Drive 2-in-1 USB-C Thumb Drive for Smartphone Tablet Computer Mac iPhone 15 Black",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$25.99",
    "rating": 4.4,
    "review_count": 3,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -946,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/51jrkzCmUML._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 25.99,
    "currency": "USD",
    "price_original": "$25.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2NTYyMjI5MDIxNjkwMDI6MTc1MzU2MTc2NTpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwNjM0NzUzNDA5MjAyOjoxOjo&url=%2FPNY-Advanced-Performance-Everyday-Computers%2Fdp%2FB0DSQVBSHG%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DSQVBSHG%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3DHcTa5%26pd_rd_wg%3DylG2r%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-82-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DSQVBSHG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 17,
    "asin": "B0DSQVBSHG",
    "title": "PNY 512GB Attach√© X USB 3.2 Gen 1 Flash Drive, Advanced Performance Up to 130MB/s Read, Everyday Data Store & Transfer, Reliable Portable Storage, Durable, Type-A, Computers, Laptops, Desktops",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$31.99",
    "rating": 4.5,
    "review_count": 300,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/41Oo++SA0+L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 31.99,
    "currency": "USD",
    "price_original": "$31.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2NTYyMjI5MDIxNjkwMDI6MTc1MzU2MTc2NTpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwNjY0MzkxNjM5OTAyOjoyOjo&url=%2FCenton-DataStick-Flash-Drive-S1-U3P6-256G-10B%2Fdp%2FB0BL7TWPL9%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0BL7TWPL9%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3DHcTa5%26pd_rd_wg%3DylG2r%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-83-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0BL7TWPL9",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 18,
    "asin": "B0BL7TWPL9",
    "title": "Centon DataStick Pro USB 3.0 Flash Drive 256GB x 10, Black (S1-U3P6-256G-10B)",
    "brand": "Centon",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$147.99",
    "rating": 4.5,
    "review_count": 250,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -250,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/61LCc9CEOBL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 147.99,
    "currency": "USD",
    "price_original": "$147.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2NTYyMjI5MDIxNjkwMDI6MTc1MzU2MTc2NTpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwODA5OTEzNzkyMTAyOjozOjo&url=%2FPNY-Elite-256GB-Speeds-P-FD256PRO-GE%2Fdp%2FB01E17LNNU%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB01E17LNNU%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3DHcTa5%26pd_rd_wg%3DylG2r%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-84-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B01E17LNNU",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 19,
    "asin": "B01E17LNNU",
    "title": "PNY 256GB PRO Elite USB 3.1 Flash Drive - 400MB/s",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$25.99",
    "rating": 4.6,
    "review_count": 2,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/41hW5cvDhjL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 25.99,
    "currency": "USD",
    "price_original": "$25.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo2NTYyMjI5MDIxNjkwMDI6MTc1MzU2MTc2NTpzcF9zZWFyY2hfdGhlbWF0aWM6MzAwODAxMDQ5MjQyNjAyOjo0Ojo&url=%2FPortable-Type-C-Smartphone-Tablet-Computer%2Fdp%2FB0DKX8XRDR%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DKX8XRDR%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3DHcTa5%26pd_rd_wg%3DylG2r%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-85-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DKX8XRDR",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 20,
    "asin": "B0DKX8XRDR",
    "title": "256GB USB C Flash Drive Dual USB 3.0 Flash Drive Type C + USB A Portable Type-C Flash Drive 2-in-1 USB-C Thumb Drive for Smartphone Tablet Computer Mac iPhone 15",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$23.99",
    "rating": 4.5,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -108,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/610ZpJlXB+L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 23.99,
    "currency": "USD",
    "price_original": "$23.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=6&crid=BALSGJKBQE1X&qid=1753561745&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_6#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 21,
    "asin": null,
    "title": "128GB USB SSD Flash Drive‚ÄìUSB 3.2 Gen1 High-Speed Thumb Drive, Up to 550MB/s, Dual USB-C & A Ports, Compatible with Smartphones, Android, PC, Laptop‚ÄìPortable Photo & Video Backup Stick",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$31.99",
    "rating": 4.4,
    "review_count": 60,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -7,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/51n0EP60InL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 31.99,
    "currency": "USD",
    "price_original": "$31.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTk5ODkxMzY3NTk3NzU2OjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MDY1Njc2NjUwMjo6MTo6&url=%2FOSCOO-High-Speed-Compatible-Smartphones-Laptop-Portable%2Fdp%2FB0F6N31HDL%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0F6N31HDL%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3D72MCC%26pd_rd_wg%3DylG2r%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-81-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0F6N31HDL",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 22,
    "asin": "B0F6N31HDL",
    "title": "128GB USB SSD Flash Drive‚ÄìUSB 3.2 Gen1 High-Speed Thumb Drive, Up to 550MB/s, Dual USB-C & A Ports, Compatible with Smartphones, Android, PC, Laptop‚ÄìPortable Photo & Video Backup Stick",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$31.99",
    "rating": 4.4,
    "review_count": 7,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -7,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/51n0EP60InL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 31.99,
    "currency": "USD",
    "price_original": "$31.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTk5ODkxMzY3NTk3NzU2OjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1NzYxMTExMTkwMjo6Mjo6&url=%2FSCICNCE-Intended-Required-Compatible-Computers%2Fdp%2FB0FFJPLDMV%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FFJPLDMV%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3D72MCC%26pd_rd_wg%3DylG2r%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-82-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FFJPLDMV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 23,
    "asin": "B0FFJPLDMV",
    "title": "SCICNCE 256GB Flash Drive Intended for iPhone, USB Memory Stick Storage Backup for Photos Videos, Plug and Play No APP Required, Compatible with iPhone iPad Android and Computers (Rose Gold)",
    "brand": "SCICNCE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$39.99",
    "rating": 4.6,
    "review_count": 39,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -39,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/71lZnj7ZftL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 39.99,
    "currency": "USD",
    "price_original": "$39.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTk5ODkxMzY3NTk3NzU2OjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1MDgwNDE5MjUwMjo6Mzo6&url=%2F128GB-USB-Flash-Drive-Compatible%2Fdp%2FB0FF4SS3P7%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FF4SS3P7%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3D72MCC%26pd_rd_wg%3DylG2r%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-83-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FF4SS3P7",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 24,
    "asin": "B0FF4SS3P7",
    "title": "128GB USB Flash Drive ‚Äì 4 in 1 Flash Drive with USB 3.0, Type C, Micro USB & iOS Connector ‚Äì High Speed Thumb Drive, Plug and Play Photo Stick, Memory Stick Compatible with Laptop, Android, PC",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": null,
    "review_count": 19,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/710hPP0F8FL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTk5ODkxMzY3NTk3NzU2OjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU4OTYwMjo6NDo6&url=%2FCustom-Drives-Personalized-Business-Promotions%2Fdp%2FB0FGQB5R4Y%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQB5R4Y%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3D72MCC%26pd_rd_wg%3DylG2r%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-84-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQB5R4Y",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 25,
    "asin": "B0FGQB5R4Y",
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (100,64GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$450.99",
    "rating": null,
    "review_count": 450,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-6_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 450.99,
    "currency": "USD",
    "price_original": "$450.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTk5ODkxMzY3NTk3NzU2OjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5MjkwMjo6NTo6&url=%2FFlash-Drive-Customizable-Thumb-4GB-128GB%2Fdp%2FB0FGQ2BM4P%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQ2BM4P%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3D72MCC%26pd_rd_wg%3DylG2r%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-85-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ2BM4P",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 26,
    "asin": "B0FGQ2BM4P",
    "title": "Mini USB Flash Drive Customizable Tiny Thumb Drive with Your Logo 4GB-128GB - Perfect for Corporate Events, Branded Promotions, Student Projects Plug and Play, PC Mac (50,128GB)",
    "brand": "Mini",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$329.99",
    "rating": null,
    "review_count": 329,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-6_files/41Y5IinJkAL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 329.99,
    "currency": "USD",
    "price_original": "$329.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTk5ODkxMzY3NTk3NzU2OjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5NzYwMjo6Njo6&url=%2FCustom-Personalized-Packaging-Business-Outreach%2Fdp%2FB0FGQ7R1BB%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3FattrModel%3Dexclude%26content-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26cv_ct_cx%3Dflash%2Bdrives%26include-variations%3D1%26keywords%3Dflash%2Bdrives%26offset%3D85%26pd_rd_i%3DB0FGQ7R1BB%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3D72MCC%26pd_rd_wg%3DylG2r%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26rrid%3D5K1TH3WRJW3K75TVP9QK%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sr%3D1-86-d1d87218-35d9-414f-9801-db7973c52143-spons%26widgetId%3Dloom-desktop-inline-slot_sptw-slnewarrivals-blended-us-t3%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ7R1BB",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 27,
    "asin": "B0FGQ7R1BB",
    "title": "Custom Logo USB Drive 50 100 Count Personalized Packaging for School Business Outreach (100,64GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$450.99",
    "rating": null,
    "review_count": 450,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-6_files/41ckOfpOT5L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 450.99,
    "currency": "USD",
    "price_original": "$450.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTk5ODkxMzY3NTk3NzU2OjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5NzYwMjo6Njo6&url=%2FCustom-Personalized-Packaging-Business-Outreach%2Fdp%2FB0FGQ7R1BB%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3FattrModel%3Dexclude%26content-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26cv_ct_cx%3Dflash%2Bdrives%26include-variations%3D1%26keywords%3Dflash%2Bdrives%26offset%3D85%26pd_rd_i%3DB0FGQ7R1BB%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3D72MCC%26pd_rd_wg%3DylG2r%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26rrid%3D5K1TH3WRJW3K75TVP9QK%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sr%3D1-86-d1d87218-35d9-414f-9801-db7973c52143-spons%26widgetId%3Dloom-desktop-inline-slot_sptw-slnewarrivals-blended-us-t3%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ7R1BB",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 28,
    "asin": "B0FGQ7R1BB",
    "title": "Custom Logo USB Drive 50 100 Count Personalized Packaging for School Business Outreach (100,64GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$450.99",
    "rating": null,
    "review_count": 450,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-6_files/41ckOfpOT5L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 450.99,
    "currency": "USD",
    "price_original": "$450.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTk5ODkxMzY3NTk3NzU2OjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU4ODgwMjo6Nzo6&url=%2FPersonalized-Custom-Nonprofits-Educational-Institutions%2Fdp%2FB0FGQ8YR1D%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3FattrModel%3Dexclude%26content-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26cv_ct_cx%3Dflash%2Bdrives%26include-variations%3D1%26keywords%3Dflash%2Bdrives%26offset%3D85%26pd_rd_i%3DB0FGQ8YR1D%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3D72MCC%26pd_rd_wg%3DylG2r%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26rrid%3D5K1TH3WRJW3K75TVP9QK%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sr%3D1-87-d1d87218-35d9-414f-9801-db7973c52143-spons%26widgetId%3Dloom-desktop-inline-slot_sptw-slnewarrivals-blended-us-t3%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ8YR1D",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 29,
    "asin": "B0FGQ8YR1D",
    "title": "Personalized Thumb Drive 50 100 PCS Pack Custom Logo Box for Nonprofits Educational Institutions Events (100,32GB)",
    "brand": "Personalized",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$410.99",
    "rating": null,
    "review_count": 410,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-6_files/41n19dEBUUL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 410.99,
    "currency": "USD",
    "price_original": "$410.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTk5ODkxMzY3NTk3NzU2OjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU4ODgwMjo6Nzo6&url=%2FPersonalized-Custom-Nonprofits-Educational-Institutions%2Fdp%2FB0FGQ8YR1D%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3FattrModel%3Dexclude%26content-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26cv_ct_cx%3Dflash%2Bdrives%26include-variations%3D1%26keywords%3Dflash%2Bdrives%26offset%3D85%26pd_rd_i%3DB0FGQ8YR1D%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3D72MCC%26pd_rd_wg%3DylG2r%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26rrid%3D5K1TH3WRJW3K75TVP9QK%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sr%3D1-87-d1d87218-35d9-414f-9801-db7973c52143-spons%26widgetId%3Dloom-desktop-inline-slot_sptw-slnewarrivals-blended-us-t3%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ8YR1D",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 30,
    "asin": "B0FGQ8YR1D",
    "title": "Personalized Thumb Drive 50 100 PCS Pack Custom Logo Box for Nonprofits Educational Institutions Events (100,32GB)",
    "brand": "Personalized",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$410.99",
    "rating": null,
    "review_count": 410,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-6_files/41n19dEBUUL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 410.99,
    "currency": "USD",
    "price_original": "$410.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTk5ODkxMzY3NTk3NzU2OjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5NDAwMjo6ODo6&url=%2FPersonalized-Corporate-University-Outreach-Branding%2Fdp%2FB0FGQ8RCNV%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3FattrModel%3Dexclude%26content-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26cv_ct_cx%3Dflash%2Bdrives%26include-variations%3D1%26keywords%3Dflash%2Bdrives%26offset%3D85%26pd_rd_i%3DB0FGQ8RCNV%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3D72MCC%26pd_rd_wg%3DylG2r%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26rrid%3D5K1TH3WRJW3K75TVP9QK%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sr%3D1-88-d1d87218-35d9-414f-9801-db7973c52143-spons%26widgetId%3Dloom-desktop-inline-slot_sptw-slnewarrivals-blended-us-t3%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ8RCNV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 31,
    "asin": "B0FGQ8RCNV",
    "title": "Personalized USB Memory Sticks 50 100 Pack Branded Boxes for Corporate Gifts University Fairs Company Outreach Client Branding (50,4GB)",
    "brand": "Personalized",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$159.99",
    "rating": null,
    "review_count": 159,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-6_files/31bGX-EfFeL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 159.99,
    "currency": "USD",
    "price_original": "$159.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1OTk5ODkxMzY3NTk3NzU2OjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5NDAwMjo6ODo6&url=%2FPersonalized-Corporate-University-Outreach-Branding%2Fdp%2FB0FGQ8RCNV%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3FattrModel%3Dexclude%26content-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26cv_ct_cx%3Dflash%2Bdrives%26include-variations%3D1%26keywords%3Dflash%2Bdrives%26offset%3D85%26pd_rd_i%3DB0FGQ8RCNV%26pd_rd_r%3D4d6c445e-8830-44fc-97a2-ce064b56d434%26pd_rd_w%3D72MCC%26pd_rd_wg%3DylG2r%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26rrid%3D5K1TH3WRJW3K75TVP9QK%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sr%3D1-88-d1d87218-35d9-414f-9801-db7973c52143-spons%26widgetId%3Dloom-desktop-inline-slot_sptw-slnewarrivals-blended-us-t3%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ8RCNV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 32,
    "asin": "B0FGQ8RCNV",
    "title": "Personalized USB Memory Sticks 50 100 Pack Branded Boxes for Corporate Gifts University Fairs Company Outreach Client Branding (50,4GB)",
    "brand": "Personalized",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$159.99",
    "rating": null,
    "review_count": 159,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-6_files/31bGX-EfFeL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 159.99,
    "currency": "USD",
    "price_original": "$159.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=6&crid=BALSGJKBQE1X&qid=1753561745&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_6#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 33,
    "asin": null,
    "title": "256GB USB Flash Drive & Outlet Wall Mount for Blink Sync Module 2 with Short Cable - Save Space - No Messy Wires - Easy Move Mount Bracket Holder for Blink Outdoor Indoor Security Camera (1 Pack)",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.5,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.4K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/51-ZBjmITLL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4ODgzNTE0ODkxODM2NjMyOjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAwNjUzMTU0MjQyMDI6OjA6Og&url=%2F256GB-Flash-Drive-Outlet-Module%2Fdp%2FB0CJFYF6VG%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CJFYF6VG%26pd_rd_r%3D35f18c98-7a55-41ae-a6fc-23136a5b22f5%26pd_rd_w%3D1h4ny%26pd_rd_wg%3DL3VRg%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-81-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CJFYF6VG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 34,
    "asin": "B0CJFYF6VG",
    "title": "256GB USB Flash Drive & Outlet Wall Mount for Blink Sync Module 2 with Short Cable - Save Space - No Messy Wires - Easy Move Mount Bracket Holder for Blink Outdoor Indoor Security Camera (1 Pack)",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.5,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.4K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/51-ZBjmITLL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4ODgzNTE0ODkxODM2NjMyOjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAwOTY0MjcxMTQyMDI6OjE6Og&url=%2F256GB-Flash-Drive-Mount-Module%2Fdp%2FB0CN5QFYZD%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CN5QFYZD%26pd_rd_r%3D35f18c98-7a55-41ae-a6fc-23136a5b22f5%26pd_rd_w%3D1h4ny%26pd_rd_wg%3DL3VRg%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-82-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CN5QFYZD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 35,
    "asin": "B0CN5QFYZD",
    "title": "256GB USB Flash Drive & Wall Mount for Blink Sync Module 2 with Short Cable ‚Äì Declutter, Save Space, and Effortlessly Enhance Security (1 Pack)",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$12.62",
    "rating": 4.5,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.1K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/61xbcUq7gdL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.62,
    "currency": "USD",
    "price_original": "$12.62"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4ODgzNTE0ODkxODM2NjMyOjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjoyMDAwNzIwMDcxNzc0NDE6OjI6Og&url=%2FDataOcean-64GB-Memory-Drives-Swivel%2Fdp%2FB07Q3Y5J5T%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07Q3Y5J5T%26pd_rd_r%3D35f18c98-7a55-41ae-a6fc-23136a5b22f5%26pd_rd_w%3D1h4ny%26pd_rd_wg%3DL3VRg%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-83-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07Q3Y5J5T",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 36,
    "asin": "B07Q3Y5J5T",
    "title": "2 Pack 64GB USB 2.0 Flash Drive Memory Stick Thumb Drives Swivel Design(2 X 64GB: Black Silver)",
    "brand": 2,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$7.99",
    "rating": 4.5,
    "review_count": 1,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(6.3K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/71arPE1Bm-S._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 7.99,
    "currency": "USD",
    "price_original": "$7.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4ODgzNTE0ODkxODM2NjMyOjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4NDc4MTE0MjgwMDI6OjM6Og&url=%2FJUANWE-Drives-Storage-Memory-Swivel%2Fdp%2FB07DHK41DK%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07DHK41DK%26pd_rd_r%3D35f18c98-7a55-41ae-a6fc-23136a5b22f5%26pd_rd_w%3D1h4ny%26pd_rd_wg%3DL3VRg%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-84-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07DHK41DK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 37,
    "asin": "B07DHK41DK",
    "title": "JUANWE 8GB USB Flash Drive 50 Packs, Bulk USB Sticks 2.0 Mutipack Thumb Drive 360¬∞ Swivel USB Stick, FAT32 Jump Drives Pen Drive Zip Drives for Data Storage/Files Backup/Document Transfer - Black",
    "brand": "JUANWE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$119.99",
    "rating": 4.4,
    "review_count": 4,
    "special_features": "Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/61p4ip0Pn+L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 119.99,
    "currency": "USD",
    "price_original": "$119.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo4ODgzNTE0ODkxODM2NjMyOjE3NTM1NjE3NjU6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA2MjI0MzA4NjYzMDI6OjQ6Og&url=%2Ffanxiang-512GB-External-Android-Windows%2Fdp%2FB0DDKZR41D%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DDKZR41D%26pd_rd_r%3D35f18c98-7a55-41ae-a6fc-23136a5b22f5%26pd_rd_w%3D1h4ny%26pd_rd_wg%3DL3VRg%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3DFZ551XN90BNKS2XCZMTH%26qid%3D1753561763%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-85-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DDKZR41D",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-6.html",
    "position": 38,
    "asin": "B0DDKZR41D",
    "title": "512GB Fast External SSD Flash Drive Up to 2000MB/s USB3.2 Gen2, 2-in-1 Dual USB A +Type-C Drive, USB Memory Stick Solid State Thumb Drive for iPhone 15/16/Android/Windows/MacPC/Laptops",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "SD",
    "price": "$59.99",
    "rating": 4.4,
    "review_count": 75,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -75,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-6_files/61tz6DtI+pL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 59.99,
    "currency": "USD",
    "price_original": "$59.99"
  },
  {
    "product_url": "https://www.amazon.com/Flash-KOOTION-Drives-Keychain-Memory/dp/B0BZ45SMMG/ref=sr_1_99?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.113K982uF4qpPnD2C0xg6HmPTC_dWbuS22QqLNE0xmTGjHj071QN20LucGBJIEps.PtHXfNlrt7umNTTiKlCVu15JoOw4tTY6eQ56H9qEPMc&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-99&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BZ45SMMG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 1,
    "asin": "B0BZ45SMMG",
    "title": "64GB Flash Drive KOOTION 10 Pack USB 2.0 Flash Drive 64GB USB Flash Drives Thumb Drive Jump Drives Keychain Memory Stick Black",
    "brand": "KOOTION",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$35.99",
    "rating": 4.6,
    "review_count": 50,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "14 sizes14 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/61cDvE0WCZL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 35.99,
    "currency": "USD",
    "price_original": "$35.99"
  },
  {
    "product_url": "https://www.amazon.com/Certified-External-Storage-Picture-Android/dp/B0DL5VCVCG/ref=sr_1_100?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.113K982uF4qpPnD2C0xg6HmPTC_dWbuS22QqLNE0xmTGjHj071QN20LucGBJIEps.PtHXfNlrt7umNTTiKlCVu15JoOw4tTY6eQ56H9qEPMc&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-100&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0DL5VCVCG",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 2,
    "asin": "B0DL5VCVCG",
    "title": "MFi Certified USB 3.0 Flash Drive 128GB for iPhone, 3in1 External Memory Photo Keeper Storage Stick for Picture/Video/Data Saver/Backup, High Speed Thumb/Jump/Hard Drives for iPhone/iPad/Android/PC",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$20.69",
    "rating": 4.3,
    "review_count": 5,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.2K)",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/7131xiPczVL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.69,
    "currency": "USD",
    "price_original": "$20.69"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Computer-SDCZ48-512G-U46-Everything-Stromboli/dp/B08DPZSNTV/ref=sr_1_101?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.113K982uF4qpPnD2C0xg6HmPTC_dWbuS22QqLNE0xmTGjHj071QN20LucGBJIEps.PtHXfNlrt7umNTTiKlCVu15JoOw4tTY6eQ56H9qEPMc&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-101&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08DPZSNTV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 3,
    "asin": "B08DPZSNTV",
    "title": "SanDisk Ultra 512GB USB 3.0 Flash Drive (Bulk 2 Pack) Works with Computer, Laptop, 130MB/s 512 GB PenDrive High Speed Memory Storage (SDCZ48-512G-U46) Bundle with (1) Everything But Stromboli Lanyard",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$80.83",
    "rating": 4.3,
    "review_count": 30,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -30,
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/61ASl3cHOZL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 80.83,
    "currency": "USD",
    "price_original": "$80.83"
  },
  {
    "product_url": "https://www.amazon.com/PNY-512GB-Elite-X-Flash-Drive/dp/B088RMCCLR/ref=sr_1_97?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.d1ViWhnoFL2iFx0CRcwcGpmIpg-UEbFr5DlLu15UBLDh8my0ZD5yRSycakls_BOzwXaSWvNDyPHzcaCFneaROc7P0QATPy-_leP8mDTV_5E-nvMVKLAaLSJ2JpdMkb1GJZOdTUg1r6pmmPgbcQcL47MHve84G3UQRDyx8dJuiyopZRN_9asChAsogNA4oyCM.CIt9AfiDB7WyZrlRCKeUWQNWJ4wQpp2BQiY6TMaG1KQ&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-97&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B088RMCCLR",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 4,
    "asin": "B088RMCCLR",
    "title": "PNY 512GB Elite-X Fit USB 3.1 Flash Drive - 200MB/s",
    "brand": "PNY",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$41.99",
    "rating": 4.4,
    "review_count": 100,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -863,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/61ZCHAKNUPL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 41.99,
    "currency": "USD",
    "price_original": "$41.99"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Cruzer-Glide-256GB-SDCZ600-256G-G35/dp/B07C9BPH2Q/ref=sr_1_98?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.d1ViWhnoFL2iFx0CRcwcGpmIpg-UEbFr5DlLu15UBLDh8my0ZD5yRSycakls_BOzwXaSWvNDyPHzcaCFneaROc7P0QATPy-_leP8mDTV_5E-nvMVKLAaLSJ2JpdMkb1GJZOdTUg1r6pmmPgbcQcL47MHve84G3UQRDyx8dJuiyopZRN_9asChAsogNA4oyCM.CIt9AfiDB7WyZrlRCKeUWQNWJ4wQpp2BQiY6TMaG1KQ&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-98&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07C9BPH2Q",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 5,
    "asin": "B07C9BPH2Q",
    "title": "SanDisk Cruzer Glide 256GB USB 3.0 Flash Drive -SDCZ600-256G-G35",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "SD",
    "price": "$20.14",
    "rating": 4.7,
    "review_count": 300,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(1.8K)",
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/411Nr-kOgPL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 20.14,
    "currency": "USD",
    "price_original": "$20.14"
  },
  {
    "product_url": "https://www.amazon.com/Aiibe-Flash-Drive-Drives-Memory/dp/B07PQF9X75/ref=sr_1_99?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.d1ViWhnoFL2iFx0CRcwcGpmIpg-UEbFr5DlLu15UBLDh8my0ZD5yRSycakls_BOzwXaSWvNDyPHzcaCFneaROc7P0QATPy-_leP8mDTV_5E-nvMVKLAaLSJ2JpdMkb1GJZOdTUg1r6pmmPgbcQcL47MHve84G3UQRDyx8dJuiyopZRN_9asChAsogNA4oyCM.CIt9AfiDB7WyZrlRCKeUWQNWJ4wQpp2BQiY6TMaG1KQ&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-99&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07PQF9X75",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 6,
    "asin": "B07PQF9X75",
    "title": "Aiibe 10 Pack 8GB USB Flash Drive Flash Drives USB 2.0 Thumb Drive Memory Stick Zip Drives Bulk (8GB, 10 Pack, Black)",
    "brand": "Aiibe",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$25.99",
    "rating": 4.6,
    "review_count": 300,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "10 sizes10 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/71H3NZVlEPL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 25.99,
    "currency": "USD",
    "price_original": "$25.99"
  },
  {
    "product_url": "https://www.amazon.com/GIGASTONE-Keychain-Push-Pull-Storage-Compatible/dp/B0BY317K3Z/ref=sr_1_100?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.d1ViWhnoFL2iFx0CRcwcGpmIpg-UEbFr5DlLu15UBLDh8my0ZD5yRSycakls_BOzwXaSWvNDyPHzcaCFneaROc7P0QATPy-_leP8mDTV_5E-nvMVKLAaLSJ2JpdMkb1GJZOdTUg1r6pmmPgbcQcL47MHve84G3UQRDyx8dJuiyopZRN_9asChAsogNA4oyCM.CIt9AfiDB7WyZrlRCKeUWQNWJ4wQpp2BQiY6TMaG1KQ&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-100&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0BY317K3Z",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 7,
    "asin": "B0BY317K3Z",
    "title": "GIGASTONE 128GB Flash Drive (5 Pack) Z30 USB 3.2 Gen 1, 100MB/s Ultra Fast, Keychain Loop, Carbon Fiber Style, Push-Pull Design, Data Storage, Backup for PC/Mac/TV/Car, USB 2.0/3.0/3.1 Compatible",
    "brand": "Gigastone",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$36.99",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Keychain",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/51O8YA-wWCL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 36.99,
    "currency": "USD",
    "price_original": "$36.99"
  },
  {
    "product_url": "https://www.amazon.com/WesData-Adapters-Drives-Storage-Laptops/dp/B0CZ7HMFB4/ref=sr_1_101?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.d1ViWhnoFL2iFx0CRcwcGpmIpg-UEbFr5DlLu15UBLDh8my0ZD5yRSycakls_BOzwXaSWvNDyPHzcaCFneaROc7P0QATPy-_leP8mDTV_5E-nvMVKLAaLSJ2JpdMkb1GJZOdTUg1r6pmmPgbcQcL47MHve84G3UQRDyx8dJuiyopZRN_9asChAsogNA4oyCM.CIt9AfiDB7WyZrlRCKeUWQNWJ4wQpp2BQiY6TMaG1KQ&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-101&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CZ7HMFB4",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 8,
    "asin": "B0CZ7HMFB4",
    "title": "5 Pack 64GB USB Flash Drive and 2 Pack USB C Adapters in a Case, Thumb Drives Memory Stick Storage and Backup for Smart Phones with Type C Port, Laptops, PC(5 Colors) (64, GB)",
    "brand": 5,
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 4.5,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -73,
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/81cPSV-x89L._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/ZZ-Memory-Expansion-Portable-Lanyard/dp/B0828Y6692/ref=sr_1_104?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.d1ViWhnoFL2iFx0CRcwcGpmIpg-UEbFr5DlLu15UBLDh8my0ZD5yRSycakls_BOzwXaSWvNDyPHzcaCFneaROc7P0QATPy-_leP8mDTV_5E-nvMVKLAaLSJ2JpdMkb1GJZOdTUg1r6pmmPgbcQcL47MHve84G3UQRDyx8dJuiyopZRN_9asChAsogNA4oyCM.CIt9AfiDB7WyZrlRCKeUWQNWJ4wQpp2BQiY6TMaG1KQ&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-104&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0828Y6692",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 9,
    "asin": "B0828Y6692",
    "title": "64GB 2 Pack USB Flash Drive K&ZZ Ultra Slim Thumb Drive USB 2.0 Memory Stick USB Drive Data Stick Expansion Disk with Black Portable Lanyard (64GB, 2 Pack Bundle)",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$12.59",
    "rating": 4.3,
    "review_count": 400,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "7 sizes7 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/613L4LoIffL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.59,
    "currency": "USD",
    "price_original": "$12.59"
  },
  {
    "product_url": "https://www.amazon.com/Wooolken-Swivel-Memory-Multipack-Lanyard/dp/B0CHNRYQ1W/ref=sr_1_105?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.d1ViWhnoFL2iFx0CRcwcGpmIpg-UEbFr5DlLu15UBLDh8my0ZD5yRSycakls_BOzwXaSWvNDyPHzcaCFneaROc7P0QATPy-_leP8mDTV_5E-nvMVKLAaLSJ2JpdMkb1GJZOdTUg1r6pmmPgbcQcL47MHve84G3UQRDyx8dJuiyopZRN_9asChAsogNA4oyCM.CIt9AfiDB7WyZrlRCKeUWQNWJ4wQpp2BQiY6TMaG1KQ&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-105&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B0CHNRYQ1W",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 10,
    "asin": "B0CHNRYQ1W",
    "title": "64GB Flash Drive 10 Pack, Wooolken USB 2.0 Thumb Drive Bulk Pen Drive Metal Swivel Memory Stick 64GB 10 Colors Multipack Value Zip USB Drives with Lanyard",
    "brand": "64GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$35.99",
    "rating": 4.6,
    "review_count": 400,
    "special_features": "Metal, Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "11 sizes11 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/71JY3OqwsHL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 35.99,
    "currency": "USD",
    "price_original": "$35.99"
  },
  {
    "product_url": "https://www.amazon.com/Verbatim-32GB-Pinstripe-Flash-Drive/dp/B08XWKJM52/ref=sr_1_106?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.d1ViWhnoFL2iFx0CRcwcGpmIpg-UEbFr5DlLu15UBLDh8my0ZD5yRSycakls_BOzwXaSWvNDyPHzcaCFneaROc7P0QATPy-_leP8mDTV_5E-nvMVKLAaLSJ2JpdMkb1GJZOdTUg1r6pmmPgbcQcL47MHve84G3UQRDyx8dJuiyopZRN_9asChAsogNA4oyCM.CIt9AfiDB7WyZrlRCKeUWQNWJ4wQpp2BQiY6TMaG1KQ&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-106&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B08XWKJM52",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 11,
    "asin": "B08XWKJM52",
    "title": "Verbatim 32GB Pinstripe USB 3.2 Gen 1 Flash Drive Retractable Thumb Drive - 10 Pack Black",
    "brand": "Verbatim",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.2 Gen 1",
    "memory_type": "USB",
    "price": "$38.87",
    "rating": 4.4,
    "review_count": 100,
    "special_features": "Retractable",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "5 sizes5 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/81fh3CmtZcL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 38.87,
    "currency": "USD",
    "price_original": "$38.87"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Cruzer-Blade-SDCZ50-008G-2-PACK/dp/B00HR36OC6/ref=sr_1_107?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.d1ViWhnoFL2iFx0CRcwcGpmIpg-UEbFr5DlLu15UBLDh8my0ZD5yRSycakls_BOzwXaSWvNDyPHzcaCFneaROc7P0QATPy-_leP8mDTV_5E-nvMVKLAaLSJ2JpdMkb1GJZOdTUg1r6pmmPgbcQcL47MHve84G3UQRDyx8dJuiyopZRN_9asChAsogNA4oyCM.CIt9AfiDB7WyZrlRCKeUWQNWJ4wQpp2BQiY6TMaG1KQ&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-107&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B00HR36OC6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 12,
    "asin": "B00HR36OC6",
    "title": "SanDisk Cruzer 16GB (8GB x 2) Cruzer Blade USB 2.0 Flash Drive Jump Drive Pen Drive Sdcz50 - Two Pack",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "SD",
    "price": "$11.87",
    "rating": 4.6,
    "review_count": 400,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -820,
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/418BFmNF9CL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 11.87,
    "currency": "USD",
    "price_original": "$11.87"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Computers-SDCZ600-064G-G35-Everything-Stromboli/dp/B07SMB81Q9/ref=sr_1_108?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.d1ViWhnoFL2iFx0CRcwcGpmIpg-UEbFr5DlLu15UBLDh8my0ZD5yRSycakls_BOzwXaSWvNDyPHzcaCFneaROc7P0QATPy-_leP8mDTV_5E-nvMVKLAaLSJ2JpdMkb1GJZOdTUg1r6pmmPgbcQcL47MHve84G3UQRDyx8dJuiyopZRN_9asChAsogNA4oyCM.CIt9AfiDB7WyZrlRCKeUWQNWJ4wQpp2BQiY6TMaG1KQ&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-108&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B07SMB81Q9",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 13,
    "asin": "B07SMB81Q9",
    "title": "SanDisk 64GB Cruzer Glide 3.0 USB Flash Drive (10 Pack Bundle) Jump Drive Pen Drive Works with Laptop Computers with USB 2.0/3.0 Port (SDCZ600-064G-G35) Plus (5) Everything But Stromboli (TM) Lanyard",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "SD",
    "price": "$78.99",
    "rating": 4.8,
    "review_count": 50,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -170,
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/71Z08hnrKRL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 78.99,
    "currency": "USD",
    "price_original": "$78.99"
  },
  {
    "product_url": "https://www.amazon.com/iPhone-External-Storage-Android-Computer/dp/B09H4NFPRN/ref=sr_1_109?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.d1ViWhnoFL2iFx0CRcwcGpmIpg-UEbFr5DlLu15UBLDh8my0ZD5yRSycakls_BOzwXaSWvNDyPHzcaCFneaROc7P0QATPy-_leP8mDTV_5E-nvMVKLAaLSJ2JpdMkb1GJZOdTUg1r6pmmPgbcQcL47MHve84G3UQRDyx8dJuiyopZRN_9asChAsogNA4oyCM.CIt9AfiDB7WyZrlRCKeUWQNWJ4wQpp2BQiY6TMaG1KQ&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-109&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B09H4NFPRN",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 14,
    "asin": "B09H4NFPRN",
    "title": "Flash Drive for iPhone 256GB, 4 in 1 USB Type C Memory Stick, Photo Stick External Storage Thumb Drive for iPhone iPad Android Computer, Rose Pink",
    "brand": "Flash",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$19.99",
    "rating": 3.9,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "3 sizes3 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/51jA42ndGnL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.99,
    "currency": "USD",
    "price_original": "$19.99"
  },
  {
    "product_url": "https://www.amazon.com/JUANWE-Flash-Drives-Drive-Pack/dp/B089K1Y1CF/ref=sr_1_110?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.d1ViWhnoFL2iFx0CRcwcGpmIpg-UEbFr5DlLu15UBLDh8my0ZD5yRSycakls_BOzwXaSWvNDyPHzcaCFneaROc7P0QATPy-_leP8mDTV_5E-nvMVKLAaLSJ2JpdMkb1GJZOdTUg1r6pmmPgbcQcL47MHve84G3UQRDyx8dJuiyopZRN_9asChAsogNA4oyCM.CIt9AfiDB7WyZrlRCKeUWQNWJ4wQpp2BQiY6TMaG1KQ&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-110&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B089K1Y1CF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 15,
    "asin": "B089K1Y1CF",
    "title": "JUANWE USB Flash Drive 256GB High Speed 3.0 Memory Stick Flash Drive Retractable Slide 256GB Jump Drive Zip Drive USB for Computers PC Laptop with Lanyard Hole",
    "brand": "JUANWE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$18.59",
    "rating": 4.4,
    "review_count": 400,
    "special_features": "Retractable, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "6 sizes6 sizes",
    "premium_brand": null,
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/41wjoWZoZbL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 18.59,
    "currency": "USD",
    "price_original": "$18.59"
  },
  {
    "product_url": "https://www.amazon.com/SanDisk-Cruzer-Glide-Flash-SDCZ60-064G-B35/dp/B004WLPIUK/ref=sr_1_111?crid=BALSGJKBQE1X&dib=eyJ2IjoiMSJ9.d1ViWhnoFL2iFx0CRcwcGpmIpg-UEbFr5DlLu15UBLDh8my0ZD5yRSycakls_BOzwXaSWvNDyPHzcaCFneaROc7P0QATPy-_leP8mDTV_5E-nvMVKLAaLSJ2JpdMkb1GJZOdTUg1r6pmmPgbcQcL47MHve84G3UQRDyx8dJuiyopZRN_9asChAsogNA4oyCM.CIt9AfiDB7WyZrlRCKeUWQNWJ4wQpp2BQiY6TMaG1KQ&dib_tag=se&keywords=flash+drives&qid=1753561770&sprefix=flash+drive%2Caps%2C146&sr=8-111&xpid=0pS0dlS6IFFFB",
    "product_link": "https://www.amazon.com/dp/B004WLPIUK",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 16,
    "asin": "B004WLPIUK",
    "title": "SanDisk Cruzer Glide 64GB (5 Pack) USB 2.0 Flash Drive SDCZ60-064G-B35 - With (2) Everything But Stromboli (tm) Lanyard",
    "brand": "SanDisk",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "SD",
    "price": "$38.35",
    "rating": 4.7,
    "review_count": 97,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -97,
    "premium_brand": "Premium Brands",
    "is_sponsored": "No",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/51X+2O19LyL._AC_UY218_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 38.35,
    "currency": "USD",
    "price_original": "$38.35"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=7&crid=BALSGJKBQE1X&qid=1753561763&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_7#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 17,
    "asin": null,
    "title": "Kepmem 32GB USB Stick Pack of 10 USB 2.0 Memory Sticks Bulk, Metal 32 Giga Flash Drive Swivel Pendrive Portable Keychain Pen Drives 32 GB Colorful Multipack U Disk for Data Storage Paper Works",
    "brand": "Kepmem",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$34.22",
    "rating": 4.6,
    "review_count": 8,
    "special_features": "Metal, Keychain, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(8.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/71lFJZly-9L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.22,
    "currency": "USD",
    "price_original": "$34.22"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1MDEzMjY5MTQ4MzYxNjYyOjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDA3MzU4MjY5MzgwMjo6MDo6&url=%2FKepmem-Portable-Keychain-Colorful-Multipack%2Fdp%2FB07HCH26MC%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07HCH26MC%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3DoOskK%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-97-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07HCH26MC",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 18,
    "asin": "B07HCH26MC",
    "title": "Kepmem 32GB USB Stick Pack of 10 USB 2.0 Memory Sticks Bulk, Metal 32 Giga Flash Drive Swivel Pendrive Portable Keychain Pen Drives 32 GB Colorful Multipack U Disk for Data Storage Paper Works",
    "brand": "Kepmem",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$34.22",
    "rating": 4.6,
    "review_count": 500,
    "special_features": "Metal, Keychain, Swivel",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(8.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/71lFJZly-9L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 34.22,
    "currency": "USD",
    "price_original": "$34.22"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1MDEzMjY5MTQ4MzYxNjYyOjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDc3MDc3NTEwODYwMjo6MTo6&url=%2FZZ-Flash-Memory-Drives-Colors%2Fdp%2FB07H26NHWW%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07H26NHWW%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3DoOskK%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-98-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07H26NHWW",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 19,
    "asin": "B07H26NHWW",
    "title": "K&ZZ 5 Pack 64GB Flash Drive 64 GB USB Flash Drives USB 2.0 Thumb Drive Gig Zip Drive Stick 64G Flash Memory Stick Jump Drives for PC Laptop, Multicolored",
    "brand": "K&ZZ",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$19.98",
    "rating": 4.5,
    "review_count": 500,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(2.9K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/71TmU8mY+MS._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 19.98,
    "currency": "USD",
    "price_original": "$19.98"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1MDEzMjY5MTQ4MzYxNjYyOjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MjM2OTExOTAwMjo6Mjo6&url=%2FSANKESU-Thumb-Memory-Storage-Laptop%2Fdp%2FB0DYSPS1FF%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DYSPS1FF%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3DoOskK%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-99-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DYSPS1FF",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 20,
    "asin": "B0DYSPS1FF",
    "title": "USB Thumb Drive 1TB,USB 3.0 Flash Drive Speed Up to 120MB/s Memory Stick Data Storage for Laptop,PC",
    "brand": "USB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 1000000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$61.19",
    "rating": 4.4,
    "review_count": 705,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -705,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/51dIuva9W1L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "tb",
    "price_numeric": 61.19,
    "currency": "USD",
    "price_original": "$61.19"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1MDEzMjY5MTQ4MzYxNjYyOjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1OTQxNDgxMzIwMjo6Mzo6&url=%2FAGECASH-Momoria-Memory-Storage-Lanyard%2Fdp%2FB0D66FB2QD%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0D66FB2QD%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3DoOskK%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-100-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0D66FB2QD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 21,
    "asin": "B0D66FB2QD",
    "title": "8GB USB Flash Drive 20 Pack AGECASH USB Thumb Drive Bulk USB 2.0 Flash Drives Unique Blue Swivel USB Jump Drive Multipack with Label Lanyard USB Memory Stick Zip Drive Pendrive 8GB for Data Storage",
    "brand": "8GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$38.57",
    "rating": 4.5,
    "review_count": 388,
    "special_features": "Swivel, Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -388,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/81sqVImusiL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 38.57,
    "currency": "USD",
    "price_original": "$38.57"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo1MDEzMjY5MTQ4MzYxNjYyOjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDA4MTE2NTMxMzgwMjo6NDo6&url=%2FSamData-Drives-Memory-Storage-Backup%2Fdp%2FB092879BVB%2Fref%3Dsxin_23_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%253Aamzn1.sym.dd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB092879BVB%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3DoOskK%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3Ddd72f1c7-655d-4b60-b1bd-fe74fe8a5924%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-101-f853d353-bf33-45e7-b5c2-2cb2b31abc9b-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B092879BVB",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 22,
    "asin": "B092879BVB",
    "title": "8GB USB Flash Drives 5 Pack 8GB Thumb Drives Memory Stick Jump Drive with LED Light for Storage and Backup (5 Colors: Black Blue Green Red Silver)",
    "brand": "8GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 8000000000,
    "capacity_category": "8 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$12.99",
    "rating": 4.5,
    "review_count": 1,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(37.6K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/71uDG7jFAKL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 12.99,
    "currency": "USD",
    "price_original": "$12.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=7&crid=BALSGJKBQE1X&qid=1753561763&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_7#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 23,
    "asin": null,
    "title": "128GB USB Flash Drive USB 3.1 Gen1 Dual USB-A & Type-C, Portable Thumb Drive for Smartphones, Laptops & Tablets",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$24.99",
    "rating": 4.4,
    "review_count": 60,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -7,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/51xwP+oHtWL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDQwNzI4NzcwMjg3ODc3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg2MDY1Njc2NjQwMjo6MTo6&url=%2FOSCOO-Portable-Smartphones-Laptops-Tablets%2Fdp%2FB0F6MQJV83%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0F6MQJV83%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3Dlu4X0%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-97-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0F6MQJV83",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 24,
    "asin": "B0F6MQJV83",
    "title": "128GB USB Flash Drive USB 3.1 Gen1 Dual USB-A & Type-C, Portable Thumb Drive for Smartphones, Laptops & Tablets",
    "brand": "128GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$24.99",
    "rating": 4.4,
    "review_count": 7,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -7,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/51xwP+oHtWL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 24.99,
    "currency": "USD",
    "price_original": "$24.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDQwNzI4NzcwMjg3ODc3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1NzYxMTExMjIwMjo6Mjo6&url=%2FSCICNCE-Intended-Required-Compatible-Computers%2Fdp%2FB0FDM6D67Z%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FDM6D67Z%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3Dlu4X0%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-98-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FDM6D67Z",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 25,
    "asin": "B0FDM6D67Z",
    "title": "SCICNCE 512GB Flash Drive Intended for iPhone, USB Memory Stick Storage Backup for Photos Videos, Plug and Play No APP Required, Compatible with iPhone iPad Android and Computers (Rose Gold)",
    "brand": "SCICNCE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$63.99",
    "rating": 4.6,
    "review_count": 39,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -39,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/71lZnj7ZftL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 63.99,
    "currency": "USD",
    "price_original": "$63.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDQwNzI4NzcwMjg3ODc3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0MDU2Njc0NzcwMjo6Mzo6&url=%2FAUAMOZ-Intended-Compatible-Application-Required%2Fdp%2FB0FCH2N9SY%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FCH2N9SY%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3Dlu4X0%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-99-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FCH2N9SY",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 26,
    "asin": "B0FCH2N9SY",
    "title": "256GB Flash Drive Intended for iPhone, Memory Stick Storage Files Photos Videos Backup, Compatible with iPhone iPad Android PC, Plug and Play, No Application Required (Metal Gray)",
    "brand": "256GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$37.49",
    "rating": 4.6,
    "review_count": 32,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -32,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/61nVJWs6wpL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.49,
    "currency": "USD",
    "price_original": "$37.49"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDQwNzI4NzcwMjg3ODc3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg1MDYyMDcyOTYwMjo6NDo6&url=%2F32GB-USB-Flash-Drive-Compatible%2Fdp%2FB0FF538QRM%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FF538QRM%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3Dlu4X0%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-100-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FF538QRM",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 27,
    "asin": "B0FF538QRM",
    "title": "32GB USB Flash Drive ‚Äì 4 in 1 USB C Flash Drive with USB 3.0, Type C, Micro USB & iOS Connector ‚Äì High Speed Thumb Drive, Plug and Play Photo Stick, Memory Stick Compatible with Laptop, Android, PC",
    "brand": "32GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB 3.0",
    "memory_type": "USB",
    "price": "$14.29",
    "rating": null,
    "review_count": 14,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/710hPP0F8FL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 14.29,
    "currency": "USD",
    "price_original": "$14.29"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDQwNzI4NzcwMjg3ODc3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU4OTAwMjo6NTo6&url=%2FCustom-Drives-Personalized-Business-Promotions%2Fdp%2FB0FGQ8WYJ5%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3Fcontent-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FGQ8WYJ5%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3Dlu4X0%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-101-d1d87218-35d9-414f-9801-db7973c52143-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ8WYJ5",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 28,
    "asin": "B0FGQ8WYJ5",
    "title": "Custom Mini USB Flash Drives Personalized Thumb Drives with Logo for Business Gifts, Promotions, Events Plug and Play, High Speed USB Memory Stick in 16GB, 32GB, 64GB (50,16GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$189.99",
    "rating": null,
    "review_count": 189,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-7_files/41gnLLYhAyL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 189.99,
    "currency": "USD",
    "price_original": "$189.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDQwNzI4NzcwMjg3ODc3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5MjUwMjo6Njo6&url=%2FFlash-Drive-Customizable-Thumb-4GB-128GB%2Fdp%2FB0FGQ3H9Y5%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3FattrModel%3Dexclude%26content-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26cv_ct_cx%3Dflash%2Bdrives%26include-variations%3D1%26keywords%3Dflash%2Bdrives%26offset%3D101%26pd_rd_i%3DB0FGQ3H9Y5%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3Dlu4X0%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26rrid%3DK9BW371VN3KVE0GKYJQZ%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sr%3D1-102-d1d87218-35d9-414f-9801-db7973c52143-spons%26widgetId%3Dloom-desktop-inline-slot_sptw-slnewarrivals-blended-us-t3%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ3H9Y5",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 29,
    "asin": "B0FGQ3H9Y5",
    "title": "Mini USB Flash Drive Customizable Tiny Thumb Drive with Your Logo 4GB-128GB - Perfect for Corporate Events, Branded Promotions, Student Projects Plug and Play, PC Mac (50,64GB)",
    "brand": "Mini",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$225.99",
    "rating": null,
    "review_count": 225,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-7_files/41Y5IinJkAL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 225.99,
    "currency": "USD",
    "price_original": "$225.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDQwNzI4NzcwMjg3ODc3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5MjUwMjo6Njo6&url=%2FFlash-Drive-Customizable-Thumb-4GB-128GB%2Fdp%2FB0FGQ3H9Y5%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3FattrModel%3Dexclude%26content-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26cv_ct_cx%3Dflash%2Bdrives%26include-variations%3D1%26keywords%3Dflash%2Bdrives%26offset%3D101%26pd_rd_i%3DB0FGQ3H9Y5%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3Dlu4X0%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26rrid%3DK9BW371VN3KVE0GKYJQZ%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sr%3D1-102-d1d87218-35d9-414f-9801-db7973c52143-spons%26widgetId%3Dloom-desktop-inline-slot_sptw-slnewarrivals-blended-us-t3%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ3H9Y5",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 30,
    "asin": "B0FGQ3H9Y5",
    "title": "Mini USB Flash Drive Customizable Tiny Thumb Drive with Your Logo 4GB-128GB - Perfect for Corporate Events, Branded Promotions, Student Projects Plug and Play, PC Mac (50,64GB)",
    "brand": "Mini",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 4000000000,
    "capacity_category": "4 GB",
    "memory_capacity_category": "8 GB & Under",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$225.99",
    "rating": null,
    "review_count": 225,
    "special_features": "Mini",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-7_files/41Y5IinJkAL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 225.99,
    "currency": "USD",
    "price_original": "$225.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDQwNzI4NzcwMjg3ODc3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5NzEwMjo6Nzo6&url=%2FCustom-Personalized-Packaging-Business-Outreach%2Fdp%2FB0FGQ75B2C%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3FattrModel%3Dexclude%26content-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26cv_ct_cx%3Dflash%2Bdrives%26include-variations%3D1%26keywords%3Dflash%2Bdrives%26offset%3D101%26pd_rd_i%3DB0FGQ75B2C%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3Dlu4X0%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26rrid%3DK9BW371VN3KVE0GKYJQZ%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sr%3D1-103-d1d87218-35d9-414f-9801-db7973c52143-spons%26widgetId%3Dloom-desktop-inline-slot_sptw-slnewarrivals-blended-us-t3%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ75B2C",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 31,
    "asin": "B0FGQ75B2C",
    "title": "Custom Logo USB Drive 50 100 Count Personalized Packaging for School Business Outreach (100,16GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$380.99",
    "rating": null,
    "review_count": 380,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-7_files/41ckOfpOT5L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 380.99,
    "currency": "USD",
    "price_original": "$380.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDQwNzI4NzcwMjg3ODc3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU5NzEwMjo6Nzo6&url=%2FCustom-Personalized-Packaging-Business-Outreach%2Fdp%2FB0FGQ75B2C%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3FattrModel%3Dexclude%26content-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26cv_ct_cx%3Dflash%2Bdrives%26include-variations%3D1%26keywords%3Dflash%2Bdrives%26offset%3D101%26pd_rd_i%3DB0FGQ75B2C%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3Dlu4X0%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26rrid%3DK9BW371VN3KVE0GKYJQZ%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sr%3D1-103-d1d87218-35d9-414f-9801-db7973c52143-spons%26widgetId%3Dloom-desktop-inline-slot_sptw-slnewarrivals-blended-us-t3%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ75B2C",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 32,
    "asin": "B0FGQ75B2C",
    "title": "Custom Logo USB Drive 50 100 Count Personalized Packaging for School Business Outreach (100,16GB)",
    "brand": "Custom",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 16000000000,
    "capacity_category": "16 GB",
    "memory_capacity_category": "16 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$380.99",
    "rating": null,
    "review_count": 380,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-7_files/41ckOfpOT5L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 380.99,
    "currency": "USD",
    "price_original": "$380.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDQwNzI4NzcwMjg3ODc3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU4ODYwMjo6ODo6&url=%2FPersonalized-Custom-Nonprofits-Educational-Institutions%2Fdp%2FB0FGQ2YX89%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3FattrModel%3Dexclude%26content-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26cv_ct_cx%3Dflash%2Bdrives%26include-variations%3D1%26keywords%3Dflash%2Bdrives%26offset%3D101%26pd_rd_i%3DB0FGQ2YX89%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3Dlu4X0%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26rrid%3DK9BW371VN3KVE0GKYJQZ%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sr%3D1-104-d1d87218-35d9-414f-9801-db7973c52143-spons%26widgetId%3Dloom-desktop-inline-slot_sptw-slnewarrivals-blended-us-t3%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ2YX89",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 33,
    "asin": "B0FGQ2YX89",
    "title": "Personalized Thumb Drive 50 100 PCS Pack Custom Logo Box for Nonprofits Educational Institutions Events (100,64GB)",
    "brand": "Personalized",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$450.99",
    "rating": null,
    "review_count": 450,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-7_files/41n19dEBUUL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 450.99,
    "currency": "USD",
    "price_original": "$450.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MTo3MDQwNzI4NzcwMjg3ODc3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljOjMwMDg0ODA1OTU4ODYwMjo6ODo6&url=%2FPersonalized-Custom-Nonprofits-Educational-Institutions%2Fdp%2FB0FGQ2YX89%2Fref%3Dsxin_24_pa_sp_search_thematic_sspa%3FattrModel%3Dexclude%26content-id%3Damzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%253Aamzn1.sym.280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26cv_ct_cx%3Dflash%2Bdrives%26include-variations%3D1%26keywords%3Dflash%2Bdrives%26offset%3D101%26pd_rd_i%3DB0FGQ2YX89%26pd_rd_r%3Deb791413-36c4-4f54-a12a-3e05ed61c8de%26pd_rd_w%3Dlu4X0%26pd_rd_wg%3D6Ys0t%26pf_rd_p%3D280ab7b0-5c2f-4ec9-9941-7e828d8ead8b%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26rrid%3DK9BW371VN3KVE0GKYJQZ%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sr%3D1-104-d1d87218-35d9-414f-9801-db7973c52143-spons%26widgetId%3Dloom-desktop-inline-slot_sptw-slnewarrivals-blended-us-t3%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWM%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FGQ2YX89",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 34,
    "asin": "B0FGQ2YX89",
    "title": "Personalized Thumb Drive 50 100 PCS Pack Custom Logo Box for Nonprofits Educational Institutions Events (100,64GB)",
    "brand": "Personalized",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 64000000000,
    "capacity_category": "64 GB",
    "memory_capacity_category": "64 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$450.99",
    "rating": null,
    "review_count": 450,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": null,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "No",
    "is_available": "Yes",
    "image_url": "./drives-7_files/41n19dEBUUL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 450.99,
    "currency": "USD",
    "price_original": "$450.99"
  },
  {
    "product_url": "https://www.amazon.com/s?k=flash+drives&page=7&crid=BALSGJKBQE1X&qid=1753561763&sprefix=flash+drive%2Caps%2C146&xpid=0pS0dlS6IFFFB&ref=sr_pg_7#",
    "product_link": "https://www.amazon.com/dp/",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 35,
    "asin": null,
    "title": "JUANWE 32GB Bulk Flash Drive 10 Packs, Mutipack USB Thumb Drives 2.0 Flashdrive Memory Sticks, Fat32 Jump Drive for Laptop Backup, Bulks Zip Drive Memoria Storage Sticks Pendrive Pack of 10 - Black",
    "brand": "JUANWE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$30.39",
    "rating": 4.4,
    "review_count": 4,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/61p4ip0Pn+L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 30.39,
    "currency": "USD",
    "price_original": "$30.39"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyNjUxOTg0OTAwOTYwNDU3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4MTU5MjQ1NDkwMDI6OjA6Og&url=%2FJUANWE-Drives-Storage-Memory-Swivel%2Fdp%2FB07D54WBZ8%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB07D54WBZ8%26pd_rd_r%3D8642c1b7-9e97-4a01-9eb6-106d09d80638%26pd_rd_w%3DeoA9W%26pd_rd_wg%3DOfISJ%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-97-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B07D54WBZ8",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 36,
    "asin": "B07D54WBZ8",
    "title": "JUANWE 32GB Bulk Flash Drive 10 Packs, Mutipack USB Thumb Drives 2.0 Flashdrive Memory Sticks, Fat32 Jump Drive for Laptop Backup, Bulks Zip Drive Memoria Storage Sticks Pendrive Pack of 10 - Black",
    "brand": "JUANWE",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 32000000000,
    "capacity_category": "32 GB",
    "memory_capacity_category": "32 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$30.39",
    "rating": 4.4,
    "review_count": 4,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": "(4.5K)",
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/61p4ip0Pn+L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 30.39,
    "currency": "USD",
    "price_original": "$30.39"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyNjUxOTg0OTAwOTYwNDU3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAyNjM4NTg0OTc0MDI6OjE6Og&url=%2FWooolken-Drives-Lanyards-Weddings-Storage%2Fdp%2FB0C7CKSBQV%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0C7CKSBQV%26pd_rd_r%3D8642c1b7-9e97-4a01-9eb6-106d09d80638%26pd_rd_w%3DeoA9W%26pd_rd_wg%3DOfISJ%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-98-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0C7CKSBQV",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 37,
    "asin": "B0C7CKSBQV",
    "title": "(Not 128GB) 128MB Flash Drives 50 Pack, Wooolken USB 2.0 Thumb Drive with Lanyards Bulk USB Sticks for Weddings,Office, School, Data Storage Backup",
    "brand": "(Not",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB 2.0",
    "memory_type": "USB",
    "price": "$55.99",
    "rating": 4.6,
    "review_count": 700,
    "special_features": "Lanyard",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -700,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/61bG6tJRBKL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 55.99,
    "currency": "USD",
    "price_original": "$55.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyNjUxOTg0OTAwOTYwNDU3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4NjA4MzczNDYyMDI6OjI6Og&url=%2FCertified-High-Speed-External-Storage-Transfer%2Fdp%2FB0DLH5JV7F%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0DLH5JV7F%26pd_rd_r%3D8642c1b7-9e97-4a01-9eb6-106d09d80638%26pd_rd_w%3DeoA9W%26pd_rd_wg%3DOfISJ%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-99-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0DLH5JV7F",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 38,
    "asin": "B0DLH5JV7F",
    "title": "MFi Certified 256GB Flash Drive for iPhone & iPad, High-Speed Photo Stick for External Memory Storage, Backup & Transfer Files, Thumb Drive Memory Stick for iPhone/iPad/iOS/Android/PC (Silver)",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 256000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$37.99",
    "rating": 4.8,
    "review_count": 200,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -200,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/61CkM1WOSxL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.99,
    "currency": "USD",
    "price_original": "$37.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyNjUxOTg0OTAwOTYwNDU3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDAxMTkzNzgxMTg0MDI6OjM6Og&url=%2FCertified-iPhone-Storage-Compatible-Android%2Fdp%2FB0CNT34ZQD%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0CNT34ZQD%26pd_rd_r%3D8642c1b7-9e97-4a01-9eb6-106d09d80638%26pd_rd_w%3DeoA9W%26pd_rd_wg%3DOfISJ%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-100-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0CNT34ZQD",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 39,
    "asin": "B0CNT34ZQD",
    "title": "MFi Certified 128GB Flash Drive for iPhone Photo Stick, USB Thumb Drive Memory Stick High Speed USB Drive Photo Storage for iPhone Flash Drive Compatible for iPhone/iPad/Android/PC",
    "brand": "MFi",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 128000000000,
    "capacity_category": "128 GB",
    "memory_capacity_category": "128 GB",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$22.99",
    "rating": 4.2,
    "review_count": 400,
    "special_features": null,
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -863,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/61uOPRk-GbL._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 22.99,
    "currency": "USD",
    "price_original": "$22.99"
  },
  {
    "product_url": "https://www.amazon.com/sspa/click?ie=UTF8&spc=MToyNjUxOTg0OTAwOTYwNDU3OjE3NTM1NjE3OTE6c3Bfc2VhcmNoX3RoZW1hdGljX2J0ZjozMDA4NDA1NjY3NDc5MDI6OjQ6Og&url=%2FAUAMOZ-Intended-Compatible-Application-Required%2Fdp%2FB0FBSB6XH6%2Fref%3Dsxbs_pa_sp_search_thematic_btf_sspa%3Fcontent-id%3Damzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%253Aamzn1.sym.a99590a4-68db-457d-9f12-5bb850c3199f%26crid%3DBALSGJKBQE1X%26cv_ct_cx%3Dflash%2Bdrives%26keywords%3Dflash%2Bdrives%26pd_rd_i%3DB0FBSB6XH6%26pd_rd_r%3D8642c1b7-9e97-4a01-9eb6-106d09d80638%26pd_rd_w%3DeoA9W%26pd_rd_wg%3DOfISJ%26pf_rd_p%3Da99590a4-68db-457d-9f12-5bb850c3199f%26pf_rd_r%3D5BRN5DVDHBX7XQXPD5J2%26qid%3D1753561770%26sbo%3DRZvfv%252F%252FHxDF%252BO5021pAnSA%253D%253D%26sprefix%3Dflash%2Bdrive%252Caps%252C146%26sr%3D1-101-d1931c17-4371-4e59-bbe3-ace4c8b0d213-spons%26xpid%3D0pS0dlS6IFFFB%26sp_csd%3Dd2lkZ2V0TmFtZT1zcF9zZWFyY2hfdGhlbWF0aWNfYnRm%26psc%3D1",
    "product_link": "https://www.amazon.com/dp/B0FBSB6XH6",
    "blank": null,
    "affiliate_link": "",
    "source_file": "drives-7.html",
    "position": 40,
    "asin": "B0FBSB6XH6",
    "title": "512GB Flash Drive Intended for iPhone, Memory Stick Storage Files Photos Videos Backup, Compatible with iPhone iPad Android PC, Plug and Play, No Application Required (Metal Silver)",
    "brand": "512GB",
    "manufacturer": null,
    "model": null,
    "capacity_raw": 512000000000,
    "capacity_category": "512 GB & Above",
    "memory_capacity_category": "200 GB & Up",
    "hardware_interface": "USB",
    "memory_type": "USB",
    "price": "$37.09",
    "rating": 4.6,
    "review_count": 32,
    "special_features": "Metal",
    "weight": null,
    "height": null,
    "warranty": null,
    "unit_count": null,
    "read_speed": null,
    "write_speed": null,
    "seller": -32,
    "premium_brand": null,
    "is_sponsored": "Yes",
    "has_prime": "Yes",
    "is_available": "Yes",
    "image_url": "./drives-7_files/61vpyoZTx9L._AC_UL320_.jpg",
    "extracted_date": "7/27/25",
    "capacity_units": "gb",
    "price_numeric": 37.09,
    "currency": "USD",
    "price_original": "$37.09"
  }
]